import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Byte: any;
  Currency: any;
  Date: any;
  DateTime: any;
  Duration: any;
  EmailAddress: any;
  GUID: any;
  HSL: any;
  HSLA: any;
  HexColorCode: any;
  Hexadecimal: any;
  IBAN: any;
  IPv4: any;
  IPv6: any;
  ISBN: any;
  ISO8601Duration: any;
  JSON: any;
  JSONObject: any;
  JWT: any;
  Latitude: any;
  LocalDate: any;
  LocalEndTime: any;
  LocalTime: any;
  Long: any;
  Longitude: any;
  MAC: any;
  NegativeFloat: any;
  NegativeInt: any;
  NonEmptyString: any;
  NonNegativeFloat: number;
  NonNegativeInt: number;
  NonPositiveFloat: any;
  NonPositiveInt: any;
  ObjectID: any;
  PhoneNumber: any;
  Port: any;
  PositiveFloat: any;
  PositiveInt: any;
  PostalCode: any;
  RGB: any;
  RGBA: any;
  SafeInt: any;
  Time: any;
  Timestamp: number;
  URL: any;
  USCurrency: any;
  UUID: any;
  UnsignedFloat: any;
  UnsignedInt: any;
  UtcOffset: any;
  Void: any;
};

export type AccountOnboardLinkInput = {
  refreshUrl: Scalars['String'];
  returnUrl: Scalars['String'];
};

export type ActionItem = {
  __typename?: 'ActionItem';
  assignee?: Maybe<User>;
  chat?: Maybe<Chat>;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pending_appointment?: Maybe<Appointment>;
  reschedule?: Maybe<Reschedule>;
  status: ActionItemStatus;
  type: ActionItemType;
  updated_at: Scalars['Timestamp'];
};

export enum ActionItemStatus {
  Completed = 'Completed',
  Expired = 'Expired',
  Pending = 'Pending'
}

export enum ActionItemType {
  Boarding = 'Boarding',
  General = 'General',
  MissingClient = 'MissingClient',
  MissingPatient = 'MissingPatient',
  NewChat = 'NewChat',
  OfficeTask = 'OfficeTask',
  PendingAppointment = 'PendingAppointment',
  Prescription = 'Prescription',
  Reschedule = 'Reschedule'
}

/** A type that describe an address */
export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  full_text?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street_a?: Maybe<Scalars['String']>;
  street_b?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['PostalCode']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  full_text?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_a?: InputMaybe<Scalars['String']>;
  street_b?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['PostalCode']>;
};

export type AnalyticsNumbers = {
  __typename?: 'AnalyticsNumbers';
  appointments_count: Scalars['NonNegativeInt'];
  forward_scheduled_patients_count: Scalars['NonNegativeInt'];
  new_appointments_count: Scalars['NonNegativeInt'];
  new_clients_count: Scalars['NonNegativeInt'];
  new_patients_count: Scalars['NonNegativeInt'];
  no_show_count: Scalars['NonNegativeInt'];
  revenue: Scalars['Float'];
  revenue_per_appointment: Scalars['Float'];
  schedule_efficiency: Scalars['Float'];
  transactions_count: Scalars['NonNegativeInt'];
};

export type AnalyticsNumbersByMonth = {
  __typename?: 'AnalyticsNumbersByMonth';
  analytics: AnalyticsNumbers;
  month: Scalars['NonNegativeInt'];
  year: Scalars['NonNegativeInt'];
};

export type Animal = {
  __typename?: 'Animal';
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export enum AnimalGender {
  Female = 'Female',
  Male = 'Male',
  Unknown = 'Unknown'
}

export type Appointment = {
  __typename?: 'Appointment';
  action_items?: Maybe<Array<ActionItem>>;
  appointment_patients?: Maybe<Array<AppointmentPatient>>;
  appt_type_pms_id?: Maybe<Scalars['String']>;
  booking_source?: Maybe<BookingSource>;
  cancelled_at?: Maybe<Scalars['NonNegativeInt']>;
  client?: Maybe<Client>;
  client_info?: Maybe<ClientInfo>;
  client_notes?: Maybe<Scalars['String']>;
  client_pms_id?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinic_approved_at?: Maybe<Scalars['NonNegativeInt']>;
  clinic_notes?: Maybe<Scalars['String']>;
  clinician?: Maybe<Clinician>;
  clinician_pms_id?: Maybe<Scalars['String']>;
  confirmation_requested_at?: Maybe<Scalars['NonNegativeInt']>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']>;
  created_at: Scalars['Timestamp'];
  drop_off_time?: Maybe<Scalars['NonNegativeInt']>;
  end_time: Scalars['NonNegativeInt'];
  from_prompt?: Maybe<AppointmentPrompt>;
  id: Scalars['ID'];
  index_of_opening?: Maybe<Scalars['NonNegativeInt']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_new_client?: Maybe<Scalars['Boolean']>;
  is_new_patient?: Maybe<Scalars['Boolean']>;
  is_time_block?: Maybe<Scalars['Boolean']>;
  minutes: Scalars['NonNegativeInt'];
  new_client_name?: Maybe<Scalars['String']>;
  new_client_phone?: Maybe<Scalars['String']>;
  new_patient_name?: Maybe<Scalars['String']>;
  new_patient_species?: Maybe<Scalars['String']>;
  origin?: Maybe<EntityOrigin>;
  patient?: Maybe<Patient>;
  patient_history_items?: Maybe<Array<PatientHistoryItem>>;
  patient_info?: Maybe<PatientInfo>;
  patient_pms_id?: Maybe<Scalars['String']>;
  patients_pms_ids?: Maybe<Array<Scalars['String']>>;
  payment?: Maybe<Payment>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']>;
  pms_id?: Maybe<Scalars['String']>;
  reason_for_cancellation?: Maybe<Scalars['String']>;
  referring_clinic_name?: Maybe<Scalars['String']>;
  requested_prompt?: Maybe<AppointmentPrompt>;
  reschedules?: Maybe<Array<Reschedule>>;
  room?: Maybe<Room>;
  service?: Maybe<Service>;
  service_name?: Maybe<Scalars['String']>;
  should_be_synced?: Maybe<Scalars['Boolean']>;
  start_time: Scalars['NonNegativeInt'];
  status: AppointmentStatus;
  stripe_payment_intent_id?: Maybe<Scalars['String']>;
  time_of_day?: Maybe<TimeOfDay>;
  updated_at: Scalars['Timestamp'];
  widget_source?: Maybe<Scalars['String']>;
};

export enum AppointmentEntryMethod {
  ConfirmationRequired = 'ConfirmationRequired',
  Instant = 'Instant',
  ManualEntry = 'ManualEntry'
}

export type AppointmentPatient = {
  __typename?: 'AppointmentPatient';
  appointment: Appointment;
  id: Scalars['ID'];
  patient?: Maybe<Patient>;
};

export type AppointmentPrompt = {
  __typename?: 'AppointmentPrompt';
  client?: Maybe<Client>;
  client_notes?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinic_notes?: Maybe<Scalars['String']>;
  clinician?: Maybe<Clinician>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']>;
  created_appointment?: Maybe<Appointment>;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  minutes?: Maybe<Scalars['NonNegativeInt']>;
  patient?: Maybe<Patient>;
  reason_for_denial?: Maybe<Scalars['String']>;
  service?: Maybe<Service>;
  service_name?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['NonNegativeInt']>;
  type: AppointmentPromptType;
  updated_at: Scalars['Timestamp'];
};

export enum AppointmentPromptType {
  FollowUp = 'FollowUp',
  NewAppointment = 'NewAppointment'
}

export enum AppointmentStatus {
  Booked = 'Booked',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Denied = 'Denied',
  Expired = 'Expired',
  NoShow = 'NoShow',
  Pending = 'Pending'
}

export type Attachment = {
  __typename?: 'Attachment';
  filename: Scalars['String'];
  id: Scalars['ID'];
  type: AttachmentType;
  url: Scalars['String'];
};

export type AttachmentInput = {
  file_location: Scalars['String'];
  file_name: Scalars['String'];
  name: Scalars['String'];
  patient_pms_id: Scalars['String'];
};

export enum AttachmentType {
  Image = 'Image',
  Pdf = 'Pdf'
}

export enum AuthRoles {
  Admin = 'Admin',
  ClinicEmployee = 'ClinicEmployee',
  ClinicManager = 'ClinicManager',
  SuperAdmin = 'SuperAdmin',
  User = 'User'
}

export enum AuthorityLevel {
  Doctor = 'Doctor',
  NonTechnicalStaff = 'NonTechnicalStaff',
  Technician = 'Technician'
}

export type Availability = {
  __typename?: 'Availability';
  date: Scalars['NonNegativeInt'];
  repeat?: Maybe<RepeatAvailability>;
  times: Array<TimeInterval>;
};

export type AvailabilityHours = {
  __typename?: 'AvailabilityHours';
  friday?: Maybe<Array<TimeInterval>>;
  monday?: Maybe<Array<TimeInterval>>;
  saturday?: Maybe<Array<TimeInterval>>;
  sunday?: Maybe<Array<TimeInterval>>;
  thursday?: Maybe<Array<TimeInterval>>;
  tuesday?: Maybe<Array<TimeInterval>>;
  wednesday?: Maybe<Array<TimeInterval>>;
};

export type AvailabilityHoursInput = {
  friday?: InputMaybe<Array<TimeIntervalInput>>;
  monday?: InputMaybe<Array<TimeIntervalInput>>;
  saturday?: InputMaybe<Array<TimeIntervalInput>>;
  sunday?: InputMaybe<Array<TimeIntervalInput>>;
  thursday?: InputMaybe<Array<TimeIntervalInput>>;
  tuesday?: InputMaybe<Array<TimeIntervalInput>>;
  wednesday?: InputMaybe<Array<TimeIntervalInput>>;
};

export type AvailabilityInput = {
  date: Scalars['NonNegativeInt'];
  repeat?: InputMaybe<RepeatAvailabilityInput>;
  times: Array<TimeIntervalInput>;
};

export enum BookingQuestions {
  ClientReturningStatus = 'ClientReturningStatus',
  PatientFixedStatus = 'PatientFixedStatus',
  PatientGender = 'PatientGender',
  PatientReturningStatus = 'PatientReturningStatus'
}

export type BookingResourceParams = {
  clinic_species_id?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']>;
  patient_gender?: InputMaybe<AnimalGender>;
  service_id?: InputMaybe<Scalars['ID']>;
};

export type BookingServiceParams = {
  clinic_species_id?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']>;
  patient_gender?: InputMaybe<AnimalGender>;
};

export enum BookingSource {
  Facebook = 'Facebook',
  Google = 'Google',
  Instagram = 'Instagram',
  Other = 'Other',
  Website = 'Website'
}

export type Breed = {
  __typename?: 'Breed';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description: Scalars['String'];
  id: Scalars['ID'];
  pms_id: Scalars['String'];
  species?: Maybe<Species>;
  updated_at: Scalars['Timestamp'];
};

export type Chat = {
  __typename?: 'Chat';
  client: Client;
  client_last_read: Scalars['NonNegativeInt'];
  client_last_read_count: Scalars['NonNegativeInt'];
  client_message_count: Scalars['NonNegativeInt'];
  client_unread_count: Scalars['NonNegativeInt'];
  clinic: Clinic;
  clinic_last_read: Scalars['NonNegativeInt'];
  clinic_last_read_count: Scalars['NonNegativeInt'];
  clinic_message_count: Scalars['NonNegativeInt'];
  clinic_unread_count: Scalars['NonNegativeInt'];
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  is_hidden: Scalars['Boolean'];
  last_message?: Maybe<Scalars['String']>;
  last_message_time: Scalars['Timestamp'];
  message_count: Scalars['NonNegativeInt'];
  status: ChatStatus;
  system_message_count: Scalars['NonNegativeInt'];
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export type ChatQueryResult = {
  __typename?: 'ChatQueryResult';
  chats: Array<Chat>;
  count: Scalars['NonNegativeInt'];
};

export enum ChatStatus {
  Closed = 'Closed',
  HighPriority = 'HighPriority',
  LowPriority = 'LowPriority',
  NormalPriority = 'NormalPriority',
  Open = 'Open'
}

export type ChckupMetadata = {
  __typename?: 'ChckupMetadata';
  id: Scalars['String'];
  last_appointment_handled_time: Scalars['NonNegativeInt'];
};

export type ChckupMetadataInput = {
  last_appointment_handled_time?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CheckIn = {
  __typename?: 'CheckIn';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  status?: Maybe<CheckInStatus>;
  updated_at: Scalars['Timestamp'];
  user: User;
  vehicle?: Maybe<Scalars['String']>;
  visit_reason?: Maybe<VisitReason>;
};

export enum CheckInStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Pending = 'Pending'
}

export type Client = {
  __typename?: 'Client';
  address?: Maybe<Address>;
  balance?: Maybe<Scalars['Float']>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp'];
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_unsubscribed: Scalars['Boolean'];
  last_appointment?: Maybe<Appointment>;
  last_appt_time?: Maybe<Scalars['NonNegativeInt']>;
  last_contact_time?: Maybe<Scalars['NonNegativeInt']>;
  last_name?: Maybe<Scalars['String']>;
  loyalty_members?: Maybe<Array<Maybe<LoyaltyMember>>>;
  next_appointment?: Maybe<Appointment>;
  next_appt_time?: Maybe<Scalars['NonNegativeInt']>;
  origin?: Maybe<EntityOrigin>;
  patient_count?: Maybe<Scalars['NonNegativeInt']>;
  patients?: Maybe<Array<Patient>>;
  phone?: Maybe<Scalars['String']>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']>;
  pms_id?: Maybe<Scalars['String']>;
  pms_status?: Maybe<Scalars['String']>;
  primary_email?: Maybe<Scalars['ID']>;
  primary_phone?: Maybe<Scalars['ID']>;
  updated_at: Scalars['Timestamp'];
  user?: Maybe<User>;
};

export type ClientForm = {
  __typename?: 'ClientForm';
  appointment?: Maybe<Appointment>;
  client: Client;
  client_completed_at?: Maybe<Scalars['NonNegativeInt']>;
  clinic_verified_at?: Maybe<Scalars['NonNegativeInt']>;
  created_at: Scalars['Timestamp'];
  form: Form;
  form_data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  updated_at: Scalars['Timestamp'];
};

export type ClientInfo = {
  __typename?: 'ClientInfo';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ClientInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export enum ClientTypeEnum {
  New = 'New',
  Returning = 'Returning'
}

export type ClientWithOverduePatient = {
  __typename?: 'ClientWithOverduePatient';
  client: Client;
  overdue_patients: Array<OverduePatient>;
};

export type Clinic = {
  __typename?: 'Clinic';
  address?: Maybe<Address>;
  adjusted_availability?: Maybe<Array<Availability>>;
  animals: Array<Animal>;
  avatar_url?: Maybe<Scalars['String']>;
  clinic_admins: Array<ClinicAdmin>;
  clinic_species?: Maybe<Array<ClinicSpecies>>;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  disabled_features?: Maybe<DisabledFeatures>;
  email?: Maybe<Scalars['String']>;
  features?: Maybe<ClinicFeatures>;
  groupup_recipients?: Maybe<Array<Scalars['String']>>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID'];
  is_archived: Scalars['Boolean'];
  is_featured?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  last_synced_times?: Maybe<ClinicLastSyncedTimes>;
  name?: Maybe<Scalars['String']>;
  offers_emergency_care?: Maybe<Scalars['Boolean']>;
  office_emails?: Maybe<Array<Scalars['String']>>;
  onboarding?: Maybe<ClinicOnboarding>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']>;
  pims_settings?: Maybe<PimsSettings>;
  pms: PracticeManagementSystem;
  pms_additional_key?: Maybe<Scalars['String']>;
  pms_api_key?: Maybe<Scalars['String']>;
  pms_api_subdomain?: Maybe<Scalars['String']>;
  pms_version?: Maybe<Scalars['String']>;
  primary_color?: Maybe<Scalars['String']>;
  ratings?: Maybe<ClinicRatings>;
  send_from_phone?: Maybe<Scalars['String']>;
  services: Array<Service>;
  settings?: Maybe<ClinicSettings>;
  slug?: Maybe<Scalars['String']>;
  stripe_connected_account_id?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
  website?: Maybe<Scalars['String']>;
};

export type ClinicAdmin = {
  __typename?: 'ClinicAdmin';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  role: Scalars['String'];
  updated_at: Scalars['Timestamp'];
  user: User;
};

export type ClinicAnalytics = {
  __typename?: 'ClinicAnalytics';
  accounts_receivable: Scalars['Float'];
  appointments: Array<Appointment>;
  appointments_count: Scalars['NonNegativeInt'];
  clients_with_negative_balances: Array<Client>;
  clients_with_negative_balances_count: Scalars['NonNegativeInt'];
  forward_scheduled_patients_count: Scalars['NonNegativeInt'];
  last_month_average_revenue_per_appointment: Scalars['Float'];
  monthly_appointments_scheduled: Scalars['NonNegativeInt'];
  monthly_revenue_completed: Scalars['Float'];
  new_appointments_count: Scalars['NonNegativeInt'];
  new_clients_count: Scalars['NonNegativeInt'];
  new_patients_count: Scalars['NonNegativeInt'];
  no_show_count: Scalars['NonNegativeInt'];
  patients_without_reschedules: Array<Patient>;
  revenue: Scalars['Float'];
  revenue_by_clinician: Array<RevenueGroup>;
  revenue_by_type: Array<RevenueGroup>;
  schedule_efficiency: Scalars['Float'];
  transactions_count: Scalars['NonNegativeInt'];
};

export type ClinicFeatures = {
  __typename?: 'ClinicFeatures';
  forms_enabled?: Maybe<Scalars['Boolean']>;
  help_enabled?: Maybe<Scalars['Boolean']>;
  huddle_enabled?: Maybe<Scalars['Boolean']>;
  loyalty_enabled?: Maybe<Scalars['Boolean']>;
  messaging_enabled?: Maybe<Scalars['Boolean']>;
  notifs_enabled?: Maybe<Scalars['Boolean']>;
  payments_enabled?: Maybe<Scalars['Boolean']>;
  reviews_enabled?: Maybe<Scalars['Boolean']>;
  scheduling_enabled?: Maybe<Scalars['Boolean']>;
  telehealth_enabled?: Maybe<Scalars['Boolean']>;
};

export type ClinicFeaturesInput = {
  forms_enabled?: InputMaybe<Scalars['Boolean']>;
  help_enabled?: InputMaybe<Scalars['Boolean']>;
  huddle_enabled?: InputMaybe<Scalars['Boolean']>;
  loyalty_enabled?: InputMaybe<Scalars['Boolean']>;
  messaging_enabled?: InputMaybe<Scalars['Boolean']>;
  notifs_enabled?: InputMaybe<Scalars['Boolean']>;
  payments_enabled?: InputMaybe<Scalars['Boolean']>;
  reviews_enabled?: InputMaybe<Scalars['Boolean']>;
  scheduling_enabled?: InputMaybe<Scalars['Boolean']>;
  telehealth_enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ClinicLastSyncedTimes = {
  __typename?: 'ClinicLastSyncedTimes';
  last_full_sync?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_appointments?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_blockoffs?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_breeds?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_clients?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_clinicians?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_diagnoses?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_history_items?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_invoice_items?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_invoices?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_patients?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_prescriptions?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_products?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_rooms?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_services?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_species?: Maybe<Scalars['NonNegativeInt']>;
  last_sync_transactions?: Maybe<Scalars['NonNegativeInt']>;
};

export type ClinicLastSyncedTimesInput = {
  last_full_sync?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_blockoffs?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_breeds?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_clients?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_clinicians?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_diagnoses?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_history_items?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_invoice_items?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_invoices?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_patients?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_prescriptions?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_products?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_rooms?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_services?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_species?: InputMaybe<Scalars['NonNegativeInt']>;
  last_sync_transactions?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type ClinicOnboarding = {
  __typename?: 'ClinicOnboarding';
  has_set_hours?: Maybe<Scalars['Boolean']>;
  has_synced_pms?: Maybe<Scalars['Boolean']>;
};

export type ClinicOnboardingInput = {
  has_set_hours?: InputMaybe<Scalars['Boolean']>;
  has_synced_pms?: InputMaybe<Scalars['Boolean']>;
};

export type ClinicRatings = {
  __typename?: 'ClinicRatings';
  care_rating_count?: Maybe<Scalars['NonNegativeInt']>;
  care_rating_total?: Maybe<Scalars['NonNegativeInt']>;
  overall_rating_count?: Maybe<Scalars['NonNegativeInt']>;
  overall_rating_total?: Maybe<Scalars['NonNegativeInt']>;
  price_rating_count?: Maybe<Scalars['NonNegativeInt']>;
  price_rating_total?: Maybe<Scalars['NonNegativeInt']>;
  time_rating_count?: Maybe<Scalars['NonNegativeInt']>;
  time_rating_total?: Maybe<Scalars['NonNegativeInt']>;
};

export type ClinicSettings = {
  __typename?: 'ClinicSettings';
  allow_first_appt_per_day?: Maybe<Scalars['Boolean']>;
  allow_reschedule?: Maybe<Scalars['Boolean']>;
  appointment_entry_method?: Maybe<AppointmentEntryMethod>;
  base_schedule_duration?: Maybe<Scalars['NonNegativeInt']>;
  cancellation_buffer_minutes?: Maybe<Scalars['NonNegativeInt']>;
  confirmation_days_before?: Maybe<Scalars['NonNegativeInt']>;
  custom_sick_description?: Maybe<Scalars['String']>;
  custom_well_description?: Maybe<Scalars['String']>;
  does_require_referral?: Maybe<Scalars['Boolean']>;
  does_require_verification?: Maybe<Scalars['Boolean']>;
  does_use_clinicians_to_schedule?: Maybe<Scalars['Boolean']>;
  does_use_rooms_to_schedule?: Maybe<Scalars['Boolean']>;
  facebook_review_link?: Maybe<Scalars['String']>;
  google_review_link?: Maybe<Scalars['String']>;
  hide_clinician_preference: Scalars['Boolean'];
  included_species?: Maybe<Array<Species>>;
  is_using_detailed_services?: Maybe<Scalars['Boolean']>;
  is_using_notifications?: Maybe<Scalars['Boolean']>;
  is_using_rooms?: Maybe<Scalars['Boolean']>;
  max_patients_per_visit?: Maybe<Scalars['NonNegativeInt']>;
  max_review_rating_for_notif?: Maybe<Scalars['NonNegativeInt']>;
  new_appt_approved_msg?: Maybe<Scalars['String']>;
  new_appt_denied_msg?: Maybe<Scalars['String']>;
  new_appt_requested_msg?: Maybe<Scalars['String']>;
  non_blocking_services: Array<Scalars['ID']>;
  pms_end_time?: Maybe<Scalars['PositiveInt']>;
  pms_start_time?: Maybe<Scalars['PositiveInt']>;
  primary_clinician_pms_id?: Maybe<Scalars['String']>;
  primary_color?: Maybe<Scalars['String']>;
  primary_room_pms_id?: Maybe<Scalars['String']>;
  reschedule_fee?: Maybe<Scalars['NonNegativeInt']>;
  reschedule_minutes_before?: Maybe<Scalars['NonNegativeInt']>;
  review_message_methods?: Maybe<Array<MessageMethod>>;
  schedule_method?: Maybe<ScheduleMethod>;
  scheduling_buffer_minutes?: Maybe<Scalars['NonNegativeInt']>;
  scheduling_max_minutes_away?: Maybe<Scalars['NonNegativeInt']>;
  scheduling_min_minutes_away?: Maybe<Scalars['NonNegativeInt']>;
  send_confirmations_to: SendConfirmationsTo;
  send_new_appt_email?: Maybe<Scalars['Boolean']>;
  send_reviews_to?: Maybe<SendConfirmationsTo>;
  server_syncing_only?: Maybe<Scalars['Boolean']>;
  should_complete_sync?: Maybe<Scalars['Boolean']>;
  should_create_clients?: Maybe<Scalars['Boolean']>;
  should_create_patients?: Maybe<Scalars['Boolean']>;
  sync_interval_minutes: Scalars['NonNegativeInt'];
  this_month_revenue?: Maybe<Scalars['Float']>;
  time_slot_minutes: Scalars['NonNegativeInt'];
  yesterday_revenue?: Maybe<Scalars['Float']>;
};

export type ClinicSettingsInput = {
  allow_first_appt_per_day?: InputMaybe<Scalars['Boolean']>;
  appointment_entry_method?: InputMaybe<AppointmentEntryMethod>;
  base_schedule_duration?: InputMaybe<Scalars['NonNegativeInt']>;
  cancellation_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  confirmation_days_before?: InputMaybe<Scalars['NonNegativeInt']>;
  custom_sick_description?: InputMaybe<Scalars['String']>;
  custom_well_description?: InputMaybe<Scalars['String']>;
  does_require_referral?: InputMaybe<Scalars['Boolean']>;
  does_require_verification?: InputMaybe<Scalars['Boolean']>;
  does_use_clinicians_to_schedule?: InputMaybe<Scalars['Boolean']>;
  does_use_rooms_to_schedule?: InputMaybe<Scalars['Boolean']>;
  facebook_review_link?: InputMaybe<Scalars['String']>;
  google_review_link?: InputMaybe<Scalars['String']>;
  hide_clinician_preference?: InputMaybe<Scalars['Boolean']>;
  included_species?: InputMaybe<Array<Species>>;
  is_using_detailed_services?: InputMaybe<Scalars['Boolean']>;
  is_using_notifications?: InputMaybe<Scalars['Boolean']>;
  is_using_rooms?: InputMaybe<Scalars['Boolean']>;
  max_patients_per_visit?: InputMaybe<Scalars['NonNegativeInt']>;
  max_review_rating_for_notif?: InputMaybe<Scalars['NonNegativeInt']>;
  new_appt_approved_msg?: InputMaybe<Scalars['String']>;
  new_appt_denied_msg?: InputMaybe<Scalars['String']>;
  new_appt_requested_msg?: InputMaybe<Scalars['String']>;
  non_blocking_services?: InputMaybe<Array<Scalars['ID']>>;
  pms_end_time?: InputMaybe<Scalars['PositiveInt']>;
  pms_start_time?: InputMaybe<Scalars['PositiveInt']>;
  primary_clinician_pms_id?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  primary_room_pms_id?: InputMaybe<Scalars['String']>;
  schedule_method?: InputMaybe<ScheduleMethod>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  secondary_color?: InputMaybe<Scalars['String']>;
  send_confirmations_to?: InputMaybe<SendConfirmationsTo>;
  send_new_appt_email?: InputMaybe<Scalars['Boolean']>;
  send_reviews_to?: InputMaybe<SendConfirmationsTo>;
  server_syncing_only?: InputMaybe<Scalars['Boolean']>;
  should_complete_sync?: InputMaybe<Scalars['Boolean']>;
  should_create_clients?: InputMaybe<Scalars['Boolean']>;
  should_create_patients?: InputMaybe<Scalars['Boolean']>;
  this_month_revenue?: InputMaybe<Scalars['Float']>;
  time_slot_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  yesterday_revenue?: InputMaybe<Scalars['Float']>;
};

export type ClinicSex = {
  __typename?: 'ClinicSex';
  animal_gender?: Maybe<AnimalGender>;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  entity_key: Scalars['String'];
  fixed_statuses: Array<FixedStatus>;
  id: Scalars['ID'];
  included_species: Array<Species>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  pms_id: Scalars['String'];
  sync_error?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export type ClinicSpecies = {
  __typename?: 'ClinicSpecies';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_primary: Scalars['Boolean'];
  pms?: Maybe<PracticeManagementSystem>;
  pms_id: Scalars['String'];
  species: Species;
  updated_at: Scalars['Timestamp'];
};

export type ClinicStats = {
  __typename?: 'ClinicStats';
  booked_appointments: Scalars['NonNegativeInt'];
  cancelled_appointments: Scalars['NonNegativeInt'];
  completed_appointments: Scalars['NonNegativeInt'];
  confirmed_appointments: Scalars['NonNegativeInt'];
  created_at: Scalars['Timestamp'];
  denied_appointments: Scalars['NonNegativeInt'];
  expired_appointments: Scalars['NonNegativeInt'];
  id: Scalars['ID'];
  pending_appointments: Scalars['NonNegativeInt'];
  total_appointments: Scalars['NonNegativeInt'];
  total_website_appointments: Scalars['NonNegativeInt'];
  total_widget_appointments: Scalars['NonNegativeInt'];
  updated_at: Scalars['Timestamp'];
};

export type Clinician = {
  __typename?: 'Clinician';
  adjusted_availability?: Maybe<Array<Availability>>;
  authority_level?: Maybe<AuthorityLevel>;
  avatar_url?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinician_services?: Maybe<Array<ClinicianService>>;
  created_at: Scalars['Timestamp'];
  excluded_service_ids?: Maybe<Array<Scalars['ID']>>;
  excluded_species?: Maybe<Array<Species>>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_assignable_in_pms?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pms?: Maybe<PracticeManagementSystem>;
  pms_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  stagger_offset_minutes?: Maybe<Scalars['NonNegativeInt']>;
  type: ResourceType;
  updated_at: Scalars['Timestamp'];
};

export type ClinicianService = {
  __typename?: 'ClinicianService';
  clinic: Clinic;
  clinician: Clinician;
  created_at: Scalars['Timestamp'];
  duration_override?: Maybe<Scalars['NonNegativeInt']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  service: Service;
  updated_at: Scalars['Timestamp'];
};

export type ClinicsScheduleEfficiency = {
  __typename?: 'ClinicsScheduleEfficiency';
  clinic: Clinic;
  schedule_efficiency: Scalars['Float'];
};

export type ConnectInstallation = {
  __typename?: 'ConnectInstallation';
  clinic: Clinic;
  computer_name?: Maybe<Scalars['String']>;
  computer_uuid?: Maybe<Scalars['String']>;
  connect_server_version?: Maybe<Scalars['String']>;
  connect_ui_version?: Maybe<Scalars['String']>;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  is_chckup_connected_to_pms?: Maybe<Scalars['Boolean']>;
  is_pms_active?: Maybe<Scalars['Boolean']>;
  is_server?: Maybe<Scalars['Boolean']>;
  is_update_service_active?: Maybe<Scalars['Boolean']>;
  last_ping?: Maybe<Scalars['NonNegativeInt']>;
  updated_at: Scalars['Timestamp'];
  version?: Maybe<Scalars['String']>;
};

export type CreateActionItemInput = {
  assignee?: InputMaybe<Scalars['ID']>;
  chat?: InputMaybe<Scalars['ID']>;
  clinic: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  pending_appointment?: InputMaybe<Scalars['ID']>;
  reschedule?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<ActionItemStatus>;
  type: ActionItemType;
};

export type CreateAnimalInput = {
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateAppointmentInput = {
  appt_type_pms_id?: InputMaybe<Scalars['String']>;
  booking_source?: InputMaybe<BookingSource>;
  checksum?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['ID']>;
  client_info?: InputMaybe<ClientInfoInput>;
  client_notes?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  clinic_notes?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  clinician_pms_id?: InputMaybe<Scalars['String']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']>;
  index_of_opening?: InputMaybe<Scalars['NonNegativeInt']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']>;
  is_time_block?: InputMaybe<Scalars['Boolean']>;
  minutes: Scalars['NonNegativeInt'];
  new_client_name?: InputMaybe<Scalars['String']>;
  new_client_phone?: InputMaybe<Scalars['String']>;
  new_patient_name?: InputMaybe<Scalars['String']>;
  new_patient_species?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<EntityOrigin>;
  patient?: InputMaybe<Scalars['ID']>;
  patient_info?: InputMaybe<PatientInfoInput>;
  patient_pms_id?: InputMaybe<Scalars['String']>;
  patients_pms_ids?: InputMaybe<Array<Scalars['String']>>;
  payment?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  reason_for_cancellation?: InputMaybe<Scalars['String']>;
  referring_clinic_name?: InputMaybe<Scalars['String']>;
  room?: InputMaybe<Scalars['ID']>;
  service?: InputMaybe<Scalars['ID']>;
  service_name?: InputMaybe<Scalars['String']>;
  start_time: Scalars['NonNegativeInt'];
  status?: InputMaybe<AppointmentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  time_of_day?: InputMaybe<TimeOfDay>;
  widget_source?: InputMaybe<Scalars['String']>;
};

export type CreateAppointmentPromptInput = {
  client?: InputMaybe<Scalars['ID']>;
  client_notes?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  clinic_notes?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  created_appointment?: InputMaybe<Scalars['ID']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  patient?: InputMaybe<Scalars['ID']>;
  reason_for_denial?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['ID']>;
  service_name?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  type: AppointmentPromptType;
};

export type CreateAttachmentInput = {
  filename: Scalars['String'];
  type: AttachmentType;
  url: Scalars['String'];
};

export type CreateBreedInput = {
  clinic: Scalars['ID'];
  description: Scalars['String'];
  pms_id: Scalars['String'];
  species?: InputMaybe<Species>;
};

export type CreateChatInput = {
  client: Scalars['ID'];
  clinic: Scalars['ID'];
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateCheckInInput = {
  clinic: Scalars['ID'];
  user: Scalars['ID'];
  vehicle?: InputMaybe<Scalars['String']>;
  visit_reason?: InputMaybe<VisitReason>;
};

export type CreateClientFormInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  client: Scalars['ID'];
  form: Scalars['ID'];
};

export type CreateClientInput = {
  address?: InputMaybe<AddressInput>;
  balance?: InputMaybe<Scalars['Float']>;
  checksum?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_unsubscribed?: InputMaybe<Scalars['Boolean']>;
  last_appointment?: InputMaybe<Scalars['ID']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  last_contact_time?: InputMaybe<Scalars['NonNegativeInt']>;
  last_name?: InputMaybe<Scalars['String']>;
  next_appointment?: InputMaybe<Scalars['ID']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  origin?: InputMaybe<EntityOrigin>;
  phone?: InputMaybe<Scalars['String']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type CreateClinicAdminInput = {
  clinic: Scalars['ID'];
  role: Scalars['String'];
  user: Scalars['ID'];
};

export type CreateClinicInput = {
  address?: InputMaybe<AddressInput>;
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  avatar_url?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<ClinicFeaturesInput>;
  groupup_recipients?: InputMaybe<Array<Scalars['String']>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_synced_times?: InputMaybe<ClinicLastSyncedTimesInput>;
  name?: InputMaybe<Scalars['String']>;
  offers_emergency_care?: InputMaybe<Scalars['Boolean']>;
  office_emails?: InputMaybe<Array<Scalars['String']>>;
  onboarding?: InputMaybe<ClinicOnboardingInput>;
  organization?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  pms: PracticeManagementSystem;
  pms_additional_key?: InputMaybe<Scalars['String']>;
  pms_api_key?: InputMaybe<Scalars['String']>;
  pms_api_subdomain?: InputMaybe<Scalars['String']>;
  pms_version?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  send_from_phone?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<Scalars['ID']>>;
  settings?: InputMaybe<ClinicSettingsInput>;
  slug?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateClinicStatsInput = {
  booked_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  cancelled_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  completed_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  confirmed_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  denied_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  expired_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  pending_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_website_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_widget_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreateClinicianInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  authority_level?: InputMaybe<AuthorityLevel>;
  avatar_url?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  excluded_service_ids?: InputMaybe<Array<Scalars['ID']>>;
  excluded_species?: InputMaybe<Array<Species>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_assignable_in_pms?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  type?: InputMaybe<ResourceType>;
};

export type CreateClinicianServiceInput = {
  clinic: Scalars['ID'];
  clinician: Scalars['ID'];
  duration_override?: InputMaybe<Scalars['NonNegativeInt']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  service: Scalars['ID'];
};

export type CreateConnectInstallationInput = {
  clinic: Scalars['ID'];
  computer_name?: InputMaybe<Scalars['String']>;
  computer_uuid?: InputMaybe<Scalars['String']>;
  connect_server_version?: InputMaybe<Scalars['String']>;
  connect_ui_version?: InputMaybe<Scalars['String']>;
  is_chckup_connected_to_pms?: InputMaybe<Scalars['Boolean']>;
  is_pms_active?: InputMaybe<Scalars['Boolean']>;
  is_server?: InputMaybe<Scalars['Boolean']>;
  is_update_service_active?: InputMaybe<Scalars['Boolean']>;
  last_ping?: InputMaybe<Scalars['NonNegativeInt']>;
  version?: InputMaybe<Scalars['String']>;
};

export type CreateCustomerSegmentInput = {
  clinic: Scalars['ID'];
  excluded_filters: Array<CustomerSegmentFilterInput>;
  filters: Array<CustomerSegmentFilterInput>;
  name: Scalars['String'];
};

export type CreateDailyHuddleInput = {
  attendees?: InputMaybe<Array<Scalars['ID']>>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']>;
  leader?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  start_time: Scalars['NonNegativeInt'];
};

export type CreateDiagnosisInput = {
  clinic: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pms_id: Scalars['String'];
};

export type CreateEntityReportInput = {
  clinic?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  entity_type: ReportEntityType;
  organization_report: Scalars['ID'];
  parent_report?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['ID']>;
  service?: InputMaybe<Scalars['ID']>;
  values: Array<CreateReportValueInput>;
};

export type CreateFamilyInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type CreateFollowUpSettingsInput = {
  days_until_next_appt?: InputMaybe<Scalars['NonNegativeInt']>;
  parent?: InputMaybe<Scalars['ID']>;
  step_number?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreateFormInput = {
  clinic: Scalars['ID'];
  form_fields?: InputMaybe<Scalars['JSON']>;
  form_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateGoalInput = {
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_chckup_modifier?: InputMaybe<Scalars['Boolean']>;
  is_new_modifier?: InputMaybe<Scalars['Boolean']>;
  is_system?: InputMaybe<Scalars['Boolean']>;
  metric_entity: GoalEntity;
  metric_target_amount: Scalars['NonNegativeInt'];
  metric_timespan: GoalTimespan;
};

export type CreateInvoiceInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  balance?: InputMaybe<Scalars['NonNegativeInt']>;
  client?: InputMaybe<Scalars['ID']>;
  clinic: Scalars['ID'];
  clinician?: InputMaybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['NonNegativeInt']>;
  discount_reason?: InputMaybe<Scalars['String']>;
  entered_by_name?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['Timestamp']>;
  patient?: InputMaybe<Scalars['ID']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']>;
  pms_id: Scalars['String'];
  status: InvoiceStatus;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['NonNegativeInt']>;
  total: Scalars['Int'];
};

export type CreateInvoiceItemInput = {
  clinic: Scalars['ID'];
  clinician?: InputMaybe<Scalars['ID']>;
  currency: Scalars['Currency'];
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['NonNegativeInt']>;
  discount_reason?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<Scalars['ID']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']>;
  pms_id: Scalars['String'];
  price?: InputMaybe<Scalars['NonNegativeInt']>;
  product?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['NonNegativeInt']>;
  total: Scalars['Int'];
  type: InvoiceItemType;
};

export type CreateLoyaltyMemberInput = {
  all_time_points?: InputMaybe<Scalars['NonNegativeInt']>;
  available_points?: InputMaybe<Scalars['NonNegativeInt']>;
  client: Scalars['ID'];
};

export type CreateLoyaltyRedemptionInput = {
  member: Scalars['ID'];
  reward: Scalars['ID'];
};

export type CreateLoyaltyRewardInput = {
  clinic: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  points_required: Scalars['NonNegativeInt'];
};

export type CreateMessageInput = {
  attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  client?: InputMaybe<Scalars['ID']>;
  clinic_user?: InputMaybe<Scalars['ID']>;
  cta_text?: InputMaybe<Scalars['String']>;
  cta_url?: InputMaybe<Scalars['String']>;
  dont_update_chat_time?: InputMaybe<Scalars['Boolean']>;
  hidden_for_client?: InputMaybe<Scalars['Boolean']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  message_origin: MessageOrigin;
  message_type: MessageType;
  notification?: InputMaybe<Scalars['ID']>;
  patient?: InputMaybe<Scalars['ID']>;
  sender_unique_id?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
  type?: InputMaybe<NotificationType>;
};

export type CreateMetricValueParamsInput = {
  custom_label?: InputMaybe<Scalars['String']>;
  value_type: MetricValueType;
};

export type CreateNotificationTemplateInput = {
  body: Scalars['String'];
  clinic: Scalars['ID'];
  cta_text?: InputMaybe<Scalars['String']>;
  cta_url?: InputMaybe<Scalars['String']>;
  customer_segment: Scalars['ID'];
  every_x_hours: Scalars['NonNegativeInt'];
  header?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_marketing?: InputMaybe<Scalars['Boolean']>;
  is_system?: InputMaybe<Scalars['Boolean']>;
  message_methods: Array<MessageMethod>;
  name: Scalars['String'];
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  send_time_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  sms_body?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NotificationType>;
};

export type CreateOrganizationInput = {
  admins?: InputMaybe<Array<Scalars['ID']>>;
  name: Scalars['String'];
};

export type CreateOrganizationReportInput = {
  description?: InputMaybe<Scalars['String']>;
  entity_structure: Array<CreateReportEntityInput>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization: Scalars['ID'];
  preferred_view_type?: InputMaybe<ReportViewType>;
  report_metrics: Array<CreateReportMetricInput>;
  report_template?: InputMaybe<Scalars['ID']>;
  time_params: CreateTimeParamsInput;
};

export type CreatePatientHistoryItemInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  clinic: Scalars['ID'];
  clinician?: InputMaybe<Scalars['ID']>;
  diagnosis?: InputMaybe<Scalars['ID']>;
  issued_at: Scalars['Timestamp'];
  patient: Scalars['ID'];
  pms_id?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['ID']>;
};

export type CreatePatientInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  breed?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinic_breed?: InputMaybe<Scalars['ID']>;
  clinic_species?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  is_deceased?: InputMaybe<Scalars['Boolean']>;
  last_appointment?: InputMaybe<Scalars['ID']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  name?: InputMaybe<Scalars['String']>;
  next_appointment?: InputMaybe<Scalars['ID']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  origin?: InputMaybe<EntityOrigin>;
  owner?: InputMaybe<Scalars['ID']>;
  pet?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  species_pms_id?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export type CreatePatientRecordInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  assessment?: InputMaybe<Scalars['String']>;
  assisting_clinicians?: InputMaybe<Array<Scalars['String']>>;
  client?: InputMaybe<Scalars['ID']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['NonNegativeInt']>;
  master_problem_list?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  patient: Scalars['ID'];
  plan?: InputMaybe<Scalars['String']>;
  public_notes?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['ID']>;
  subjective?: InputMaybe<Scalars['String']>;
};

export type CreatePaymentInput = {
  amount: Scalars['PositiveInt'];
  appointment?: InputMaybe<Scalars['ID']>;
  category: PurchaseCategory;
  client: Scalars['ID'];
  clinic: Scalars['ID'];
  currency?: InputMaybe<Scalars['Currency']>;
  date: Scalars['NonNegativeInt'];
  errors?: InputMaybe<Array<PaymentErrorInput>>;
  payment_method_id?: InputMaybe<Scalars['String']>;
  processing_fee?: InputMaybe<Scalars['NonNegativeInt']>;
  sales_tax?: InputMaybe<Scalars['NonNegativeInt']>;
  service_fee?: InputMaybe<Scalars['NonNegativeInt']>;
  status: PaymentStatus;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
};

export type CreatePetInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  breed?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  name?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Species>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export type CreatePimsSettingsInput = {
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['NonNegativeInt']>;
  additional_key?: InputMaybe<Scalars['String']>;
  api_clinic_id?: InputMaybe<Scalars['String']>;
  api_key?: InputMaybe<Scalars['String']>;
  api_subdomain?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  cookie?: InputMaybe<Array<Scalars['String']>>;
  password?: InputMaybe<Scalars['String']>;
  pims_version?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  practice_key?: InputMaybe<Scalars['String']>;
  pulse_ar_report_id?: InputMaybe<Scalars['String']>;
  pulse_sales_report_id?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  request_verification_token?: InputMaybe<Scalars['String']>;
  user_key?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type CreatePmsApptTypeInput = {
  clinic: Scalars['ID'];
  color?: InputMaybe<Scalars['HexColorCode']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pms_id: Scalars['String'];
};

export type CreatePrescriptionInput = {
  clinic: Scalars['ID'];
  clinician?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  expiration_date?: InputMaybe<Scalars['Timestamp']>;
  is_active: Scalars['Boolean'];
  last_refill_time?: InputMaybe<Scalars['NonNegativeInt']>;
  name: Scalars['String'];
  patient: Scalars['ID'];
  pms_created_at: Scalars['Timestamp'];
  pms_id: Scalars['String'];
  product?: InputMaybe<Scalars['ID']>;
  product_name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']>;
  refill_count?: InputMaybe<Scalars['NonNegativeInt']>;
  refill_limit?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreatePrescriptionRequestInput = {
  clinic: Scalars['ID'];
  clinic_notes?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  patient: Scalars['ID'];
  pickup_date: Scalars['Timestamp'];
  quantity?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PrescriptionRequestStatus>;
  user: Scalars['ID'];
};

export type CreatePressItemInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<LinkInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateProductInput = {
  category: ProductCategory;
  clinic: Scalars['ID'];
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  pims_category?: InputMaybe<Scalars['String']>;
  pms_id: Scalars['String'];
  price: Scalars['NonNegativeInt'];
};

export type CreateRepeatParamsInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt'];
  unit: RepeatUnit;
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

export type CreateReportClinicInput = {
  clinic: Scalars['ID'];
  report: Scalars['ID'];
};

export type CreateReportColumnValueInput = {
  percentile?: InputMaybe<Scalars['NonNegativeFloat']>;
  value: Scalars['Float'];
  value_params: CreateMetricValueParamsInput;
};

export type CreateReportEntityInput = {
  child_entities?: InputMaybe<Array<CreateReportEntityInput>>;
  entity_type: ReportEntityType;
};

export type CreateReportMetricInput = {
  field_modifiers?: InputMaybe<Array<CreateReportMetricModifierInput>>;
  format?: InputMaybe<MetricFormat>;
  key: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['NonNegativeInt'];
  organization_report?: InputMaybe<Scalars['ID']>;
  report_template?: InputMaybe<Scalars['ID']>;
  special_modifier?: InputMaybe<SpecialMetricModifierType>;
  time_params_overrides?: InputMaybe<CreateTimeParamsInput>;
  type: ReportMetricType;
  value_types: Array<CreateMetricValueParamsInput>;
};

export type CreateReportMetricModifierInput = {
  category: MetricModifierCategory;
  column: Scalars['String'];
  filterOp: FilterOp;
  not?: InputMaybe<Scalars['Boolean']>;
  value: MetricModifierValueInput;
};

export type CreateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  entity_structure: Array<CreateReportEntityInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization: Scalars['ID'];
  preferred_view_type: ReportViewType;
  repeat: CreateRepeatParamsInput;
  report_metrics: Array<CreateReportMetricInput>;
  time_params: CreateTimeParamsInput;
};

export type CreateReportValueInput = {
  column_values: Array<CreateReportColumnValueInput>;
  key: Scalars['String'];
  metric: ReportMetricType;
};

export type CreateRescheduleInput = {
  appointment: Scalars['ID'];
  client_notes?: InputMaybe<Scalars['String']>;
  clinic: Scalars['ID'];
  clinic_notes?: InputMaybe<Scalars['String']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  initiated_by: RescheduleInitiatedBy;
  reason_for_denial?: InputMaybe<Scalars['String']>;
  requested_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']>;
  requested_start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  status?: InputMaybe<RescheduleStatus>;
};

export type CreateReviewInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  care_rating?: InputMaybe<Scalars['NonNegativeInt']>;
  client?: InputMaybe<Scalars['ID']>;
  clinic: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  overall_rating: Scalars['NonNegativeInt'];
  price_rating?: InputMaybe<Scalars['NonNegativeInt']>;
  time_rating?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreateRoomInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  clinic: Scalars['ID'];
  concurrent_patients?: InputMaybe<Scalars['NonNegativeInt']>;
  description?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  pms: PracticeManagementSystem;
  pms_id: Scalars['String'];
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type CreateSchedulingRulesInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  client_type?: InputMaybe<ClientTypeEnum>;
  clinic: Scalars['ID'];
  fixed_status?: InputMaybe<FixedStatus>;
  included_clinicians?: InputMaybe<Array<Scalars['ID']>>;
  included_rooms?: InputMaybe<Array<Scalars['ID']>>;
  included_services?: InputMaybe<Array<Scalars['ID']>>;
  included_species?: InputMaybe<Array<Scalars['ID']>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  only_modifier?: InputMaybe<OnlyModifierEnum>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_type?: InputMaybe<PatientTypeEnum>;
};

export type CreateServiceInput = {
  allow_new?: InputMaybe<Scalars['Boolean']>;
  allow_returning?: InputMaybe<Scalars['Boolean']>;
  authorized_levels?: InputMaybe<Array<AuthorityLevel>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  clinic?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  default_room?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  drop_off_hours?: InputMaybe<AvailabilityHoursInput>;
  drop_off_minutes_before?: InputMaybe<Scalars['NonNegativeInt']>;
  duration?: InputMaybe<Scalars['NonNegativeInt']>;
  excluded_species?: InputMaybe<Array<Species>>;
  follow_up_services?: InputMaybe<Array<Scalars['ID']>>;
  follow_up_settings?: InputMaybe<CreateFollowUpSettingsInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  max_per_day?: InputMaybe<Scalars['NonNegativeInt']>;
  minimum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']>;
  more_info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pms_appt_type?: InputMaybe<Scalars['ID']>;
  points?: InputMaybe<Scalars['NonNegativeInt']>;
  pricing?: InputMaybe<CreateServicePricingInput>;
  recurring?: InputMaybe<RecurringSettingsInput>;
  required_room?: InputMaybe<Scalars['ID']>;
  reserved_per_day?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  service_types?: InputMaybe<Array<ServiceType>>;
};

export type CreateServicePricingInput = {
  currency?: InputMaybe<Scalars['Currency']>;
  price: Scalars['PositiveInt'];
  type?: InputMaybe<ServicePricingType>;
};

export type CreateTemplateClinicInput = {
  clinic: Scalars['ID'];
  report_template: Scalars['ID'];
};

export type CreateTimeParamsInput = {
  end?: InputMaybe<Scalars['Timestamp']>;
  from_millis_ago?: InputMaybe<Scalars['Long']>;
  from_periods_ago?: InputMaybe<Scalars['NonNegativeInt']>;
  period_type?: InputMaybe<PeriodType>;
  start?: InputMaybe<Scalars['Timestamp']>;
  to_millis_ago?: InputMaybe<Scalars['Long']>;
  to_periods_ago?: InputMaybe<Scalars['NonNegativeInt']>;
  type: TimeParamType;
};

export type CreateTransactionInput = {
  amount?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['ID']>;
  clinic_id: Scalars['ID'];
  clinician_pms_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['NonNegativeInt']>;
  description?: InputMaybe<Scalars['String']>;
  patient_pms_id?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  service_pms_id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<TransactionType>;
};

export type CreateTreatmentInput = {
  description: Scalars['String'];
  pms_id: Scalars['String'];
  price?: InputMaybe<Scalars['Float']>;
};

export type CreateUserInput = {
  address?: InputMaybe<AddressInput>;
  avatar_url?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  family?: InputMaybe<Scalars['ID']>;
  favorited_clinics?: Array<Scalars['ID']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
};

export type CreateWidgetInput = {
  average_chat_response_time?: InputMaybe<Scalars['String']>;
  button_color?: InputMaybe<Scalars['String']>;
  button_text?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  enabled_chat_buttons?: InputMaybe<Array<WidgetMenuButtonType>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
  trigger_type: WidgetTriggerType;
  type: WidgetType;
  widget_name: Scalars['String'];
};

export type CustSegRpcResult = {
  __typename?: 'CustSegRPCResult';
  count: Scalars['NonNegativeInt'];
  results: Array<CustSegResult>;
};

export type CustSegResult = {
  __typename?: 'CustSegResult';
  appointment?: Maybe<Appointment>;
  client: Client;
  patient?: Maybe<Patient>;
  patient_history_item?: Maybe<PatientHistoryItem>;
  prescription?: Maybe<Prescription>;
};

export type CustomerInfoInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  excluded_filters: Array<CustomerSegmentFilter>;
  filters: Array<CustomerSegmentFilter>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export type CustomerSegmentFilter = {
  __typename?: 'CustomerSegmentFilter';
  filters: Array<QueryFilter>;
  only_consider_other_rows?: Maybe<Scalars['Boolean']>;
  type: CustomerSegmentFilterType;
};

export type CustomerSegmentFilterInput = {
  filters: Array<QueryInput>;
  only_consider_other_rows?: InputMaybe<Scalars['Boolean']>;
  type: CustomerSegmentFilterType;
};

export enum CustomerSegmentFilterType {
  Appointment = 'Appointment',
  History = 'History',
  Prescription = 'Prescription'
}

export type DailyHuddle = {
  __typename?: 'DailyHuddle';
  attendees?: Maybe<Array<Clinician>>;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  end_time?: Maybe<Scalars['NonNegativeInt']>;
  id: Scalars['ID'];
  leader?: Maybe<Clinician>;
  notes?: Maybe<Scalars['String']>;
  start_time: Scalars['NonNegativeInt'];
  updated_at: Scalars['Timestamp'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type Diagnosis = {
  __typename?: 'Diagnosis';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pms_id: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export type DisabledFeatures = {
  __typename?: 'DisabledFeatures';
  is_appt_cancellation_disabled?: Maybe<Scalars['Boolean']>;
  is_appt_confirmation_disabled?: Maybe<Scalars['Boolean']>;
  is_appt_rescheduling_disabled?: Maybe<Scalars['Boolean']>;
  is_client_assignment_disabled?: Maybe<Scalars['Boolean']>;
};

export enum EntityOrigin {
  ChckupDashboard = 'ChckupDashboard',
  ChckupWebsite = 'ChckupWebsite',
  ChckupWidget = 'ChckupWidget',
  Other = 'Other',
  Pms = 'PMS'
}

export type EntityReport = {
  __typename?: 'EntityReport';
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  entity_reports: Array<EntityReport>;
  entity_type: ReportEntityType;
  id: Scalars['ID'];
  organization_report: OrganizationReport;
  parent_report?: Maybe<EntityReport>;
  product?: Maybe<Product>;
  service?: Maybe<Service>;
  updated_at: Scalars['Timestamp'];
  values: Array<ReportValue>;
};

export type Family = {
  __typename?: 'Family';
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  pets?: Maybe<Array<Pet>>;
  updated_at: Scalars['Timestamp'];
  users?: Maybe<Array<User>>;
};

export type FilterAppointmentInput = {
  clinicId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  petId?: InputMaybe<Scalars['ID']>;
  queryString?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AppointmentStatus>;
};

export enum FilterOp {
  Adj = 'adj',
  Cd = 'cd',
  Cs = 'cs',
  Eq = 'eq',
  Fts = 'fts',
  Gt = 'gt',
  Gte = 'gte',
  Ilike = 'ilike',
  In = 'in',
  Is = 'is',
  Like = 'like',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  Nxl = 'nxl',
  Nxr = 'nxr',
  Ov = 'ov',
  Phfts = 'phfts',
  Plfts = 'plfts',
  Sl = 'sl',
  Sr = 'sr',
  Wfts = 'wfts'
}

export enum FixedStatus {
  Fixed = 'Fixed',
  Intact = 'Intact',
  Unknown = 'Unknown'
}

export type FloatPercentile = {
  __typename?: 'FloatPercentile';
  percentile: Scalars['Float'];
  value: Scalars['Float'];
};

export type FollowUpSettings = {
  __typename?: 'FollowUpSettings';
  days_until_next_appt?: Maybe<Scalars['NonNegativeInt']>;
  parent?: Maybe<Service>;
  step_number?: Maybe<Scalars['NonNegativeInt']>;
};

export type Form = {
  __typename?: 'Form';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  form_fields?: Maybe<Scalars['JSON']>;
  form_url?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export type Goal = {
  __typename?: 'Goal';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  is_chckup_modifier?: Maybe<Scalars['Boolean']>;
  is_new_modifier?: Maybe<Scalars['Boolean']>;
  is_system?: Maybe<Scalars['Boolean']>;
  last_synced_time?: Maybe<Scalars['NonNegativeInt']>;
  metric_current_amount: Scalars['NonNegativeInt'];
  metric_entity: GoalEntity;
  metric_target_amount: Scalars['NonNegativeInt'];
  metric_timespan: GoalTimespan;
  status: GoalStatus;
  updated_at: Scalars['Timestamp'];
};

export enum GoalEntity {
  Appointments = 'Appointments',
  Clients = 'Clients',
  Patients = 'Patients',
  Revenue = 'Revenue'
}

export enum GoalStatus {
  Achieved = 'Achieved',
  Unreached = 'Unreached'
}

export enum GoalTimespan {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type HeartbeatResponse = {
  __typename?: 'HeartbeatResponse';
  last_ping: Scalars['NonNegativeInt'];
  version: Scalars['String'];
};

export type IntPercentile = {
  __typename?: 'IntPercentile';
  percentile: Scalars['Float'];
  value: Scalars['NonNegativeInt'];
};

export type Invoice = {
  __typename?: 'Invoice';
  appointment?: Maybe<Appointment>;
  balance?: Maybe<Scalars['NonNegativeInt']>;
  client?: Maybe<Client>;
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  currency: Scalars['Currency'];
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['NonNegativeInt']>;
  discount_reason?: Maybe<Scalars['String']>;
  entered_by_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_items: Array<InvoiceItem>;
  paid_at?: Maybe<Scalars['Timestamp']>;
  patient?: Maybe<Patient>;
  pims_created_at?: Maybe<Scalars['Timestamp']>;
  pms_id: Scalars['String'];
  status: InvoiceStatus;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['NonNegativeInt']>;
  total: Scalars['Int'];
  updated_at: Scalars['Timestamp'];
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  currency: Scalars['Currency'];
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['NonNegativeInt']>;
  discount_reason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice?: Maybe<Invoice>;
  pims_created_at?: Maybe<Scalars['Timestamp']>;
  pms_id: Scalars['String'];
  price?: Maybe<Scalars['NonNegativeInt']>;
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['NonNegativeFloat']>;
  subtotal?: Maybe<Scalars['Int']>;
  tax?: Maybe<Scalars['NonNegativeInt']>;
  total: Scalars['Int'];
  type: InvoiceItemType;
  updated_at: Scalars['Timestamp'];
};

export enum InvoiceItemType {
  Discount = 'Discount',
  Other = 'Other',
  Payment = 'Payment',
  Prescription = 'Prescription',
  Product = 'Product',
  Service = 'Service'
}

export enum InvoiceStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Paid = 'Paid',
  Unknown = 'Unknown',
  Void = 'Void'
}

export type Link = {
  __typename?: 'Link';
  type?: Maybe<LinkType>;
  url?: Maybe<Scalars['String']>;
};

export type LinkInput = {
  type?: InputMaybe<LinkType>;
  url?: InputMaybe<Scalars['String']>;
};

export enum LinkType {
  Anchor = 'Anchor',
  Apple = 'Apple',
  Spotify = 'Spotify',
  Website = 'Website',
  YouTube = 'YouTube'
}

export type LoyaltyMember = {
  __typename?: 'LoyaltyMember';
  all_time_points: Scalars['NonNegativeInt'];
  available_points: Scalars['NonNegativeInt'];
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  loyalty_redemptions: Array<LoyaltyRedemption>;
  updated_at: Scalars['Timestamp'];
};

export type LoyaltyRedemption = {
  __typename?: 'LoyaltyRedemption';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  member: LoyaltyMember;
  reward: LoyaltyReward;
  updated_at: Scalars['Timestamp'];
};

export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image_url?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  loyalty_redemptions: Array<LoyaltyRedemption>;
  name: Scalars['String'];
  points_required: Scalars['NonNegativeInt'];
  updated_at: Scalars['Timestamp'];
};

export type Message = {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  chat: Chat;
  client?: Maybe<Client>;
  clinic_user?: Maybe<User>;
  created_at: Scalars['NonNegativeInt'];
  cta_text?: Maybe<Scalars['String']>;
  cta_url?: Maybe<Scalars['String']>;
  hidden_for_client?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  is_hidden: Scalars['Boolean'];
  message_methods?: Maybe<Array<MessageMethod>>;
  message_origin?: Maybe<MessageOrigin>;
  message_type?: Maybe<MessageType>;
  notification?: Maybe<NotificationTemplate>;
  patient?: Maybe<Patient>;
  sender_unique_id?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  type?: Maybe<NotificationType>;
  updated_at: Scalars['NonNegativeInt'];
};

export enum MessageMethod {
  Email = 'Email',
  Native = 'Native',
  Sms = 'Sms',
  WhatsApp = 'WhatsApp'
}

export enum MessageOrigin {
  ChckupDashboard = 'ChckupDashboard',
  ChckupPortal = 'ChckupPortal',
  ChckupWidget = 'ChckupWidget',
  Email = 'Email',
  Sms = 'Sms',
  System = 'System'
}

export enum MessageType {
  Clinic = 'Clinic',
  System = 'System',
  User = 'User'
}

export enum MetricFormat {
  Count = 'Count',
  Rate = 'Rate'
}

export enum MetricModifierCategory {
  Appointment = 'Appointment',
  Client = 'Client',
  Patient = 'Patient'
}

export type MetricModifierValue = {
  __typename?: 'MetricModifierValue';
  boolean?: Maybe<Scalars['Boolean']>;
  float?: Maybe<Scalars['Float']>;
  string?: Maybe<Scalars['String']>;
};

export type MetricModifierValueInput = {
  boolean?: InputMaybe<Scalars['Boolean']>;
  float?: InputMaybe<Scalars['Float']>;
  string?: InputMaybe<Scalars['String']>;
};

export type MetricValueParams = {
  __typename?: 'MetricValueParams';
  custom_label?: Maybe<Scalars['String']>;
  value_type: MetricValueType;
};

export enum MetricValueType {
  PerAppointment = 'PerAppointment',
  PerClient = 'PerClient',
  PerClinician = 'PerClinician',
  PerDay = 'PerDay',
  PerInvoice = 'PerInvoice',
  PerInvoiceItem = 'PerInvoiceItem',
  PerMonth = 'PerMonth',
  PerPatient = 'PerPatient',
  PerQuarter = 'PerQuarter',
  PerWeek = 'PerWeek',
  PerWorkDay = 'PerWorkDay',
  PerWorkWeek = 'PerWorkWeek',
  PerYear = 'PerYear',
  Total = 'Total'
}

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Void']>;
  addClinicToClient: Client;
  addPointsToLoyaltyMember: LoyaltyMember;
  addToAppWaitlist?: Maybe<Scalars['Void']>;
  addToEmailList?: Maybe<Scalars['Void']>;
  approveReschedule: Reschedule;
  clientCancelAppointment: Appointment;
  clientConfirmAppointment: Appointment;
  confirmAppointment: Scalars['Boolean'];
  createActionItem: ActionItem;
  createAnimal: Animal;
  createAppointment: Appointment;
  createAppointmentPrompt: AppointmentPrompt;
  createChat: Chat;
  createCheckIn: CheckIn;
  createClient: Client;
  createClientForm: ClientForm;
  createClinic: Clinic;
  createClinicAdmin: ClinicAdmin;
  createClinicFeatures: ClinicFeatures;
  createClinicService: Service;
  createClinicStats: ClinicStats;
  createClinician: Clinician;
  createClinicianService: ClinicianService;
  createConnectInstallation: ConnectInstallation;
  createCustomerSegment: CustomerSegment;
  createDailyHuddle: DailyHuddle;
  createDiagnosis: Diagnosis;
  createEntityReport: EntityReport;
  createFamily: Family;
  createForm: Form;
  createGoal: Goal;
  createLoyaltyMember: LoyaltyMember;
  createLoyaltyRedemption: LoyaltyRedemption;
  createLoyaltyReward: LoyaltyReward;
  createMessage: Message;
  createNotificationTemplate: NotificationTemplate;
  createOrganization: Organization;
  createOrganizationReport: OrganizationReport;
  createPatient: Patient;
  createPatientHistoryItem: PatientHistoryItem;
  createPatientRecord: PatientRecord;
  createPet: Pet;
  createPimsSettings: PimsSettings;
  createPmsApptType: PmsApptType;
  createPrescription: Prescription;
  createPrescriptionRequest: PrescriptionRequest;
  createPressItem: PressItem;
  createPrivateNote: PrivateNote;
  createProduct: Product;
  createReportClinic: ReportClinic;
  createReportMetric: ReportMetric;
  createReportTemplate: ReportTemplate;
  createReschedule: Reschedule;
  createReview: Review;
  createRoom: Room;
  createSchedulingRules: SchedulingRules;
  createService: Service;
  createTemplateClinic: TemplateClinic;
  createTransaction: Transaction;
  createTreatment: Treatment;
  createUser: User;
  createWidget: Widget;
  deleteActionItem?: Maybe<Scalars['Void']>;
  deleteAnimal?: Maybe<Scalars['Void']>;
  deleteAppointment?: Maybe<Scalars['Void']>;
  deleteAppointmentPrompt?: Maybe<Scalars['Void']>;
  deleteChat?: Maybe<Scalars['Void']>;
  deleteClient?: Maybe<Scalars['Void']>;
  deleteClinic?: Maybe<Scalars['Void']>;
  deleteClinicAdmin?: Maybe<Scalars['Void']>;
  deleteClinicFeatures?: Maybe<Scalars['Void']>;
  deleteClinicService?: Maybe<Scalars['Void']>;
  deleteClinician?: Maybe<Scalars['Void']>;
  deleteClinicianService?: Maybe<Scalars['Void']>;
  deleteConnectInstallation?: Maybe<Scalars['Void']>;
  deleteCustomerSegment?: Maybe<Scalars['Void']>;
  deleteDailyHuddle?: Maybe<Scalars['Void']>;
  deleteDiagnosis?: Maybe<Scalars['Void']>;
  deleteFamily?: Maybe<Scalars['Void']>;
  deleteGoal?: Maybe<Scalars['Void']>;
  deleteLoyaltyMember?: Maybe<Scalars['Void']>;
  deleteLoyaltyReward?: Maybe<Scalars['Void']>;
  deleteMessage?: Maybe<Scalars['Void']>;
  deleteNotificationTemplate?: Maybe<Scalars['Void']>;
  deleteOrganization?: Maybe<Scalars['Void']>;
  deleteOrganizationReport?: Maybe<Scalars['Void']>;
  deletePatient?: Maybe<Scalars['Void']>;
  deletePatientHistoryItem?: Maybe<Scalars['Void']>;
  deletePatientRecord?: Maybe<Scalars['Void']>;
  deletePet?: Maybe<Scalars['Void']>;
  deletePmsApptType?: Maybe<Scalars['Void']>;
  deletePrescription?: Maybe<Scalars['Void']>;
  deletePrescriptionRequest?: Maybe<Scalars['Void']>;
  deletePressItem?: Maybe<Scalars['Void']>;
  deletePrivateNote?: Maybe<Scalars['Void']>;
  deleteProduct?: Maybe<Scalars['Void']>;
  deleteReportClinic?: Maybe<Scalars['Void']>;
  deleteReportMetric?: Maybe<Scalars['Void']>;
  deleteReportTemplate?: Maybe<Scalars['Void']>;
  deleteReschedule?: Maybe<Scalars['Void']>;
  deleteReview?: Maybe<Scalars['Void']>;
  deleteRoom?: Maybe<Scalars['Void']>;
  deleteSchedulingRules?: Maybe<Scalars['Void']>;
  deleteService?: Maybe<Scalars['Void']>;
  deleteTemplateClinic?: Maybe<Scalars['Void']>;
  deleteTransaction?: Maybe<Scalars['Void']>;
  deleteTreatment?: Maybe<Scalars['Void']>;
  deleteWidget?: Maybe<Scalars['Void']>;
  makePrimaryClinicSpecies: ClinicSpecies;
  markAppointmentAsResolved: Appointment;
  memberRequestRedemption?: Maybe<Scalars['Void']>;
  refreshGoal: Goal;
  refreshGoalsForClinic: Array<Goal>;
  removeFromEmailList?: Maybe<Scalars['Void']>;
  sendAppointmentPrompt: AppointmentPrompt;
  submitAppointment: Appointment;
  syncAppointmentsForBookableTimes: Array<Appointment>;
  triggerServiceUpdateForClinic: Scalars['Boolean'];
  triggerSyncForClinic: Scalars['Boolean'];
  triggerUpdateServiceRestartForClinic: Scalars['Boolean'];
  updateActionItem: ActionItem;
  updateAnimal: Animal;
  updateAppointment: Appointment;
  updateAppointmentClientPatient: Appointment;
  updateAppointmentPrompt: AppointmentPrompt;
  updateBreed: Breed;
  updateChat: Chat;
  updateChckupMetadata?: Maybe<ChckupMetadata>;
  updateCheckIn: CheckIn;
  updateClient: Client;
  updateClientForm: ClientForm;
  updateClinic: Clinic;
  updateClinicAdmin: ClinicAdmin;
  updateClinicFeatures: ClinicFeatures;
  updateClinicService: Service;
  updateClinicSex: ClinicSex;
  updateClinicSpecies: ClinicSpecies;
  updateClinician: Clinician;
  updateClinicianService: ClinicianService;
  updateConnectInstallation: ConnectInstallation;
  updateCustomerSegment: CustomerSegment;
  updateDailyHuddle: DailyHuddle;
  updateDiagnosis: Diagnosis;
  updateFamily: Family;
  updateForm: Form;
  updateGoal: Goal;
  updateLoyaltyMember: LoyaltyMember;
  updateLoyaltyReward: LoyaltyReward;
  updateMessage: Message;
  updateNotificationTemplate: NotificationTemplate;
  updateOrganization: Organization;
  updateOrganizationReport: OrganizationReport;
  updatePatient: Patient;
  updatePatientHistoryItem: PatientHistoryItem;
  updatePatientRecord: PatientRecord;
  updatePayment: Payment;
  updatePet: Pet;
  updatePimsSettings: PimsSettings;
  updatePmsApptType: PmsApptType;
  updatePrescription: Prescription;
  updatePrescriptionRequest: PrescriptionRequest;
  updatePressItem: PressItem;
  updatePrivateNote: PrivateNote;
  updateProduct: Product;
  updateReportMetric: ReportMetric;
  updateReportTemplate: ReportTemplate;
  updateReschedule: Reschedule;
  updateRoom: Room;
  updateSchedulingRules: SchedulingRules;
  updateService: Service;
  updateTransaction: Transaction;
  updateTreatment: Treatment;
  updateUser: User;
  updateWidget: Widget;
  uploadAttachment?: Maybe<Scalars['Void']>;
  verifyUserPhone?: Maybe<User>;
};


export type MutationAddClinicToClientArgs = {
  clientId: Scalars['ID'];
  clinicId: Scalars['ID'];
};


export type MutationAddPointsToLoyaltyMemberArgs = {
  id: Scalars['ID'];
  points: Scalars['NonNegativeInt'];
};


export type MutationAddToAppWaitlistArgs = {
  data: PhoneInput;
};


export type MutationAddToEmailListArgs = {
  email: Scalars['String'];
};


export type MutationApproveRescheduleArgs = {
  id: Scalars['ID'];
};


export type MutationClientCancelAppointmentArgs = {
  id: Scalars['ID'];
};


export type MutationClientConfirmAppointmentArgs = {
  id: Scalars['ID'];
};


export type MutationConfirmAppointmentArgs = {
  id: Scalars['ID'];
};


export type MutationCreateActionItemArgs = {
  data: CreateActionItemInput;
};


export type MutationCreateAnimalArgs = {
  data: CreateAnimalInput;
};


export type MutationCreateAppointmentArgs = {
  data: CreateAppointmentInput;
};


export type MutationCreateAppointmentPromptArgs = {
  data: CreateAppointmentPromptInput;
};


export type MutationCreateChatArgs = {
  data: CreateChatInput;
};


export type MutationCreateCheckInArgs = {
  data: CreateCheckInInput;
};


export type MutationCreateClientArgs = {
  data: CreateClientInput;
};


export type MutationCreateClientFormArgs = {
  data: CreateClientFormInput;
};


export type MutationCreateClinicArgs = {
  data: CreateClinicInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateClinicAdminArgs = {
  data: CreateClinicAdminInput;
};


export type MutationCreateClinicFeaturesArgs = {
  data: ClinicFeaturesInput;
};


export type MutationCreateClinicServiceArgs = {
  clinicId: Scalars['ID'];
  data: CreateServiceInput;
};


export type MutationCreateClinicStatsArgs = {
  clinicId: Scalars['ID'];
};


export type MutationCreateClinicianArgs = {
  data: CreateClinicianInput;
};


export type MutationCreateClinicianServiceArgs = {
  data: CreateClinicianServiceInput;
};


export type MutationCreateConnectInstallationArgs = {
  clinicId: Scalars['ID'];
  data: CreateConnectInstallationInput;
  installationId: Scalars['ID'];
};


export type MutationCreateCustomerSegmentArgs = {
  data: CreateCustomerSegmentInput;
};


export type MutationCreateDailyHuddleArgs = {
  clinicId: Scalars['ID'];
  data: CreateDailyHuddleInput;
};


export type MutationCreateDiagnosisArgs = {
  data: CreateDiagnosisInput;
};


export type MutationCreateEntityReportArgs = {
  data: CreateEntityReportInput;
};


export type MutationCreateFamilyArgs = {
  data: CreateFamilyInput;
};


export type MutationCreateFormArgs = {
  data: CreateFormInput;
};


export type MutationCreateGoalArgs = {
  clinicId: Scalars['ID'];
  data: CreateGoalInput;
};


export type MutationCreateLoyaltyMemberArgs = {
  data: CreateLoyaltyMemberInput;
};


export type MutationCreateLoyaltyRedemptionArgs = {
  data: CreateLoyaltyRedemptionInput;
};


export type MutationCreateLoyaltyRewardArgs = {
  data: CreateLoyaltyRewardInput;
};


export type MutationCreateMessageArgs = {
  chatId: Scalars['ID'];
  data: CreateMessageInput;
};


export type MutationCreateNotificationTemplateArgs = {
  data: CreateNotificationTemplateInput;
};


export type MutationCreateOrganizationArgs = {
  data: CreateOrganizationInput;
};


export type MutationCreateOrganizationReportArgs = {
  data: CreateOrganizationReportInput;
};


export type MutationCreatePatientArgs = {
  data: CreatePatientInput;
};


export type MutationCreatePatientHistoryItemArgs = {
  data: CreatePatientHistoryItemInput;
};


export type MutationCreatePatientRecordArgs = {
  data: CreatePatientRecordInput;
};


export type MutationCreatePetArgs = {
  data: CreatePetInput;
};


export type MutationCreatePimsSettingsArgs = {
  data: CreatePimsSettingsInput;
};


export type MutationCreatePmsApptTypeArgs = {
  clinicId: Scalars['ID'];
  data: CreatePmsApptTypeInput;
};


export type MutationCreatePrescriptionArgs = {
  data: CreatePrescriptionInput;
};


export type MutationCreatePrescriptionRequestArgs = {
  data: CreatePrescriptionRequestInput;
};


export type MutationCreatePressItemArgs = {
  data: CreatePressItemInput;
};


export type MutationCreatePrivateNoteArgs = {
  data: PrivateNoteInput;
  patientRecordId: Scalars['ID'];
};


export type MutationCreateProductArgs = {
  data: CreateProductInput;
};


export type MutationCreateReportClinicArgs = {
  data: CreateReportClinicInput;
};


export type MutationCreateReportMetricArgs = {
  data: CreateReportMetricInput;
};


export type MutationCreateReportTemplateArgs = {
  data: CreateReportTemplateInput;
};


export type MutationCreateRescheduleArgs = {
  data: CreateRescheduleInput;
};


export type MutationCreateReviewArgs = {
  data: CreateReviewInput;
};


export type MutationCreateRoomArgs = {
  data: CreateRoomInput;
};


export type MutationCreateSchedulingRulesArgs = {
  data: CreateSchedulingRulesInput;
};


export type MutationCreateServiceArgs = {
  data: CreateServiceInput;
};


export type MutationCreateTemplateClinicArgs = {
  data: CreateTemplateClinicInput;
};


export type MutationCreateTransactionArgs = {
  data: CreateTransactionInput;
};


export type MutationCreateTreatmentArgs = {
  clinicId: Scalars['ID'];
  data: CreateTreatmentInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
  email: Scalars['String'];
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};


export type MutationCreateWidgetArgs = {
  data: CreateWidgetInput;
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAnimalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAppointmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAppointmentPromptArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChatArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicAdminArgs = {
  clinicId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDeleteClinicFeaturesArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicServiceArgs = {
  clinicId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteClinicianArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClinicianServiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConnectInstallationArgs = {
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
};


export type MutationDeleteCustomerSegmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDailyHuddleArgs = {
  clinicId: Scalars['ID'];
  dailyHuddleId: Scalars['ID'];
};


export type MutationDeleteDiagnosisArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFamilyArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGoalArgs = {
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
};


export type MutationDeleteLoyaltyMemberArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLoyaltyRewardArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteMessageArgs = {
  chatId: Scalars['ID'];
  messageId: Scalars['ID'];
};


export type MutationDeleteNotificationTemplateArgs = {
  notificationTemplateId: Scalars['ID'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationReportArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePatientArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePatientHistoryItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePatientRecordArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePetArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePmsApptTypeArgs = {
  clinicId: Scalars['ID'];
  pmsApptTypeId: Scalars['ID'];
};


export type MutationDeletePrescriptionArgs = {
  prescriptionId: Scalars['ID'];
};


export type MutationDeletePrescriptionRequestArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePressItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePrivateNoteArgs = {
  id: Scalars['ID'];
  patientRecordId: Scalars['ID'];
};


export type MutationDeleteProductArgs = {
  productId: Scalars['ID'];
};


export type MutationDeleteReportClinicArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReportMetricArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReportTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRescheduleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRoomArgs = {
  roomId: Scalars['ID'];
};


export type MutationDeleteSchedulingRulesArgs = {
  clinicId: Scalars['ID'];
  schedulingRulesId: Scalars['ID'];
};


export type MutationDeleteServiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTemplateClinicArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTransactionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTreatmentArgs = {
  clinicId: Scalars['ID'];
  treatmentId: Scalars['ID'];
};


export type MutationDeleteWidgetArgs = {
  id: Scalars['ID'];
};


export type MutationMakePrimaryClinicSpeciesArgs = {
  clinicId: Scalars['ID'];
  speciesId: Scalars['ID'];
};


export type MutationMarkAppointmentAsResolvedArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<ResolveReason>;
};


export type MutationMemberRequestRedemptionArgs = {
  memberId: Scalars['ID'];
  rewardId: Scalars['ID'];
};


export type MutationRefreshGoalArgs = {
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
};


export type MutationRefreshGoalsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type MutationRemoveFromEmailListArgs = {
  email: Scalars['String'];
};


export type MutationSendAppointmentPromptArgs = {
  data: CreateAppointmentPromptInput;
};


export type MutationSubmitAppointmentArgs = {
  data: SubmitAppointmentInput;
};


export type MutationSyncAppointmentsForBookableTimesArgs = {
  clinicId: Scalars['ID'];
};


export type MutationTriggerServiceUpdateForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type MutationTriggerSyncForClinicArgs = {
  clinicId: Scalars['ID'];
  isFullSync: Scalars['Boolean'];
};


export type MutationTriggerUpdateServiceRestartForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type MutationUpdateActionItemArgs = {
  data: UpdateActionItemInput;
  id: Scalars['ID'];
};


export type MutationUpdateAnimalArgs = {
  data: UpdateAnimalInput;
  id: Scalars['ID'];
};


export type MutationUpdateAppointmentArgs = {
  data: UpdateAppointmentInput;
  id: Scalars['ID'];
};


export type MutationUpdateAppointmentClientPatientArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  patientId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateAppointmentPromptArgs = {
  data: UpdateAppointmentPromptInput;
  id: Scalars['ID'];
};


export type MutationUpdateBreedArgs = {
  breedId: Scalars['String'];
  clinicId: Scalars['ID'];
  data: UpdateBreedInput;
};


export type MutationUpdateChatArgs = {
  data: UpdateChatInput;
  id: Scalars['ID'];
};


export type MutationUpdateChckupMetadataArgs = {
  data: ChckupMetadataInput;
};


export type MutationUpdateCheckInArgs = {
  data: UpdateCheckInInput;
  id: Scalars['ID'];
};


export type MutationUpdateClientArgs = {
  data: UpdateClientInput;
  id: Scalars['ID'];
};


export type MutationUpdateClientFormArgs = {
  data: UpdateClientFormInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicArgs = {
  data: UpdateClinicInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicAdminArgs = {
  clinicId: Scalars['ID'];
  data: UpdateClinicAdminInput;
  userId: Scalars['ID'];
};


export type MutationUpdateClinicFeaturesArgs = {
  data: ClinicFeaturesInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicServiceArgs = {
  clinicId: Scalars['ID'];
  data: UpdateServiceInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicSexArgs = {
  data: UpdateClinicSexInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicSpeciesArgs = {
  clinicId: Scalars['ID'];
  data: UpdateClinicSpeciesInput;
  speciesId: Scalars['ID'];
};


export type MutationUpdateClinicianArgs = {
  data: UpdateClinicianInput;
  id: Scalars['ID'];
};


export type MutationUpdateClinicianServiceArgs = {
  data: UpdateClinicianServiceInput;
  id: Scalars['ID'];
};


export type MutationUpdateConnectInstallationArgs = {
  clinicId: Scalars['ID'];
  data: UpdateConnectInstallationInput;
  installationId: Scalars['ID'];
};


export type MutationUpdateCustomerSegmentArgs = {
  data: UpdateCustomerSegmentInput;
  id: Scalars['ID'];
};


export type MutationUpdateDailyHuddleArgs = {
  clinicId: Scalars['ID'];
  dailyHuddleId: Scalars['ID'];
  data: UpdateDailyHuddleInput;
};


export type MutationUpdateDiagnosisArgs = {
  data: UpdateDiagnosisInput;
  id: Scalars['ID'];
};


export type MutationUpdateFamilyArgs = {
  data: UpdateFamilyInput;
  id: Scalars['ID'];
};


export type MutationUpdateFormArgs = {
  data: UpdateFormInput;
  id: Scalars['ID'];
};


export type MutationUpdateGoalArgs = {
  clinicId: Scalars['ID'];
  data: UpdateGoalInput;
  goalId: Scalars['ID'];
};


export type MutationUpdateLoyaltyMemberArgs = {
  data: UpdateLoyaltyMemberInput;
  id: Scalars['ID'];
};


export type MutationUpdateLoyaltyRewardArgs = {
  data: UpdateLoyaltyRewardInput;
  id: Scalars['ID'];
};


export type MutationUpdateMessageArgs = {
  chatId: Scalars['ID'];
  data: UpdateMessageInput;
  messageId: Scalars['ID'];
};


export type MutationUpdateNotificationTemplateArgs = {
  data: UpdateNotificationTemplateInput;
  notificationTemplateId: Scalars['ID'];
};


export type MutationUpdateOrganizationArgs = {
  data: UpdateOrganizationInput;
  id: Scalars['ID'];
};


export type MutationUpdateOrganizationReportArgs = {
  data: UpdateOrganizationReportInput;
  id: Scalars['ID'];
};


export type MutationUpdatePatientArgs = {
  data: UpdatePatientInput;
  id: Scalars['ID'];
};


export type MutationUpdatePatientHistoryItemArgs = {
  data: UpdatePatientHistoryItemInput;
  id: Scalars['ID'];
};


export type MutationUpdatePatientRecordArgs = {
  data: UpdatePatientRecordInput;
  id: Scalars['ID'];
};


export type MutationUpdatePaymentArgs = {
  data: UpdatePaymentInput;
  id: Scalars['ID'];
};


export type MutationUpdatePetArgs = {
  data: UpdatePetInput;
  id: Scalars['ID'];
};


export type MutationUpdatePimsSettingsArgs = {
  clinicId: Scalars['ID'];
  data: UpdatePimsSettingsInput;
};


export type MutationUpdatePmsApptTypeArgs = {
  clinicId: Scalars['ID'];
  data: UpdatePmsApptTypeInput;
  pmsApptTypeId: Scalars['ID'];
};


export type MutationUpdatePrescriptionArgs = {
  data: UpdatePrescriptionInput;
  prescriptionId: Scalars['ID'];
};


export type MutationUpdatePrescriptionRequestArgs = {
  data: UpdatePrescriptionRequestInput;
  id: Scalars['ID'];
};


export type MutationUpdatePressItemArgs = {
  data: UpdatePressItemInput;
  id: Scalars['ID'];
};


export type MutationUpdatePrivateNoteArgs = {
  data: PrivateNoteInput;
  id: Scalars['ID'];
  patientRecordId: Scalars['ID'];
};


export type MutationUpdateProductArgs = {
  data: UpdateProductInput;
  productId: Scalars['ID'];
};


export type MutationUpdateReportMetricArgs = {
  data: UpdateReportMetricInput;
  id: Scalars['ID'];
};


export type MutationUpdateReportTemplateArgs = {
  data: UpdateReportTemplateInput;
  id: Scalars['ID'];
};


export type MutationUpdateRescheduleArgs = {
  data: UpdateRescheduleInput;
  id: Scalars['ID'];
};


export type MutationUpdateRoomArgs = {
  data: UpdateRoomInput;
  roomId: Scalars['ID'];
};


export type MutationUpdateSchedulingRulesArgs = {
  clinicId: Scalars['ID'];
  data: UpdateSchedulingRulesInput;
  schedulingRulesId: Scalars['ID'];
};


export type MutationUpdateServiceArgs = {
  data: UpdateServiceInput;
  id: Scalars['ID'];
};


export type MutationUpdateTransactionArgs = {
  data: UpdateTransactionInput;
  id: Scalars['ID'];
};


export type MutationUpdateTreatmentArgs = {
  clinicId: Scalars['ID'];
  data: UpdateTreatmentInput;
  treatmentId: Scalars['ID'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['ID'];
};


export type MutationUpdateWidgetArgs = {
  data: UpdateWidgetInput;
  id: Scalars['ID'];
};


export type MutationUploadAttachmentArgs = {
  clinicId: Scalars['ID'];
  data: AttachmentInput;
};


export type MutationVerifyUserPhoneArgs = {
  code: Scalars['String'];
  id: Scalars['ID'];
  phone: Scalars['String'];
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  body?: Maybe<Scalars['String']>;
  clinic: Clinic;
  created_at: Scalars['NonNegativeInt'];
  cta_text?: Maybe<Scalars['String']>;
  cta_url?: Maybe<Scalars['String']>;
  customer_segment: CustomerSegment;
  every_x_hours: Scalars['NonNegativeInt'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_marketing: Scalars['Boolean'];
  is_system: Scalars['Boolean'];
  message_methods: Array<MessageMethod>;
  name: Scalars['String'];
  notif_attachments?: Maybe<Array<Attachment>>;
  send_time_minutes?: Maybe<Scalars['NonNegativeInt']>;
  sms_body?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  type: NotificationType;
  updated_at: Scalars['NonNegativeInt'];
};

export enum NotificationTrigger {
  Recurring = 'Recurring'
}

export enum NotificationType {
  Confirmation = 'Confirmation',
  Custom = 'Custom',
  Message1 = 'Message1',
  Message2 = 'Message2',
  Message3 = 'Message3',
  Review = 'Review'
}

export enum OnlyModifierEnum {
  Client = 'Client',
  Clinician = 'Clinician',
  FixedStatus = 'FixedStatus',
  Gender = 'Gender',
  Patient = 'Patient',
  Room = 'Room',
  Service = 'Service',
  Species = 'Species',
  Time = 'Time'
}

export type OrderByInput = {
  column: Scalars['String'];
  foreignTable?: InputMaybe<Scalars['String']>;
  isAscending?: InputMaybe<Scalars['Boolean']>;
};

export type Organization = {
  __typename?: 'Organization';
  admins: Array<User>;
  clinics: Array<Clinic>;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export type OrganizationAnalytics = {
  __typename?: 'OrganizationAnalytics';
  analytics: ClinicAnalytics;
  clinic: Clinic;
};

export type OrganizationAnalyticsNumbers = {
  __typename?: 'OrganizationAnalyticsNumbers';
  analytic_numbers: OrganizationClinicAnalyticsNumbers;
  clinic: Clinic;
};

export type OrganizationAnalyticsNumbersByMonth = {
  __typename?: 'OrganizationAnalyticsNumbersByMonth';
  analytic_numbers: Array<AnalyticsNumbersByMonth>;
  clinic: Clinic;
};

export type OrganizationClinicAnalyticsNumbers = {
  __typename?: 'OrganizationClinicAnalyticsNumbers';
  appointments_count: IntPercentile;
  forward_scheduled_patients_count: IntPercentile;
  new_appointments_count: IntPercentile;
  new_clients_count: IntPercentile;
  new_patients_count: IntPercentile;
  no_show_count: IntPercentile;
  revenue: FloatPercentile;
  revenue_per_appointment: FloatPercentile;
  schedule_efficiency: FloatPercentile;
  transactions_count: IntPercentile;
};

export type OrganizationReport = {
  __typename?: 'OrganizationReport';
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  entity_reports: Array<EntityReport>;
  entity_structure: Array<ReportEntity>;
  id: Scalars['ID'];
  is_hidden: Scalars['Boolean'];
  name: Scalars['String'];
  organization: Organization;
  preferred_view_type: ReportViewType;
  report_clinics: Array<ReportClinic>;
  report_metrics: Array<ReportMetric>;
  report_template?: Maybe<ReportTemplate>;
  time_params: TimeParams;
  updated_at: Scalars['Timestamp'];
};

export type OrganizationRevenueByMonth = {
  __typename?: 'OrganizationRevenueByMonth';
  clinic: Clinic;
  revenue: Array<RevenueByMonth>;
};

export type OrganizationScheduleEfficiency = {
  __typename?: 'OrganizationScheduleEfficiency';
  average: Scalars['Float'];
  per_clinic: Array<ClinicsScheduleEfficiency>;
};

export type OverduePatient = {
  __typename?: 'OverduePatient';
  lastAppointment: Appointment;
  patient: Patient;
};

export type Patient = {
  __typename?: 'Patient';
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['NonNegativeInt']>;
  breed?: Maybe<Scalars['String']>;
  client_pms_id?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  clinic_breed?: Maybe<Breed>;
  clinic_species?: Maybe<ClinicSpecies>;
  created_at: Scalars['Timestamp'];
  fixed_status?: Maybe<FixedStatus>;
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_deceased?: Maybe<Scalars['Boolean']>;
  last_appointment?: Maybe<Appointment>;
  last_appt_time?: Maybe<Scalars['NonNegativeInt']>;
  name?: Maybe<Scalars['String']>;
  next_appointment?: Maybe<Appointment>;
  next_appt_time?: Maybe<Scalars['NonNegativeInt']>;
  origin?: Maybe<EntityOrigin>;
  owner?: Maybe<Client>;
  pet?: Maybe<Pet>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_created_at?: Maybe<Scalars['NonNegativeInt']>;
  pms_id?: Maybe<Scalars['String']>;
  species_pms_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
  weight?: Maybe<Scalars['NonNegativeFloat']>;
};

export type PatientHistoryItem = {
  __typename?: 'PatientHistoryItem';
  appointment?: Maybe<Appointment>;
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  computed_id: Scalars['String'];
  created_at: Scalars['Timestamp'];
  diagnosis?: Maybe<Diagnosis>;
  id: Scalars['ID'];
  issued_at: Scalars['Timestamp'];
  patient: Patient;
  pms_id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
  updated_at: Scalars['Timestamp'];
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  patient_birthday?: Maybe<Scalars['NonNegativeInt']>;
  patient_breed?: Maybe<Scalars['String']>;
  patient_clinic_breed?: Maybe<Scalars['ID']>;
  patient_clinic_species?: Maybe<Scalars['ID']>;
  patient_gender?: Maybe<AnimalGender>;
  patient_is_fixed?: Maybe<Scalars['Boolean']>;
  patient_name?: Maybe<Scalars['String']>;
};

export type PatientInfoInput = {
  patient_birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  patient_breed?: InputMaybe<Scalars['String']>;
  patient_clinic_breed?: InputMaybe<Scalars['ID']>;
  patient_clinic_species?: InputMaybe<Scalars['ID']>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_is_fixed?: InputMaybe<Scalars['Boolean']>;
  patient_name?: InputMaybe<Scalars['String']>;
};

export type PatientRecord = {
  __typename?: 'PatientRecord';
  appointment?: Maybe<Appointment>;
  assessment?: Maybe<Scalars['String']>;
  assisting_clinicians?: Maybe<Array<Scalars['String']>>;
  client?: Maybe<Client>;
  clinic?: Maybe<Clinic>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  date?: Maybe<Scalars['NonNegativeInt']>;
  id: Scalars['ID'];
  master_problem_list?: Maybe<Scalars['String']>;
  objective?: Maybe<Scalars['String']>;
  patient: Patient;
  plan?: Maybe<Scalars['String']>;
  public_notes?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  subjective?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export enum PatientTypeEnum {
  New = 'New',
  Returning = 'Returning'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['PositiveInt'];
  appointment?: Maybe<Appointment>;
  category: PurchaseCategory;
  client: Client;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  currency: Scalars['Currency'];
  date: Scalars['NonNegativeInt'];
  errors: Array<PaymentError>;
  id: Scalars['ID'];
  payment_method_id?: Maybe<Scalars['String']>;
  processing_fee: Scalars['NonNegativeInt'];
  sales_tax: Scalars['NonNegativeInt'];
  service_fee: Scalars['NonNegativeInt'];
  status: PaymentStatus;
  stripe_payment_intent_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type PaymentErrorInput = {
  code?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export enum PaymentStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

export enum PeriodType {
  Day = 'Day',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Pet = {
  __typename?: 'Pet';
  avatar_url?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['NonNegativeInt']>;
  breed?: Maybe<Scalars['String']>;
  created_at: Scalars['Timestamp'];
  family?: Maybe<Family>;
  fixed_status?: Maybe<FixedStatus>;
  gender?: Maybe<AnimalGender>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  patients: Array<Patient>;
  species?: Maybe<Species>;
  updated_at: Scalars['Timestamp'];
  weight?: Maybe<Scalars['NonNegativeFloat']>;
};

export type PhoneInput = {
  is_android?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
};

export type PimsSettings = {
  __typename?: 'PimsSettings';
  access_token?: Maybe<Scalars['String']>;
  access_token_expiration?: Maybe<Scalars['NonNegativeInt']>;
  additional_key?: Maybe<Scalars['String']>;
  api_clinic_id?: Maybe<Scalars['String']>;
  api_key?: Maybe<Scalars['String']>;
  api_subdomain?: Maybe<Scalars['String']>;
  clinic: Clinic;
  cookie: Array<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  pims_version?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  practice_key?: Maybe<Scalars['String']>;
  pulse_ar_report_id?: Maybe<Scalars['String']>;
  pulse_sales_report_id?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  request_verification_token?: Maybe<Scalars['String']>;
  user_key?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type PmsApptType = {
  __typename?: 'PmsApptType';
  clinic: Clinic;
  color?: Maybe<Scalars['HexColorCode']>;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  pms_id: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export enum PracticeManagementSystem {
  AvImark = 'AVImark',
  Cornerstone = 'Cornerstone',
  Daysmart = 'Daysmart',
  EzyVet = 'EzyVet',
  ImpromedInfinity = 'ImpromedInfinity',
  Provet = 'Provet',
  Pulse = 'Pulse',
  Rhapsody = 'Rhapsody',
  Shepherd = 'Shepherd'
}

export type Prescription = {
  __typename?: 'Prescription';
  clinic: Clinic;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  last_refill_time?: Maybe<Scalars['NonNegativeInt']>;
  name: Scalars['String'];
  patient: Patient;
  pms_created_at: Scalars['Timestamp'];
  pms_id: Scalars['String'];
  product?: Maybe<Product>;
  product_name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['NonNegativeFloat']>;
  updated_at: Scalars['Timestamp'];
};

export type PrescriptionRequest = {
  __typename?: 'PrescriptionRequest';
  clinic: Clinic;
  clinic_notes?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  patient: Patient;
  pickup_date: Scalars['Timestamp'];
  quantity?: Maybe<Scalars['String']>;
  status: PrescriptionRequestStatus;
  updated_at: Scalars['Timestamp'];
  user: User;
};

export enum PrescriptionRequestStatus {
  Denied = 'Denied',
  Fulfilled = 'Fulfilled',
  Pending = 'Pending',
  PickedUp = 'PickedUp'
}

export type PressItem = {
  __typename?: 'PressItem';
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Link>>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export type PrivateNote = {
  __typename?: 'PrivateNote';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  notes: Scalars['String'];
  updated_at: Scalars['Timestamp'];
};

export type PrivateNoteInput = {
  clinic: Scalars['ID'];
  notes: Scalars['String'];
};

export type Product = {
  __typename?: 'Product';
  category: ProductCategory;
  clinic: Clinic;
  code?: Maybe<Scalars['String']>;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  pims_category?: Maybe<Scalars['String']>;
  pms_id: Scalars['String'];
  price: Scalars['NonNegativeInt'];
  updated_at: Scalars['Timestamp'];
};

export enum ProductCategory {
  Food = 'Food',
  Medicine = 'Medicine',
  Other = 'Other',
  Service = 'Service',
  Vaccines = 'Vaccines'
}

export type PublicAppointmentTime = {
  __typename?: 'PublicAppointmentTime';
  clinician_id?: Maybe<Scalars['ID']>;
  is_time_block?: Maybe<Scalars['Boolean']>;
  minutes: Scalars['NonNegativeInt'];
  room_id?: Maybe<Scalars['ID']>;
  start_time: Scalars['NonNegativeInt'];
};

export enum PurchaseCategory {
  Appointment = 'Appointment',
  Prescription = 'Prescription'
}

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['Void']>;
  actionItem: ActionItem;
  allAnimals: Array<Animal>;
  allAppointmentPrompts: Array<AppointmentPrompt>;
  allAppointments: Array<Appointment>;
  allClinicians: Array<Clinician>;
  allClinics: Array<Clinic>;
  allOrganizations: Array<Organization>;
  allPatients: Array<Patient>;
  allPressItems: Array<PressItem>;
  allReschedules: Array<Reschedule>;
  allServices: Array<Service>;
  allServicesByClinicId: Array<Service>;
  allWidgets: Array<Widget>;
  animal: Animal;
  appointment: Appointment;
  appointmentPrompt: AppointmentPrompt;
  appointmentsByClient: Array<Appointment>;
  appointmentsByClinicAndRange: Array<Appointment>;
  appointmentsByUser: Array<Appointment>;
  appointmentsWithinRange: Array<Appointment>;
  breed: Breed;
  chat: Chat;
  checkEmailList?: Maybe<Scalars['Boolean']>;
  checkExistingClient?: Maybe<Array<Client>>;
  checkExistingClients: Array<Client>;
  checkExistingPatient?: Maybe<Patient>;
  checkForUserByEmail?: Maybe<Array<User>>;
  checkIfServerRunning: Scalars['Boolean'];
  checkIn: CheckIn;
  client: Client;
  clientForm: ClientForm;
  clinic: Clinic;
  clinicAnalytics: ClinicAnalytics;
  clinicAnalyticsNumbers: AnalyticsNumbers;
  clinicBySlug: Clinic;
  clinicFeatures: ClinicFeatures;
  clinicStats: ClinicStats;
  clinician: Clinician;
  cloudClinics: Array<Clinic>;
  connectInstallation: ConnectInstallation;
  countActionItems: Scalars['NonNegativeInt'];
  countAppointments: Scalars['NonNegativeInt'];
  countBreeds: Scalars['NonNegativeInt'];
  countChats: Scalars['NonNegativeInt'];
  countClientForms: Scalars['NonNegativeInt'];
  countClients: Scalars['NonNegativeInt'];
  countClinicSexes: Scalars['NonNegativeInt'];
  countClinicSpecies: Scalars['NonNegativeInt'];
  countClinicians: Scalars['NonNegativeInt'];
  countClinics: Scalars['NonNegativeInt'];
  countDiagnoses: Scalars['NonNegativeInt'];
  countForms: Scalars['NonNegativeInt'];
  countInvoiceItems: Scalars['NonNegativeInt'];
  countInvoices: Scalars['NonNegativeInt'];
  countLoyaltyMembers: Scalars['NonNegativeInt'];
  countLoyaltyRedemptions: Scalars['NonNegativeInt'];
  countLoyaltyRewards: Scalars['NonNegativeInt'];
  countMessages: Scalars['NonNegativeInt'];
  countOrganizationReports: Scalars['NonNegativeInt'];
  countOrganizations: Scalars['NonNegativeInt'];
  countOverduePatients: Scalars['NonNegativeInt'];
  countPatientHistoryItems: Scalars['NonNegativeInt'];
  countPatients: Scalars['NonNegativeInt'];
  countPayments: Scalars['NonNegativeInt'];
  countPrescriptions: Scalars['NonNegativeInt'];
  countProducts: Scalars['NonNegativeInt'];
  countReportTemplates: Scalars['NonNegativeInt'];
  countReschedules: Scalars['NonNegativeInt'];
  countReviews: Scalars['NonNegativeInt'];
  countRooms: Scalars['NonNegativeInt'];
  countServices: Scalars['NonNegativeInt'];
  countUsers: Scalars['NonNegativeInt'];
  customerSegment: CustomerSegment;
  dailyHuddle: DailyHuddle;
  diagnosis: Diagnosis;
  family?: Maybe<Family>;
  filterAppointments: Array<Appointment>;
  form: Form;
  getAccountsReceivable: Scalars['Float'];
  getAnalyticsNumbersByMonthsForClinic: Array<AnalyticsNumbersByMonth>;
  getAnalyticsNumbersByMonthsForOrganization: Array<OrganizationAnalyticsNumbersByMonth>;
  getAppointmentCountByWidgetSource: Scalars['NonNegativeInt'];
  getAverageRatingForRecentReviews: ReviewTotals;
  getBookingQuestionsFromSchedulingRules: Array<BookingQuestions>;
  getBreedsByClinic: Array<Breed>;
  getChatByClientAndClinic?: Maybe<Chat>;
  getChatsByClientId: Array<Chat>;
  getChatsByClinicId: Array<Chat>;
  getChckupMetadata?: Maybe<ChckupMetadata>;
  getCheckInsByClinic: Array<CheckIn>;
  getCheckInsByUser: Array<CheckIn>;
  getClientCountForClinic: Scalars['NonNegativeInt'];
  getClientFormsForClinic: Array<ClientForm>;
  getClientsByCustomerSegment: Array<CustSegResult>;
  getClientsByCustomerSegmentRPC: CustSegRpcResult;
  getClientsCountByCustomerSegment: Scalars['NonNegativeInt'];
  getClientsForClinic: Array<Client>;
  getClientsWithNegativeBalancesForClinic: Array<Client>;
  getClientsWithOverduePatients: Array<ClientWithOverduePatient>;
  getClientsWithoutApptOverDaysForClinic: Array<Client>;
  getClinicAdmin: ClinicAdmin;
  getClinicAdminsByClinic: Array<ClinicAdmin>;
  getClinicAdminsByUser: Array<ClinicAdmin>;
  getClinicSpeciesByClinic: Array<ClinicSpecies>;
  getClinicianService: ClinicianService;
  getClinicianServicesByClinic: Array<ClinicianService>;
  getClinicianServicesByClinician: Array<ClinicianService>;
  getClinicianServicesByService: Array<ClinicianService>;
  getCliniciansByClinic: Array<Clinician>;
  getCliniciansForBooking: Array<Clinician>;
  getClinics: Array<Clinic>;
  getClinicsForOrganization?: Maybe<Array<Clinic>>;
  getClinicsForUserAdmin: Array<Clinic>;
  getConnectInstallationsByClinic: Array<ConnectInstallation>;
  getCustomerSegmentsForClinic: Array<CustomerSegment>;
  getDailyHuddlesByClinic: Array<DailyHuddle>;
  getEmailList?: Maybe<Array<Scalars['String']>>;
  getFeaturedClinics: Array<Clinic>;
  getFormsForClinic: Array<Form>;
  getGoalsByClinic: Array<Goal>;
  getGoalsByClinicAndStatus: Array<Goal>;
  getLastServerHeartbeatForClinic?: Maybe<HeartbeatResponse>;
  getLoyaltyMembersForClinic: Array<LoyaltyMember>;
  getLoyaltyRedemptionsForClinic: Array<LoyaltyRedemption>;
  getLoyaltyRewardsForClinic: Array<LoyaltyReward>;
  getMessagesByChatId: Array<Message>;
  getNewAppointmentsForClinic: Scalars['NonNegativeInt'];
  getNewClientsForClinic: Scalars['NonNegativeInt'];
  getNewPatientsForClinic: Scalars['NonNegativeInt'];
  getNextAvailableDay?: Maybe<Scalars['NonNegativeInt']>;
  getNotificationTemplatesByClinicId: Array<NotificationTemplate>;
  getNumberOfCompletedAppointmentsForTimeRange: Scalars['NonNegativeInt'];
  getOverduePatients: Array<OverduePatient>;
  getPatientRecordsForPatient: Array<PatientRecord>;
  getPatientsByClient: Array<Patient>;
  getPatientsByClients: Array<Patient>;
  getPatientsForClinic: Array<Patient>;
  getPatientsWithoutApptOverDaysForClinic: Array<Patient>;
  getPatientsWithoutRescheduledAppointmentsForTimeRange: Array<Patient>;
  getPaymentsByClinicId: Array<Payment>;
  getPetsByUserId: Array<Pet>;
  getPmsApptTypesForClinic: Array<PmsApptType>;
  getPrescriptionRequestsForClinic: Array<PrescriptionRequest>;
  getPrescriptionRequestsForPatient: Array<PrescriptionRequest>;
  getPrescriptionRequestsForUser: Array<PrescriptionRequest>;
  getPrimaryClinicSpecies?: Maybe<ClinicSpecies>;
  getPrivateNotes: Array<PrivateNote>;
  getRevenueByMonthsForClinic: Array<RevenueByMonth>;
  getRevenueByMonthsForOrganization: Array<OrganizationRevenueByMonth>;
  getRevenueForTimeRange: Scalars['Float'];
  getRevenuesByClinicianForTimeRange: Array<RevenueGroup>;
  getRevenuesByTypeForTimeRange: Array<RevenueGroup>;
  getReviewsForClinic: Array<Review>;
  getRoomsByClinic: Array<Room>;
  getRoomsForBooking: Array<Room>;
  getServicesForBooking: Array<Service>;
  getSumOfInvoices: Scalars['Int'];
  getSyncedCloudClinics: Array<Clinic>;
  getTimeSlotsForClinicForDay: ScheduleData;
  getTimeSlotsForSchedulingDay: Array<TimeSlot>;
  getTotalRevenueForClinicBetweenTimes: Scalars['Float'];
  getTransactionsByClinic: Array<Transaction>;
  getTransactionsByClinicAndRange: Array<Transaction>;
  getTreatmentsByClinic: Array<Treatment>;
  getWidgetsByClinic: Array<Widget>;
  getWidgetsByOrganization?: Maybe<Array<Widget>>;
  goal: Goal;
  invoice: Invoice;
  invoiceItem: InvoiceItem;
  loyaltyMember: LoyaltyMember;
  loyaltyRedemption: LoyaltyRedemption;
  loyaltyReward: LoyaltyReward;
  notificationTemplate: NotificationTemplate;
  organization: Organization;
  organizationAnalytics: Array<OrganizationAnalytics>;
  organizationAnalyticsNumbers: Array<OrganizationAnalyticsNumbers>;
  organizationReport: OrganizationReport;
  organizationScheduleEfficiency: OrganizationScheduleEfficiency;
  patient: Patient;
  patientHistoryItem: PatientHistoryItem;
  patientRecord: PatientRecord;
  payment?: Maybe<Payment>;
  paymentIntentFromService: StripePaymentIntent;
  pet?: Maybe<Pet>;
  pimsSettings: PimsSettings;
  pmsApptType: PmsApptType;
  prescription: Prescription;
  prescriptionRequest: PrescriptionRequest;
  pressItem: PressItem;
  product: Product;
  publicAppointmentTimes?: Maybe<Array<PublicAppointmentTime>>;
  queryActionItems: Array<ActionItem>;
  queryAppointmentPrompts: Array<AppointmentPrompt>;
  queryAppointments: Array<Appointment>;
  queryBreeds: Array<Breed>;
  queryChats: Array<Chat>;
  queryClientForms: Array<ClientForm>;
  queryClients: Array<Client>;
  queryClientsPatients: QueryClientsPatientsResults;
  queryClinicSexes: Array<ClinicSex>;
  queryClinicSpecies: Array<ClinicSpecies>;
  queryClinicians: Array<Clinician>;
  queryClinics: Array<Clinic>;
  queryConnectInstallations: Array<ConnectInstallation>;
  queryCustomerSegments: Array<CustomerSegment>;
  queryDiagnoses: Array<Diagnosis>;
  queryEntityReports: Array<EntityReport>;
  queryForms: Array<Form>;
  queryInvoiceItems: Array<InvoiceItem>;
  queryInvoices: Array<Invoice>;
  queryLoyaltyMembers: Array<LoyaltyMember>;
  queryLoyaltyRedemptions: Array<LoyaltyRedemption>;
  queryLoyaltyRewards: Array<LoyaltyReward>;
  queryMessages: Array<Message>;
  queryNotificationTemplates: Array<NotificationTemplate>;
  queryOrganizationReports: Array<OrganizationReport>;
  queryOrganizations: Array<Organization>;
  queryPatientHistoryItems: Array<PatientHistoryItem>;
  queryPatients: Array<Patient>;
  queryPayments: Array<Payment>;
  queryPrescriptions: Array<Prescription>;
  queryProducts: Array<Product>;
  queryReportTemplates: Array<ReportTemplate>;
  queryReschedules: Array<Reschedule>;
  queryReviews: Array<Review>;
  queryRooms: Array<Room>;
  queryServices: Array<Service>;
  queryUsers: Array<User>;
  reportTemplate: ReportTemplate;
  reschedule: Reschedule;
  review: Review;
  room: Room;
  schedulingRuleByClinicAndId?: Maybe<SchedulingRules>;
  schedulingRulesForClinic?: Maybe<Array<SchedulingRules>>;
  searchAppointments: Array<Appointment>;
  searchClinicians: Array<Clinician>;
  searchClinics: Array<Clinic>;
  searchUsers: Array<User>;
  service: Service;
  species: ClinicSpecies;
  stripeAccountCheck: Scalars['Boolean'];
  stripeAccountLoginLink: Scalars['URL'];
  stripeAccountOnboardLink: Scalars['URL'];
  transaction: Transaction;
  treatment: Treatment;
  upcomingAppointmentsByPet: Array<Appointment>;
  user?: Maybe<User>;
  widget: Widget;
};


export type QueryActionItemArgs = {
  id: Scalars['ID'];
};


export type QueryAllClinicsArgs = {
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryAllServicesByClinicIdArgs = {
  id: Scalars['ID'];
};


export type QueryAnimalArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentPromptArgs = {
  id: Scalars['ID'];
};


export type QueryAppointmentsByClientArgs = {
  clientId: Scalars['ID'];
};


export type QueryAppointmentsByClinicAndRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryAppointmentsByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryAppointmentsWithinRangeArgs = {
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryBreedArgs = {
  breedId: Scalars['String'];
  clinicId: Scalars['ID'];
};


export type QueryChatArgs = {
  id: Scalars['ID'];
};


export type QueryCheckEmailListArgs = {
  email: Scalars['String'];
};


export type QueryCheckExistingClientArgs = {
  clinicId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};


export type QueryCheckExistingClientsArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};


export type QueryCheckExistingPatientArgs = {
  clientId: Scalars['ID'];
  clinicId: Scalars['ID'];
  name: Scalars['String'];
};


export type QueryCheckForUserByEmailArgs = {
  email: Scalars['String'];
};


export type QueryCheckIfServerRunningArgs = {
  clinicId: Scalars['ID'];
};


export type QueryCheckInArgs = {
  id: Scalars['ID'];
};


export type QueryClientArgs = {
  id: Scalars['ID'];
};


export type QueryClientFormArgs = {
  id: Scalars['ID'];
};


export type QueryClinicArgs = {
  id: Scalars['ID'];
};


export type QueryClinicAnalyticsArgs = {
  clinicId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
};


export type QueryClinicAnalyticsNumbersArgs = {
  clinicId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
};


export type QueryClinicBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryClinicFeaturesArgs = {
  id: Scalars['ID'];
};


export type QueryClinicStatsArgs = {
  clinicId: Scalars['ID'];
};


export type QueryClinicianArgs = {
  id: Scalars['ID'];
};


export type QueryConnectInstallationArgs = {
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
};


export type QueryCountActionItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountAppointmentsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountBreedsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountChatsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClientFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClientsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicSexesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicSpeciesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountCliniciansArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountClinicsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountDiagnosesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountFormsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInvoiceItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountInvoicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyMembersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyRedemptionsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountLoyaltyRewardsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountMessagesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOrganizationReportsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOrganizationsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountOverduePatientsArgs = {
  clinicId: Scalars['ID'];
};


export type QueryCountPatientHistoryItemsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPatientsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPaymentsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountPrescriptionsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountProductsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReportTemplatesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReschedulesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountReviewsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountRoomsArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountServicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCountUsersArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryCustomerSegmentArgs = {
  id: Scalars['ID'];
};


export type QueryDailyHuddleArgs = {
  clinicId: Scalars['ID'];
  dailyHuddleId: Scalars['ID'];
};


export type QueryDiagnosisArgs = {
  id: Scalars['ID'];
};


export type QueryFamilyArgs = {
  id: Scalars['ID'];
};


export type QueryFilterAppointmentsArgs = {
  filters: FilterAppointmentInput;
  userId: Scalars['ID'];
};


export type QueryFormArgs = {
  id: Scalars['ID'];
};


export type QueryGetAccountsReceivableArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetAnalyticsNumbersByMonthsForClinicArgs = {
  clinicId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
};


export type QueryGetAnalyticsNumbersByMonthsForOrganizationArgs = {
  numMonths: Scalars['NonNegativeInt'];
  organizationId: Scalars['ID'];
};


export type QueryGetAppointmentCountByWidgetSourceArgs = {
  widgetSource: Scalars['String'];
};


export type QueryGetAverageRatingForRecentReviewsArgs = {
  clinicId: Scalars['ID'];
  maxCount?: InputMaybe<Scalars['PositiveInt']>;
};


export type QueryGetBookingQuestionsFromSchedulingRulesArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetBreedsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetChatByClientAndClinicArgs = {
  clientId: Scalars['ID'];
  clinicId: Scalars['ID'];
};


export type QueryGetChatsByClientIdArgs = {
  clientId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetChatsByClinicIdArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetCheckInsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetCheckInsByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetClientCountForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClientFormsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClientsByCustomerSegmentArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  referenceDate?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetClientsByCustomerSegmentRpcArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  referenceDate?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetClientsCountByCustomerSegmentArgs = {
  id: Scalars['ID'];
};


export type QueryGetClientsForClinicArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetClientsWithNegativeBalancesForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClientsWithOverduePatientsArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetClientsWithoutApptOverDaysForClinicArgs = {
  clinicId: Scalars['ID'];
  days: Scalars['NonNegativeInt'];
};


export type QueryGetClinicAdminArgs = {
  clinicId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryGetClinicAdminsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClinicAdminsByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetClinicSpeciesByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClinicianServiceArgs = {
  id: Scalars['ID'];
};


export type QueryGetClinicianServicesByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetClinicianServicesByClinicianArgs = {
  clinicianId: Scalars['ID'];
};


export type QueryGetClinicianServicesByServiceArgs = {
  serviceId: Scalars['ID'];
};


export type QueryGetCliniciansByClinicArgs = {
  clinicId: Scalars['ID'];
  onlyAvailable?: InputMaybe<Scalars['Boolean']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  usingRooms?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCliniciansForBookingArgs = {
  clinicId: Scalars['ID'];
  params: BookingResourceParams;
};


export type QueryGetClinicsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryGetClinicsForOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGetClinicsForUserAdminArgs = {
  userId: Scalars['ID'];
};


export type QueryGetConnectInstallationsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetCustomerSegmentsForClinicArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetDailyHuddlesByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetFormsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetGoalsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetGoalsByClinicAndStatusArgs = {
  clinicId: Scalars['ID'];
  status: GoalStatus;
};


export type QueryGetLastServerHeartbeatForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetLoyaltyMembersForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetLoyaltyRedemptionsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetLoyaltyRewardsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetMessagesByChatIdArgs = {
  chatId: Scalars['ID'];
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  patientId?: InputMaybe<Scalars['ID']>;
  startAtCreatedAt?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetNewAppointmentsForClinicArgs = {
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
};


export type QueryGetNewClientsForClinicArgs = {
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
};


export type QueryGetNewPatientsForClinicArgs = {
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
};


export type QueryGetNextAvailableDayArgs = {
  clinicId: Scalars['ID'];
  params: TimeSlotParams;
};


export type QueryGetNotificationTemplatesByClinicIdArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetNumberOfCompletedAppointmentsForTimeRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetOverduePatientsArgs = {
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
};


export type QueryGetPatientRecordsForPatientArgs = {
  patientId: Scalars['ID'];
};


export type QueryGetPatientsByClientArgs = {
  clientId: Scalars['ID'];
};


export type QueryGetPatientsByClientsArgs = {
  clientIds: Array<Scalars['ID']>;
};


export type QueryGetPatientsForClinicArgs = {
  clinicId: Scalars['ID'];
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type QueryGetPatientsWithoutApptOverDaysForClinicArgs = {
  clinicId: Scalars['ID'];
  days: Scalars['NonNegativeInt'];
};


export type QueryGetPatientsWithoutRescheduledAppointmentsForTimeRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetPaymentsByClinicIdArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetPetsByUserIdArgs = {
  userId: Scalars['ID'];
};


export type QueryGetPmsApptTypesForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetPrescriptionRequestsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetPrescriptionRequestsForPatientArgs = {
  patientId: Scalars['ID'];
};


export type QueryGetPrescriptionRequestsForUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetPrimaryClinicSpeciesArgs = {
  clinicId: Scalars['ID'];
  species: Species;
};


export type QueryGetPrivateNotesArgs = {
  clinicId: Scalars['ID'];
  patientRecordId: Scalars['ID'];
};


export type QueryGetRevenueByMonthsForClinicArgs = {
  clinicId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
};


export type QueryGetRevenueByMonthsForOrganizationArgs = {
  numMonths: Scalars['NonNegativeInt'];
  organizationId: Scalars['ID'];
};


export type QueryGetRevenueForTimeRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetRevenuesByClinicianForTimeRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetRevenuesByTypeForTimeRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetReviewsForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetRoomsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetRoomsForBookingArgs = {
  clinicId: Scalars['ID'];
  params: BookingResourceParams;
};


export type QueryGetServicesForBookingArgs = {
  clinicId: Scalars['ID'];
  params: BookingServiceParams;
};


export type QueryGetSumOfInvoicesArgs = {
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryGetTimeSlotsForClinicForDayArgs = {
  clinicId: Scalars['ID'];
  date: Scalars['NonNegativeInt'];
};


export type QueryGetTimeSlotsForSchedulingDayArgs = {
  clinicId: Scalars['ID'];
  params: TimeSlotParams;
};


export type QueryGetTotalRevenueForClinicBetweenTimesArgs = {
  clinicId: Scalars['ID'];
  endTime: Scalars['NonNegativeInt'];
  startTime: Scalars['NonNegativeInt'];
};


export type QueryGetTransactionsByClinicArgs = {
  clinicId: Scalars['ID'];
  pms?: InputMaybe<PracticeManagementSystem>;
};


export type QueryGetTransactionsByClinicAndRangeArgs = {
  clinicId: Scalars['ID'];
  end_time: Scalars['NonNegativeInt'];
  pms?: InputMaybe<PracticeManagementSystem>;
  start_time: Scalars['NonNegativeInt'];
};


export type QueryGetTreatmentsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetWidgetsByClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QueryGetWidgetsByOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type QueryGoalArgs = {
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceItemArgs = {
  id: Scalars['ID'];
};


export type QueryLoyaltyMemberArgs = {
  id: Scalars['ID'];
};


export type QueryLoyaltyRedemptionArgs = {
  id: Scalars['ID'];
};


export type QueryLoyaltyRewardArgs = {
  id: Scalars['ID'];
};


export type QueryNotificationTemplateArgs = {
  notificationTemplateId: Scalars['ID'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationAnalyticsArgs = {
  fromDate: Scalars['NonNegativeInt'];
  organizationId: Scalars['ID'];
  toDate: Scalars['NonNegativeInt'];
};


export type QueryOrganizationAnalyticsNumbersArgs = {
  fromDate: Scalars['NonNegativeInt'];
  organizationId: Scalars['ID'];
  toDate: Scalars['NonNegativeInt'];
};


export type QueryOrganizationReportArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationScheduleEfficiencyArgs = {
  fromDate: Scalars['NonNegativeInt'];
  organizationId: Scalars['ID'];
  toDate: Scalars['NonNegativeInt'];
};


export type QueryPatientArgs = {
  id: Scalars['ID'];
};


export type QueryPatientHistoryItemArgs = {
  id: Scalars['ID'];
};


export type QueryPatientRecordArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentIntentFromServiceArgs = {
  clinicId: Scalars['ID'];
  customerInfo: CustomerInfoInput;
  serviceId: Scalars['ID'];
};


export type QueryPetArgs = {
  id: Scalars['ID'];
};


export type QueryPimsSettingsArgs = {
  clinicId: Scalars['ID'];
};


export type QueryPmsApptTypeArgs = {
  clinicId: Scalars['ID'];
  pmsApptTypeId: Scalars['ID'];
};


export type QueryPrescriptionArgs = {
  prescriptionId: Scalars['ID'];
};


export type QueryPrescriptionRequestArgs = {
  id: Scalars['ID'];
};


export type QueryPressItemArgs = {
  id: Scalars['ID'];
};


export type QueryProductArgs = {
  productId: Scalars['ID'];
};


export type QueryPublicAppointmentTimesArgs = {
  searchInput: SearchAppointmentsInput;
};


export type QueryQueryActionItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryAppointmentPromptsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryAppointmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryBreedsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryChatsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClientsPatientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicSexesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicSpeciesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryCliniciansArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryClinicsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryConnectInstallationsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryCustomerSegmentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryDiagnosesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryEntityReportsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryFormsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInvoiceItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryInvoicesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyMembersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyRedemptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryLoyaltyRewardsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryMessagesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryNotificationTemplatesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryOrganizationReportsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryOrganizationsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientHistoryItemsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPatientsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPaymentsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryPrescriptionsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryProductsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReportTemplatesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReschedulesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryReviewsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryRoomsArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryServicesArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryQueryUsersArgs = {
  orderBy?: InputMaybe<OrderByInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  where?: InputMaybe<Array<QueryInput>>;
};


export type QueryReportTemplateArgs = {
  id: Scalars['ID'];
};


export type QueryRescheduleArgs = {
  id: Scalars['ID'];
};


export type QueryReviewArgs = {
  id: Scalars['ID'];
};


export type QueryRoomArgs = {
  roomId: Scalars['ID'];
};


export type QuerySchedulingRuleByClinicAndIdArgs = {
  clinicId: Scalars['ID'];
  schedulingRulesId: Scalars['ID'];
};


export type QuerySchedulingRulesForClinicArgs = {
  clinicId: Scalars['ID'];
};


export type QuerySearchAppointmentsArgs = {
  searchInput: SearchAppointmentsInput;
};


export type QuerySearchCliniciansArgs = {
  searchInput: SearchCliniciansInput;
};


export type QuerySearchClinicsArgs = {
  page: Scalars['NonNegativeInt'];
  size: Scalars['PositiveInt'];
  text: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  roles?: InputMaybe<Array<AuthRoles>>;
  startAtId?: InputMaybe<Scalars['String']>;
};


export type QueryServiceArgs = {
  id: Scalars['ID'];
};


export type QuerySpeciesArgs = {
  clinicId: Scalars['ID'];
  speciesId: Scalars['ID'];
};


export type QueryStripeAccountCheckArgs = {
  clinicId: Scalars['ID'];
};


export type QueryStripeAccountLoginLinkArgs = {
  clinicId: Scalars['ID'];
};


export type QueryStripeAccountOnboardLinkArgs = {
  clinicId: Scalars['ID'];
  data: AccountOnboardLinkInput;
};


export type QueryTransactionArgs = {
  id: Scalars['ID'];
};


export type QueryTreatmentArgs = {
  clinicId: Scalars['ID'];
  treatmentId: Scalars['ID'];
};


export type QueryUpcomingAppointmentsByPetArgs = {
  petId: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID'];
};

export type QueryClientsPatientsResult = {
  __typename?: 'QueryClientsPatientsResult';
  client?: Maybe<Client>;
  matchingText: Scalars['String'];
  patients: Array<Patient>;
};

export type QueryClientsPatientsResults = {
  __typename?: 'QueryClientsPatientsResults';
  count: Scalars['NonNegativeInt'];
  results: Array<QueryClientsPatientsResult>;
};

export type QueryFilter = {
  __typename?: 'QueryFilter';
  column: Scalars['String'];
  filterOp: FilterOp;
  not?: Maybe<Scalars['Boolean']>;
  value: QueryFilterValue;
};

export type QueryFilterValue = {
  __typename?: 'QueryFilterValue';
  boolean?: Maybe<Scalars['Boolean']>;
  booleanArray?: Maybe<Array<Scalars['Boolean']>>;
  float?: Maybe<Scalars['Float']>;
  floatArray?: Maybe<Array<Scalars['Float']>>;
  intArray?: Maybe<Array<Scalars['Int']>>;
  millisFromNow?: Maybe<Scalars['Float']>;
  string?: Maybe<Scalars['String']>;
  stringArray?: Maybe<Array<Scalars['String']>>;
};

export type QueryInput = {
  column: Scalars['String'];
  filterOp: FilterOp;
  not?: InputMaybe<Scalars['Boolean']>;
  value: QueryInputValue;
};

export type QueryInputValue = {
  boolean?: InputMaybe<Scalars['Boolean']>;
  booleanArray?: InputMaybe<Array<Scalars['Boolean']>>;
  float?: InputMaybe<Scalars['Float']>;
  floatArray?: InputMaybe<Array<Scalars['Float']>>;
  intArray?: InputMaybe<Array<Scalars['Int']>>;
  millisFromNow?: InputMaybe<Scalars['Float']>;
  string?: InputMaybe<Scalars['String']>;
  stringArray?: InputMaybe<Array<Scalars['String']>>;
};

export type RecurringSettings = {
  __typename?: 'RecurringSettings';
  expires_after_days?: Maybe<Scalars['NonNegativeInt']>;
  recur_after_days?: Maybe<Scalars['NonNegativeInt']>;
};

export type RecurringSettingsInput = {
  expires_after_days?: InputMaybe<Scalars['NonNegativeInt']>;
  recur_after_days?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type RepeatAvailability = {
  __typename?: 'RepeatAvailability';
  daysOfMonth?: Maybe<Array<Scalars['Int']>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt'];
  unit: RepeatUnit;
  weekOfMonth?: Maybe<WeekOfMonth>;
};

export type RepeatAvailabilityInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt'];
  unit: RepeatUnit;
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

export type RepeatParams = {
  __typename?: 'RepeatParams';
  daysOfMonth?: Maybe<Array<Scalars['Int']>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  frequency: Scalars['PositiveInt'];
  unit: RepeatUnit;
  weekOfMonth?: Maybe<WeekOfMonth>;
};

export enum RepeatUnit {
  Day = 'day',
  Month = 'month',
  Week = 'week'
}

export type ReportClinic = {
  __typename?: 'ReportClinic';
  clinic: Clinic;
  id: Scalars['ID'];
  report: OrganizationReport;
};

export type ReportColumnValue = {
  __typename?: 'ReportColumnValue';
  percentile?: Maybe<Scalars['NonNegativeFloat']>;
  value: Scalars['Float'];
  value_params: MetricValueParams;
};

export type ReportEntity = {
  __typename?: 'ReportEntity';
  child_entities?: Maybe<Array<ReportEntity>>;
  entity_type: ReportEntityType;
};

export enum ReportEntityType {
  Clinic = 'Clinic',
  Clinician = 'Clinician',
  Product = 'Product',
  Service = 'Service'
}

export type ReportMetric = {
  __typename?: 'ReportMetric';
  field_modifiers: Array<ReportMetricModifier>;
  format?: Maybe<MetricFormat>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['NonNegativeInt'];
  organization_report?: Maybe<OrganizationReport>;
  report_template?: Maybe<ReportTemplate>;
  special_modifier?: Maybe<SpecialMetricModifierType>;
  time_params_overrides?: Maybe<TimeParams>;
  type: ReportMetricType;
  value_types: Array<MetricValueParams>;
};

export type ReportMetricModifier = {
  __typename?: 'ReportMetricModifier';
  category: MetricModifierCategory;
  column: Scalars['String'];
  filterOp: FilterOp;
  not?: Maybe<Scalars['Boolean']>;
  value: MetricModifierValue;
};

export enum ReportMetricType {
  AccountsReceivable = 'AccountsReceivable',
  AppointmentRate = 'AppointmentRate',
  Appointments = 'Appointments',
  FillRate = 'FillRate',
  InvoiceItemsCount = 'InvoiceItemsCount',
  InvoicesCount = 'InvoicesCount',
  NewClients = 'NewClients',
  NewPatients = 'NewPatients',
  ReturningClients = 'ReturningClients',
  ReturningPatients = 'ReturningPatients',
  Revenue = 'Revenue',
  ShowRate = 'ShowRate',
  UniqueClients = 'UniqueClients',
  UniquePatients = 'UniquePatients',
  WorkingHours = 'WorkingHours'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  entity_structure: Array<ReportEntity>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  last_run?: Maybe<Scalars['Timestamp']>;
  name: Scalars['String'];
  next_run?: Maybe<Scalars['Timestamp']>;
  organization: Organization;
  organization_reports: Array<OrganizationReport>;
  preferred_view_type: ReportViewType;
  repeat: RepeatParams;
  report_metrics: Array<ReportMetric>;
  template_clinics: Array<TemplateClinic>;
  time_params: TimeParams;
  updated_at: Scalars['Timestamp'];
};

export type ReportValue = {
  __typename?: 'ReportValue';
  column_values: Array<ReportColumnValue>;
  key: Scalars['String'];
  metric: ReportMetricType;
};

export enum ReportViewType {
  BarChart = 'BarChart',
  PieChart = 'PieChart',
  Table = 'Table'
}

export type Reschedule = {
  __typename?: 'Reschedule';
  action_items?: Maybe<Array<ActionItem>>;
  appointment: Appointment;
  client_notes?: Maybe<Scalars['String']>;
  clinic: Clinic;
  clinic_notes?: Maybe<Scalars['String']>;
  confirmed_at?: Maybe<Scalars['NonNegativeInt']>;
  created_at: Scalars['Timestamp'];
  id: Scalars['ID'];
  initiated_by: RescheduleInitiatedBy;
  reason_for_denial?: Maybe<Scalars['String']>;
  requested_drop_off_time?: Maybe<Scalars['NonNegativeInt']>;
  requested_start_time?: Maybe<Scalars['NonNegativeInt']>;
  status: RescheduleStatus;
  updated_at: Scalars['Timestamp'];
};

export enum RescheduleInitiatedBy {
  Client = 'Client',
  Clinic = 'Clinic'
}

export enum RescheduleStatus {
  Approved = 'Approved',
  AwaitingClinicApproval = 'AwaitingClinicApproval',
  Denied = 'Denied',
  Expired = 'Expired',
  Requested = 'Requested'
}

export enum ResolveReason {
  EnteredManually = 'EnteredManually',
  Resolved = 'Resolved'
}

export enum ResourceType {
  Clinician = 'Clinician',
  Room = 'Room'
}

export type RevenueByMonth = {
  __typename?: 'RevenueByMonth';
  month: Scalars['NonNegativeInt'];
  revenue: Scalars['Float'];
  year: Scalars['NonNegativeInt'];
};

export type RevenueGroup = {
  __typename?: 'RevenueGroup';
  amount: Scalars['Float'];
  group: Scalars['String'];
};

export type Review = {
  __typename?: 'Review';
  appointment?: Maybe<Appointment>;
  care_rating?: Maybe<Scalars['NonNegativeInt']>;
  client?: Maybe<Client>;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_anonymous?: Maybe<Scalars['Boolean']>;
  overall_rating: Scalars['NonNegativeInt'];
  price_rating?: Maybe<Scalars['NonNegativeInt']>;
  time_rating?: Maybe<Scalars['NonNegativeInt']>;
  updated_at: Scalars['Timestamp'];
};

export type ReviewTotals = {
  __typename?: 'ReviewTotals';
  count: Scalars['NonNegativeInt'];
  total: Scalars['NonNegativeInt'];
};

export type Room = {
  __typename?: 'Room';
  adjusted_availability?: Maybe<Array<Availability>>;
  clinic: Clinic;
  concurrent_patients?: Maybe<Scalars['NonNegativeInt']>;
  created_at: Scalars['Timestamp'];
  description?: Maybe<Scalars['String']>;
  hours?: Maybe<AvailabilityHours>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  name: Scalars['String'];
  pms: PracticeManagementSystem;
  pms_id: Scalars['String'];
  stagger_offset_minutes?: Maybe<Scalars['NonNegativeInt']>;
  updated_at: Scalars['Timestamp'];
};

export type ScheduleData = {
  __typename?: 'ScheduleData';
  schedule_efficiency: Scalars['Float'];
  time_slots: Array<TimeSlot>;
};

export enum ScheduleMethod {
  Optimized = 'Optimized',
  Realistic = 'Realistic',
  RealisticOptimized = 'RealisticOptimized'
}

export type SchedulingRules = {
  __typename?: 'SchedulingRules';
  adjusted_availability?: Maybe<Array<Availability>>;
  availability?: Maybe<AvailabilityHours>;
  client_type?: Maybe<ClientTypeEnum>;
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  fixed_status?: Maybe<FixedStatus>;
  id: Scalars['ID'];
  included_clinicians?: Maybe<Array<Clinician>>;
  included_rooms?: Maybe<Array<Room>>;
  included_services?: Maybe<Array<Service>>;
  included_species?: Maybe<Array<ClinicSpecies>>;
  is_active: Scalars['Boolean'];
  only_modifier?: Maybe<OnlyModifierEnum>;
  patient_gender?: Maybe<AnimalGender>;
  patient_type?: Maybe<PatientTypeEnum>;
  updated_at: Scalars['Timestamp'];
};

export type SearchAppointmentsInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  clinicId?: InputMaybe<Scalars['ID']>;
  clinicianId?: InputMaybe<Scalars['ID']>;
  cursor_id?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['NonNegativeInt']>;
  is_native_origin?: InputMaybe<Scalars['Boolean']>;
  is_time_block?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  origin?: InputMaybe<EntityOrigin>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  should_be_synced?: InputMaybe<Scalars['Boolean']>;
  start_date?: InputMaybe<Scalars['NonNegativeInt']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  start_time_ordering?: InputMaybe<StartTimeOrdering>;
  status?: InputMaybe<AppointmentStatus>;
  time_of_day?: InputMaybe<TimeOfDay>;
  updated_from?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type SearchCliniciansInput = {
  authority_level?: InputMaybe<AuthorityLevel>;
  clinic_id?: InputMaybe<Scalars['ID']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
};

export enum SendConfirmationsTo {
  All = 'All',
  ChckupApptsOnly = 'ChckupApptsOnly',
  None = 'None'
}

export type Service = {
  __typename?: 'Service';
  allow_new?: Maybe<Scalars['Boolean']>;
  allow_returning?: Maybe<Scalars['Boolean']>;
  authorized_levels?: Maybe<Array<AuthorityLevel>>;
  availability?: Maybe<AvailabilityHours>;
  clinic?: Maybe<Clinic>;
  color?: Maybe<Scalars['String']>;
  created_at: Scalars['Timestamp'];
  default_room?: Maybe<Room>;
  description?: Maybe<Scalars['String']>;
  drop_off_hours?: Maybe<AvailabilityHours>;
  drop_off_minutes_before?: Maybe<Scalars['NonNegativeInt']>;
  duration?: Maybe<Scalars['NonNegativeInt']>;
  excluded_species?: Maybe<Array<Species>>;
  follow_up_services?: Maybe<Array<Service>>;
  follow_up_settings?: Maybe<FollowUpSettings>;
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  max_per_day?: Maybe<Scalars['NonNegativeInt']>;
  minimum_patient_age_in_days?: Maybe<Scalars['NonNegativeInt']>;
  more_info?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pms_appt_type?: Maybe<PmsApptType>;
  points: Scalars['NonNegativeInt'];
  pricing?: Maybe<ServicePricing>;
  recurring?: Maybe<RecurringSettings>;
  required_room?: Maybe<Room>;
  reserved_per_day?: Maybe<Scalars['NonNegativeInt']>;
  scheduling_buffer_minutes?: Maybe<Scalars['NonNegativeInt']>;
  scheduling_max_minutes_away?: Maybe<Scalars['NonNegativeInt']>;
  scheduling_min_minutes_away?: Maybe<Scalars['NonNegativeInt']>;
  service_types: Array<ServiceType>;
  updated_at: Scalars['Timestamp'];
};

export type ServicePricing = {
  __typename?: 'ServicePricing';
  currency: Scalars['Currency'];
  price: Scalars['PositiveInt'];
  type: ServicePricingType;
};

export enum ServicePricingType {
  OneTime = 'OneTime',
  PerDay = 'PerDay'
}

export enum ServiceType {
  Healthy = 'Healthy',
  Sick = 'Sick'
}

export enum SpecialMetricModifierType {
  NewClients = 'NewClients',
  NewPatients = 'NewPatients',
  ReturningClients = 'ReturningClients',
  ReturningPatients = 'ReturningPatients'
}

export enum Species {
  Amphibian = 'Amphibian',
  Bird = 'Bird',
  Cat = 'Cat',
  Cow = 'Cow',
  Deer = 'Deer',
  Dog = 'Dog',
  Donkey = 'Donkey',
  Ferret = 'Ferret',
  Fish = 'Fish',
  Goat = 'Goat',
  Horse = 'Horse',
  Lion = 'Lion',
  Lizard = 'Lizard',
  Marsupial = 'Marsupial',
  Other = 'Other',
  Panther = 'Panther',
  Pig = 'Pig',
  PocketPet = 'PocketPet',
  Primate = 'Primate',
  Rabbit = 'Rabbit',
  Reptile = 'Reptile',
  Rodent = 'Rodent',
  Sheep = 'Sheep',
  Snake = 'Snake',
  Turtle = 'Turtle',
  Wolf = 'Wolf'
}

export enum StartTimeOrdering {
  Asc = 'asc',
  Desc = 'desc'
}

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  amount: Scalars['Int'];
  client_secret?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SubmitAppointmentInput = {
  client_email: Scalars['String'];
  client_first_name: Scalars['String'];
  client_last_name: Scalars['String'];
  client_notes?: InputMaybe<Scalars['String']>;
  client_phone: Scalars['String'];
  clinic: Scalars['ID'];
  clinician?: InputMaybe<Scalars['ID']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']>;
  minutes: Scalars['NonNegativeInt'];
  origin: EntityOrigin;
  patient_birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  patient_breed?: InputMaybe<Scalars['String']>;
  patient_clinic_breed?: InputMaybe<Scalars['ID']>;
  patient_clinic_species: Scalars['ID'];
  patient_gender?: InputMaybe<AnimalGender>;
  patient_is_fixed?: InputMaybe<Scalars['Boolean']>;
  patient_name: Scalars['String'];
  previous_clinic_name?: InputMaybe<Scalars['String']>;
  room?: InputMaybe<Scalars['ID']>;
  service?: InputMaybe<Scalars['ID']>;
  service_name?: InputMaybe<Scalars['String']>;
  start_time: Scalars['NonNegativeInt'];
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  widget_source?: InputMaybe<Scalars['String']>;
};

export type TemplateClinic = {
  __typename?: 'TemplateClinic';
  clinic: Clinic;
  id: Scalars['ID'];
  report_template: ReportTemplate;
};

export type TimeInterval = {
  __typename?: 'TimeInterval';
  end?: Maybe<Scalars['NonNegativeFloat']>;
  start?: Maybe<Scalars['NonNegativeFloat']>;
};

export type TimeIntervalInput = {
  end?: InputMaybe<Scalars['NonNegativeFloat']>;
  start?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export enum TimeOfDay {
  Afternoon = 'Afternoon',
  EarlyMorning = 'EarlyMorning',
  LateAfternoon = 'LateAfternoon',
  Morning = 'Morning'
}

export enum TimeParamType {
  RelativeMillisTimeRange = 'RelativeMillisTimeRange',
  RelativePeriodTimeRange = 'RelativePeriodTimeRange',
  SetTimeRange = 'SetTimeRange'
}

export type TimeParams = {
  __typename?: 'TimeParams';
  end?: Maybe<Scalars['Timestamp']>;
  from_millis_ago?: Maybe<Scalars['Long']>;
  from_periods_ago?: Maybe<Scalars['NonNegativeInt']>;
  period_type?: Maybe<PeriodType>;
  start?: Maybe<Scalars['Timestamp']>;
  to_millis_ago?: Maybe<Scalars['Long']>;
  to_periods_ago?: Maybe<Scalars['NonNegativeInt']>;
  type: TimeParamType;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  clinicians: Array<Clinician>;
  display_time?: Maybe<Scalars['NonNegativeInt']>;
  rooms: Array<Room>;
  start_time: Scalars['NonNegativeInt'];
};

export type TimeSlotParams = {
  clinic_species_id: Scalars['ID'];
  clinician_preference_id?: InputMaybe<Array<Scalars['ID']>>;
  date: Scalars['NonNegativeInt'];
  duration_in_minutes: Scalars['NonNegativeInt'];
  fixed_status?: InputMaybe<FixedStatus>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient: Scalars['Boolean'];
  patient_gender?: InputMaybe<AnimalGender>;
  room_id?: InputMaybe<Scalars['ID']>;
  service_id?: InputMaybe<Scalars['ID']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['String']>;
  client_pms_id?: Maybe<Client>;
  clinic_id: Scalars['ID'];
  clinician_pms_id?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  date?: Maybe<Scalars['NonNegativeInt']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  patient_pms_id?: Maybe<Patient>;
  pms?: Maybe<PracticeManagementSystem>;
  pms_id?: Maybe<Scalars['String']>;
  service_pms_id?: Maybe<Scalars['ID']>;
  type?: Maybe<TransactionType>;
  updated_at: Scalars['Timestamp'];
};

export enum TransactionType {
  Medical = 'Medical',
  Otc = 'OTC',
  Other = 'Other',
  Payment = 'Payment'
}

export type Treatment = {
  __typename?: 'Treatment';
  clinic: Clinic;
  created_at: Scalars['Timestamp'];
  description: Scalars['String'];
  id: Scalars['ID'];
  pms_id: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  updated_at: Scalars['Timestamp'];
};

export type UpdateActionItemInput = {
  assignee?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ActionItemStatus>;
  type?: InputMaybe<ActionItemType>;
};

export type UpdateAnimalInput = {
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAppointmentInput = {
  appt_type_pms_id?: InputMaybe<Scalars['String']>;
  booking_source?: InputMaybe<BookingSource>;
  cancelled_at?: InputMaybe<Scalars['NonNegativeInt']>;
  checksum?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['ID']>;
  client_info?: InputMaybe<ClientInfoInput>;
  client_notes?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinic_approved_at?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_notes?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  clinician_pms_id?: InputMaybe<Scalars['String']>;
  confirmation_requested_at?: InputMaybe<Scalars['NonNegativeInt']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  drop_off_time?: InputMaybe<Scalars['NonNegativeInt']>;
  index_of_opening?: InputMaybe<Scalars['NonNegativeInt']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_new_client?: InputMaybe<Scalars['Boolean']>;
  is_new_patient?: InputMaybe<Scalars['Boolean']>;
  is_time_block?: InputMaybe<Scalars['Boolean']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  new_client_name?: InputMaybe<Scalars['String']>;
  new_client_phone?: InputMaybe<Scalars['String']>;
  new_patient_name?: InputMaybe<Scalars['String']>;
  new_patient_species?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<EntityOrigin>;
  patient?: InputMaybe<Scalars['ID']>;
  patient_info?: InputMaybe<PatientInfoInput>;
  patient_pms_id?: InputMaybe<Scalars['String']>;
  patients_pms_ids?: InputMaybe<Array<Scalars['String']>>;
  payment?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  reason_for_cancellation?: InputMaybe<Scalars['String']>;
  referring_clinic_name?: InputMaybe<Scalars['String']>;
  requested_prompt?: InputMaybe<Scalars['ID']>;
  room?: InputMaybe<Scalars['ID']>;
  service?: InputMaybe<Scalars['ID']>;
  service_name?: InputMaybe<Scalars['String']>;
  should_be_synced?: InputMaybe<Scalars['Boolean']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  status?: InputMaybe<AppointmentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
  time_of_day?: InputMaybe<TimeOfDay>;
};

export type UpdateAppointmentPromptInput = {
  client?: InputMaybe<Scalars['ID']>;
  client_notes?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinic_notes?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  created_appointment?: InputMaybe<Scalars['ID']>;
  minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  patient?: InputMaybe<Scalars['ID']>;
  reason_for_denial?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['ID']>;
  service_name?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  type?: InputMaybe<AppointmentPromptType>;
};

export type UpdateBreedInput = {
  description?: InputMaybe<Scalars['String']>;
  pms_id?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Species>;
};

export type UpdateChatInput = {
  client_last_read?: InputMaybe<Scalars['NonNegativeInt']>;
  client_last_read_count?: InputMaybe<Scalars['NonNegativeInt']>;
  client_message_count?: InputMaybe<Scalars['NonNegativeInt']>;
  client_unread_count?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_last_read?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_last_read_count?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_message_count?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_unread_count?: InputMaybe<Scalars['NonNegativeInt']>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  last_message?: InputMaybe<Scalars['String']>;
  last_message_time?: InputMaybe<Scalars['Timestamp']>;
  message_count?: InputMaybe<Scalars['NonNegativeInt']>;
  status?: InputMaybe<ChatStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCheckInInput = {
  status?: InputMaybe<CheckInStatus>;
  vehicle?: InputMaybe<Scalars['String']>;
  visit_reason?: InputMaybe<VisitReason>;
};

export type UpdateClientFormInput = {
  client_completed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  clinic_verified_at?: InputMaybe<Scalars['NonNegativeInt']>;
  form_data?: InputMaybe<Scalars['JSON']>;
};

export type UpdateClientInput = {
  address?: InputMaybe<AddressInput>;
  balance?: InputMaybe<Scalars['Float']>;
  checksum?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_unsubscribed?: InputMaybe<Scalars['Boolean']>;
  last_appointment?: InputMaybe<Scalars['ID']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  last_contact_time?: InputMaybe<Scalars['NonNegativeInt']>;
  last_name?: InputMaybe<Scalars['String']>;
  next_appointment?: InputMaybe<Scalars['ID']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  origin?: InputMaybe<EntityOrigin>;
  phone?: InputMaybe<Scalars['String']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type UpdateClinicAdminInput = {
  role?: InputMaybe<Scalars['String']>;
};

export type UpdateClinicInput = {
  address?: InputMaybe<AddressInput>;
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  animals?: InputMaybe<Array<Scalars['ID']>>;
  avatar_url?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<ClinicFeaturesInput>;
  groupup_recipients?: InputMaybe<Array<Scalars['String']>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_archived?: InputMaybe<Scalars['Boolean']>;
  is_featured?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  last_synced_times?: InputMaybe<ClinicLastSyncedTimesInput>;
  name?: InputMaybe<Scalars['String']>;
  offers_emergency_care?: InputMaybe<Scalars['Boolean']>;
  office_emails?: InputMaybe<Array<Scalars['String']>>;
  onboarding?: InputMaybe<ClinicOnboardingInput>;
  organization?: InputMaybe<Scalars['ID']>;
  phone?: InputMaybe<Scalars['String']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_additional_key?: InputMaybe<Scalars['String']>;
  pms_api_key?: InputMaybe<Scalars['String']>;
  pms_api_subdomain?: InputMaybe<Scalars['String']>;
  pms_version?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  send_from_phone?: InputMaybe<Scalars['String']>;
  services?: InputMaybe<Array<Scalars['ID']>>;
  settings?: InputMaybe<ClinicSettingsInput>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateClinicSexInput = {
  animal_gender?: InputMaybe<AnimalGender>;
  description?: InputMaybe<Scalars['String']>;
  fixed_statuses?: InputMaybe<Array<FixedStatus>>;
  included_species?: InputMaybe<Array<Species>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateClinicSpeciesInput = {
  description?: InputMaybe<Scalars['String']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Species>;
};

export type UpdateClinicStatsInput = {
  booked_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  cancelled_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  completed_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  confirmed_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  denied_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  expired_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  pending_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_website_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
  total_widget_appointments?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateClinicianInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  authority_level?: InputMaybe<AuthorityLevel>;
  avatar_url?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  excluded_service_ids?: InputMaybe<Array<Scalars['ID']>>;
  excluded_species?: InputMaybe<Array<Species>>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_assignable_in_pms?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  type?: InputMaybe<ResourceType>;
};

export type UpdateClinicianServiceInput = {
  clinician?: InputMaybe<Scalars['ID']>;
  duration_override?: InputMaybe<Scalars['NonNegativeInt']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  service?: InputMaybe<Scalars['ID']>;
};

export type UpdateConnectInstallationInput = {
  clinic?: InputMaybe<Scalars['ID']>;
  computer_name?: InputMaybe<Scalars['String']>;
  computer_uuid?: InputMaybe<Scalars['String']>;
  connect_server_version?: InputMaybe<Scalars['String']>;
  connect_ui_version?: InputMaybe<Scalars['String']>;
  is_chckup_connected_to_pms?: InputMaybe<Scalars['Boolean']>;
  is_pms_active?: InputMaybe<Scalars['Boolean']>;
  is_server?: InputMaybe<Scalars['Boolean']>;
  is_update_service_active?: InputMaybe<Scalars['Boolean']>;
  last_ping?: InputMaybe<Scalars['NonNegativeInt']>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerSegmentInput = {
  excluded_filters?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  filters?: InputMaybe<Array<CustomerSegmentFilterInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDailyHuddleInput = {
  attendees?: InputMaybe<Array<Scalars['ID']>>;
  end_time?: InputMaybe<Scalars['NonNegativeInt']>;
  leader?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateDiagnosisInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateEntityReportInput = {
  clinic?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  entity_report?: InputMaybe<Scalars['ID']>;
  entity_type?: InputMaybe<ReportEntityType>;
  organization_report?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['ID']>;
  service?: InputMaybe<Scalars['ID']>;
  values?: InputMaybe<Array<UpdateReportValueInput>>;
};

export type UpdateFamilyInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFollowUpSettingsInput = {
  days_until_next_appt?: InputMaybe<Scalars['NonNegativeInt']>;
  step_number?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateFormInput = {
  form_fields?: InputMaybe<Scalars['JSON']>;
  form_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGoalInput = {
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_chckup_modifier?: InputMaybe<Scalars['Boolean']>;
  is_new_modifier?: InputMaybe<Scalars['Boolean']>;
  last_synced_time?: InputMaybe<Scalars['NonNegativeInt']>;
  metric_current_amount?: InputMaybe<Scalars['NonNegativeInt']>;
  metric_entity?: InputMaybe<GoalEntity>;
  metric_target_amount?: InputMaybe<Scalars['NonNegativeInt']>;
  metric_timespan?: InputMaybe<GoalTimespan>;
  status?: InputMaybe<GoalStatus>;
};

export type UpdateInvoiceInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  balance?: InputMaybe<Scalars['NonNegativeInt']>;
  client?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['Currency']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['NonNegativeInt']>;
  discount_reason?: InputMaybe<Scalars['String']>;
  entered_by_name?: InputMaybe<Scalars['String']>;
  paid_at?: InputMaybe<Scalars['Timestamp']>;
  patient?: InputMaybe<Scalars['ID']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<InvoiceStatus>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['NonNegativeInt']>;
  total?: InputMaybe<Scalars['Int']>;
};

export type UpdateInvoiceItemInput = {
  clinician?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['Currency']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['NonNegativeInt']>;
  discount_reason?: InputMaybe<Scalars['String']>;
  pims_created_at?: InputMaybe<Scalars['Timestamp']>;
  price?: InputMaybe<Scalars['NonNegativeInt']>;
  product?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']>;
  subtotal?: InputMaybe<Scalars['Int']>;
  tax?: InputMaybe<Scalars['NonNegativeInt']>;
  total?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<InvoiceItemType>;
};

export type UpdateLoyaltyMemberInput = {
  all_time_points?: InputMaybe<Scalars['NonNegativeInt']>;
  available_points?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateLoyaltyRewardInput = {
  description?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  points_required?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateMessageInput = {
  hidden_for_client?: InputMaybe<Scalars['Boolean']>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  patient?: InputMaybe<Scalars['ID']>;
};

export type UpdateMetricValueParamsInput = {
  custom_label?: InputMaybe<Scalars['String']>;
  value_type?: InputMaybe<MetricValueType>;
};

export type UpdateNotificationTemplateInput = {
  body?: InputMaybe<Scalars['String']>;
  cta_text?: InputMaybe<Scalars['String']>;
  cta_url?: InputMaybe<Scalars['String']>;
  every_x_hours?: InputMaybe<Scalars['NonNegativeInt']>;
  header?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_marketing?: InputMaybe<Scalars['Boolean']>;
  message_methods?: InputMaybe<Array<MessageMethod>>;
  name?: InputMaybe<Scalars['String']>;
  notif_attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  send_time_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  sms_body?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<NotificationType>;
};

export type UpdateOrganizationInput = {
  admins?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationReportInput = {
  description?: InputMaybe<Scalars['String']>;
  is_hidden?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  preferred_view_type?: InputMaybe<ReportViewType>;
  time_params?: InputMaybe<UpdateTimeParamsInput>;
};

export type UpdatePatientHistoryItemInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  diagnosis?: InputMaybe<Scalars['ID']>;
  issued_at?: InputMaybe<Scalars['Timestamp']>;
  pms_id?: InputMaybe<Scalars['ID']>;
  product?: InputMaybe<Scalars['ID']>;
};

export type UpdatePatientInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  breed?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinic_breed?: InputMaybe<Scalars['ID']>;
  clinic_species?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  is_deceased?: InputMaybe<Scalars['Boolean']>;
  last_appointment?: InputMaybe<Scalars['ID']>;
  last_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  name?: InputMaybe<Scalars['String']>;
  next_appointment?: InputMaybe<Scalars['ID']>;
  next_appt_time?: InputMaybe<Scalars['NonNegativeInt']>;
  origin?: InputMaybe<EntityOrigin>;
  owner?: InputMaybe<Scalars['ID']>;
  pet?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_created_at?: InputMaybe<Scalars['NonNegativeInt']>;
  pms_id?: InputMaybe<Scalars['String']>;
  species_pms_id?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export type UpdatePatientRecordInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  assessment?: InputMaybe<Scalars['String']>;
  assisting_clinicians?: InputMaybe<Array<Scalars['String']>>;
  client?: InputMaybe<Scalars['ID']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinician?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['NonNegativeInt']>;
  master_problem_list?: InputMaybe<Scalars['String']>;
  objective?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Scalars['ID']>;
  plan?: InputMaybe<Scalars['String']>;
  public_notes?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<Scalars['ID']>;
  subjective?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentInput = {
  amount?: InputMaybe<Scalars['PositiveInt']>;
  client?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['Currency']>;
  errors?: InputMaybe<Array<PaymentErrorInput>>;
  payment_method_id?: InputMaybe<Scalars['String']>;
  processing_fee?: InputMaybe<Scalars['NonNegativeInt']>;
  sales_tax?: InputMaybe<Scalars['NonNegativeInt']>;
  service_fee?: InputMaybe<Scalars['NonNegativeInt']>;
  status?: InputMaybe<PaymentStatus>;
  stripe_payment_intent_id?: InputMaybe<Scalars['String']>;
};

export type UpdatePetInput = {
  avatar_url?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['NonNegativeInt']>;
  breed?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<Scalars['ID']>;
  fixed_status?: InputMaybe<FixedStatus>;
  gender?: InputMaybe<AnimalGender>;
  name?: InputMaybe<Scalars['String']>;
  species?: InputMaybe<Species>;
  weight?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export type UpdatePimsSettingsInput = {
  access_token?: InputMaybe<Scalars['String']>;
  access_token_expiration?: InputMaybe<Scalars['NonNegativeInt']>;
  additional_key?: InputMaybe<Scalars['String']>;
  api_clinic_id?: InputMaybe<Scalars['String']>;
  api_key?: InputMaybe<Scalars['String']>;
  api_subdomain?: InputMaybe<Scalars['String']>;
  cookie?: InputMaybe<Array<Scalars['String']>>;
  password?: InputMaybe<Scalars['String']>;
  pims_version?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  practice_key?: InputMaybe<Scalars['String']>;
  pulse_ar_report_id?: InputMaybe<Scalars['String']>;
  pulse_sales_report_id?: InputMaybe<Scalars['String']>;
  refresh_token?: InputMaybe<Scalars['String']>;
  request_verification_token?: InputMaybe<Scalars['String']>;
  user_key?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UpdatePmsApptTypeInput = {
  color?: InputMaybe<Scalars['HexColorCode']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePrescriptionInput = {
  clinician?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_refill_time?: InputMaybe<Scalars['NonNegativeInt']>;
  name?: InputMaybe<Scalars['String']>;
  patient?: InputMaybe<Scalars['ID']>;
  pms_created_at?: InputMaybe<Scalars['Timestamp']>;
  pms_id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['ID']>;
  product_name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['NonNegativeFloat']>;
};

export type UpdatePrescriptionRequestInput = {
  clinic_notes?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pickup_date?: InputMaybe<Scalars['Timestamp']>;
  quantity?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PrescriptionRequestStatus>;
};

export type UpdatePressItemInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<LinkInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateProductInput = {
  category?: InputMaybe<ProductCategory>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pims_category?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateRepeatParamsInput = {
  daysOfMonth?: InputMaybe<Array<Scalars['Int']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  frequency?: InputMaybe<Scalars['PositiveInt']>;
  unit?: InputMaybe<RepeatUnit>;
  weekOfMonth?: InputMaybe<WeekOfMonth>;
};

export type UpdateReportColumnValueInput = {
  percentile?: InputMaybe<Scalars['NonNegativeFloat']>;
  value?: InputMaybe<Scalars['Float']>;
  value_params?: InputMaybe<UpdateMetricValueParamsInput>;
};

export type UpdateReportEntityInput = {
  child_entities?: InputMaybe<Array<UpdateReportEntityInput>>;
  entity_type?: InputMaybe<ReportEntityType>;
};

export type UpdateReportMetricInput = {
  field_modifiers?: InputMaybe<Array<UpdateReportMetricModifierInput>>;
  format?: InputMaybe<MetricFormat>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['NonNegativeInt']>;
  organization_report?: InputMaybe<Scalars['ID']>;
  report_template?: InputMaybe<Scalars['ID']>;
  special_modifier?: InputMaybe<SpecialMetricModifierType>;
  time_params_overrides?: InputMaybe<UpdateTimeParamsInput>;
  type?: InputMaybe<ReportMetricType>;
  value_types?: InputMaybe<Array<UpdateMetricValueParamsInput>>;
};

export type UpdateReportMetricModifierInput = {
  category?: InputMaybe<MetricModifierCategory>;
  column?: InputMaybe<Scalars['String']>;
  filterOp?: InputMaybe<FilterOp>;
  not?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<MetricModifierValueInput>;
};

export type UpdateReportTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  entity_structure?: InputMaybe<Array<UpdateReportEntityInput>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  preferred_view_type?: InputMaybe<ReportViewType>;
  repeat?: InputMaybe<UpdateRepeatParamsInput>;
  time_params?: InputMaybe<UpdateTimeParamsInput>;
};

export type UpdateReportValueInput = {
  column_values?: InputMaybe<Array<UpdateReportColumnValueInput>>;
  key?: InputMaybe<Scalars['String']>;
  metric?: InputMaybe<ReportMetricType>;
};

export type UpdateRescheduleInput = {
  appointment?: InputMaybe<Scalars['ID']>;
  client_notes?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  clinic_notes?: InputMaybe<Scalars['String']>;
  confirmed_at?: InputMaybe<Scalars['NonNegativeInt']>;
  initiated_by?: InputMaybe<RescheduleInitiatedBy>;
  reason_for_denial?: InputMaybe<Scalars['String']>;
  requested_drop_off_time?: InputMaybe<Scalars['NonNegativeInt']>;
  requested_start_time?: InputMaybe<Scalars['NonNegativeInt']>;
  status?: InputMaybe<RescheduleStatus>;
};

export type UpdateRoomInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  concurrent_patients?: InputMaybe<Scalars['NonNegativeInt']>;
  description?: InputMaybe<Scalars['String']>;
  hours?: InputMaybe<AvailabilityHoursInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  stagger_offset_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
};

export type UpdateSchedulingRulesInput = {
  adjusted_availability?: InputMaybe<Array<AvailabilityInput>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  client_type?: InputMaybe<ClientTypeEnum>;
  fixed_status?: InputMaybe<FixedStatus>;
  included_clinicians?: InputMaybe<Array<Scalars['ID']>>;
  included_rooms?: InputMaybe<Array<Scalars['ID']>>;
  included_services?: InputMaybe<Array<Scalars['ID']>>;
  included_species?: InputMaybe<Array<Scalars['ID']>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  only_modifier?: InputMaybe<OnlyModifierEnum>;
  patient_gender?: InputMaybe<AnimalGender>;
  patient_type?: InputMaybe<PatientTypeEnum>;
};

export type UpdateServiceInput = {
  allow_new?: InputMaybe<Scalars['Boolean']>;
  allow_returning?: InputMaybe<Scalars['Boolean']>;
  authorized_levels?: InputMaybe<Array<AuthorityLevel>>;
  availability?: InputMaybe<AvailabilityHoursInput>;
  clinic?: InputMaybe<Scalars['ID']>;
  color?: InputMaybe<Scalars['String']>;
  default_room?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  drop_off_hours?: InputMaybe<AvailabilityHoursInput>;
  drop_off_minutes_before?: InputMaybe<Scalars['NonNegativeInt']>;
  duration?: InputMaybe<Scalars['NonNegativeInt']>;
  excluded_species?: InputMaybe<Array<Species>>;
  follow_up_services?: InputMaybe<Array<Scalars['ID']>>;
  follow_up_settings?: InputMaybe<UpdateFollowUpSettingsInput>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  keywords?: InputMaybe<Scalars['String']>;
  max_per_day?: InputMaybe<Scalars['NonNegativeInt']>;
  minimum_patient_age_in_days?: InputMaybe<Scalars['NonNegativeInt']>;
  more_info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pms_appt_type?: InputMaybe<Scalars['ID']>;
  points?: InputMaybe<Scalars['NonNegativeInt']>;
  pricing?: InputMaybe<UpdateServicePricingInput>;
  recurring?: InputMaybe<RecurringSettingsInput>;
  required_room?: InputMaybe<Scalars['ID']>;
  reserved_per_day?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_buffer_minutes?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_max_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  scheduling_min_minutes_away?: InputMaybe<Scalars['NonNegativeInt']>;
  service_types?: InputMaybe<Array<ServiceType>>;
};

export type UpdateServicePricingInput = {
  currency?: InputMaybe<Scalars['Currency']>;
  price?: InputMaybe<Scalars['PositiveInt']>;
  type?: InputMaybe<ServicePricingType>;
};

export type UpdateTimeParamsInput = {
  end?: InputMaybe<Scalars['Timestamp']>;
  from_millis_ago?: InputMaybe<Scalars['Long']>;
  from_periods_ago?: InputMaybe<Scalars['NonNegativeInt']>;
  period_type?: InputMaybe<PeriodType>;
  start?: InputMaybe<Scalars['Timestamp']>;
  to_millis_ago?: InputMaybe<Scalars['Long']>;
  to_periods_ago?: InputMaybe<Scalars['NonNegativeInt']>;
  type?: InputMaybe<TimeParamType>;
};

export type UpdateTransactionInput = {
  amount?: InputMaybe<Scalars['String']>;
  client_pms_id?: InputMaybe<Scalars['ID']>;
  clinician_pms_id?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['NonNegativeInt']>;
  description?: InputMaybe<Scalars['String']>;
  patient_pms_id?: InputMaybe<Scalars['ID']>;
  pms?: InputMaybe<PracticeManagementSystem>;
  pms_id?: InputMaybe<Scalars['String']>;
  service_pms_id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<TransactionType>;
};

export type UpdateTreatmentInput = {
  description?: InputMaybe<Scalars['String']>;
  pms_id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  avatar_url?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  family?: InputMaybe<Scalars['ID']>;
  favorited_clinics?: InputMaybe<Array<Scalars['ID']>>;
  first_name?: InputMaybe<Scalars['String']>;
  has_verified_email?: InputMaybe<Scalars['Boolean']>;
  has_verified_phone?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<AuthRoles>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
};

export type UpdateWidgetInput = {
  average_chat_response_time?: InputMaybe<Scalars['String']>;
  button_color?: InputMaybe<Scalars['String']>;
  button_text?: InputMaybe<Scalars['String']>;
  clinic?: InputMaybe<Scalars['ID']>;
  enabled_chat_buttons?: InputMaybe<Array<WidgetMenuButtonType>>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_external?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<Scalars['String']>;
  text_color?: InputMaybe<Scalars['String']>;
  trigger_type?: InputMaybe<WidgetTriggerType>;
  type?: InputMaybe<WidgetType>;
  widget_name?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  avatar_url?: Maybe<Scalars['String']>;
  clients: Array<Client>;
  clinician?: Maybe<Clinician>;
  created_at: Scalars['Timestamp'];
  email?: Maybe<Scalars['EmailAddress']>;
  family?: Maybe<Family>;
  favorited_clinics?: Maybe<Array<Clinic>>;
  first_name?: Maybe<Scalars['String']>;
  has_verified_email?: Maybe<Scalars['Boolean']>;
  has_verified_phone?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<AuthRoles>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  updated_at: Scalars['Timestamp'];
};

export enum VisitReason {
  AdmissionForProcedure = 'AdmissionForProcedure',
  DayAdmission = 'DayAdmission',
  MedicationOrFoodPickUp = 'MedicationOrFoodPickUp',
  Other = 'Other',
  OutpatientAppointmentWithNurse = 'OutpatientAppointmentWithNurse',
  PatientPickUp = 'PatientPickUp',
  RecheckExam = 'RecheckExam',
  SickVisit = 'SickVisit',
  WellnessVisit = 'WellnessVisit'
}

export enum WeekOfMonth {
  First = 'first',
  Fourth = 'fourth',
  Last = 'last',
  Second = 'second',
  Third = 'third'
}

export type Widget = {
  __typename?: 'Widget';
  average_chat_response_time?: Maybe<Scalars['String']>;
  button_color?: Maybe<Scalars['String']>;
  button_text?: Maybe<Scalars['String']>;
  clinic?: Maybe<Clinic>;
  created_at: Scalars['Timestamp'];
  enabled_chat_buttons?: Maybe<Array<WidgetMenuButtonType>>;
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  is_external: Scalars['Boolean'];
  organization?: Maybe<Organization>;
  source?: Maybe<Scalars['String']>;
  text_color?: Maybe<Scalars['String']>;
  trigger_type: WidgetTriggerType;
  type: WidgetType;
  updated_at: Scalars['Timestamp'];
  widget_name: Scalars['String'];
};

export enum WidgetMenuButtonType {
  Boarding = 'Boarding',
  BookAppointment = 'BookAppointment',
  PrescriptionRefill = 'PrescriptionRefill',
  RescheduleAppointment = 'RescheduleAppointment',
  StartConversation = 'StartConversation'
}

export enum WidgetTriggerType {
  Button = 'Button',
  Inline = 'Inline',
  Modal = 'Modal',
  Tab = 'Tab'
}

export enum WidgetType {
  Booking = 'Booking',
  Chat = 'Chat'
}

export type Result = {
  __typename?: 'result';
  res?: Maybe<Scalars['String']>;
};

export type UserBasicInfoFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null };

export type ActionItemBaseFieldsFragment = { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number };

export type ActionItemFieldsFragment = { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } | null, assignee?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null };

export type AppointmentWithActionItemsFieldsFragment = { __typename?: 'Appointment', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null }> | null };

export type RescheduleWithActionItemsFieldsFragment = { __typename?: 'Reschedule', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null }> | null };

export type GetActionItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetActionItemQuery = { __typename?: 'Query', actionItem: { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } | null, assignee?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type QueryActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryActionItemsQuery = { __typename?: 'Query', queryActionItems: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } | null, assignee?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type CountActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountActionItemsQuery = { __typename?: 'Query', countActionItems: number };

export type QueryAppointmentActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentActionItemsQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null }> | null }> };

export type QueryRescheduleActionItemsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryRescheduleActionItemsQuery = { __typename?: 'Query', queryReschedules: Array<{ __typename?: 'Reschedule', action_items?: Array<{ __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null }> | null }> };

export type UpdateActionItemMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateActionItemInput;
}>;


export type UpdateActionItemMutation = { __typename?: 'Mutation', updateActionItem: { __typename?: 'ActionItem', id: string, type: ActionItemType, status: ActionItemStatus, created_at: number, updated_at: number, pending_appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, reschedule?: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } | null, chat?: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } | null, assignee?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null } };

export type AnimalFieldsFragment = { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number };

export type GetAllAnimalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAnimalsQuery = { __typename?: 'Query', allAnimals: Array<{ __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number }> };

export type CreateAnimalMutationVariables = Exact<{
  data: CreateAnimalInput;
}>;


export type CreateAnimalMutation = { __typename?: 'Mutation', createAnimal: { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number } };

export type UpdateAnimalMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateAnimalInput;
}>;


export type UpdateAnimalMutation = { __typename?: 'Mutation', updateAnimal: { __typename?: 'Animal', id: string, name?: string | null, image?: string | null, created_at: number, updated_at: number } };

export type DeleteAnimalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAnimalMutation = { __typename?: 'Mutation', deleteAnimal?: any | null };

export type AppointmentPromptFieldsFragment = { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null };

export type GetAppointmentPromptQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAppointmentPromptQuery = { __typename?: 'Query', appointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null } };

export type AllAppointmentPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAppointmentPromptsQuery = { __typename?: 'Query', allAppointmentPrompts: Array<{ __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null }> };

export type QueryAppointmentPromptsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentPromptsQuery = { __typename?: 'Query', queryAppointmentPrompts: Array<{ __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null }> };

export type CreateAppointmentPromptMutationVariables = Exact<{
  data: CreateAppointmentPromptInput;
}>;


export type CreateAppointmentPromptMutation = { __typename?: 'Mutation', createAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null } };

export type SendAppointmentPromptMutationVariables = Exact<{
  data: CreateAppointmentPromptInput;
}>;


export type SendAppointmentPromptMutation = { __typename?: 'Mutation', sendAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null } };

export type UpdateAppointmentPromptMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateAppointmentPromptInput;
}>;


export type UpdateAppointmentPromptMutation = { __typename?: 'Mutation', updateAppointmentPrompt: { __typename?: 'AppointmentPrompt', id: string, client_notes?: string | null, clinic_notes?: string | null, confirmed_at?: number | null, minutes?: number | null, reason_for_denial?: string | null, service_name?: string | null, start_time?: number | null, type: AppointmentPromptType, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } | null } };

export type AppointmentBaseFieldsFragment = { __typename?: 'Appointment', id: string };

export type AppointmentPreviewFieldsFragment = { __typename?: 'Appointment', id: string, start_time: number, drop_off_time?: number | null, minutes: number };

export type AppointmentFieldsFragment = { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null };

export type PublicAppointmentTimeFieldsFragment = { __typename?: 'PublicAppointmentTime', start_time: number, minutes: number, clinician_id?: string | null, room_id?: string | null, is_time_block?: boolean | null };

export type TimeSlotClinicianFieldsFragment = { __typename?: 'Clinician', id: string, name: string };

export type TimeSlotFieldsFragment = { __typename?: 'TimeSlot', start_time: number, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }> };

export type ClientInfoFieldsFragment = { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null };

export type PatientInfoFieldsFragment = { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null };

export type GetPublicAppointmentTimesQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type GetPublicAppointmentTimesQuery = { __typename?: 'Query', publicAppointmentTimes?: Array<{ __typename?: 'PublicAppointmentTime', start_time: number, minutes: number, clinician_id?: string | null, room_id?: string | null, is_time_block?: boolean | null }> | null };

export type GetAllAppointmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAppointmentsQuery = { __typename?: 'Query', allAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }> };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAppointmentQuery = { __typename?: 'Query', appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type SearchAppointmentsQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type SearchAppointmentsQuery = { __typename?: 'Query', searchAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }> };

export type QueryAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryAppointmentsQuery = { __typename?: 'Query', queryAppointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }> };

export type CountAppointmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountAppointmentsQuery = { __typename?: 'Query', countAppointments: number };

export type SearchAppointmentsStatusQueryVariables = Exact<{
  searchInput: SearchAppointmentsInput;
}>;


export type SearchAppointmentsStatusQuery = { __typename?: 'Query', searchAppointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatus }> };

export type GetNewAppointmentsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
}>;


export type GetNewAppointmentsForClinicQuery = { __typename?: 'Query', getNewAppointmentsForClinic: number };

export type GetAppointmentsByClinicAndRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetAppointmentsByClinicAndRangeQuery = { __typename?: 'Query', appointmentsByClinicAndRange: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }> };

export type GetTimeSlotsForClinicForDayQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  date: Scalars['NonNegativeInt'];
}>;


export type GetTimeSlotsForClinicForDayQuery = { __typename?: 'Query', getTimeSlotsForClinicForDay: { __typename?: 'ScheduleData', schedule_efficiency: number, time_slots: Array<{ __typename?: 'TimeSlot', start_time: number, clinicians: Array<{ __typename?: 'Clinician', id: string, name: string }> }> } };

export type CreateAppointmentMutationVariables = Exact<{
  data: CreateAppointmentInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type UpdateAppointmentMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', updateAppointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type MarkAppointmentAsResolvedMutationVariables = Exact<{
  id: Scalars['ID'];
  reason?: InputMaybe<ResolveReason>;
}>;


export type MarkAppointmentAsResolvedMutation = { __typename?: 'Mutation', markAppointmentAsResolved: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type ConfirmAppointmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConfirmAppointmentMutation = { __typename?: 'Mutation', confirmAppointment: boolean };

export type UpdateAppointmentClientPatientMutationVariables = Exact<{
  id: Scalars['ID'];
  clientId?: InputMaybe<Scalars['ID']>;
  patientId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateAppointmentClientPatientMutation = { __typename?: 'Mutation', updateAppointmentClientPatient: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type DeleteAppointmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAppointmentMutation = { __typename?: 'Mutation', deleteAppointment?: any | null };

export type BreedFieldsFragment = { __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string };

export type GetBreedsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetBreedsByClinicQuery = { __typename?: 'Query', getBreedsByClinic: Array<{ __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string }> };

export type QueryBreedsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryBreedsQuery = { __typename?: 'Query', queryBreeds: Array<{ __typename?: 'Breed', id: string, pms_id: string, species?: Species | null, description: string }> };

export type ChatFieldsFragment = { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } };

export type GetChatQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetChatQuery = { __typename?: 'Query', chat: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } };

export type GetChatsByClientIdQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type GetChatsByClientIdQuery = { __typename?: 'Query', getChatsByClientId: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } }> };

export type GetChatsByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type GetChatsByClinicIdQuery = { __typename?: 'Query', getChatsByClinicId: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } }> };

export type QueryChatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryChatsQuery = { __typename?: 'Query', queryChats: Array<{ __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } }> };

export type CountChatsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountChatsQuery = { __typename?: 'Query', countChats: number };

export type GetChatByClientAndClinicQueryVariables = Exact<{
  clientId: Scalars['ID'];
  clinicId: Scalars['ID'];
}>;


export type GetChatByClientAndClinicQuery = { __typename?: 'Query', getChatByClientAndClinic?: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } | null };

export type CreateChatMutationVariables = Exact<{
  data: CreateChatInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', createChat: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } };

export type UpdateChatMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateChatInput;
}>;


export type UpdateChatMutation = { __typename?: 'Mutation', updateChat: { __typename?: 'Chat', id: string, title?: string | null, client_last_read: number, client_last_read_count: number, client_unread_count: number, client_message_count: number, clinic_unread_count: number, clinic_last_read: number, clinic_last_read_count: number, clinic_message_count: number, message_count: number, last_message?: string | null, last_message_time: number, status: ChatStatus, is_hidden: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null, is_deceased?: boolean | null }> | null } } };

export type UploadAttachmentMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: AttachmentInput;
}>;


export type UploadAttachmentMutation = { __typename?: 'Mutation', uploadAttachment?: any | null };

export type CheckInFieldsFragment = { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } };

export type GetCheckInQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCheckInQuery = { __typename?: 'Query', checkIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type GetCheckInsByUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetCheckInsByUserQuery = { __typename?: 'Query', getCheckInsByUser: Array<{ __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type GetCheckInsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetCheckInsByClinicQuery = { __typename?: 'Query', getCheckInsByClinic: Array<{ __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type CreateCheckInMutationVariables = Exact<{
  data: CreateCheckInInput;
}>;


export type CreateCheckInMutation = { __typename?: 'Mutation', createCheckIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type UpdateCheckInMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateCheckInInput;
}>;


export type UpdateCheckInMutation = { __typename?: 'Mutation', updateCheckIn: { __typename?: 'CheckIn', id: string, status?: CheckInStatus | null, vehicle?: string | null, visit_reason?: VisitReason | null, created_at: number, updated_at: number, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type ClientFormFieldsFragment = { __typename?: 'ClientForm', id: string, form_data?: any | null, client_completed_at?: number | null, clinic_verified_at?: number | null, created_at: number, updated_at: number, client: { __typename?: 'Client', id: string }, form: { __typename?: 'Form', id: string } };

export type CreateClientFormMutationVariables = Exact<{
  data: CreateClientFormInput;
}>;


export type CreateClientFormMutation = { __typename?: 'Mutation', createClientForm: { __typename?: 'ClientForm', id: string, form_data?: any | null, client_completed_at?: number | null, clinic_verified_at?: number | null, created_at: number, updated_at: number, client: { __typename?: 'Client', id: string }, form: { __typename?: 'Form', id: string } } };

export type UpdateClientFormMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClientFormInput;
}>;


export type UpdateClientFormMutation = { __typename?: 'Mutation', updateClientForm: { __typename?: 'ClientForm', id: string, form_data?: any | null, client_completed_at?: number | null, clinic_verified_at?: number | null, created_at: number, updated_at: number, client: { __typename?: 'Client', id: string }, form: { __typename?: 'Form', id: string } } };

export type QueryClientFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClientFormsQuery = { __typename?: 'Query', queryClientForms: Array<{ __typename?: 'ClientForm', id: string, form_data?: any | null, client_completed_at?: number | null, clinic_verified_at?: number | null, created_at: number, updated_at: number, client: { __typename?: 'Client', id: string }, form: { __typename?: 'Form', id: string } }> };

export type CountClientFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClientFormsQuery = { __typename?: 'Query', countClientForms: number };

export type ClientPreviewFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, last_appt_time?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null };

export type ClientLoyaltyMemberFieldsFragment = { __typename?: 'LoyaltyMember', id: string, available_points: number };

export type ClientFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } };

export type CheckExistingClientsQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type CheckExistingClientsQuery = { __typename?: 'Query', checkExistingClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }> };

export type CheckExistingClientQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
}>;


export type CheckExistingClientQuery = { __typename?: 'Query', checkExistingClient?: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }> | null };

export type GetClientsWithNegativeBalancesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetClientsWithNegativeBalancesForClinicQuery = { __typename?: 'Query', getClientsWithNegativeBalancesForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }> };

export type GetClientsWithoutApptOverDaysForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  days: Scalars['NonNegativeInt'];
}>;


export type GetClientsWithoutApptOverDaysForClinicQuery = { __typename?: 'Query', getClientsWithoutApptOverDaysForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }> };

export type GetNewClientsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
}>;


export type GetNewClientsForClinicQuery = { __typename?: 'Query', getNewClientsForClinic: number };

export type QueryClientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClientsQuery = { __typename?: 'Query', queryClients: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, last_appt_time?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null }> };

export type QueryClientsPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClientsPatientsQuery = { __typename?: 'Query', queryClientsPatients: { __typename?: 'QueryClientsPatientsResults', results: Array<{ __typename?: 'QueryClientsPatientsResult', client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, last_appt_time?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null } | null, patients: Array<{ __typename?: 'Patient', id: string, name?: string | null }> }> } };

export type CountClientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClientsQuery = { __typename?: 'Query', countClients: number };

export type CreateClientMutationVariables = Exact<{
  data: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient?: any | null };

export type AddClinicToClientMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  clientId: Scalars['ID'];
}>;


export type AddClinicToClientMutation = { __typename?: 'Mutation', addClinicToClient: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } };

export type ClinicAdminFieldsFragment = { __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } };

export type ClinicAdminFieldsForLoginFragment = { __typename?: 'ClinicAdmin', id: string, clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null } };

export type GetClinicAdminQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GetClinicAdminQuery = { __typename?: 'Query', getClinicAdmin: { __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } } };

export type GetClinicAdminsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetClinicAdminsByClinicQuery = { __typename?: 'Query', getClinicAdminsByClinic: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }> };

export type GetClinicAdminsByUserQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetClinicAdminsByUserQuery = { __typename?: 'Query', getClinicAdminsByUser: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }> };

export type GetClinicAdminsForLoginQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetClinicAdminsForLoginQuery = { __typename?: 'Query', getClinicAdminsByUser: Array<{ __typename?: 'ClinicAdmin', id: string, clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null } }> };

export type CreateClinicAdminMutationVariables = Exact<{
  data: CreateClinicAdminInput;
}>;


export type CreateClinicAdminMutation = { __typename?: 'Mutation', createClinicAdmin: { __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } } };

export type UpdateClinicAdminMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  userId: Scalars['ID'];
  data: UpdateClinicAdminInput;
}>;


export type UpdateClinicAdminMutation = { __typename?: 'Mutation', updateClinicAdmin: { __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } } };

export type DeleteClinicAdminMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type DeleteClinicAdminMutation = { __typename?: 'Mutation', deleteClinicAdmin?: any | null };

export type ClinicAnalyticsFieldsFragment = { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> };

export type AnalyticsNumbersFieldsFragment = { __typename?: 'AnalyticsNumbers', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number };

export type GetClinicAnalyticsQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
}>;


export type GetClinicAnalyticsQuery = { __typename?: 'Query', clinicAnalytics: { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> } };

export type GetAnalyticsNumbersByMonthsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
}>;


export type GetAnalyticsNumbersByMonthsForClinicQuery = { __typename?: 'Query', getAnalyticsNumbersByMonthsForClinic: Array<{ __typename?: 'AnalyticsNumbersByMonth', month: number, year: number, analytics: { __typename?: 'AnalyticsNumbers', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number } }> };

export type GetRevenueByMonthsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
}>;


export type GetRevenueByMonthsForClinicQuery = { __typename?: 'Query', getRevenueByMonthsForClinic: Array<{ __typename?: 'RevenueByMonth', month: number, year: number, revenue: number }> };

export type ClinicSexFieldsFragment = { __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean };

export type QueryClinicSexesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicSexesQuery = { __typename?: 'Query', queryClinicSexes: Array<{ __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean }> };

export type UpdateClinicSexMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClinicSexInput;
}>;


export type UpdateClinicSexMutation = { __typename?: 'Mutation', updateClinicSex: { __typename?: 'ClinicSex', id: string, pms_id: string, name: string, description?: string | null, animal_gender?: AnimalGender | null, fixed_statuses: Array<FixedStatus>, included_species: Array<Species>, is_active: boolean } };

export type ClinicSpeciesFieldsFragment = { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number };

export type GetClinicSpeciesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetClinicSpeciesByClinicQuery = { __typename?: 'Query', getClinicSpeciesByClinic: Array<{ __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number }> };

export type QueryClinicSpeciesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicSpeciesQuery = { __typename?: 'Query', queryClinicSpecies: Array<{ __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number }> };

export type MakePrimaryClinicSpeciesMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  speciesId: Scalars['ID'];
}>;


export type MakePrimaryClinicSpeciesMutation = { __typename?: 'Mutation', makePrimaryClinicSpecies: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } };

export type UpdateClinicSpeciesMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  speciesId: Scalars['ID'];
  data: UpdateClinicSpeciesInput;
}>;


export type UpdateClinicSpeciesMutation = { __typename?: 'Mutation', updateClinicSpecies: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } };

export type GetRevenueForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetRevenueForTimeRangeQuery = { __typename?: 'Query', getRevenueForTimeRange: number };

export type GetRevenuesByTypeForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetRevenuesByTypeForTimeRangeQuery = { __typename?: 'Query', getRevenuesByTypeForTimeRange: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }> };

export type GetRevenuesByClinicianForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetRevenuesByClinicianForTimeRangeQuery = { __typename?: 'Query', getRevenuesByClinicianForTimeRange: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }> };

export type GetAccountsReceivableQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetAccountsReceivableQuery = { __typename?: 'Query', getAccountsReceivable: number };

export type ClinicianServiceFieldsFragment = { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } };

export type GetClinicianServicesByServiceQueryVariables = Exact<{
  serviceId: Scalars['ID'];
}>;


export type GetClinicianServicesByServiceQuery = { __typename?: 'Query', getClinicianServicesByService: Array<{ __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } }> };

export type CreateClinicianServiceMutationVariables = Exact<{
  data: CreateClinicianServiceInput;
}>;


export type CreateClinicianServiceMutation = { __typename?: 'Mutation', createClinicianService: { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } } };

export type UpdateClinicianServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClinicianServiceInput;
}>;


export type UpdateClinicianServiceMutation = { __typename?: 'Mutation', updateClinicianService: { __typename?: 'ClinicianService', id: string, duration_override?: number | null, created_at: number, updated_at: number, clinician: { __typename?: 'Clinician', id: string, name: string }, service: { __typename?: 'Service', id: string } } };

export type DeleteClinicianServiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClinicianServiceMutation = { __typename?: 'Mutation', deleteClinicianService?: any | null };

export type AvailabilityDayFieldsFragment = { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null };

export type AdjustedAvailabilityFieldsFragment = { __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null };

export type ClinicianFieldsFragment = { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null };

export type GetClinicianQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClinicianQuery = { __typename?: 'Query', clinician: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type GetCliniciansByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  usingRooms?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCliniciansByClinicQuery = { __typename?: 'Query', getCliniciansByClinic: Array<{ __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null }> };

export type QueryCliniciansQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryCliniciansQuery = { __typename?: 'Query', queryClinicians: Array<{ __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null }> };

export type CreateClinicianMutationVariables = Exact<{
  data: CreateClinicianInput;
}>;


export type CreateClinicianMutation = { __typename?: 'Mutation', createClinician: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type UpdateClinicianMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClinicianInput;
}>;


export type UpdateClinicianMutation = { __typename?: 'Mutation', updateClinician: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type DeleteClinicianMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClinicianMutation = { __typename?: 'Mutation', deleteClinician?: any | null };

export type ClinicFieldsFragment = { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null };

export type ClinicFeatureFieldsFragment = { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null };

export type ClinicSettingsFieldsFragment = { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null };

export type ClinicPreviewFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null };

export type ClinicStatsFieldsFragment = { __typename?: 'ClinicStats', completed_appointments: number, confirmed_appointments: number, booked_appointments: number, pending_appointments: number, cancelled_appointments: number, denied_appointments: number, expired_appointments: number, total_appointments: number, total_website_appointments: number, total_widget_appointments: number };

export type GetAllClinicsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type GetAllClinicsQuery = { __typename?: 'Query', allClinics: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null }> };

export type GetClinicQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClinicQuery = { __typename?: 'Query', clinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null } };

export type GetClientsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type GetClientsForClinicQuery = { __typename?: 'Query', getClientsForClinic: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }> };

export type GetClientCountForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetClientCountForClinicQuery = { __typename?: 'Query', getClientCountForClinic: number };

export type GetClinicsForUserAdminQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type GetClinicsForUserAdminQuery = { __typename?: 'Query', getClinicsForUserAdmin: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null }> };

export type SearchClinicsQueryVariables = Exact<{
  text: Scalars['String'];
  size: Scalars['PositiveInt'];
  page: Scalars['NonNegativeInt'];
}>;


export type SearchClinicsQuery = { __typename?: 'Query', searchClinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }> };

export type QueryClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryClinicsQuery = { __typename?: 'Query', queryClinics: Array<{ __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null }> };

export type CountClinicsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountClinicsQuery = { __typename?: 'Query', countClinics: number };

export type ClinicStatsQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type ClinicStatsQuery = { __typename?: 'Query', clinicStats: { __typename?: 'ClinicStats', completed_appointments: number, confirmed_appointments: number, booked_appointments: number, pending_appointments: number, cancelled_appointments: number, denied_appointments: number, expired_appointments: number, total_appointments: number, total_website_appointments: number, total_widget_appointments: number } };

export type GetTotalRevenueForClinicBetweenTimesQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  endTime: Scalars['NonNegativeInt'];
  startTime: Scalars['NonNegativeInt'];
}>;


export type GetTotalRevenueForClinicBetweenTimesQuery = { __typename?: 'Query', getTotalRevenueForClinicBetweenTimes: number };

export type CreateClinicMutationVariables = Exact<{
  data: CreateClinicInput;
  shouldCreateWidget?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateClinicMutation = { __typename?: 'Mutation', createClinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null } };

export type UpdateClinicMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateClinicInput;
}>;


export type UpdateClinicMutation = { __typename?: 'Mutation', updateClinic: { __typename?: 'Clinic', id: string, slug?: string | null, name?: string | null, description?: string | null, email?: string | null, phone?: string | null, send_from_phone?: string | null, website?: string | null, pms: PracticeManagementSystem, pms_api_key?: string | null, pms_additional_key?: string | null, office_emails?: Array<string> | null, avatar_url?: string | null, time_zone?: string | null, is_archived: boolean, created_at: number, updated_at: number, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string, role: string, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, avatar_url?: string | null, is_verified?: boolean | null, is_archived: boolean, description?: string | null, pms: PracticeManagementSystem, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null } | null, clinic_admins: Array<{ __typename?: 'ClinicAdmin', id: string }>, organization?: { __typename?: 'Organization', id: string } | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null, lat?: number | null, lng?: number | null } | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } }>, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null, services: Array<{ __typename?: 'Service', id: string, name?: string | null }>, settings?: { __typename?: 'ClinicSettings', does_require_verification?: boolean | null, is_using_detailed_services?: boolean | null, is_using_rooms?: boolean | null, pms_start_time?: any | null, pms_end_time?: any | null, primary_color?: string | null, new_appt_requested_msg?: string | null, new_appt_approved_msg?: string | null, new_appt_denied_msg?: string | null, schedule_method?: ScheduleMethod | null, scheduling_buffer_minutes?: number | null, base_schedule_duration?: number | null, does_require_referral?: boolean | null, appointment_entry_method?: AppointmentEntryMethod | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, included_species?: Array<Species> | null, max_patients_per_visit?: number | null, should_complete_sync?: boolean | null, server_syncing_only?: boolean | null, confirmation_days_before?: number | null, send_confirmations_to: SendConfirmationsTo, send_new_appt_email?: boolean | null, send_reviews_to?: SendConfirmationsTo | null, max_review_rating_for_notif?: number | null, google_review_link?: string | null, facebook_review_link?: string | null, non_blocking_services: Array<string>, yesterday_revenue?: number | null, this_month_revenue?: number | null, hide_clinician_preference: boolean, does_use_rooms_to_schedule?: boolean | null, primary_room_pms_id?: string | null, does_use_clinicians_to_schedule?: boolean | null, time_slot_minutes: number, primary_clinician_pms_id?: string | null, allow_first_appt_per_day?: boolean | null, custom_well_description?: string | null, custom_sick_description?: string | null } | null, onboarding?: { __typename?: 'ClinicOnboarding', has_set_hours?: boolean | null, has_synced_pms?: boolean | null } | null, organization?: { __typename?: 'Organization', id: string } | null, features?: { __typename?: 'ClinicFeatures', scheduling_enabled?: boolean | null, huddle_enabled?: boolean | null, payments_enabled?: boolean | null, messaging_enabled?: boolean | null, reviews_enabled?: boolean | null, loyalty_enabled?: boolean | null, notifs_enabled?: boolean | null, forms_enabled?: boolean | null, help_enabled?: boolean | null } | null, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null, last_synced_times?: { __typename?: 'ClinicLastSyncedTimes', last_full_sync?: number | null, last_sync_appointments?: number | null, last_sync_clients?: number | null, last_sync_patients?: number | null, last_sync_clinicians?: number | null, last_sync_services?: number | null, last_sync_transactions?: number | null, last_sync_invoices?: number | null, last_sync_history_items?: number | null, last_sync_diagnoses?: number | null, last_sync_prescriptions?: number | null, last_sync_products?: number | null, last_sync_rooms?: number | null, last_sync_species?: number | null } | null } };

export type DeleteClinicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClinicMutation = { __typename?: 'Mutation', deleteClinic?: any | null };

export type ConnectInstallationFieldsFragment = { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number };

export type GetConnectInstallationQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
}>;


export type GetConnectInstallationQuery = { __typename?: 'Query', connectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type GetConnectInstallationsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetConnectInstallationsByClinicQuery = { __typename?: 'Query', getConnectInstallationsByClinic: Array<{ __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number }> };

export type CheckIfServerRunningQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type CheckIfServerRunningQuery = { __typename?: 'Query', checkIfServerRunning: boolean };

export type GetLastServerHeartbeatForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetLastServerHeartbeatForClinicQuery = { __typename?: 'Query', getLastServerHeartbeatForClinic?: { __typename?: 'HeartbeatResponse', version: string, last_ping: number } | null };

export type TriggerServiceUpdateMutationVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type TriggerServiceUpdateMutation = { __typename?: 'Mutation', triggerServiceUpdateForClinic: boolean };

export type CreateConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
  data: CreateConnectInstallationInput;
}>;


export type CreateConnectInstallationMutation = { __typename?: 'Mutation', createConnectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type UpdateConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
  data: UpdateConnectInstallationInput;
}>;


export type UpdateConnectInstallationMutation = { __typename?: 'Mutation', updateConnectInstallation: { __typename?: 'ConnectInstallation', id: string, computer_name?: string | null, last_ping?: number | null, is_server?: boolean | null, version?: string | null, connect_ui_version?: string | null, connect_server_version?: string | null, created_at: number, updated_at: number } };

export type DeleteConnectInstallationMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  installationId: Scalars['ID'];
}>;


export type DeleteConnectInstallationMutation = { __typename?: 'Mutation', deleteConnectInstallation?: any | null };

export type QueryFilterFieldsFragment = { __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } };

export type CustomerSegmentFieldsFragment = { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> };

export type CustomerSegmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerSegmentQuery = { __typename?: 'Query', customerSegment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> } };

export type GetCustomerSegmentsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type GetCustomerSegmentsForClinicQuery = { __typename?: 'Query', getCustomerSegmentsForClinic: Array<{ __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }> };

export type QueryCustomerSegmentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryCustomerSegmentsQuery = { __typename?: 'Query', queryCustomerSegments: Array<{ __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }> };

export type GetClientsByCustomerSegmentRpcQueryVariables = Exact<{
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
}>;


export type GetClientsByCustomerSegmentRpcQuery = { __typename?: 'Query', getClientsByCustomerSegmentRPC: { __typename?: 'CustSegRPCResult', count: number, results: Array<{ __typename?: 'CustSegResult', client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, last_appt_time?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, patients?: Array<{ __typename?: 'Patient', id: string, name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, species: Species } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null }, appointment?: { __typename?: 'Appointment', id: string, start_time: number, drop_off_time?: number | null, minutes: number } | null, patient?: { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, is_deceased?: boolean | null } | null }> } };

export type CreateCustomerSegmentMutationVariables = Exact<{
  data: CreateCustomerSegmentInput;
}>;


export type CreateCustomerSegmentMutation = { __typename?: 'Mutation', createCustomerSegment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> } };

export type UpdateCustomerSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateCustomerSegmentInput;
}>;


export type UpdateCustomerSegmentMutation = { __typename?: 'Mutation', updateCustomerSegment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> } };

export type DeleteCustomerSegmentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCustomerSegmentMutation = { __typename?: 'Mutation', deleteCustomerSegment?: any | null };

export type DailyHuddleFieldsFragment = { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null };

export type GetDailyHuddleQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  dailyHuddleId: Scalars['ID'];
}>;


export type GetDailyHuddleQuery = { __typename?: 'Query', dailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type GetDailyHuddlesByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetDailyHuddlesByClinicQuery = { __typename?: 'Query', getDailyHuddlesByClinic: Array<{ __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null }> };

export type CreateDailyHuddleMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: CreateDailyHuddleInput;
}>;


export type CreateDailyHuddleMutation = { __typename?: 'Mutation', createDailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type UpdateDailyHuddleMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  dailyHuddleId: Scalars['ID'];
  data: UpdateDailyHuddleInput;
}>;


export type UpdateDailyHuddleMutation = { __typename?: 'Mutation', updateDailyHuddle: { __typename?: 'DailyHuddle', id: string, notes?: string | null, start_time: number, end_time?: number | null, created_at: number, updated_at: number, leader?: { __typename?: 'Clinician', id: string, name: string } | null, attendees?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null } };

export type DiagnosisFieldsFragment = { __typename?: 'Diagnosis', id: string, pms_id: string, name: string };

export type QueryDiagnosesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryDiagnosesQuery = { __typename?: 'Query', queryDiagnoses: Array<{ __typename?: 'Diagnosis', id: string, pms_id: string, name: string }> };

export type EntityReportSharedFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type EntityReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type FirstChildReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type SecondChildReportFieldsFragment = { __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> };

export type ReportValueFieldsFragment = { __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> };

export type EntityReportClinicianFieldsFragment = { __typename?: 'Clinician', id: string, name: string };

export type EntityReportServiceFieldsFragment = { __typename?: 'Service', id: string, name?: string | null };

export type EntityReportProductFieldsFragment = { __typename?: 'Product', id: string, name: string };

export type QueryEntityReportsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryEntityReportsQuery = { __typename?: 'Query', queryEntityReports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }> };

export type OrganizationReportFieldsFragment = { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization: { __typename?: 'Organization', id: string, name: string }, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, special_modifier?: SpecialMetricModifierType | null, format?: MetricFormat | null, order: number, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null };

export type OrganizationReportPreviewFieldsFragment = { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, is_hidden: boolean, created_at: number, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', name?: string | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, report_template?: { __typename?: 'ReportTemplate', id: string, name: string } | null };

export type GetOrganizationReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationReportQuery = { __typename?: 'Query', organizationReport: { __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization: { __typename?: 'Organization', id: string, name: string }, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, special_modifier?: SpecialMetricModifierType | null, format?: MetricFormat | null, order: number, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null } };

export type QueryOrganizationReportsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationReportsQuery = { __typename?: 'Query', queryOrganizationReports: Array<{ __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, is_hidden: boolean, created_at: number, updated_at: number, organization: { __typename?: 'Organization', id: string, name: string }, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, special_modifier?: SpecialMetricModifierType | null, format?: MetricFormat | null, order: number, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }> }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, entity_reports: Array<{ __typename?: 'EntityReport', id: string, entity_type: ReportEntityType, created_at: number, updated_at: number, entity_reports: Array<{ __typename?: 'EntityReport', id: string }>, clinic?: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null, product?: { __typename?: 'Product', id: string, name: string } | null, values: Array<{ __typename?: 'ReportValue', metric: ReportMetricType, key: string, column_values: Array<{ __typename?: 'ReportColumnValue', value: number, percentile?: number | null, value_params: { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType } }> }> }>, report_template?: { __typename?: 'ReportTemplate', id: string } | null }> };

export type QueryOrganizationReportPreviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationReportPreviewsQuery = { __typename?: 'Query', queryOrganizationReports: Array<{ __typename?: 'OrganizationReport', id: string, name: string, description?: string | null, is_hidden: boolean, created_at: number, report_clinics: Array<{ __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', name?: string | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, report_template?: { __typename?: 'ReportTemplate', id: string, name: string } | null }> };

export type ReportClinicClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null };

export type ReportClinicFieldsFragment = { __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } };

export type CreateReportClinicMutationVariables = Exact<{
  data: CreateReportClinicInput;
}>;


export type CreateReportClinicMutation = { __typename?: 'Mutation', createReportClinic: { __typename?: 'ReportClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } } };

export type DeleteReportClinicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteReportClinicMutation = { __typename?: 'Mutation', deleteReportClinic?: any | null };

export type ReportMetricFieldsFragment = { __typename?: 'ReportMetric', id: string, key: string, type: ReportMetricType, name: string, special_modifier?: SpecialMetricModifierType | null, format?: MetricFormat | null, order: number, time_params_overrides?: { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null } | null, field_modifiers: Array<{ __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, float?: number | null, boolean?: boolean | null } }>, value_types: Array<{ __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType }> };

export type TimeParamFieldsFragment = { __typename?: 'TimeParams', type: TimeParamType, from_millis_ago?: any | null, to_millis_ago?: any | null, period_type?: PeriodType | null, from_periods_ago?: number | null, to_periods_ago?: number | null, start?: number | null, end?: number | null };

export type MetricValueParamsFieldsFragment = { __typename?: 'MetricValueParams', custom_label?: string | null, value_type: MetricValueType };

export type ReportMetricModifierFieldsFragment = { __typename?: 'ReportMetricModifier', category: MetricModifierCategory, column: string, not?: boolean | null, filterOp: FilterOp, value: { __typename?: 'MetricModifierValue', string?: string | null, float?: number | null, boolean?: boolean | null } };

export type ReportTemplateFieldsFragment = { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, repeat: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null }, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }> };

export type ReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null };

export type ChildReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null };

export type SecondChildReportEntityFieldsFragment = { __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null };

export type RepeatParamsFieldsFragment = { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null };

export type GetReportTemplateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetReportTemplateQuery = { __typename?: 'Query', reportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, repeat: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null }, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }> } };

export type QueryReportTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReportTemplatesQuery = { __typename?: 'Query', queryReportTemplates: Array<{ __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, repeat: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null }, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }> }> };

export type CreateReportTemplateMutationVariables = Exact<{
  data: CreateReportTemplateInput;
}>;


export type CreateReportTemplateMutation = { __typename?: 'Mutation', createReportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, repeat: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null }, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }> } };

export type UpdateReportTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateReportTemplateInput;
}>;


export type UpdateReportTemplateMutation = { __typename?: 'Mutation', updateReportTemplate: { __typename?: 'ReportTemplate', id: string, name: string, description?: string | null, preferred_view_type: ReportViewType, last_run?: number | null, next_run?: number | null, is_active: boolean, created_at: number, updated_at: number, template_clinics: Array<{ __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } }>, report_metrics: Array<{ __typename?: 'ReportMetric', id: string, name: string, type: ReportMetricType }>, entity_structure: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType, child_entities?: Array<{ __typename?: 'ReportEntity', entity_type: ReportEntityType }> | null }> | null }> | null }>, repeat: { __typename?: 'RepeatParams', frequency: any, unit: RepeatUnit, daysOfWeek?: Array<DayOfWeek> | null, daysOfMonth?: Array<number> | null, weekOfMonth?: WeekOfMonth | null }, organization_reports: Array<{ __typename?: 'OrganizationReport', id: string }> } };

export type TemplateClinicClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null };

export type TemplateClinicFieldsFragment = { __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } };

export type CreateTemplateClinicMutationVariables = Exact<{
  data: CreateTemplateClinicInput;
}>;


export type CreateTemplateClinicMutation = { __typename?: 'Mutation', createTemplateClinic: { __typename?: 'TemplateClinic', id: string, clinic: { __typename?: 'Clinic', id: string, name?: string | null, slug?: string | null, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null, country?: string | null } | null } } };

export type DeleteTemplateClinicMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTemplateClinicMutation = { __typename?: 'Mutation', deleteTemplateClinic?: any | null };

export type FormFieldsFragment = { __typename?: 'Form', id: string, name?: string | null, form_fields?: any | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string } };

export type CreateFormMutationVariables = Exact<{
  data: CreateFormInput;
}>;


export type CreateFormMutation = { __typename?: 'Mutation', createForm: { __typename?: 'Form', id: string, name?: string | null, form_fields?: any | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type UpdateFormMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateFormInput;
}>;


export type UpdateFormMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string, name?: string | null, form_fields?: any | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type QueryFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryFormsQuery = { __typename?: 'Query', queryForms: Array<{ __typename?: 'Form', id: string, name?: string | null, form_fields?: any | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string } }> };

export type CountFormsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountFormsQuery = { __typename?: 'Query', countForms: number };

export type GoalsFieldsFragment = { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } };

export type GetGoalByClinicAndIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
}>;


export type GetGoalByClinicAndIdQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type GetGoalsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetGoalsByClinicQuery = { __typename?: 'Query', getGoalsByClinic: Array<{ __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } }> };

export type CreateGoalMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: CreateGoalInput;
}>;


export type CreateGoalMutation = { __typename?: 'Mutation', createGoal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type UpdateGoalMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
  data: UpdateGoalInput;
}>;


export type UpdateGoalMutation = { __typename?: 'Mutation', updateGoal: { __typename?: 'Goal', id: string, description?: string | null, created_at: number, is_active?: boolean | null, is_chckup_modifier?: boolean | null, is_new_modifier?: boolean | null, is_system?: boolean | null, last_synced_time?: number | null, metric_current_amount: number, metric_entity: GoalEntity, metric_target_amount: number, metric_timespan: GoalTimespan, status: GoalStatus, updated_at: number, clinic: { __typename?: 'Clinic', id: string } } };

export type DeleteGoalMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  goalId: Scalars['ID'];
}>;


export type DeleteGoalMutation = { __typename?: 'Mutation', deleteGoal?: any | null };

export type LoyaltyClientFieldsFragment = { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null };

export type LoyaltyMemberFieldsFragment = { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } };

export type LoyaltyRewardFieldsFragment = { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number };

export type LoyaltyRedemptionFieldsFragment = { __typename?: 'LoyaltyRedemption', id: string, created_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } };

export type GetLoyaltyRewardsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetLoyaltyRewardsForClinicQuery = { __typename?: 'Query', getLoyaltyRewardsForClinic: Array<{ __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number }> };

export type GetLoyaltyMemberFromClientQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type GetLoyaltyMemberFromClientQuery = { __typename?: 'Query', client: { __typename?: 'Client', loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number } | null> | null } };

export type GetLoyaltyMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLoyaltyMemberQuery = { __typename?: 'Query', loyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } } };

export type GetLoyaltyRewardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLoyaltyRewardQuery = { __typename?: 'Query', loyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } };

export type CreateLoyaltyRewardMutationVariables = Exact<{
  data: CreateLoyaltyRewardInput;
}>;


export type CreateLoyaltyRewardMutation = { __typename?: 'Mutation', createLoyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } };

export type UpdateLoyaltyRewardMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateLoyaltyRewardInput;
}>;


export type UpdateLoyaltyRewardMutation = { __typename?: 'Mutation', updateLoyaltyReward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } };

export type DeleteLoyaltyRewardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteLoyaltyRewardMutation = { __typename?: 'Mutation', deleteLoyaltyReward?: any | null };

export type CreateLoyaltyMemberMutationVariables = Exact<{
  data: CreateLoyaltyMemberInput;
}>;


export type CreateLoyaltyMemberMutation = { __typename?: 'Mutation', createLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } } };

export type UpdateLoyaltyMemberMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateLoyaltyMemberInput;
}>;


export type UpdateLoyaltyMemberMutation = { __typename?: 'Mutation', updateLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } } };

export type AddPointsToLoyaltyMemberMutationVariables = Exact<{
  id: Scalars['ID'];
  points: Scalars['NonNegativeInt'];
}>;


export type AddPointsToLoyaltyMemberMutation = { __typename?: 'Mutation', addPointsToLoyaltyMember: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } } };

export type QueryLoyaltyRedemptionsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryLoyaltyRedemptionsQuery = { __typename?: 'Query', queryLoyaltyRedemptions: Array<{ __typename?: 'LoyaltyRedemption', id: string, created_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } }> };

export type CreateLoyaltyRedemptionMutationVariables = Exact<{
  data: CreateLoyaltyRedemptionInput;
}>;


export type CreateLoyaltyRedemptionMutation = { __typename?: 'Mutation', createLoyaltyRedemption: { __typename?: 'LoyaltyRedemption', id: string, created_at: number, member: { __typename?: 'LoyaltyMember', id: string, available_points: number, all_time_points: number, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } }, reward: { __typename?: 'LoyaltyReward', id: string, name: string, description?: string | null, points_required: number, image_url?: string | null, created_at: number, updated_at: number } } };

export type AttachmentFieldsFragment = { __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType };

export type MessagePatientFieldsFragment = { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null };

export type MessageFieldsFragment = { __typename?: 'Message', id: string, text: string, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, cta_text?: string | null, cta_url?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } | null };

export type GetMessagesByChatIdQueryVariables = Exact<{
  chatId: Scalars['ID'];
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  startAtCreatedAt?: InputMaybe<Scalars['NonNegativeInt']>;
  patientId?: InputMaybe<Scalars['ID']>;
}>;


export type GetMessagesByChatIdQuery = { __typename?: 'Query', getMessagesByChatId: Array<{ __typename?: 'Message', id: string, text: string, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, cta_text?: string | null, cta_url?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } | null }> };

export type QueryMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryMessagesQuery = { __typename?: 'Query', queryMessages: Array<{ __typename?: 'Message', id: string, text: string, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, cta_text?: string | null, cta_url?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } | null }> };

export type CountMessagesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountMessagesQuery = { __typename?: 'Query', countMessages: number };

export type CreateMessageMutationVariables = Exact<{
  chatId: Scalars['ID'];
  data: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, text: string, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, cta_text?: string | null, cta_url?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } | null } };

export type UpdateMessageMutationVariables = Exact<{
  chatId: Scalars['ID'];
  messageId: Scalars['ID'];
  data: UpdateMessageInput;
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: string, text: string, message_methods?: Array<MessageMethod> | null, message_type?: MessageType | null, message_origin?: MessageOrigin | null, cta_text?: string | null, cta_url?: string | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } | null, chat: { __typename?: 'Chat', id: string, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null } }, patient?: { __typename?: 'Patient', id: string, name?: string | null, pms_id?: string | null } | null, clinic_user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, filename: string, type: AttachmentType }> | null, notification?: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } | null } };

export type DeleteMessageMutationVariables = Exact<{
  chatId: Scalars['ID'];
  messageId: Scalars['ID'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage?: any | null };

export type NotificationTemplateFieldsFragment = { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } };

export type NotificationTemplateQueryVariables = Exact<{
  notificationTemplateId: Scalars['ID'];
}>;


export type NotificationTemplateQuery = { __typename?: 'Query', notificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type GetNotificationTemplatesByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetNotificationTemplatesByClinicIdQuery = { __typename?: 'Query', getNotificationTemplatesByClinicId: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> };

export type QueryNotificationTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryNotificationTemplatesQuery = { __typename?: 'Query', queryNotificationTemplates: Array<{ __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> };

export type CreateNotificationTemplateMutationVariables = Exact<{
  data: CreateNotificationTemplateInput;
}>;


export type CreateNotificationTemplateMutation = { __typename?: 'Mutation', createNotificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type UpdateNotificationTemplateMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID'];
  data: UpdateNotificationTemplateInput;
}>;


export type UpdateNotificationTemplateMutation = { __typename?: 'Mutation', updateNotificationTemplate: { __typename?: 'NotificationTemplate', id: string, name: string, every_x_hours: number, send_time_minutes?: number | null, body?: string | null, message_methods: Array<MessageMethod>, is_marketing: boolean, is_active: boolean, is_system: boolean, subject?: string | null, cta_text?: string | null, cta_url?: string | null, updated_at: number, created_at: number, notif_attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, type: AttachmentType }> | null, customer_segment: { __typename?: 'CustomerSegment', id: string, name: string, created_at: number, updated_at: number, filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }>, excluded_filters: Array<{ __typename?: 'CustomerSegmentFilter', type: CustomerSegmentFilterType, only_consider_other_rows?: boolean | null, filters: Array<{ __typename?: 'QueryFilter', column: string, filterOp: FilterOp, value: { __typename?: 'QueryFilterValue', string?: string | null, float?: number | null, boolean?: boolean | null, stringArray?: Array<string> | null, floatArray?: Array<number> | null, millisFromNow?: number | null } }> }> }, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type DeleteNotificationTemplateMutationVariables = Exact<{
  notificationTemplateId: Scalars['ID'];
}>;


export type DeleteNotificationTemplateMutation = { __typename?: 'Mutation', deleteNotificationTemplate?: any | null };

export type OrganizationClinicAnalyticsNumbersFieldsFragment = { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } };

export type OrganizationAnalyticsFieldsFragment = { __typename?: 'OrganizationAnalytics', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytics: { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> } };

export type OrganizationAnalyticsNumbersFieldsFragment = { __typename?: 'OrganizationAnalyticsNumbers', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytic_numbers: { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } } };

export type GetOrganizationAnalyticsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
}>;


export type GetOrganizationAnalyticsQuery = { __typename?: 'Query', organizationAnalytics: Array<{ __typename?: 'OrganizationAnalytics', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytics: { __typename?: 'ClinicAnalytics', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, accounts_receivable: number, clients_with_negative_balances_count: number, monthly_revenue_completed: number, monthly_appointments_scheduled: number, last_month_average_revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number, appointments: Array<{ __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null }>, revenue_by_type: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, revenue_by_clinician: Array<{ __typename?: 'RevenueGroup', group: string, amount: number }>, clients_with_negative_balances: Array<{ __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null }>, patients_without_reschedules: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> } }> };

export type GetOrganizationAnalyticsNumbersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
}>;


export type GetOrganizationAnalyticsNumbersQuery = { __typename?: 'Query', organizationAnalyticsNumbers: Array<{ __typename?: 'OrganizationAnalyticsNumbers', clinic: { __typename?: 'Clinic', id: string, name?: string | null, pms: PracticeManagementSystem }, analytic_numbers: { __typename?: 'OrganizationClinicAnalyticsNumbers', appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, no_show_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue: { __typename?: 'FloatPercentile', value: number, percentile: number }, transactions_count: { __typename?: 'IntPercentile', value: number, percentile: number }, revenue_per_appointment: { __typename?: 'FloatPercentile', value: number, percentile: number }, new_clients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number }, new_appointments_count: { __typename?: 'IntPercentile', value: number, percentile: number }, schedule_efficiency: { __typename?: 'FloatPercentile', value: number, percentile: number }, forward_scheduled_patients_count: { __typename?: 'IntPercentile', value: number, percentile: number } } }> };

export type GetOrganizationScheduleEfficiencyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  fromDate: Scalars['NonNegativeInt'];
  toDate: Scalars['NonNegativeInt'];
}>;


export type GetOrganizationScheduleEfficiencyQuery = { __typename?: 'Query', organizationScheduleEfficiency: { __typename?: 'OrganizationScheduleEfficiency', average: number, per_clinic: Array<{ __typename?: 'ClinicsScheduleEfficiency', schedule_efficiency: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null } }> } };

export type GetOrganizationAnalyticsNumbersByMonthsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
}>;


export type GetOrganizationAnalyticsNumbersByMonthsQuery = { __typename?: 'Query', getAnalyticsNumbersByMonthsForOrganization: Array<{ __typename?: 'OrganizationAnalyticsNumbersByMonth', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, analytic_numbers: Array<{ __typename?: 'AnalyticsNumbersByMonth', month: number, year: number, analytics: { __typename?: 'AnalyticsNumbers', appointments_count: number, no_show_count: number, revenue: number, transactions_count: number, revenue_per_appointment: number, new_clients_count: number, new_patients_count: number, new_appointments_count: number, schedule_efficiency: number, forward_scheduled_patients_count: number } }> }> };

export type GetOrganizationRevenueByMonthsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  numMonths: Scalars['NonNegativeInt'];
}>;


export type GetOrganizationRevenueByMonthsQuery = { __typename?: 'Query', getRevenueByMonthsForOrganization: Array<{ __typename?: 'OrganizationRevenueByMonth', clinic: { __typename?: 'Clinic', id: string, name?: string | null }, revenue: Array<{ __typename?: 'RevenueByMonth', revenue: number, month: number, year: number }> }> };

export type OrganizationClinicFieldsFragment = { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null };

export type OrganizationAdminFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }> };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }> } };

export type QueryOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryOrganizationsQuery = { __typename?: 'Query', queryOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }> }> };

export type CountOrganizationsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountOrganizationsQuery = { __typename?: 'Query', countOrganizations: number };

export type CreateOrganizationMutationVariables = Exact<{
  data: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }> } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, created_at: number, updated_at: number, clinics: Array<{ __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null, is_archived: boolean, address?: { __typename?: 'Address', street_a?: string | null, street_b?: string | null, city?: string | null, state?: string | null, zip?: any | null } | null }>, admins: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null }> } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: any | null };

export type PatientHistoryItemFieldsFragment = { __typename?: 'PatientHistoryItem', id: string, issued_at: number, patient: { __typename?: 'Patient', id: string }, diagnosis?: { __typename?: 'Diagnosis', id: string } | null, product?: { __typename?: 'Product', id: string } | null };

export type PatientPreviewFieldsFragment = { __typename?: 'Patient', id: string, name?: string | null, breed?: string | null, is_deceased?: boolean | null };

export type PatientFieldsFragment = { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null };

export type GetPatientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPatientQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } };

export type GetPatientsByClientQueryVariables = Exact<{
  clientId: Scalars['ID'];
}>;


export type GetPatientsByClientQuery = { __typename?: 'Query', getPatientsByClient: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> };

export type GetPatientsByClientsQueryVariables = Exact<{
  clientIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetPatientsByClientsQuery = { __typename?: 'Query', getPatientsByClients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> };

export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery = { __typename?: 'Query', getPatientsWithoutRescheduledAppointmentsForTimeRange: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> };

export type GetNewPatientsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  fromPmsCreatedAt: Scalars['NonNegativeInt'];
  toPmsCreatedAt: Scalars['NonNegativeInt'];
}>;


export type GetNewPatientsForClinicQuery = { __typename?: 'Query', getNewPatientsForClinic: number };

export type QueryPatientsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPatientsQuery = { __typename?: 'Query', queryPatients: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> };

export type CreatePatientMutationVariables = Exact<{
  data: CreatePatientInput;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } };

export type UpdatePatientMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } };

export type DeletePatientMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePatientMutation = { __typename?: 'Mutation', deletePatient?: any | null };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } } | null };

export type GetPaymentsByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetPaymentsByClinicIdQuery = { __typename?: 'Query', getPaymentsByClinicId: Array<{ __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } }> };

export type QueryPaymentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryPaymentsQuery = { __typename?: 'Query', queryPayments: Array<{ __typename?: 'Payment', id: string, payment_method_id?: string | null, stripe_payment_intent_id?: string | null, amount: any, category: PurchaseCategory, status: PaymentStatus, date: number, created_at: number, updated_at: number, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null, client: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null }, clinic: { __typename?: 'Clinic', id: string } }> };

export type CountPaymentsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountPaymentsQuery = { __typename?: 'Query', countPayments: number };

export type PatientRecordFieldsFragment = { __typename?: 'PatientRecord', id: string, date?: number | null, assisting_clinicians?: Array<string> | null, master_problem_list?: string | null, subjective?: string | null, objective?: string | null, assessment?: string | null, plan?: string | null, public_notes?: string | null, service?: string | null, patient: { __typename?: 'Patient', id: string, name?: string | null, weight?: number | null, breed?: string | null, birthday?: number | null, avatar_url?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null };

export type GetPatientRecordQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPatientRecordQuery = { __typename?: 'Query', patientRecord: { __typename?: 'PatientRecord', id: string, date?: number | null, assisting_clinicians?: Array<string> | null, master_problem_list?: string | null, subjective?: string | null, objective?: string | null, assessment?: string | null, plan?: string | null, public_notes?: string | null, service?: string | null, patient: { __typename?: 'Patient', id: string, name?: string | null, weight?: number | null, breed?: string | null, birthday?: number | null, avatar_url?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null } | null, appointment?: { __typename?: 'Appointment', id: string, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, service?: { __typename?: 'Service', id: string, name?: string | null } | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string } | null, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null } };

export type PimsSettingsFieldsFragment = { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null } };

export type GetPimsSettingsQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetPimsSettingsQuery = { __typename?: 'Query', pimsSettings: { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type CreatePimsSettingsMutationVariables = Exact<{
  data: CreatePimsSettingsInput;
}>;


export type CreatePimsSettingsMutation = { __typename?: 'Mutation', createPimsSettings: { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type UpdatePimsSettingsMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: UpdatePimsSettingsInput;
}>;


export type UpdatePimsSettingsMutation = { __typename?: 'Mutation', updatePimsSettings: { __typename?: 'PimsSettings', username?: string | null, password?: string | null, pin?: string | null, api_key?: string | null, additional_key?: string | null, api_clinic_id?: string | null, api_subdomain?: string | null, pulse_sales_report_id?: string | null, pulse_ar_report_id?: string | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null } } };

export type PmsApptTypeFieldsFragment = { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null };

export type GetPmsApptTypeQueryVariables = Exact<{
  clinidId: Scalars['ID'];
  pmsApptTypeId: Scalars['ID'];
}>;


export type GetPmsApptTypeQuery = { __typename?: 'Query', pmsApptType: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } };

export type GetPmsApptTypesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetPmsApptTypesForClinicQuery = { __typename?: 'Query', getPmsApptTypesForClinic: Array<{ __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null }> };

export type PrescriptionRequestFieldsFragment = { __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } };

export type GetPrescriptionRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPrescriptionRequestQuery = { __typename?: 'Query', prescriptionRequest: { __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type GetPrescriptionRequestsForPatientQueryVariables = Exact<{
  patientId: Scalars['ID'];
}>;


export type GetPrescriptionRequestsForPatientQuery = { __typename?: 'Query', getPrescriptionRequestsForPatient: Array<{ __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type GetPrescriptionRequestsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetPrescriptionRequestsForClinicQuery = { __typename?: 'Query', getPrescriptionRequestsForClinic: Array<{ __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } }> };

export type CreatePrescriptionRequestMutationVariables = Exact<{
  data: CreatePrescriptionRequestInput;
}>;


export type CreatePrescriptionRequestMutation = { __typename?: 'Mutation', createPrescriptionRequest: { __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type UpdatePrescriptionRequestMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdatePrescriptionRequestInput;
}>;


export type UpdatePrescriptionRequestMutation = { __typename?: 'Mutation', updatePrescriptionRequest: { __typename?: 'PrescriptionRequest', id: string, name?: string | null, image?: string | null, quantity?: string | null, pickup_date: number, comments?: string | null, clinic_notes?: string | null, status: PrescriptionRequestStatus, created_at: number, updated_at: number, patient: { __typename?: 'Patient', id: string, name?: string | null, avatar_url?: string | null }, user: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, avatar_url?: string | null }, clinic: { __typename?: 'Clinic', id: string, name?: string | null, avatar_url?: string | null } } };

export type PrescriptionFieldsFragment = { __typename?: 'Prescription', id: string, quantity?: number | null, last_refill_time?: number | null, pms_created_at: number, product?: { __typename?: 'Product', id: string } | null };

export type PressItemFieldsFragment = { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null };

export type GetAllPressItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPressItemsQuery = { __typename?: 'Query', allPressItems: Array<{ __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null }> };

export type GetPressItemQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPressItemQuery = { __typename?: 'Query', pressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type CreatePressItemMutationVariables = Exact<{
  data: CreatePressItemInput;
}>;


export type CreatePressItemMutation = { __typename?: 'Mutation', createPressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type UpdatePressItemMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdatePressItemInput;
}>;


export type UpdatePressItemMutation = { __typename?: 'Mutation', updatePressItem: { __typename?: 'PressItem', id: string, title?: string | null, description?: string | null, image?: string | null, created_at: number, updated_at: number, links?: Array<{ __typename?: 'Link', url?: string | null, type?: LinkType | null }> | null } };

export type DeletePressItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePressItemMutation = { __typename?: 'Mutation', deletePressItem?: any | null };

export type ProductFieldsFragment = { __typename?: 'Product', id: string, name: string, pms_id: string, price: number };

export type QueryProductsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryProductsQuery = { __typename?: 'Query', queryProducts: Array<{ __typename?: 'Product', id: string, name: string, pms_id: string, price: number }> };

export type TriggerSyncForClinicMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  isFullSync: Scalars['Boolean'];
}>;


export type TriggerSyncForClinicMutation = { __typename?: 'Mutation', triggerSyncForClinic: boolean };

export type RescheduleAppointmentFieldsFragment = { __typename?: 'Appointment', id: string, service_name?: string | null, start_time: number, minutes: number, service?: { __typename?: 'Service', name?: string | null } | null, clinician?: { __typename?: 'Clinician', name: string } | null, client?: { __typename?: 'Client', first_name?: string | null, last_name?: string | null } | null, patient?: { __typename?: 'Patient', name?: string | null, clinic_species?: { __typename?: 'ClinicSpecies', species: Species } | null } | null };

export type RescheduleFieldsFragment = { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } };

export type QueryReschedulesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReschedulesQuery = { __typename?: 'Query', queryReschedules: Array<{ __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } }> };

export type UpdateRescheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateRescheduleInput;
}>;


export type UpdateRescheduleMutation = { __typename?: 'Mutation', updateReschedule: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } };

export type ApproveRescheduleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ApproveRescheduleMutation = { __typename?: 'Mutation', approveReschedule: { __typename?: 'Reschedule', id: string, requested_start_time?: number | null, clinic_notes?: string | null, client_notes?: string | null, reason_for_denial?: string | null, status: RescheduleStatus, initiated_by: RescheduleInitiatedBy, confirmed_at?: number | null, created_at: number, updated_at: number, appointment: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } } };

export type ReviewFieldsFragment = { __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null };

export type GetReviewsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetReviewsForClinicQuery = { __typename?: 'Query', getReviewsForClinic: Array<{ __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null }> };

export type QueryReviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryReviewsQuery = { __typename?: 'Query', queryReviews: Array<{ __typename?: 'Review', id: string, description?: string | null, overall_rating: number, is_anonymous?: boolean | null, created_at: number, updated_at: number, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, appointment?: { __typename?: 'Appointment', id: string, pms?: PracticeManagementSystem | null, client_pms_id?: string | null, is_new_client?: boolean | null, start_time: number, drop_off_time?: number | null, minutes: number, is_new_patient?: boolean | null, patient_pms_id?: string | null, referring_clinic_name?: string | null, client_notes?: string | null, clinic_notes?: string | null, service_name?: string | null, status: AppointmentStatus, is_time_block?: boolean | null, origin?: EntityOrigin | null, reason_for_cancellation?: string | null, new_client_name?: string | null, new_client_phone?: string | null, new_patient_name?: string | null, new_patient_species?: string | null, confirmed_at?: number | null, widget_source?: string | null, created_at: number, updated_at: number, pms_created_at?: number | null, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, client?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, phone?: string | null, email?: string | null, pms?: PracticeManagementSystem | null, pms_id?: string | null, last_appt_time?: number | null, last_contact_time?: number | null, balance?: number | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, patients?: Array<{ __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null }> | null, user?: { __typename?: 'User', avatar_url?: string | null } | null, loyalty_members?: Array<{ __typename?: 'LoyaltyMember', id: string, available_points: number } | null> | null } | null, clinician?: { __typename?: 'Clinician', id: string, name: string, bio?: string | null, avatar_url?: string | null, excluded_species?: Array<Species> | null, excluded_service_ids?: Array<string> | null, authority_level?: AuthorityLevel | null, type: ResourceType, is_active?: boolean | null, is_assignable_in_pms?: boolean | null, pms_id?: string | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string, name?: string | null }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, service?: { __typename?: 'Service', id: string, name?: string | null, color?: string | null } | null, patient?: { __typename?: 'Patient', id: string, pms?: PracticeManagementSystem | null, pms_id?: string | null, name?: string | null, breed?: string | null, avatar_url?: string | null, last_appt_time?: number | null, gender?: string | null, fixed_status?: FixedStatus | null, weight?: number | null, birthday?: number | null, is_deceased?: boolean | null, pms_created_at?: number | null, created_at: number, updated_at: number, owner?: { __typename?: 'Client', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, clinic_species?: { __typename?: 'ClinicSpecies', id: string, pms_id: string, description: string, is_primary: boolean, species: Species, created_at: number, updated_at: number } | null, clinic_breed?: { __typename?: 'Breed', id: string, description: string } | null } | null, client_info?: { __typename?: 'ClientInfo', first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null } | null, patient_info?: { __typename?: 'PatientInfo', patient_name?: string | null, patient_breed?: string | null, patient_clinic_species?: string | null, patient_clinic_breed?: string | null } | null } | null }> };

export type GetAverageRatingForRecentReviewsQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  maxCount?: InputMaybe<Scalars['PositiveInt']>;
}>;


export type GetAverageRatingForRecentReviewsQuery = { __typename?: 'Query', getAverageRatingForRecentReviews: { __typename?: 'ReviewTotals', count: number, total: number } };

export type CountReviewsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountReviewsQuery = { __typename?: 'Query', countReviews: number };

export type RoomFieldsFragment = { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null };

export type GetRoomQueryVariables = Exact<{
  roomId: Scalars['ID'];
}>;


export type GetRoomQuery = { __typename?: 'Query', room: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type QueryRoomsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryRoomsQuery = { __typename?: 'Query', queryRooms: Array<{ __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null }> };

export type CountRoomsQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountRoomsQuery = { __typename?: 'Query', countRooms: number };

export type GetRoomsForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetRoomsForClinicQuery = { __typename?: 'Query', getRoomsByClinic: Array<{ __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null }> };

export type UpdateRoomMutationVariables = Exact<{
  roomId: Scalars['ID'];
  data: UpdateRoomInput;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type SchedulingRulesFieldsFragment = { __typename?: 'SchedulingRules', id: string, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null };

export type GetSchedulingRuleByClinicAndIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  schedulingRulesId: Scalars['ID'];
}>;


export type GetSchedulingRuleByClinicAndIdQuery = { __typename?: 'Query', schedulingRuleByClinicAndId?: { __typename?: 'SchedulingRules', id: string, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null };

export type GetSchedulingRulesForClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetSchedulingRulesForClinicQuery = { __typename?: 'Query', schedulingRulesForClinic?: Array<{ __typename?: 'SchedulingRules', id: string, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null }> | null };

export type UpdateSchedulingRulesMutationVariables = Exact<{
  data: UpdateSchedulingRulesInput;
  clinicId: Scalars['ID'];
  schedulingRulesId: Scalars['ID'];
}>;


export type UpdateSchedulingRulesMutation = { __typename?: 'Mutation', updateSchedulingRules: { __typename?: 'SchedulingRules', id: string, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type CreateSchedulingRulesMutationVariables = Exact<{
  data: CreateSchedulingRulesInput;
}>;


export type CreateSchedulingRulesMutation = { __typename?: 'Mutation', createSchedulingRules: { __typename?: 'SchedulingRules', id: string, is_active: boolean, patient_type?: PatientTypeEnum | null, client_type?: ClientTypeEnum | null, patient_gender?: AnimalGender | null, fixed_status?: FixedStatus | null, only_modifier?: OnlyModifierEnum | null, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, included_clinicians?: Array<{ __typename?: 'Clinician', id: string, name: string }> | null, included_species?: Array<{ __typename?: 'ClinicSpecies', id: string, species: Species }> | null, included_services?: Array<{ __typename?: 'Service', id: string, name?: string | null }> | null, included_rooms?: Array<{ __typename?: 'Room', id: string, name: string }> | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } };

export type DeleteSchedulingRuleMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  schedulingRulesId: Scalars['ID'];
}>;


export type DeleteSchedulingRuleMutation = { __typename?: 'Mutation', deleteSchedulingRules?: any | null };

export type PricingFieldsFragment = { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType };

export type ServiceFieldsFragment = { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null };

export type GetAllServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllServicesQuery = { __typename?: 'Query', allServices: Array<{ __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null }> };

export type GetAllServicesByClinicIdQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetAllServicesByClinicIdQuery = { __typename?: 'Query', allServicesByClinicId: Array<{ __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null }> };

export type QueryServicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryServicesQuery = { __typename?: 'Query', queryServices: Array<{ __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null }> };

export type CountServicesQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountServicesQuery = { __typename?: 'Query', countServices: number };

export type GetServiceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetServiceQuery = { __typename?: 'Query', service: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type PaymentIntentFromServiceQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  serviceId: Scalars['ID'];
  customerInfo: CustomerInfoInput;
}>;


export type PaymentIntentFromServiceQuery = { __typename?: 'Query', paymentIntentFromService: { __typename?: 'StripePaymentIntent', id: string, amount: number, client_secret?: string | null } };

export type CreateServiceMutationVariables = Exact<{
  data: CreateServiceInput;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type CreateClinicServiceMutationVariables = Exact<{
  clinicId: Scalars['ID'];
  data: CreateServiceInput;
}>;


export type CreateClinicServiceMutation = { __typename?: 'Mutation', createClinicService: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type UpdateServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type UpdateClinicServiceMutationVariables = Exact<{
  serviceId: Scalars['ID'];
  clinicId: Scalars['ID'];
  data: UpdateServiceInput;
}>;


export type UpdateClinicServiceMutation = { __typename?: 'Mutation', updateClinicService: { __typename?: 'Service', id: string, name?: string | null, keywords?: string | null, service_types: Array<ServiceType>, is_active?: boolean | null, allow_new?: boolean | null, color?: string | null, description?: string | null, duration?: number | null, allow_returning?: boolean | null, max_per_day?: number | null, excluded_species?: Array<Species> | null, reserved_per_day?: number | null, authorized_levels?: Array<AuthorityLevel> | null, scheduling_buffer_minutes?: number | null, scheduling_min_minutes_away?: number | null, scheduling_max_minutes_away?: number | null, minimum_patient_age_in_days?: number | null, more_info?: string | null, points: number, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string } | null, pricing?: { __typename?: 'ServicePricing', price: any, currency: any, type: ServicePricingType } | null, pms_appt_type?: { __typename?: 'PmsApptType', id: string, name: string, pms_id: string, description?: string | null, color?: any | null } | null, required_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, default_room?: { __typename?: 'Room', id: string, pms_id: string, name: string, description?: string | null, concurrent_patients?: number | null, is_active: boolean, created_at: number, updated_at: number, clinic: { __typename?: 'Clinic', id: string }, hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, adjusted_availability?: Array<{ __typename?: 'Availability', date: number, times: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }>, repeat?: { __typename?: 'RepeatAvailability', daysOfMonth?: Array<number> | null, daysOfWeek?: Array<DayOfWeek> | null, weekOfMonth?: WeekOfMonth | null, frequency: any, unit: RepeatUnit } | null }> | null } | null, availability?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null, drop_off_hours?: { __typename?: 'AvailabilityHours', monday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, tuesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, wednesday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, thursday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, friday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, saturday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null, sunday?: Array<{ __typename?: 'TimeInterval', start?: number | null, end?: number | null }> | null } | null } };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService?: any | null };

export type DeleteClinicServiceMutationVariables = Exact<{
  serviceId: Scalars['ID'];
  clinicId: Scalars['ID'];
}>;


export type DeleteClinicServiceMutation = { __typename?: 'Mutation', deleteClinicService?: any | null };

export type TransactionFieldsFragment = { __typename?: 'Transaction', id: string, clinic_id: string, date?: number | null, amount?: string | null, type?: TransactionType | null };

export type GetTransactionsByClinicAndRangeQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  pms?: InputMaybe<PracticeManagementSystem>;
  start_time: Scalars['NonNegativeInt'];
  end_time: Scalars['NonNegativeInt'];
}>;


export type GetTransactionsByClinicAndRangeQuery = { __typename?: 'Query', getTransactionsByClinicAndRange: Array<{ __typename?: 'Transaction', id: string, clinic_id: string, date?: number | null, amount?: string | null, type?: TransactionType | null }> };

export type UserFieldsFragment = { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } | null };

export type SearchUsersQueryVariables = Exact<{
  roles?: InputMaybe<Array<AuthRoles> | AuthRoles>;
  limit?: InputMaybe<Scalars['NonNegativeInt']>;
  startAtId?: InputMaybe<Scalars['String']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number }> };

export type QueryUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
  page?: InputMaybe<Scalars['NonNegativeInt']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInt']>;
  orderBy?: InputMaybe<OrderByInput>;
}>;


export type QueryUsersQuery = { __typename?: 'Query', queryUsers: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number }> };

export type CountUsersQueryVariables = Exact<{
  where?: InputMaybe<Array<QueryInput> | QueryInput>;
}>;


export type CountUsersQuery = { __typename?: 'Query', countUsers: number };

export type CheckForUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckForUserByEmailQuery = { __typename?: 'Query', checkForUserByEmail?: Array<{ __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number }> | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  data: CreateUserInput;
  role?: InputMaybe<Scalars['String']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } };

export type UpdateUserMutationVariables = Exact<{
  updateUserId: Scalars['ID'];
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, first_name?: string | null, last_name?: string | null, email?: any | null, phone?: string | null, avatar_url?: string | null, role?: AuthRoles | null, created_at: number, updated_at: number } };

export type StripeAccountOnboardLinkQueryVariables = Exact<{
  clinicId: Scalars['ID'];
  data: AccountOnboardLinkInput;
}>;


export type StripeAccountOnboardLinkQuery = { __typename?: 'Query', stripeAccountOnboardLink: any };

export type StripeAccountLoginLinkQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type StripeAccountLoginLinkQuery = { __typename?: 'Query', stripeAccountLoginLink: any };

export type StripeAccountCheckQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type StripeAccountCheckQuery = { __typename?: 'Query', stripeAccountCheck: boolean };

export type WidgetFieldsFragment = { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null };

export type GetWidgetQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetWidgetQuery = { __typename?: 'Query', widget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type GetWidgetsByClinicQueryVariables = Exact<{
  clinicId: Scalars['ID'];
}>;


export type GetWidgetsByClinicQuery = { __typename?: 'Query', getWidgetsByClinic: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null }> };

export type GetWidgetsByOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetWidgetsByOrganizationQuery = { __typename?: 'Query', getWidgetsByOrganization?: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null }> | null };

export type GetAllWidgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWidgetsQuery = { __typename?: 'Query', allWidgets: Array<{ __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null }> };

export type GetAppointmentCountByWidgetSourceQueryVariables = Exact<{
  widgetSource: Scalars['String'];
}>;


export type GetAppointmentCountByWidgetSourceQuery = { __typename?: 'Query', getAppointmentCountByWidgetSource: number };

export type CreateWidgetMutationVariables = Exact<{
  data: CreateWidgetInput;
}>;


export type CreateWidgetMutation = { __typename?: 'Mutation', createWidget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type UpdateWidgetMutationVariables = Exact<{
  id: Scalars['ID'];
  data: UpdateWidgetInput;
}>;


export type UpdateWidgetMutation = { __typename?: 'Mutation', updateWidget: { __typename?: 'Widget', id: string, widget_name: string, type: WidgetType, trigger_type: WidgetTriggerType, button_color?: string | null, button_text?: string | null, text_color?: string | null, is_external: boolean, is_active: boolean, enabled_chat_buttons?: Array<WidgetMenuButtonType> | null, average_chat_response_time?: string | null, source?: string | null, created_at: number, updated_at: number, clinic?: { __typename?: 'Clinic', id: string, name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type DeleteWidgetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWidgetMutation = { __typename?: 'Mutation', deleteWidget?: any | null };

export const ActionItemBaseFieldsFragmentDoc = gql`
    fragment ActionItemBaseFields on ActionItem {
  id
  type
  status
  created_at
  updated_at
}
    `;
export const ClinicSpeciesFieldsFragmentDoc = gql`
    fragment ClinicSpeciesFields on ClinicSpecies {
  id
  pms_id
  description
  is_primary
  species
  created_at
  updated_at
}
    `;
export const PatientFieldsFragmentDoc = gql`
    fragment PatientFields on Patient {
  id
  owner {
    id
    first_name
    last_name
    email
    phone
  }
  clinic_species {
    ...ClinicSpeciesFields
  }
  pms
  pms_id
  name
  breed
  clinic_breed {
    id
    description
  }
  avatar_url
  last_appt_time
  gender
  fixed_status
  weight
  birthday
  is_deceased
  pms_created_at
  created_at
  updated_at
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export const ClientLoyaltyMemberFieldsFragmentDoc = gql`
    fragment ClientLoyaltyMemberFields on LoyaltyMember {
  id
  available_points
}
    `;
export const ClientFieldsFragmentDoc = gql`
    fragment ClientFields on Client {
  id
  first_name
  last_name
  phone
  email
  clinic {
    id
  }
  patients {
    ...PatientFields
  }
  user {
    avatar_url
  }
  loyalty_members {
    ...ClientLoyaltyMemberFields
  }
  pms
  pms_id
  last_appt_time
  last_contact_time
  balance
  created_at
  updated_at
}
    ${PatientFieldsFragmentDoc}
${ClientLoyaltyMemberFieldsFragmentDoc}`;
export const AvailabilityDayFieldsFragmentDoc = gql`
    fragment AvailabilityDayFields on AvailabilityHours {
  monday {
    start
    end
  }
  tuesday {
    start
    end
  }
  wednesday {
    start
    end
  }
  thursday {
    start
    end
  }
  friday {
    start
    end
  }
  saturday {
    start
    end
  }
  sunday {
    start
    end
  }
}
    `;
export const AdjustedAvailabilityFieldsFragmentDoc = gql`
    fragment AdjustedAvailabilityFields on Availability {
  date
  times {
    start
    end
  }
  repeat {
    daysOfMonth
    daysOfWeek
    weekOfMonth
    frequency
    unit
  }
}
    `;
export const ClinicianFieldsFragmentDoc = gql`
    fragment ClinicianFields on Clinician {
  id
  name
  clinic {
    id
    name
  }
  bio
  avatar_url
  hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  excluded_species
  excluded_service_ids
  authority_level
  type
  is_active
  is_assignable_in_pms
  pms_id
  created_at
  updated_at
}
    ${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const RoomFieldsFragmentDoc = gql`
    fragment RoomFields on Room {
  id
  clinic {
    id
  }
  pms_id
  name
  description
  concurrent_patients
  is_active
  hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  created_at
  updated_at
}
    ${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const ClientInfoFieldsFragmentDoc = gql`
    fragment ClientInfoFields on ClientInfo {
  first_name
  last_name
  email
  phone
}
    `;
export const PatientInfoFieldsFragmentDoc = gql`
    fragment PatientInfoFields on PatientInfo {
  patient_name
  patient_breed
  patient_clinic_species
  patient_clinic_breed
}
    `;
export const AppointmentFieldsFragmentDoc = gql`
    fragment AppointmentFields on Appointment {
  id
  clinic {
    id
    name
  }
  pms
  client {
    ...ClientFields
  }
  client_pms_id
  clinician {
    ...ClinicianFields
  }
  is_new_client
  room {
    ...RoomFields
  }
  start_time
  drop_off_time
  minutes
  service {
    id
    name
    color
  }
  patient {
    ...PatientFields
  }
  is_new_patient
  patient_pms_id
  referring_clinic_name
  client_notes
  clinic_notes
  service_name
  status
  is_time_block
  origin
  reason_for_cancellation
  new_client_name
  new_client_phone
  new_patient_name
  new_patient_species
  client_info {
    ...ClientInfoFields
  }
  patient_info {
    ...PatientInfoFields
  }
  confirmed_at
  widget_source
  created_at
  updated_at
  pms_created_at
}
    ${ClientFieldsFragmentDoc}
${ClinicianFieldsFragmentDoc}
${RoomFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ClientInfoFieldsFragmentDoc}
${PatientInfoFieldsFragmentDoc}`;
export const RescheduleFieldsFragmentDoc = gql`
    fragment RescheduleFields on Reschedule {
  id
  appointment {
    ...AppointmentFields
  }
  requested_start_time
  clinic_notes
  client_notes
  reason_for_denial
  status
  initiated_by
  confirmed_at
  created_at
  updated_at
}
    ${AppointmentFieldsFragmentDoc}`;
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  id
  title
  clinic {
    id
    name
    pms
  }
  client {
    id
    first_name
    last_name
    patients {
      id
      name
      pms_id
      is_deceased
    }
  }
  client_last_read
  client_last_read_count
  client_unread_count
  client_message_count
  clinic_unread_count
  clinic_last_read
  clinic_last_read_count
  clinic_message_count
  message_count
  last_message
  last_message_time
  status
  is_hidden
  created_at
  updated_at
}
    `;
export const UserBasicInfoFragmentDoc = gql`
    fragment UserBasicInfo on User {
  id
  first_name
  last_name
}
    `;
export const ActionItemFieldsFragmentDoc = gql`
    fragment ActionItemFields on ActionItem {
  ...ActionItemBaseFields
  pending_appointment {
    ...AppointmentFields
  }
  reschedule {
    ...RescheduleFields
  }
  chat {
    ...ChatFields
  }
  assignee {
    ...UserBasicInfo
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${AppointmentFieldsFragmentDoc}
${RescheduleFieldsFragmentDoc}
${ChatFieldsFragmentDoc}
${UserBasicInfoFragmentDoc}`;
export const AppointmentWithActionItemsFieldsFragmentDoc = gql`
    fragment AppointmentWithActionItemsFields on Appointment {
  action_items {
    ...ActionItemBaseFields
    pending_appointment {
      ...AppointmentFields
    }
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${AppointmentFieldsFragmentDoc}`;
export const RescheduleWithActionItemsFieldsFragmentDoc = gql`
    fragment RescheduleWithActionItemsFields on Reschedule {
  action_items {
    ...ActionItemBaseFields
    reschedule {
      ...RescheduleFields
    }
  }
}
    ${ActionItemBaseFieldsFragmentDoc}
${RescheduleFieldsFragmentDoc}`;
export const AnimalFieldsFragmentDoc = gql`
    fragment AnimalFields on Animal {
  id
  name
  image
  created_at
  updated_at
}
    `;
export const PricingFieldsFragmentDoc = gql`
    fragment PricingFields on ServicePricing {
  price
  currency
  type
}
    `;
export const PmsApptTypeFieldsFragmentDoc = gql`
    fragment PmsApptTypeFields on PmsApptType {
  id
  name
  pms_id
  description
  color
}
    `;
export const ServiceFieldsFragmentDoc = gql`
    fragment ServiceFields on Service {
  id
  name
  clinic {
    id
  }
  keywords
  service_types
  is_active
  allow_new
  color
  description
  pricing {
    ...PricingFields
  }
  pms_appt_type {
    ...PmsApptTypeFields
  }
  required_room {
    ...RoomFields
  }
  default_room {
    ...RoomFields
  }
  duration
  allow_returning
  max_per_day
  excluded_species
  availability {
    ...AvailabilityDayFields
  }
  drop_off_hours {
    ...AvailabilityDayFields
  }
  reserved_per_day
  authorized_levels
  scheduling_buffer_minutes
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  minimum_patient_age_in_days
  more_info
  points
  created_at
  updated_at
}
    ${PricingFieldsFragmentDoc}
${PmsApptTypeFieldsFragmentDoc}
${RoomFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}`;
export const AppointmentPromptFieldsFragmentDoc = gql`
    fragment AppointmentPromptFields on AppointmentPrompt {
  id
  clinic {
    id
    name
  }
  client {
    ...ClientFields
  }
  clinician {
    ...ClinicianFields
  }
  patient {
    ...PatientFields
  }
  service {
    ...ServiceFields
  }
  client_notes
  clinic_notes
  confirmed_at
  minutes
  reason_for_denial
  service_name
  start_time
  type
  created_at
  updated_at
}
    ${ClientFieldsFragmentDoc}
${ClinicianFieldsFragmentDoc}
${PatientFieldsFragmentDoc}
${ServiceFieldsFragmentDoc}`;
export const AppointmentBaseFieldsFragmentDoc = gql`
    fragment AppointmentBaseFields on Appointment {
  id
}
    `;
export const AppointmentPreviewFieldsFragmentDoc = gql`
    fragment AppointmentPreviewFields on Appointment {
  id
  start_time
  drop_off_time
  minutes
}
    `;
export const PublicAppointmentTimeFieldsFragmentDoc = gql`
    fragment PublicAppointmentTimeFields on PublicAppointmentTime {
  start_time
  minutes
  clinician_id
  room_id
  is_time_block
}
    `;
export const TimeSlotClinicianFieldsFragmentDoc = gql`
    fragment TimeSlotClinicianFields on Clinician {
  id
  name
}
    `;
export const TimeSlotFieldsFragmentDoc = gql`
    fragment TimeSlotFields on TimeSlot {
  start_time
  clinicians {
    ...TimeSlotClinicianFields
  }
}
    ${TimeSlotClinicianFieldsFragmentDoc}`;
export const BreedFieldsFragmentDoc = gql`
    fragment BreedFields on Breed {
  id
  pms_id
  species
  description
}
    `;
export const CheckInFieldsFragmentDoc = gql`
    fragment CheckInFields on CheckIn {
  id
  user {
    id
    first_name
    last_name
    avatar_url
  }
  clinic {
    id
    name
    avatar_url
  }
  status
  vehicle
  visit_reason
  created_at
  updated_at
}
    `;
export const ClientFormFieldsFragmentDoc = gql`
    fragment ClientFormFields on ClientForm {
  id
  client {
    id
  }
  form {
    id
  }
  form_data
  client_completed_at
  clinic_verified_at
  created_at
  updated_at
}
    `;
export const ClientPreviewFieldsFragmentDoc = gql`
    fragment ClientPreviewFields on Client {
  id
  first_name
  last_name
  phone
  email
  clinic {
    id
  }
  user {
    avatar_url
  }
  patients {
    id
    name
    clinic_species {
      id
      species
    }
    clinic_breed {
      id
      description
    }
  }
  last_appt_time
  created_at
  updated_at
}
    `;
export const ClinicPreviewFieldsFragmentDoc = gql`
    fragment ClinicPreviewFields on Clinic {
  id
  name
  slug
  avatar_url
  is_verified
  is_archived
  description
  pms
  last_synced_times {
    last_full_sync
  }
  clinic_admins {
    id
  }
  organization {
    id
  }
  address {
    street_a
    street_b
    city
    state
    zip
    country
    lat
    lng
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  first_name
  last_name
  email
  phone
  avatar_url
  role
  created_at
  updated_at
}
    `;
export const ClinicAdminFieldsFragmentDoc = gql`
    fragment ClinicAdminFields on ClinicAdmin {
  id
  clinic {
    ...ClinicPreviewFields
  }
  user {
    ...UserFields
  }
  role
  created_at
  updated_at
}
    ${ClinicPreviewFieldsFragmentDoc}
${UserFieldsFragmentDoc}`;
export const ClinicSettingsFieldsFragmentDoc = gql`
    fragment ClinicSettingsFields on ClinicSettings {
  does_require_verification
  is_using_detailed_services
  is_using_rooms
  pms_start_time
  pms_end_time
  primary_color
  new_appt_requested_msg
  new_appt_approved_msg
  new_appt_denied_msg
  schedule_method
  scheduling_buffer_minutes
  base_schedule_duration
  does_require_referral
  appointment_entry_method
  scheduling_min_minutes_away
  scheduling_max_minutes_away
  included_species
  max_patients_per_visit
  should_complete_sync
  server_syncing_only
  confirmation_days_before
  send_confirmations_to
  send_new_appt_email
  send_reviews_to
  max_review_rating_for_notif
  google_review_link
  facebook_review_link
  non_blocking_services
  yesterday_revenue
  this_month_revenue
  hide_clinician_preference
  does_use_rooms_to_schedule
  primary_room_pms_id
  does_use_clinicians_to_schedule
  time_slot_minutes
  primary_clinician_pms_id
  allow_first_appt_per_day
  custom_well_description
  custom_sick_description
}
    `;
export const ClinicFeatureFieldsFragmentDoc = gql`
    fragment ClinicFeatureFields on ClinicFeatures {
  scheduling_enabled
  huddle_enabled
  payments_enabled
  messaging_enabled
  reviews_enabled
  loyalty_enabled
  notifs_enabled
  forms_enabled
  help_enabled
}
    `;
export const ClinicFieldsFragmentDoc = gql`
    fragment ClinicFields on Clinic {
  id
  slug
  name
  description
  email
  phone
  send_from_phone
  website
  pms
  pms_api_key
  pms_additional_key
  office_emails
  clinic_admins {
    ...ClinicAdminFields
  }
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
  services {
    id
    name
  }
  settings {
    ...ClinicSettingsFields
  }
  onboarding {
    has_set_hours
    has_synced_pms
  }
  organization {
    id
  }
  features {
    ...ClinicFeatureFields
  }
  avatar_url
  hours {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  last_synced_times {
    last_full_sync
    last_sync_appointments
    last_sync_clients
    last_sync_patients
    last_sync_clinicians
    last_sync_services
    last_sync_transactions
    last_sync_invoices
    last_sync_history_items
    last_sync_diagnoses
    last_sync_prescriptions
    last_sync_products
    last_sync_rooms
    last_sync_species
  }
  organization {
    id
  }
  time_zone
  is_archived
  created_at
  updated_at
}
    ${ClinicAdminFieldsFragmentDoc}
${ClinicSettingsFieldsFragmentDoc}
${ClinicFeatureFieldsFragmentDoc}
${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const ClinicAdminFieldsForLoginFragmentDoc = gql`
    fragment ClinicAdminFieldsForLogin on ClinicAdmin {
  id
  clinic {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export const AnalyticsNumbersFieldsFragmentDoc = gql`
    fragment AnalyticsNumbersFields on AnalyticsNumbers {
  appointments_count
  no_show_count
  revenue
  transactions_count
  revenue_per_appointment
  new_clients_count
  new_patients_count
  new_appointments_count
  schedule_efficiency
  forward_scheduled_patients_count
}
    `;
export const ClinicSexFieldsFragmentDoc = gql`
    fragment ClinicSexFields on ClinicSex {
  id
  pms_id
  name
  description
  animal_gender
  fixed_statuses
  included_species
  is_active
}
    `;
export const ClinicianServiceFieldsFragmentDoc = gql`
    fragment ClinicianServiceFields on ClinicianService {
  id
  clinician {
    id
    name
  }
  service {
    id
  }
  duration_override
  created_at
  updated_at
}
    `;
export const ClinicStatsFieldsFragmentDoc = gql`
    fragment ClinicStatsFields on ClinicStats {
  completed_appointments
  confirmed_appointments
  booked_appointments
  pending_appointments
  cancelled_appointments
  denied_appointments
  expired_appointments
  total_appointments
  total_website_appointments
  total_widget_appointments
}
    `;
export const ConnectInstallationFieldsFragmentDoc = gql`
    fragment ConnectInstallationFields on ConnectInstallation {
  id
  computer_name
  last_ping
  is_server
  version
  connect_ui_version
  connect_server_version
  created_at
  updated_at
}
    `;
export const DailyHuddleFieldsFragmentDoc = gql`
    fragment DailyHuddleFields on DailyHuddle {
  id
  notes
  start_time
  end_time
  leader {
    id
    name
  }
  attendees {
    id
    name
  }
  created_at
  updated_at
}
    `;
export const DiagnosisFieldsFragmentDoc = gql`
    fragment DiagnosisFields on Diagnosis {
  id
  pms_id
  name
}
    `;
export const TemplateClinicClinicFieldsFragmentDoc = gql`
    fragment TemplateClinicClinicFields on Clinic {
  id
  name
  slug
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
}
    `;
export const EntityReportClinicianFieldsFragmentDoc = gql`
    fragment EntityReportClinicianFields on Clinician {
  id
  name
}
    `;
export const EntityReportServiceFieldsFragmentDoc = gql`
    fragment EntityReportServiceFields on Service {
  id
  name
}
    `;
export const EntityReportProductFieldsFragmentDoc = gql`
    fragment EntityReportProductFields on Product {
  id
  name
}
    `;
export const MetricValueParamsFieldsFragmentDoc = gql`
    fragment MetricValueParamsFields on MetricValueParams {
  custom_label
  value_type
}
    `;
export const ReportValueFieldsFragmentDoc = gql`
    fragment ReportValueFields on ReportValue {
  metric
  key
  column_values {
    value
    percentile
    value_params {
      ...MetricValueParamsFields
    }
  }
}
    ${MetricValueParamsFieldsFragmentDoc}`;
export const EntityReportSharedFieldsFragmentDoc = gql`
    fragment EntityReportSharedFields on EntityReport {
  id
  entity_type
  clinic {
    ...TemplateClinicClinicFields
  }
  clinician {
    ...EntityReportClinicianFields
  }
  service {
    ...EntityReportServiceFields
  }
  product {
    ...EntityReportProductFields
  }
  values {
    ...ReportValueFields
  }
  created_at
  updated_at
}
    ${TemplateClinicClinicFieldsFragmentDoc}
${EntityReportClinicianFieldsFragmentDoc}
${EntityReportServiceFieldsFragmentDoc}
${EntityReportProductFieldsFragmentDoc}
${ReportValueFieldsFragmentDoc}`;
export const FirstChildReportFieldsFragmentDoc = gql`
    fragment FirstChildReportFields on EntityReport {
  ...EntityReportSharedFields
  entity_reports {
    id
  }
}
    ${EntityReportSharedFieldsFragmentDoc}`;
export const SecondChildReportFieldsFragmentDoc = gql`
    fragment SecondChildReportFields on EntityReport {
  ...EntityReportSharedFields
}
    ${EntityReportSharedFieldsFragmentDoc}`;
export const ReportClinicClinicFieldsFragmentDoc = gql`
    fragment ReportClinicClinicFields on Clinic {
  id
  name
  slug
  address {
    street_a
    street_b
    city
    state
    zip
    country
  }
}
    `;
export const ReportClinicFieldsFragmentDoc = gql`
    fragment ReportClinicFields on ReportClinic {
  id
  clinic {
    ...ReportClinicClinicFields
  }
}
    ${ReportClinicClinicFieldsFragmentDoc}`;
export const TimeParamFieldsFragmentDoc = gql`
    fragment TimeParamFields on TimeParams {
  type
  from_millis_ago
  to_millis_ago
  period_type
  from_periods_ago
  to_periods_ago
  start
  end
}
    `;
export const ReportMetricModifierFieldsFragmentDoc = gql`
    fragment ReportMetricModifierFields on ReportMetricModifier {
  category
  column
  not
  filterOp
  value {
    string
    float
    boolean
  }
}
    `;
export const ReportMetricFieldsFragmentDoc = gql`
    fragment ReportMetricFields on ReportMetric {
  id
  key
  type
  name
  time_params_overrides {
    ...TimeParamFields
  }
  special_modifier
  field_modifiers {
    ...ReportMetricModifierFields
  }
  format
  value_types {
    ...MetricValueParamsFields
  }
  order
}
    ${TimeParamFieldsFragmentDoc}
${ReportMetricModifierFieldsFragmentDoc}
${MetricValueParamsFieldsFragmentDoc}`;
export const SecondChildReportEntityFieldsFragmentDoc = gql`
    fragment SecondChildReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    entity_type
  }
}
    `;
export const ChildReportEntityFieldsFragmentDoc = gql`
    fragment ChildReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    ...SecondChildReportEntityFields
  }
}
    ${SecondChildReportEntityFieldsFragmentDoc}`;
export const ReportEntityFieldsFragmentDoc = gql`
    fragment ReportEntityFields on ReportEntity {
  entity_type
  child_entities {
    ...ChildReportEntityFields
  }
}
    ${ChildReportEntityFieldsFragmentDoc}`;
export const EntityReportFieldsFragmentDoc = gql`
    fragment EntityReportFields on EntityReport {
  ...EntityReportSharedFields
  entity_reports {
    id
  }
}
    ${EntityReportSharedFieldsFragmentDoc}`;
export const OrganizationReportFieldsFragmentDoc = gql`
    fragment OrganizationReportFields on OrganizationReport {
  id
  organization {
    id
    name
  }
  name
  description
  preferred_view_type
  report_clinics {
    ...ReportClinicFields
  }
  report_metrics {
    ...ReportMetricFields
  }
  entity_structure {
    ...ReportEntityFields
  }
  entity_reports {
    ...EntityReportFields
  }
  report_template {
    id
  }
  is_hidden
  created_at
  updated_at
}
    ${ReportClinicFieldsFragmentDoc}
${ReportMetricFieldsFragmentDoc}
${ReportEntityFieldsFragmentDoc}
${EntityReportFieldsFragmentDoc}`;
export const OrganizationReportPreviewFieldsFragmentDoc = gql`
    fragment OrganizationReportPreviewFields on OrganizationReport {
  id
  name
  description
  report_clinics {
    id
    clinic {
      name
    }
  }
  report_metrics {
    id
    name
    type
  }
  report_template {
    id
    name
  }
  is_hidden
  created_at
}
    `;
export const TemplateClinicFieldsFragmentDoc = gql`
    fragment TemplateClinicFields on TemplateClinic {
  id
  clinic {
    ...TemplateClinicClinicFields
  }
}
    ${TemplateClinicClinicFieldsFragmentDoc}`;
export const RepeatParamsFieldsFragmentDoc = gql`
    fragment RepeatParamsFields on RepeatParams {
  frequency
  unit
  daysOfWeek
  daysOfMonth
  weekOfMonth
}
    `;
export const ReportTemplateFieldsFragmentDoc = gql`
    fragment ReportTemplateFields on ReportTemplate {
  id
  name
  description
  template_clinics {
    ...TemplateClinicFields
  }
  report_metrics {
    id
    name
    type
  }
  preferred_view_type
  entity_structure {
    ...ReportEntityFields
  }
  last_run
  next_run
  repeat {
    ...RepeatParamsFields
  }
  organization_reports {
    id
  }
  is_active
  created_at
  updated_at
}
    ${TemplateClinicFieldsFragmentDoc}
${ReportEntityFieldsFragmentDoc}
${RepeatParamsFieldsFragmentDoc}`;
export const FormFieldsFragmentDoc = gql`
    fragment FormFields on Form {
  id
  name
  clinic {
    id
  }
  form_fields
  is_active
  created_at
  updated_at
}
    `;
export const GoalsFieldsFragmentDoc = gql`
    fragment GoalsFields on Goal {
  id
  clinic {
    id
  }
  description
  created_at
  is_active
  is_chckup_modifier
  is_new_modifier
  is_system
  last_synced_time
  metric_current_amount
  metric_entity
  metric_target_amount
  metric_timespan
  status
  updated_at
}
    `;
export const LoyaltyClientFieldsFragmentDoc = gql`
    fragment LoyaltyClientFields on Client {
  id
  first_name
  last_name
}
    `;
export const LoyaltyMemberFieldsFragmentDoc = gql`
    fragment LoyaltyMemberFields on LoyaltyMember {
  id
  client {
    ...LoyaltyClientFields
  }
  available_points
  all_time_points
}
    ${LoyaltyClientFieldsFragmentDoc}`;
export const LoyaltyRewardFieldsFragmentDoc = gql`
    fragment LoyaltyRewardFields on LoyaltyReward {
  id
  name
  description
  points_required
  image_url
  created_at
  updated_at
}
    `;
export const LoyaltyRedemptionFieldsFragmentDoc = gql`
    fragment LoyaltyRedemptionFields on LoyaltyRedemption {
  id
  member {
    ...LoyaltyMemberFields
  }
  reward {
    ...LoyaltyRewardFields
  }
  created_at
}
    ${LoyaltyMemberFieldsFragmentDoc}
${LoyaltyRewardFieldsFragmentDoc}`;
export const MessagePatientFieldsFragmentDoc = gql`
    fragment MessagePatientFields on Patient {
  id
  name
  pms_id
}
    `;
export const AttachmentFieldsFragmentDoc = gql`
    fragment AttachmentFields on Attachment {
  id
  url
  filename
  type
}
    `;
export const QueryFilterFieldsFragmentDoc = gql`
    fragment QueryFilterFields on QueryFilter {
  column
  filterOp
  value {
    string
    float
    boolean
    stringArray
    floatArray
    millisFromNow
  }
}
    `;
export const CustomerSegmentFieldsFragmentDoc = gql`
    fragment CustomerSegmentFields on CustomerSegment {
  id
  name
  filters {
    type
    only_consider_other_rows
    filters {
      ...QueryFilterFields
    }
  }
  excluded_filters {
    type
    only_consider_other_rows
    filters {
      ...QueryFilterFields
    }
  }
  created_at
  updated_at
}
    ${QueryFilterFieldsFragmentDoc}`;
export const NotificationTemplateFieldsFragmentDoc = gql`
    fragment NotificationTemplateFields on NotificationTemplate {
  id
  name
  every_x_hours
  send_time_minutes
  body
  message_methods
  notif_attachments {
    id
    filename
    type
  }
  customer_segment {
    ...CustomerSegmentFields
  }
  clinic {
    id
    name
  }
  is_marketing
  is_active
  is_system
  subject
  cta_text
  cta_url
  updated_at
  created_at
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  client {
    id
    first_name
    last_name
    phone
    email
  }
  chat {
    id
    client {
      id
      first_name
      last_name
      phone
      email
    }
  }
  patient {
    ...MessagePatientFields
  }
  clinic_user {
    id
    first_name
    last_name
  }
  text
  attachments {
    ...AttachmentFields
  }
  notification {
    ...NotificationTemplateFields
  }
  message_methods
  message_type
  message_origin
  cta_text
  cta_url
  created_at
  updated_at
}
    ${MessagePatientFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}
${NotificationTemplateFieldsFragmentDoc}`;
export const ClinicAnalyticsFieldsFragmentDoc = gql`
    fragment ClinicAnalyticsFields on ClinicAnalytics {
  appointments {
    ...AppointmentFields
  }
  appointments_count
  no_show_count
  revenue
  transactions_count
  revenue_by_type {
    group
    amount
  }
  revenue_by_clinician {
    group
    amount
  }
  accounts_receivable
  clients_with_negative_balances {
    ...ClientFields
  }
  clients_with_negative_balances_count
  patients_without_reschedules {
    ...PatientFields
  }
  monthly_revenue_completed
  monthly_appointments_scheduled
  last_month_average_revenue_per_appointment
  new_clients_count
  new_patients_count
  new_appointments_count
  schedule_efficiency
  forward_scheduled_patients_count
}
    ${AppointmentFieldsFragmentDoc}
${ClientFieldsFragmentDoc}
${PatientFieldsFragmentDoc}`;
export const OrganizationAnalyticsFieldsFragmentDoc = gql`
    fragment OrganizationAnalyticsFields on OrganizationAnalytics {
  clinic {
    id
    name
    pms
  }
  analytics {
    ...ClinicAnalyticsFields
  }
}
    ${ClinicAnalyticsFieldsFragmentDoc}`;
export const OrganizationClinicAnalyticsNumbersFieldsFragmentDoc = gql`
    fragment OrganizationClinicAnalyticsNumbersFields on OrganizationClinicAnalyticsNumbers {
  appointments_count {
    value
    percentile
  }
  no_show_count {
    value
    percentile
  }
  revenue {
    value
    percentile
  }
  transactions_count {
    value
    percentile
  }
  revenue_per_appointment {
    value
    percentile
  }
  new_clients_count {
    value
    percentile
  }
  new_patients_count {
    value
    percentile
  }
  new_appointments_count {
    value
    percentile
  }
  schedule_efficiency {
    value
    percentile
  }
  forward_scheduled_patients_count {
    value
    percentile
  }
}
    `;
export const OrganizationAnalyticsNumbersFieldsFragmentDoc = gql`
    fragment OrganizationAnalyticsNumbersFields on OrganizationAnalyticsNumbers {
  clinic {
    id
    name
    pms
  }
  analytic_numbers {
    ...OrganizationClinicAnalyticsNumbersFields
  }
}
    ${OrganizationClinicAnalyticsNumbersFieldsFragmentDoc}`;
export const OrganizationClinicFieldsFragmentDoc = gql`
    fragment OrganizationClinicFields on Clinic {
  id
  name
  avatar_url
  address {
    street_a
    street_b
    city
    state
    zip
  }
  is_archived
}
    `;
export const OrganizationAdminFieldsFragmentDoc = gql`
    fragment OrganizationAdminFields on User {
  id
  first_name
  last_name
  email
}
    `;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  name
  clinics {
    ...OrganizationClinicFields
  }
  admins {
    ...OrganizationAdminFields
  }
  created_at
  updated_at
}
    ${OrganizationClinicFieldsFragmentDoc}
${OrganizationAdminFieldsFragmentDoc}`;
export const PatientHistoryItemFieldsFragmentDoc = gql`
    fragment PatientHistoryItemFields on PatientHistoryItem {
  id
  patient {
    id
  }
  diagnosis {
    id
  }
  product {
    id
  }
  issued_at
}
    `;
export const PatientPreviewFieldsFragmentDoc = gql`
    fragment PatientPreviewFields on Patient {
  id
  name
  breed
  is_deceased
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  appointment {
    ...AppointmentFields
  }
  client {
    id
    first_name
    last_name
    phone
    email
  }
  clinic {
    id
  }
  payment_method_id
  stripe_payment_intent_id
  amount
  category
  status
  date
  created_at
  updated_at
}
    ${AppointmentFieldsFragmentDoc}`;
export const PatientRecordFieldsFragmentDoc = gql`
    fragment PatientRecordFields on PatientRecord {
  id
  patient {
    id
    name
    clinic_species {
      ...ClinicSpeciesFields
    }
    weight
    breed
    birthday
    avatar_url
  }
  client {
    id
    first_name
    last_name
  }
  appointment {
    id
    clinician {
      id
      name
    }
    service {
      id
      name
    }
  }
  clinician {
    id
    name
  }
  date
  assisting_clinicians
  master_problem_list
  subjective
  objective
  assessment
  plan
  public_notes
  service
  clinic {
    id
    name
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export const PimsSettingsFieldsFragmentDoc = gql`
    fragment PimsSettingsFields on PimsSettings {
  clinic {
    id
    name
  }
  username
  password
  pin
  api_key
  additional_key
  api_clinic_id
  api_subdomain
  pulse_sales_report_id
  pulse_ar_report_id
}
    `;
export const PrescriptionRequestFieldsFragmentDoc = gql`
    fragment PrescriptionRequestFields on PrescriptionRequest {
  id
  patient {
    id
    name
    avatar_url
  }
  user {
    id
    first_name
    last_name
    avatar_url
  }
  clinic {
    id
    name
    avatar_url
  }
  name
  image
  quantity
  pickup_date
  comments
  clinic_notes
  status
  created_at
  updated_at
}
    `;
export const PrescriptionFieldsFragmentDoc = gql`
    fragment PrescriptionFields on Prescription {
  id
  product {
    id
  }
  quantity
  last_refill_time
  pms_created_at
}
    `;
export const PressItemFieldsFragmentDoc = gql`
    fragment PressItemFields on PressItem {
  id
  title
  description
  image
  links {
    url
    type
  }
  created_at
  updated_at
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  name
  pms_id
  price
}
    `;
export const RescheduleAppointmentFieldsFragmentDoc = gql`
    fragment RescheduleAppointmentFields on Appointment {
  id
  service {
    name
  }
  service_name
  clinician {
    name
  }
  client {
    first_name
    last_name
  }
  patient {
    name
    clinic_species {
      species
    }
  }
  start_time
  minutes
}
    `;
export const ReviewFieldsFragmentDoc = gql`
    fragment ReviewFields on Review {
  id
  client {
    ...ClientFields
  }
  appointment {
    ...AppointmentFields
  }
  description
  overall_rating
  is_anonymous
  created_at
  updated_at
}
    ${ClientFieldsFragmentDoc}
${AppointmentFieldsFragmentDoc}`;
export const SchedulingRulesFieldsFragmentDoc = gql`
    fragment SchedulingRulesFields on SchedulingRules {
  id
  clinic {
    id
  }
  included_clinicians {
    id
    name
  }
  included_species {
    id
    species
  }
  included_services {
    id
    name
  }
  included_rooms {
    id
    name
  }
  is_active
  patient_type
  client_type
  patient_gender
  fixed_status
  availability {
    ...AvailabilityDayFields
  }
  adjusted_availability {
    ...AdjustedAvailabilityFields
  }
  only_modifier
  created_at
  updated_at
}
    ${AvailabilityDayFieldsFragmentDoc}
${AdjustedAvailabilityFieldsFragmentDoc}`;
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  id
  clinic_id
  date
  amount
  type
}
    `;
export const WidgetFieldsFragmentDoc = gql`
    fragment WidgetFields on Widget {
  id
  clinic {
    id
    name
  }
  organization {
    id
    name
  }
  widget_name
  type
  trigger_type
  button_color
  button_text
  text_color
  is_external
  is_active
  enabled_chat_buttons
  average_chat_response_time
  source
  created_at
  updated_at
}
    `;
export const GetActionItemDocument = gql`
    query getActionItem($id: ID!) {
  actionItem(id: $id) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useGetActionItemQuery__
 *
 * To run a query within a React component, call `useGetActionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionItemQuery(baseOptions: Apollo.QueryHookOptions<GetActionItemQuery, GetActionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionItemQuery, GetActionItemQueryVariables>(GetActionItemDocument, options);
      }
export function useGetActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionItemQuery, GetActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionItemQuery, GetActionItemQueryVariables>(GetActionItemDocument, options);
        }
export type GetActionItemQueryHookResult = ReturnType<typeof useGetActionItemQuery>;
export type GetActionItemLazyQueryHookResult = ReturnType<typeof useGetActionItemLazyQuery>;
export type GetActionItemQueryResult = Apollo.QueryResult<GetActionItemQuery, GetActionItemQueryVariables>;
export const QueryActionItemsDocument = gql`
    query queryActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryActionItems(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useQueryActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryActionItemsQuery, QueryActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryActionItemsQuery, QueryActionItemsQueryVariables>(QueryActionItemsDocument, options);
      }
export function useQueryActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryActionItemsQuery, QueryActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryActionItemsQuery, QueryActionItemsQueryVariables>(QueryActionItemsDocument, options);
        }
export type QueryActionItemsQueryHookResult = ReturnType<typeof useQueryActionItemsQuery>;
export type QueryActionItemsLazyQueryHookResult = ReturnType<typeof useQueryActionItemsLazyQuery>;
export type QueryActionItemsQueryResult = Apollo.QueryResult<QueryActionItemsQuery, QueryActionItemsQueryVariables>;
export const CountActionItemsDocument = gql`
    query countActionItems($where: [QueryInput!]) {
  countActionItems(where: $where)
}
    `;

/**
 * __useCountActionItemsQuery__
 *
 * To run a query within a React component, call `useCountActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<CountActionItemsQuery, CountActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountActionItemsQuery, CountActionItemsQueryVariables>(CountActionItemsDocument, options);
      }
export function useCountActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountActionItemsQuery, CountActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountActionItemsQuery, CountActionItemsQueryVariables>(CountActionItemsDocument, options);
        }
export type CountActionItemsQueryHookResult = ReturnType<typeof useCountActionItemsQuery>;
export type CountActionItemsLazyQueryHookResult = ReturnType<typeof useCountActionItemsLazyQuery>;
export type CountActionItemsQueryResult = Apollo.QueryResult<CountActionItemsQuery, CountActionItemsQueryVariables>;
export const QueryAppointmentActionItemsDocument = gql`
    query queryAppointmentActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentWithActionItemsFields
  }
}
    ${AppointmentWithActionItemsFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>(QueryAppointmentActionItemsDocument, options);
      }
export function useQueryAppointmentActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>(QueryAppointmentActionItemsDocument, options);
        }
export type QueryAppointmentActionItemsQueryHookResult = ReturnType<typeof useQueryAppointmentActionItemsQuery>;
export type QueryAppointmentActionItemsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentActionItemsLazyQuery>;
export type QueryAppointmentActionItemsQueryResult = Apollo.QueryResult<QueryAppointmentActionItemsQuery, QueryAppointmentActionItemsQueryVariables>;
export const QueryRescheduleActionItemsDocument = gql`
    query queryRescheduleActionItems($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReschedules(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...RescheduleWithActionItemsFields
  }
}
    ${RescheduleWithActionItemsFieldsFragmentDoc}`;

/**
 * __useQueryRescheduleActionItemsQuery__
 *
 * To run a query within a React component, call `useQueryRescheduleActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryRescheduleActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryRescheduleActionItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryRescheduleActionItemsQuery(baseOptions?: Apollo.QueryHookOptions<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>(QueryRescheduleActionItemsDocument, options);
      }
export function useQueryRescheduleActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>(QueryRescheduleActionItemsDocument, options);
        }
export type QueryRescheduleActionItemsQueryHookResult = ReturnType<typeof useQueryRescheduleActionItemsQuery>;
export type QueryRescheduleActionItemsLazyQueryHookResult = ReturnType<typeof useQueryRescheduleActionItemsLazyQuery>;
export type QueryRescheduleActionItemsQueryResult = Apollo.QueryResult<QueryRescheduleActionItemsQuery, QueryRescheduleActionItemsQueryVariables>;
export const UpdateActionItemDocument = gql`
    mutation updateActionItem($id: ID!, $data: UpdateActionItemInput!) {
  updateActionItem(id: $id, data: $data) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;
export type UpdateActionItemMutationFn = Apollo.MutationFunction<UpdateActionItemMutation, UpdateActionItemMutationVariables>;

/**
 * __useUpdateActionItemMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemMutation, { data, loading, error }] = useUpdateActionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateActionItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionItemMutation, UpdateActionItemMutationVariables>(UpdateActionItemDocument, options);
      }
export type UpdateActionItemMutationHookResult = ReturnType<typeof useUpdateActionItemMutation>;
export type UpdateActionItemMutationResult = Apollo.MutationResult<UpdateActionItemMutation>;
export type UpdateActionItemMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemMutation, UpdateActionItemMutationVariables>;
export const GetAllAnimalsDocument = gql`
    query getAllAnimals {
  allAnimals {
    ...AnimalFields
  }
}
    ${AnimalFieldsFragmentDoc}`;

/**
 * __useGetAllAnimalsQuery__
 *
 * To run a query within a React component, call `useGetAllAnimalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAnimalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAnimalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAnimalsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAnimalsQuery, GetAllAnimalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAnimalsQuery, GetAllAnimalsQueryVariables>(GetAllAnimalsDocument, options);
      }
export function useGetAllAnimalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAnimalsQuery, GetAllAnimalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAnimalsQuery, GetAllAnimalsQueryVariables>(GetAllAnimalsDocument, options);
        }
export type GetAllAnimalsQueryHookResult = ReturnType<typeof useGetAllAnimalsQuery>;
export type GetAllAnimalsLazyQueryHookResult = ReturnType<typeof useGetAllAnimalsLazyQuery>;
export type GetAllAnimalsQueryResult = Apollo.QueryResult<GetAllAnimalsQuery, GetAllAnimalsQueryVariables>;
export const CreateAnimalDocument = gql`
    mutation createAnimal($data: CreateAnimalInput!) {
  createAnimal(data: $data) {
    ...AnimalFields
  }
}
    ${AnimalFieldsFragmentDoc}`;
export type CreateAnimalMutationFn = Apollo.MutationFunction<CreateAnimalMutation, CreateAnimalMutationVariables>;

/**
 * __useCreateAnimalMutation__
 *
 * To run a mutation, you first call `useCreateAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnimalMutation, { data, loading, error }] = useCreateAnimalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAnimalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnimalMutation, CreateAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnimalMutation, CreateAnimalMutationVariables>(CreateAnimalDocument, options);
      }
export type CreateAnimalMutationHookResult = ReturnType<typeof useCreateAnimalMutation>;
export type CreateAnimalMutationResult = Apollo.MutationResult<CreateAnimalMutation>;
export type CreateAnimalMutationOptions = Apollo.BaseMutationOptions<CreateAnimalMutation, CreateAnimalMutationVariables>;
export const UpdateAnimalDocument = gql`
    mutation updateAnimal($id: ID!, $data: UpdateAnimalInput!) {
  updateAnimal(id: $id, data: $data) {
    ...AnimalFields
  }
}
    ${AnimalFieldsFragmentDoc}`;
export type UpdateAnimalMutationFn = Apollo.MutationFunction<UpdateAnimalMutation, UpdateAnimalMutationVariables>;

/**
 * __useUpdateAnimalMutation__
 *
 * To run a mutation, you first call `useUpdateAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnimalMutation, { data, loading, error }] = useUpdateAnimalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAnimalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnimalMutation, UpdateAnimalMutationVariables>(UpdateAnimalDocument, options);
      }
export type UpdateAnimalMutationHookResult = ReturnType<typeof useUpdateAnimalMutation>;
export type UpdateAnimalMutationResult = Apollo.MutationResult<UpdateAnimalMutation>;
export type UpdateAnimalMutationOptions = Apollo.BaseMutationOptions<UpdateAnimalMutation, UpdateAnimalMutationVariables>;
export const DeleteAnimalDocument = gql`
    mutation deleteAnimal($id: ID!) {
  deleteAnimal(id: $id)
}
    `;
export type DeleteAnimalMutationFn = Apollo.MutationFunction<DeleteAnimalMutation, DeleteAnimalMutationVariables>;

/**
 * __useDeleteAnimalMutation__
 *
 * To run a mutation, you first call `useDeleteAnimalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnimalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnimalMutation, { data, loading, error }] = useDeleteAnimalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnimalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnimalMutation, DeleteAnimalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnimalMutation, DeleteAnimalMutationVariables>(DeleteAnimalDocument, options);
      }
export type DeleteAnimalMutationHookResult = ReturnType<typeof useDeleteAnimalMutation>;
export type DeleteAnimalMutationResult = Apollo.MutationResult<DeleteAnimalMutation>;
export type DeleteAnimalMutationOptions = Apollo.BaseMutationOptions<DeleteAnimalMutation, DeleteAnimalMutationVariables>;
export const GetAppointmentPromptDocument = gql`
    query getAppointmentPrompt($id: ID!) {
  appointmentPrompt(id: $id) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;

/**
 * __useGetAppointmentPromptQuery__
 *
 * To run a query within a React component, call `useGetAppointmentPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentPromptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentPromptQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>(GetAppointmentPromptDocument, options);
      }
export function useGetAppointmentPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>(GetAppointmentPromptDocument, options);
        }
export type GetAppointmentPromptQueryHookResult = ReturnType<typeof useGetAppointmentPromptQuery>;
export type GetAppointmentPromptLazyQueryHookResult = ReturnType<typeof useGetAppointmentPromptLazyQuery>;
export type GetAppointmentPromptQueryResult = Apollo.QueryResult<GetAppointmentPromptQuery, GetAppointmentPromptQueryVariables>;
export const AllAppointmentPromptsDocument = gql`
    query allAppointmentPrompts {
  allAppointmentPrompts {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;

/**
 * __useAllAppointmentPromptsQuery__
 *
 * To run a query within a React component, call `useAllAppointmentPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAppointmentPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAppointmentPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAppointmentPromptsQuery(baseOptions?: Apollo.QueryHookOptions<AllAppointmentPromptsQuery, AllAppointmentPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAppointmentPromptsQuery, AllAppointmentPromptsQueryVariables>(AllAppointmentPromptsDocument, options);
      }
export function useAllAppointmentPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAppointmentPromptsQuery, AllAppointmentPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAppointmentPromptsQuery, AllAppointmentPromptsQueryVariables>(AllAppointmentPromptsDocument, options);
        }
export type AllAppointmentPromptsQueryHookResult = ReturnType<typeof useAllAppointmentPromptsQuery>;
export type AllAppointmentPromptsLazyQueryHookResult = ReturnType<typeof useAllAppointmentPromptsLazyQuery>;
export type AllAppointmentPromptsQueryResult = Apollo.QueryResult<AllAppointmentPromptsQuery, AllAppointmentPromptsQueryVariables>;
export const QueryAppointmentPromptsDocument = gql`
    query queryAppointmentPrompts($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointmentPrompts(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentPromptsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentPromptsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentPromptsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>(QueryAppointmentPromptsDocument, options);
      }
export function useQueryAppointmentPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>(QueryAppointmentPromptsDocument, options);
        }
export type QueryAppointmentPromptsQueryHookResult = ReturnType<typeof useQueryAppointmentPromptsQuery>;
export type QueryAppointmentPromptsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentPromptsLazyQuery>;
export type QueryAppointmentPromptsQueryResult = Apollo.QueryResult<QueryAppointmentPromptsQuery, QueryAppointmentPromptsQueryVariables>;
export const CreateAppointmentPromptDocument = gql`
    mutation createAppointmentPrompt($data: CreateAppointmentPromptInput!) {
  createAppointmentPrompt(data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type CreateAppointmentPromptMutationFn = Apollo.MutationFunction<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>;

/**
 * __useCreateAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentPromptMutation, { data, loading, error }] = useCreateAppointmentPromptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>(CreateAppointmentPromptDocument, options);
      }
export type CreateAppointmentPromptMutationHookResult = ReturnType<typeof useCreateAppointmentPromptMutation>;
export type CreateAppointmentPromptMutationResult = Apollo.MutationResult<CreateAppointmentPromptMutation>;
export type CreateAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentPromptMutation, CreateAppointmentPromptMutationVariables>;
export const SendAppointmentPromptDocument = gql`
    mutation sendAppointmentPrompt($data: CreateAppointmentPromptInput!) {
  sendAppointmentPrompt(data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type SendAppointmentPromptMutationFn = Apollo.MutationFunction<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>;

/**
 * __useSendAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useSendAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAppointmentPromptMutation, { data, loading, error }] = useSendAppointmentPromptMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>(SendAppointmentPromptDocument, options);
      }
export type SendAppointmentPromptMutationHookResult = ReturnType<typeof useSendAppointmentPromptMutation>;
export type SendAppointmentPromptMutationResult = Apollo.MutationResult<SendAppointmentPromptMutation>;
export type SendAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<SendAppointmentPromptMutation, SendAppointmentPromptMutationVariables>;
export const UpdateAppointmentPromptDocument = gql`
    mutation updateAppointmentPrompt($id: ID!, $data: UpdateAppointmentPromptInput!) {
  updateAppointmentPrompt(id: $id, data: $data) {
    ...AppointmentPromptFields
  }
}
    ${AppointmentPromptFieldsFragmentDoc}`;
export type UpdateAppointmentPromptMutationFn = Apollo.MutationFunction<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>;

/**
 * __useUpdateAppointmentPromptMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentPromptMutation, { data, loading, error }] = useUpdateAppointmentPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>(UpdateAppointmentPromptDocument, options);
      }
export type UpdateAppointmentPromptMutationHookResult = ReturnType<typeof useUpdateAppointmentPromptMutation>;
export type UpdateAppointmentPromptMutationResult = Apollo.MutationResult<UpdateAppointmentPromptMutation>;
export type UpdateAppointmentPromptMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentPromptMutation, UpdateAppointmentPromptMutationVariables>;
export const GetPublicAppointmentTimesDocument = gql`
    query getPublicAppointmentTimes($searchInput: SearchAppointmentsInput!) {
  publicAppointmentTimes(searchInput: $searchInput) {
    ...PublicAppointmentTimeFields
  }
}
    ${PublicAppointmentTimeFieldsFragmentDoc}`;

/**
 * __useGetPublicAppointmentTimesQuery__
 *
 * To run a query within a React component, call `useGetPublicAppointmentTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicAppointmentTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicAppointmentTimesQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useGetPublicAppointmentTimesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>(GetPublicAppointmentTimesDocument, options);
      }
export function useGetPublicAppointmentTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>(GetPublicAppointmentTimesDocument, options);
        }
export type GetPublicAppointmentTimesQueryHookResult = ReturnType<typeof useGetPublicAppointmentTimesQuery>;
export type GetPublicAppointmentTimesLazyQueryHookResult = ReturnType<typeof useGetPublicAppointmentTimesLazyQuery>;
export type GetPublicAppointmentTimesQueryResult = Apollo.QueryResult<GetPublicAppointmentTimesQuery, GetPublicAppointmentTimesQueryVariables>;
export const GetAllAppointmentsDocument = gql`
    query getAllAppointments {
  allAppointments {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useGetAllAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetAllAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAppointmentsQuery, GetAllAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAppointmentsQuery, GetAllAppointmentsQueryVariables>(GetAllAppointmentsDocument, options);
      }
export function useGetAllAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAppointmentsQuery, GetAllAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAppointmentsQuery, GetAllAppointmentsQueryVariables>(GetAllAppointmentsDocument, options);
        }
export type GetAllAppointmentsQueryHookResult = ReturnType<typeof useGetAllAppointmentsQuery>;
export type GetAllAppointmentsLazyQueryHookResult = ReturnType<typeof useGetAllAppointmentsLazyQuery>;
export type GetAllAppointmentsQueryResult = Apollo.QueryResult<GetAllAppointmentsQuery, GetAllAppointmentsQueryVariables>;
export const GetAppointmentDocument = gql`
    query getAppointment($id: ID!) {
  appointment(id: $id) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const SearchAppointmentsDocument = gql`
    query searchAppointments($searchInput: SearchAppointmentsInput!) {
  searchAppointments(searchInput: $searchInput) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useSearchAppointmentsQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentsQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>(SearchAppointmentsDocument, options);
      }
export function useSearchAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>(SearchAppointmentsDocument, options);
        }
export type SearchAppointmentsQueryHookResult = ReturnType<typeof useSearchAppointmentsQuery>;
export type SearchAppointmentsLazyQueryHookResult = ReturnType<typeof useSearchAppointmentsLazyQuery>;
export type SearchAppointmentsQueryResult = Apollo.QueryResult<SearchAppointmentsQuery, SearchAppointmentsQueryVariables>;
export const QueryAppointmentsDocument = gql`
    query queryAppointments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryAppointments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useQueryAppointmentsQuery__
 *
 * To run a query within a React component, call `useQueryAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>(QueryAppointmentsDocument, options);
      }
export function useQueryAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>(QueryAppointmentsDocument, options);
        }
export type QueryAppointmentsQueryHookResult = ReturnType<typeof useQueryAppointmentsQuery>;
export type QueryAppointmentsLazyQueryHookResult = ReturnType<typeof useQueryAppointmentsLazyQuery>;
export type QueryAppointmentsQueryResult = Apollo.QueryResult<QueryAppointmentsQuery, QueryAppointmentsQueryVariables>;
export const CountAppointmentsDocument = gql`
    query countAppointments($where: [QueryInput!]) {
  countAppointments(where: $where)
}
    `;

/**
 * __useCountAppointmentsQuery__
 *
 * To run a query within a React component, call `useCountAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAppointmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<CountAppointmentsQuery, CountAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountAppointmentsQuery, CountAppointmentsQueryVariables>(CountAppointmentsDocument, options);
      }
export function useCountAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountAppointmentsQuery, CountAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountAppointmentsQuery, CountAppointmentsQueryVariables>(CountAppointmentsDocument, options);
        }
export type CountAppointmentsQueryHookResult = ReturnType<typeof useCountAppointmentsQuery>;
export type CountAppointmentsLazyQueryHookResult = ReturnType<typeof useCountAppointmentsLazyQuery>;
export type CountAppointmentsQueryResult = Apollo.QueryResult<CountAppointmentsQuery, CountAppointmentsQueryVariables>;
export const SearchAppointmentsStatusDocument = gql`
    query searchAppointmentsStatus($searchInput: SearchAppointmentsInput!) {
  searchAppointments(searchInput: $searchInput) {
    id
    status
  }
}
    `;

/**
 * __useSearchAppointmentsStatusQuery__
 *
 * To run a query within a React component, call `useSearchAppointmentsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppointmentsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppointmentsStatusQuery({
 *   variables: {
 *      searchInput: // value for 'searchInput'
 *   },
 * });
 */
export function useSearchAppointmentsStatusQuery(baseOptions: Apollo.QueryHookOptions<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>(SearchAppointmentsStatusDocument, options);
      }
export function useSearchAppointmentsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>(SearchAppointmentsStatusDocument, options);
        }
export type SearchAppointmentsStatusQueryHookResult = ReturnType<typeof useSearchAppointmentsStatusQuery>;
export type SearchAppointmentsStatusLazyQueryHookResult = ReturnType<typeof useSearchAppointmentsStatusLazyQuery>;
export type SearchAppointmentsStatusQueryResult = Apollo.QueryResult<SearchAppointmentsStatusQuery, SearchAppointmentsStatusQueryVariables>;
export const GetNewAppointmentsForClinicDocument = gql`
    query getNewAppointmentsForClinic($clinicId: ID!, $fromPmsCreatedAt: NonNegativeInt!, $toPmsCreatedAt: NonNegativeInt!) {
  getNewAppointmentsForClinic(
    clinicId: $clinicId
    fromPmsCreatedAt: $fromPmsCreatedAt
    toPmsCreatedAt: $toPmsCreatedAt
  )
}
    `;

/**
 * __useGetNewAppointmentsForClinicQuery__
 *
 * To run a query within a React component, call `useGetNewAppointmentsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewAppointmentsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewAppointmentsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromPmsCreatedAt: // value for 'fromPmsCreatedAt'
 *      toPmsCreatedAt: // value for 'toPmsCreatedAt'
 *   },
 * });
 */
export function useGetNewAppointmentsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>(GetNewAppointmentsForClinicDocument, options);
      }
export function useGetNewAppointmentsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>(GetNewAppointmentsForClinicDocument, options);
        }
export type GetNewAppointmentsForClinicQueryHookResult = ReturnType<typeof useGetNewAppointmentsForClinicQuery>;
export type GetNewAppointmentsForClinicLazyQueryHookResult = ReturnType<typeof useGetNewAppointmentsForClinicLazyQuery>;
export type GetNewAppointmentsForClinicQueryResult = Apollo.QueryResult<GetNewAppointmentsForClinicQuery, GetNewAppointmentsForClinicQueryVariables>;
export const GetAppointmentsByClinicAndRangeDocument = gql`
    query getAppointmentsByClinicAndRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  appointmentsByClinicAndRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;

/**
 * __useGetAppointmentsByClinicAndRangeQuery__
 *
 * To run a query within a React component, call `useGetAppointmentsByClinicAndRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentsByClinicAndRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentsByClinicAndRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetAppointmentsByClinicAndRangeQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>(GetAppointmentsByClinicAndRangeDocument, options);
      }
export function useGetAppointmentsByClinicAndRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>(GetAppointmentsByClinicAndRangeDocument, options);
        }
export type GetAppointmentsByClinicAndRangeQueryHookResult = ReturnType<typeof useGetAppointmentsByClinicAndRangeQuery>;
export type GetAppointmentsByClinicAndRangeLazyQueryHookResult = ReturnType<typeof useGetAppointmentsByClinicAndRangeLazyQuery>;
export type GetAppointmentsByClinicAndRangeQueryResult = Apollo.QueryResult<GetAppointmentsByClinicAndRangeQuery, GetAppointmentsByClinicAndRangeQueryVariables>;
export const GetTimeSlotsForClinicForDayDocument = gql`
    query getTimeSlotsForClinicForDay($clinicId: ID!, $date: NonNegativeInt!) {
  getTimeSlotsForClinicForDay(clinicId: $clinicId, date: $date) {
    time_slots {
      ...TimeSlotFields
    }
    schedule_efficiency
  }
}
    ${TimeSlotFieldsFragmentDoc}`;

/**
 * __useGetTimeSlotsForClinicForDayQuery__
 *
 * To run a query within a React component, call `useGetTimeSlotsForClinicForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeSlotsForClinicForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeSlotsForClinicForDayQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetTimeSlotsForClinicForDayQuery(baseOptions: Apollo.QueryHookOptions<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>(GetTimeSlotsForClinicForDayDocument, options);
      }
export function useGetTimeSlotsForClinicForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>(GetTimeSlotsForClinicForDayDocument, options);
        }
export type GetTimeSlotsForClinicForDayQueryHookResult = ReturnType<typeof useGetTimeSlotsForClinicForDayQuery>;
export type GetTimeSlotsForClinicForDayLazyQueryHookResult = ReturnType<typeof useGetTimeSlotsForClinicForDayLazyQuery>;
export type GetTimeSlotsForClinicForDayQueryResult = Apollo.QueryResult<GetTimeSlotsForClinicForDayQuery, GetTimeSlotsForClinicForDayQueryVariables>;
export const CreateAppointmentDocument = gql`
    mutation createAppointment($data: CreateAppointmentInput!) {
  createAppointment(data: $data) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation updateAppointment($id: ID!, $data: UpdateAppointmentInput!) {
  updateAppointment(id: $id, data: $data) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const MarkAppointmentAsResolvedDocument = gql`
    mutation markAppointmentAsResolved($id: ID!, $reason: ResolveReason) {
  markAppointmentAsResolved(id: $id, reason: $reason) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type MarkAppointmentAsResolvedMutationFn = Apollo.MutationFunction<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>;

/**
 * __useMarkAppointmentAsResolvedMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentAsResolvedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentAsResolvedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentAsResolvedMutation, { data, loading, error }] = useMarkAppointmentAsResolvedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMarkAppointmentAsResolvedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>(MarkAppointmentAsResolvedDocument, options);
      }
export type MarkAppointmentAsResolvedMutationHookResult = ReturnType<typeof useMarkAppointmentAsResolvedMutation>;
export type MarkAppointmentAsResolvedMutationResult = Apollo.MutationResult<MarkAppointmentAsResolvedMutation>;
export type MarkAppointmentAsResolvedMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentAsResolvedMutation, MarkAppointmentAsResolvedMutationVariables>;
export const ConfirmAppointmentDocument = gql`
    mutation confirmAppointment($id: ID!) {
  confirmAppointment(id: $id)
}
    `;
export type ConfirmAppointmentMutationFn = Apollo.MutationFunction<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;

/**
 * __useConfirmAppointmentMutation__
 *
 * To run a mutation, you first call `useConfirmAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAppointmentMutation, { data, loading, error }] = useConfirmAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfirmAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>(ConfirmAppointmentDocument, options);
      }
export type ConfirmAppointmentMutationHookResult = ReturnType<typeof useConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationResult = Apollo.MutationResult<ConfirmAppointmentMutation>;
export type ConfirmAppointmentMutationOptions = Apollo.BaseMutationOptions<ConfirmAppointmentMutation, ConfirmAppointmentMutationVariables>;
export const UpdateAppointmentClientPatientDocument = gql`
    mutation updateAppointmentClientPatient($id: ID!, $clientId: ID, $patientId: ID) {
  updateAppointmentClientPatient(
    id: $id
    clientId: $clientId
    patientId: $patientId
  ) {
    ...AppointmentFields
  }
}
    ${AppointmentFieldsFragmentDoc}`;
export type UpdateAppointmentClientPatientMutationFn = Apollo.MutationFunction<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>;

/**
 * __useUpdateAppointmentClientPatientMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentClientPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentClientPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentClientPatientMutation, { data, loading, error }] = useUpdateAppointmentClientPatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      clientId: // value for 'clientId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useUpdateAppointmentClientPatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>(UpdateAppointmentClientPatientDocument, options);
      }
export type UpdateAppointmentClientPatientMutationHookResult = ReturnType<typeof useUpdateAppointmentClientPatientMutation>;
export type UpdateAppointmentClientPatientMutationResult = Apollo.MutationResult<UpdateAppointmentClientPatientMutation>;
export type UpdateAppointmentClientPatientMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentClientPatientMutation, UpdateAppointmentClientPatientMutationVariables>;
export const DeleteAppointmentDocument = gql`
    mutation deleteAppointment($id: ID!) {
  deleteAppointment(id: $id)
}
    `;
export type DeleteAppointmentMutationFn = Apollo.MutationFunction<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;

/**
 * __useDeleteAppointmentMutation__
 *
 * To run a mutation, you first call `useDeleteAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAppointmentMutation, { data, loading, error }] = useDeleteAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>(DeleteAppointmentDocument, options);
      }
export type DeleteAppointmentMutationHookResult = ReturnType<typeof useDeleteAppointmentMutation>;
export type DeleteAppointmentMutationResult = Apollo.MutationResult<DeleteAppointmentMutation>;
export type DeleteAppointmentMutationOptions = Apollo.BaseMutationOptions<DeleteAppointmentMutation, DeleteAppointmentMutationVariables>;
export const GetBreedsByClinicDocument = gql`
    query getBreedsByClinic($clinicId: ID!) {
  getBreedsByClinic(clinicId: $clinicId) {
    ...BreedFields
  }
}
    ${BreedFieldsFragmentDoc}`;

/**
 * __useGetBreedsByClinicQuery__
 *
 * To run a query within a React component, call `useGetBreedsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreedsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreedsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetBreedsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>(GetBreedsByClinicDocument, options);
      }
export function useGetBreedsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>(GetBreedsByClinicDocument, options);
        }
export type GetBreedsByClinicQueryHookResult = ReturnType<typeof useGetBreedsByClinicQuery>;
export type GetBreedsByClinicLazyQueryHookResult = ReturnType<typeof useGetBreedsByClinicLazyQuery>;
export type GetBreedsByClinicQueryResult = Apollo.QueryResult<GetBreedsByClinicQuery, GetBreedsByClinicQueryVariables>;
export const QueryBreedsDocument = gql`
    query queryBreeds($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryBreeds(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...BreedFields
  }
}
    ${BreedFieldsFragmentDoc}`;

/**
 * __useQueryBreedsQuery__
 *
 * To run a query within a React component, call `useQueryBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryBreedsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryBreedsQuery(baseOptions?: Apollo.QueryHookOptions<QueryBreedsQuery, QueryBreedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryBreedsQuery, QueryBreedsQueryVariables>(QueryBreedsDocument, options);
      }
export function useQueryBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryBreedsQuery, QueryBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryBreedsQuery, QueryBreedsQueryVariables>(QueryBreedsDocument, options);
        }
export type QueryBreedsQueryHookResult = ReturnType<typeof useQueryBreedsQuery>;
export type QueryBreedsLazyQueryHookResult = ReturnType<typeof useQueryBreedsLazyQuery>;
export type QueryBreedsQueryResult = Apollo.QueryResult<QueryBreedsQuery, QueryBreedsQueryVariables>;
export const GetChatDocument = gql`
    query getChat($id: ID!) {
  chat(id: $id) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQuery, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQuery, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQuery, GetChatQueryVariables>;
export const GetChatsByClientIdDocument = gql`
    query getChatsByClientId($clientId: ID!) {
  getChatsByClientId(clientId: $clientId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatsByClientIdQuery__
 *
 * To run a query within a React component, call `useGetChatsByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetChatsByClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>(GetChatsByClientIdDocument, options);
      }
export function useGetChatsByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>(GetChatsByClientIdDocument, options);
        }
export type GetChatsByClientIdQueryHookResult = ReturnType<typeof useGetChatsByClientIdQuery>;
export type GetChatsByClientIdLazyQueryHookResult = ReturnType<typeof useGetChatsByClientIdLazyQuery>;
export type GetChatsByClientIdQueryResult = Apollo.QueryResult<GetChatsByClientIdQuery, GetChatsByClientIdQueryVariables>;
export const GetChatsByClinicIdDocument = gql`
    query getChatsByClinicId($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getChatsByClinicId(clinicId: $clinicId, page: $page, pageSize: $pageSize) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatsByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetChatsByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetChatsByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>(GetChatsByClinicIdDocument, options);
      }
export function useGetChatsByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>(GetChatsByClinicIdDocument, options);
        }
export type GetChatsByClinicIdQueryHookResult = ReturnType<typeof useGetChatsByClinicIdQuery>;
export type GetChatsByClinicIdLazyQueryHookResult = ReturnType<typeof useGetChatsByClinicIdLazyQuery>;
export type GetChatsByClinicIdQueryResult = Apollo.QueryResult<GetChatsByClinicIdQuery, GetChatsByClinicIdQueryVariables>;
export const QueryChatsDocument = gql`
    query queryChats($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryChats(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useQueryChatsQuery__
 *
 * To run a query within a React component, call `useQueryChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryChatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryChatsQuery(baseOptions?: Apollo.QueryHookOptions<QueryChatsQuery, QueryChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryChatsQuery, QueryChatsQueryVariables>(QueryChatsDocument, options);
      }
export function useQueryChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryChatsQuery, QueryChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryChatsQuery, QueryChatsQueryVariables>(QueryChatsDocument, options);
        }
export type QueryChatsQueryHookResult = ReturnType<typeof useQueryChatsQuery>;
export type QueryChatsLazyQueryHookResult = ReturnType<typeof useQueryChatsLazyQuery>;
export type QueryChatsQueryResult = Apollo.QueryResult<QueryChatsQuery, QueryChatsQueryVariables>;
export const CountChatsDocument = gql`
    query countChats($where: [QueryInput!]) {
  countChats(where: $where)
}
    `;

/**
 * __useCountChatsQuery__
 *
 * To run a query within a React component, call `useCountChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountChatsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountChatsQuery(baseOptions?: Apollo.QueryHookOptions<CountChatsQuery, CountChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountChatsQuery, CountChatsQueryVariables>(CountChatsDocument, options);
      }
export function useCountChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountChatsQuery, CountChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountChatsQuery, CountChatsQueryVariables>(CountChatsDocument, options);
        }
export type CountChatsQueryHookResult = ReturnType<typeof useCountChatsQuery>;
export type CountChatsLazyQueryHookResult = ReturnType<typeof useCountChatsLazyQuery>;
export type CountChatsQueryResult = Apollo.QueryResult<CountChatsQuery, CountChatsQueryVariables>;
export const GetChatByClientAndClinicDocument = gql`
    query getChatByClientAndClinic($clientId: ID!, $clinicId: ID!) {
  getChatByClientAndClinic(clientId: $clientId, clinicId: $clinicId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;

/**
 * __useGetChatByClientAndClinicQuery__
 *
 * To run a query within a React component, call `useGetChatByClientAndClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByClientAndClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByClientAndClinicQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetChatByClientAndClinicQuery(baseOptions: Apollo.QueryHookOptions<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>(GetChatByClientAndClinicDocument, options);
      }
export function useGetChatByClientAndClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>(GetChatByClientAndClinicDocument, options);
        }
export type GetChatByClientAndClinicQueryHookResult = ReturnType<typeof useGetChatByClientAndClinicQuery>;
export type GetChatByClientAndClinicLazyQueryHookResult = ReturnType<typeof useGetChatByClientAndClinicLazyQuery>;
export type GetChatByClientAndClinicQueryResult = Apollo.QueryResult<GetChatByClientAndClinicQuery, GetChatByClientAndClinicQueryVariables>;
export const CreateChatDocument = gql`
    mutation createChat($data: CreateChatInput!) {
  createChat(data: $data) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const UpdateChatDocument = gql`
    mutation updateChat($id: ID!, $data: UpdateChatInput!) {
  updateChat(id: $id, data: $data) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;
export type UpdateChatMutationFn = Apollo.MutationFunction<UpdateChatMutation, UpdateChatMutationVariables>;

/**
 * __useUpdateChatMutation__
 *
 * To run a mutation, you first call `useUpdateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatMutation, { data, loading, error }] = useUpdateChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChatMutation, UpdateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChatMutation, UpdateChatMutationVariables>(UpdateChatDocument, options);
      }
export type UpdateChatMutationHookResult = ReturnType<typeof useUpdateChatMutation>;
export type UpdateChatMutationResult = Apollo.MutationResult<UpdateChatMutation>;
export type UpdateChatMutationOptions = Apollo.BaseMutationOptions<UpdateChatMutation, UpdateChatMutationVariables>;
export const UploadAttachmentDocument = gql`
    mutation uploadAttachment($clinicId: ID!, $data: AttachmentInput!) {
  uploadAttachment(clinicId: $clinicId, data: $data)
}
    `;
export type UploadAttachmentMutationFn = Apollo.MutationFunction<UploadAttachmentMutation, UploadAttachmentMutationVariables>;

/**
 * __useUploadAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentMutation, { data, loading, error }] = useUploadAttachmentMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentMutation, UploadAttachmentMutationVariables>(UploadAttachmentDocument, options);
      }
export type UploadAttachmentMutationHookResult = ReturnType<typeof useUploadAttachmentMutation>;
export type UploadAttachmentMutationResult = Apollo.MutationResult<UploadAttachmentMutation>;
export type UploadAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentMutation, UploadAttachmentMutationVariables>;
export const GetCheckInDocument = gql`
    query getCheckIn($id: ID!) {
  checkIn(id: $id) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInQuery__
 *
 * To run a query within a React component, call `useGetCheckInQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCheckInQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInQuery, GetCheckInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInQuery, GetCheckInQueryVariables>(GetCheckInDocument, options);
      }
export function useGetCheckInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInQuery, GetCheckInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInQuery, GetCheckInQueryVariables>(GetCheckInDocument, options);
        }
export type GetCheckInQueryHookResult = ReturnType<typeof useGetCheckInQuery>;
export type GetCheckInLazyQueryHookResult = ReturnType<typeof useGetCheckInLazyQuery>;
export type GetCheckInQueryResult = Apollo.QueryResult<GetCheckInQuery, GetCheckInQueryVariables>;
export const GetCheckInsByUserDocument = gql`
    query getCheckInsByUser($userId: ID!) {
  getCheckInsByUser(userId: $userId) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInsByUserQuery__
 *
 * To run a query within a React component, call `useGetCheckInsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCheckInsByUserQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>(GetCheckInsByUserDocument, options);
      }
export function useGetCheckInsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>(GetCheckInsByUserDocument, options);
        }
export type GetCheckInsByUserQueryHookResult = ReturnType<typeof useGetCheckInsByUserQuery>;
export type GetCheckInsByUserLazyQueryHookResult = ReturnType<typeof useGetCheckInsByUserLazyQuery>;
export type GetCheckInsByUserQueryResult = Apollo.QueryResult<GetCheckInsByUserQuery, GetCheckInsByUserQueryVariables>;
export const GetCheckInsByClinicDocument = gql`
    query getCheckInsByClinic($clinicId: ID!) {
  getCheckInsByClinic(clinicId: $clinicId) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;

/**
 * __useGetCheckInsByClinicQuery__
 *
 * To run a query within a React component, call `useGetCheckInsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckInsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckInsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetCheckInsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>(GetCheckInsByClinicDocument, options);
      }
export function useGetCheckInsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>(GetCheckInsByClinicDocument, options);
        }
export type GetCheckInsByClinicQueryHookResult = ReturnType<typeof useGetCheckInsByClinicQuery>;
export type GetCheckInsByClinicLazyQueryHookResult = ReturnType<typeof useGetCheckInsByClinicLazyQuery>;
export type GetCheckInsByClinicQueryResult = Apollo.QueryResult<GetCheckInsByClinicQuery, GetCheckInsByClinicQueryVariables>;
export const CreateCheckInDocument = gql`
    mutation createCheckIn($data: CreateCheckInInput!) {
  createCheckIn(data: $data) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;
export type CreateCheckInMutationFn = Apollo.MutationFunction<CreateCheckInMutation, CreateCheckInMutationVariables>;

/**
 * __useCreateCheckInMutation__
 *
 * To run a mutation, you first call `useCreateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckInMutation, { data, loading, error }] = useCreateCheckInMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckInMutation, CreateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckInMutation, CreateCheckInMutationVariables>(CreateCheckInDocument, options);
      }
export type CreateCheckInMutationHookResult = ReturnType<typeof useCreateCheckInMutation>;
export type CreateCheckInMutationResult = Apollo.MutationResult<CreateCheckInMutation>;
export type CreateCheckInMutationOptions = Apollo.BaseMutationOptions<CreateCheckInMutation, CreateCheckInMutationVariables>;
export const UpdateCheckInDocument = gql`
    mutation updateCheckIn($id: ID!, $data: UpdateCheckInInput!) {
  updateCheckIn(id: $id, data: $data) {
    ...CheckInFields
  }
}
    ${CheckInFieldsFragmentDoc}`;
export type UpdateCheckInMutationFn = Apollo.MutationFunction<UpdateCheckInMutation, UpdateCheckInMutationVariables>;

/**
 * __useUpdateCheckInMutation__
 *
 * To run a mutation, you first call `useUpdateCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckInMutation, { data, loading, error }] = useUpdateCheckInMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCheckInMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckInMutation, UpdateCheckInMutationVariables>(UpdateCheckInDocument, options);
      }
export type UpdateCheckInMutationHookResult = ReturnType<typeof useUpdateCheckInMutation>;
export type UpdateCheckInMutationResult = Apollo.MutationResult<UpdateCheckInMutation>;
export type UpdateCheckInMutationOptions = Apollo.BaseMutationOptions<UpdateCheckInMutation, UpdateCheckInMutationVariables>;
export const CreateClientFormDocument = gql`
    mutation createClientForm($data: CreateClientFormInput!) {
  createClientForm(data: $data) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type CreateClientFormMutationFn = Apollo.MutationFunction<CreateClientFormMutation, CreateClientFormMutationVariables>;

/**
 * __useCreateClientFormMutation__
 *
 * To run a mutation, you first call `useCreateClientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientFormMutation, { data, loading, error }] = useCreateClientFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientFormMutation, CreateClientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientFormMutation, CreateClientFormMutationVariables>(CreateClientFormDocument, options);
      }
export type CreateClientFormMutationHookResult = ReturnType<typeof useCreateClientFormMutation>;
export type CreateClientFormMutationResult = Apollo.MutationResult<CreateClientFormMutation>;
export type CreateClientFormMutationOptions = Apollo.BaseMutationOptions<CreateClientFormMutation, CreateClientFormMutationVariables>;
export const UpdateClientFormDocument = gql`
    mutation updateClientForm($id: ID!, $data: UpdateClientFormInput!) {
  updateClientForm(id: $id, data: $data) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;
export type UpdateClientFormMutationFn = Apollo.MutationFunction<UpdateClientFormMutation, UpdateClientFormMutationVariables>;

/**
 * __useUpdateClientFormMutation__
 *
 * To run a mutation, you first call `useUpdateClientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientFormMutation, { data, loading, error }] = useUpdateClientFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientFormMutation, UpdateClientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientFormMutation, UpdateClientFormMutationVariables>(UpdateClientFormDocument, options);
      }
export type UpdateClientFormMutationHookResult = ReturnType<typeof useUpdateClientFormMutation>;
export type UpdateClientFormMutationResult = Apollo.MutationResult<UpdateClientFormMutation>;
export type UpdateClientFormMutationOptions = Apollo.BaseMutationOptions<UpdateClientFormMutation, UpdateClientFormMutationVariables>;
export const QueryClientFormsDocument = gql`
    query queryClientForms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClientForms(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClientFormFields
  }
}
    ${ClientFormFieldsFragmentDoc}`;

/**
 * __useQueryClientFormsQuery__
 *
 * To run a query within a React component, call `useQueryClientFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClientFormsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClientFormsQuery, QueryClientFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientFormsQuery, QueryClientFormsQueryVariables>(QueryClientFormsDocument, options);
      }
export function useQueryClientFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientFormsQuery, QueryClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientFormsQuery, QueryClientFormsQueryVariables>(QueryClientFormsDocument, options);
        }
export type QueryClientFormsQueryHookResult = ReturnType<typeof useQueryClientFormsQuery>;
export type QueryClientFormsLazyQueryHookResult = ReturnType<typeof useQueryClientFormsLazyQuery>;
export type QueryClientFormsQueryResult = Apollo.QueryResult<QueryClientFormsQuery, QueryClientFormsQueryVariables>;
export const CountClientFormsDocument = gql`
    query countClientForms($where: [QueryInput!]) {
  countClientForms(where: $where)
}
    `;

/**
 * __useCountClientFormsQuery__
 *
 * To run a query within a React component, call `useCountClientFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClientFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClientFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClientFormsQuery(baseOptions?: Apollo.QueryHookOptions<CountClientFormsQuery, CountClientFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClientFormsQuery, CountClientFormsQueryVariables>(CountClientFormsDocument, options);
      }
export function useCountClientFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClientFormsQuery, CountClientFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClientFormsQuery, CountClientFormsQueryVariables>(CountClientFormsDocument, options);
        }
export type CountClientFormsQueryHookResult = ReturnType<typeof useCountClientFormsQuery>;
export type CountClientFormsLazyQueryHookResult = ReturnType<typeof useCountClientFormsLazyQuery>;
export type CountClientFormsQueryResult = Apollo.QueryResult<CountClientFormsQuery, CountClientFormsQueryVariables>;
export const GetClientDocument = gql`
    query getClient($id: ID!) {
  client(id: $id) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const CheckExistingClientsDocument = gql`
    query checkExistingClients($email: String, $phone: String) {
  checkExistingClients(email: $email, phone: $phone) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useCheckExistingClientsQuery__
 *
 * To run a query within a React component, call `useCheckExistingClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingClientsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckExistingClientsQuery(baseOptions?: Apollo.QueryHookOptions<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>(CheckExistingClientsDocument, options);
      }
export function useCheckExistingClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>(CheckExistingClientsDocument, options);
        }
export type CheckExistingClientsQueryHookResult = ReturnType<typeof useCheckExistingClientsQuery>;
export type CheckExistingClientsLazyQueryHookResult = ReturnType<typeof useCheckExistingClientsLazyQuery>;
export type CheckExistingClientsQueryResult = Apollo.QueryResult<CheckExistingClientsQuery, CheckExistingClientsQueryVariables>;
export const CheckExistingClientDocument = gql`
    query checkExistingClient($clinicId: ID!, $firstName: String!, $lastName: String!, $email: String, $phone: String!) {
  checkExistingClient(
    clinicId: $clinicId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
  ) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useCheckExistingClientQuery__
 *
 * To run a query within a React component, call `useCheckExistingClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckExistingClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckExistingClientQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCheckExistingClientQuery(baseOptions: Apollo.QueryHookOptions<CheckExistingClientQuery, CheckExistingClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckExistingClientQuery, CheckExistingClientQueryVariables>(CheckExistingClientDocument, options);
      }
export function useCheckExistingClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckExistingClientQuery, CheckExistingClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckExistingClientQuery, CheckExistingClientQueryVariables>(CheckExistingClientDocument, options);
        }
export type CheckExistingClientQueryHookResult = ReturnType<typeof useCheckExistingClientQuery>;
export type CheckExistingClientLazyQueryHookResult = ReturnType<typeof useCheckExistingClientLazyQuery>;
export type CheckExistingClientQueryResult = Apollo.QueryResult<CheckExistingClientQuery, CheckExistingClientQueryVariables>;
export const GetClientsWithNegativeBalancesForClinicDocument = gql`
    query getClientsWithNegativeBalancesForClinic($clinicId: ID!) {
  getClientsWithNegativeBalancesForClinic(clinicId: $clinicId) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsWithNegativeBalancesForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsWithNegativeBalancesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsWithNegativeBalancesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsWithNegativeBalancesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClientsWithNegativeBalancesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>(GetClientsWithNegativeBalancesForClinicDocument, options);
      }
export function useGetClientsWithNegativeBalancesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>(GetClientsWithNegativeBalancesForClinicDocument, options);
        }
export type GetClientsWithNegativeBalancesForClinicQueryHookResult = ReturnType<typeof useGetClientsWithNegativeBalancesForClinicQuery>;
export type GetClientsWithNegativeBalancesForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsWithNegativeBalancesForClinicLazyQuery>;
export type GetClientsWithNegativeBalancesForClinicQueryResult = Apollo.QueryResult<GetClientsWithNegativeBalancesForClinicQuery, GetClientsWithNegativeBalancesForClinicQueryVariables>;
export const GetClientsWithoutApptOverDaysForClinicDocument = gql`
    query getClientsWithoutApptOverDaysForClinic($clinicId: ID!, $days: NonNegativeInt!) {
  getClientsWithoutApptOverDaysForClinic(clinicId: $clinicId, days: $days) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsWithoutApptOverDaysForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsWithoutApptOverDaysForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsWithoutApptOverDaysForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsWithoutApptOverDaysForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetClientsWithoutApptOverDaysForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>(GetClientsWithoutApptOverDaysForClinicDocument, options);
      }
export function useGetClientsWithoutApptOverDaysForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>(GetClientsWithoutApptOverDaysForClinicDocument, options);
        }
export type GetClientsWithoutApptOverDaysForClinicQueryHookResult = ReturnType<typeof useGetClientsWithoutApptOverDaysForClinicQuery>;
export type GetClientsWithoutApptOverDaysForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsWithoutApptOverDaysForClinicLazyQuery>;
export type GetClientsWithoutApptOverDaysForClinicQueryResult = Apollo.QueryResult<GetClientsWithoutApptOverDaysForClinicQuery, GetClientsWithoutApptOverDaysForClinicQueryVariables>;
export const GetNewClientsForClinicDocument = gql`
    query getNewClientsForClinic($clinicId: ID!, $fromPmsCreatedAt: NonNegativeInt!, $toPmsCreatedAt: NonNegativeInt!) {
  getNewClientsForClinic(
    clinicId: $clinicId
    fromPmsCreatedAt: $fromPmsCreatedAt
    toPmsCreatedAt: $toPmsCreatedAt
  )
}
    `;

/**
 * __useGetNewClientsForClinicQuery__
 *
 * To run a query within a React component, call `useGetNewClientsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewClientsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewClientsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromPmsCreatedAt: // value for 'fromPmsCreatedAt'
 *      toPmsCreatedAt: // value for 'toPmsCreatedAt'
 *   },
 * });
 */
export function useGetNewClientsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>(GetNewClientsForClinicDocument, options);
      }
export function useGetNewClientsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>(GetNewClientsForClinicDocument, options);
        }
export type GetNewClientsForClinicQueryHookResult = ReturnType<typeof useGetNewClientsForClinicQuery>;
export type GetNewClientsForClinicLazyQueryHookResult = ReturnType<typeof useGetNewClientsForClinicLazyQuery>;
export type GetNewClientsForClinicQueryResult = Apollo.QueryResult<GetNewClientsForClinicQuery, GetNewClientsForClinicQueryVariables>;
export const QueryClientsDocument = gql`
    query queryClients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClients(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ClientPreviewFields
  }
}
    ${ClientPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClientsQuery__
 *
 * To run a query within a React component, call `useQueryClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClientsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClientsQuery, QueryClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientsQuery, QueryClientsQueryVariables>(QueryClientsDocument, options);
      }
export function useQueryClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientsQuery, QueryClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientsQuery, QueryClientsQueryVariables>(QueryClientsDocument, options);
        }
export type QueryClientsQueryHookResult = ReturnType<typeof useQueryClientsQuery>;
export type QueryClientsLazyQueryHookResult = ReturnType<typeof useQueryClientsLazyQuery>;
export type QueryClientsQueryResult = Apollo.QueryResult<QueryClientsQuery, QueryClientsQueryVariables>;
export const QueryClientsPatientsDocument = gql`
    query queryClientsPatients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClientsPatients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    results {
      client {
        ...ClientPreviewFields
      }
      patients {
        id
        name
      }
    }
  }
}
    ${ClientPreviewFieldsFragmentDoc}`;

/**
 * __useQueryClientsPatientsQuery__
 *
 * To run a query within a React component, call `useQueryClientsPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClientsPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClientsPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClientsPatientsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>(QueryClientsPatientsDocument, options);
      }
export function useQueryClientsPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>(QueryClientsPatientsDocument, options);
        }
export type QueryClientsPatientsQueryHookResult = ReturnType<typeof useQueryClientsPatientsQuery>;
export type QueryClientsPatientsLazyQueryHookResult = ReturnType<typeof useQueryClientsPatientsLazyQuery>;
export type QueryClientsPatientsQueryResult = Apollo.QueryResult<QueryClientsPatientsQuery, QueryClientsPatientsQueryVariables>;
export const CountClientsDocument = gql`
    query countClients($where: [QueryInput!]) {
  countClients(where: $where)
}
    `;

/**
 * __useCountClientsQuery__
 *
 * To run a query within a React component, call `useCountClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClientsQuery(baseOptions?: Apollo.QueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
      }
export function useCountClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClientsQuery, CountClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClientsQuery, CountClientsQueryVariables>(CountClientsDocument, options);
        }
export type CountClientsQueryHookResult = ReturnType<typeof useCountClientsQuery>;
export type CountClientsLazyQueryHookResult = ReturnType<typeof useCountClientsLazyQuery>;
export type CountClientsQueryResult = Apollo.QueryResult<CountClientsQuery, CountClientsQueryVariables>;
export const CreateClientDocument = gql`
    mutation createClient($data: CreateClientInput!) {
  createClient(data: $data) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation updateClient($id: ID!, $data: UpdateClientInput!) {
  updateClient(id: $id, data: $data) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation deleteClient($id: ID!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const AddClinicToClientDocument = gql`
    mutation addClinicToClient($clinicId: ID!, $clientId: ID!) {
  addClinicToClient(clinicId: $clinicId, clientId: $clientId) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type AddClinicToClientMutationFn = Apollo.MutationFunction<AddClinicToClientMutation, AddClinicToClientMutationVariables>;

/**
 * __useAddClinicToClientMutation__
 *
 * To run a mutation, you first call `useAddClinicToClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClinicToClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClinicToClientMutation, { data, loading, error }] = useAddClinicToClientMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useAddClinicToClientMutation(baseOptions?: Apollo.MutationHookOptions<AddClinicToClientMutation, AddClinicToClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClinicToClientMutation, AddClinicToClientMutationVariables>(AddClinicToClientDocument, options);
      }
export type AddClinicToClientMutationHookResult = ReturnType<typeof useAddClinicToClientMutation>;
export type AddClinicToClientMutationResult = Apollo.MutationResult<AddClinicToClientMutation>;
export type AddClinicToClientMutationOptions = Apollo.BaseMutationOptions<AddClinicToClientMutation, AddClinicToClientMutationVariables>;
export const GetClinicAdminDocument = gql`
    query getClinicAdmin($clinicId: ID!, $userId: ID!) {
  getClinicAdmin(clinicId: $clinicId, userId: $userId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminQuery, GetClinicAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminQuery, GetClinicAdminQueryVariables>(GetClinicAdminDocument, options);
      }
export function useGetClinicAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminQuery, GetClinicAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminQuery, GetClinicAdminQueryVariables>(GetClinicAdminDocument, options);
        }
export type GetClinicAdminQueryHookResult = ReturnType<typeof useGetClinicAdminQuery>;
export type GetClinicAdminLazyQueryHookResult = ReturnType<typeof useGetClinicAdminLazyQuery>;
export type GetClinicAdminQueryResult = Apollo.QueryResult<GetClinicAdminQuery, GetClinicAdminQueryVariables>;
export const GetClinicAdminsByClinicDocument = gql`
    query getClinicAdminsByClinic($clinicId: ID!) {
  getClinicAdminsByClinic(clinicId: $clinicId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminsByClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicAdminsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>(GetClinicAdminsByClinicDocument, options);
      }
export function useGetClinicAdminsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>(GetClinicAdminsByClinicDocument, options);
        }
export type GetClinicAdminsByClinicQueryHookResult = ReturnType<typeof useGetClinicAdminsByClinicQuery>;
export type GetClinicAdminsByClinicLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsByClinicLazyQuery>;
export type GetClinicAdminsByClinicQueryResult = Apollo.QueryResult<GetClinicAdminsByClinicQuery, GetClinicAdminsByClinicQueryVariables>;
export const GetClinicAdminsByUserDocument = gql`
    query getClinicAdminsByUser($userId: ID!) {
  getClinicAdminsByUser(userId: $userId) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;

/**
 * __useGetClinicAdminsByUserQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminsByUserQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>(GetClinicAdminsByUserDocument, options);
      }
export function useGetClinicAdminsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>(GetClinicAdminsByUserDocument, options);
        }
export type GetClinicAdminsByUserQueryHookResult = ReturnType<typeof useGetClinicAdminsByUserQuery>;
export type GetClinicAdminsByUserLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsByUserLazyQuery>;
export type GetClinicAdminsByUserQueryResult = Apollo.QueryResult<GetClinicAdminsByUserQuery, GetClinicAdminsByUserQueryVariables>;
export const GetClinicAdminsForLoginDocument = gql`
    query getClinicAdminsForLogin($userId: ID!) {
  getClinicAdminsByUser(userId: $userId) {
    ...ClinicAdminFieldsForLogin
  }
}
    ${ClinicAdminFieldsForLoginFragmentDoc}`;

/**
 * __useGetClinicAdminsForLoginQuery__
 *
 * To run a query within a React component, call `useGetClinicAdminsForLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAdminsForLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAdminsForLoginQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicAdminsForLoginQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>(GetClinicAdminsForLoginDocument, options);
      }
export function useGetClinicAdminsForLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>(GetClinicAdminsForLoginDocument, options);
        }
export type GetClinicAdminsForLoginQueryHookResult = ReturnType<typeof useGetClinicAdminsForLoginQuery>;
export type GetClinicAdminsForLoginLazyQueryHookResult = ReturnType<typeof useGetClinicAdminsForLoginLazyQuery>;
export type GetClinicAdminsForLoginQueryResult = Apollo.QueryResult<GetClinicAdminsForLoginQuery, GetClinicAdminsForLoginQueryVariables>;
export const CreateClinicAdminDocument = gql`
    mutation createClinicAdmin($data: CreateClinicAdminInput!) {
  createClinicAdmin(data: $data) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;
export type CreateClinicAdminMutationFn = Apollo.MutationFunction<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>;

/**
 * __useCreateClinicAdminMutation__
 *
 * To run a mutation, you first call `useCreateClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicAdminMutation, { data, loading, error }] = useCreateClinicAdminMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>(CreateClinicAdminDocument, options);
      }
export type CreateClinicAdminMutationHookResult = ReturnType<typeof useCreateClinicAdminMutation>;
export type CreateClinicAdminMutationResult = Apollo.MutationResult<CreateClinicAdminMutation>;
export type CreateClinicAdminMutationOptions = Apollo.BaseMutationOptions<CreateClinicAdminMutation, CreateClinicAdminMutationVariables>;
export const UpdateClinicAdminDocument = gql`
    mutation updateClinicAdmin($clinicId: ID!, $userId: ID!, $data: UpdateClinicAdminInput!) {
  updateClinicAdmin(clinicId: $clinicId, userId: $userId, data: $data) {
    ...ClinicAdminFields
  }
}
    ${ClinicAdminFieldsFragmentDoc}`;
export type UpdateClinicAdminMutationFn = Apollo.MutationFunction<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>;

/**
 * __useUpdateClinicAdminMutation__
 *
 * To run a mutation, you first call `useUpdateClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicAdminMutation, { data, loading, error }] = useUpdateClinicAdminMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>(UpdateClinicAdminDocument, options);
      }
export type UpdateClinicAdminMutationHookResult = ReturnType<typeof useUpdateClinicAdminMutation>;
export type UpdateClinicAdminMutationResult = Apollo.MutationResult<UpdateClinicAdminMutation>;
export type UpdateClinicAdminMutationOptions = Apollo.BaseMutationOptions<UpdateClinicAdminMutation, UpdateClinicAdminMutationVariables>;
export const DeleteClinicAdminDocument = gql`
    mutation deleteClinicAdmin($clinicId: ID!, $userId: ID!) {
  deleteClinicAdmin(clinicId: $clinicId, userId: $userId)
}
    `;
export type DeleteClinicAdminMutationFn = Apollo.MutationFunction<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>;

/**
 * __useDeleteClinicAdminMutation__
 *
 * To run a mutation, you first call `useDeleteClinicAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicAdminMutation, { data, loading, error }] = useDeleteClinicAdminMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteClinicAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>(DeleteClinicAdminDocument, options);
      }
export type DeleteClinicAdminMutationHookResult = ReturnType<typeof useDeleteClinicAdminMutation>;
export type DeleteClinicAdminMutationResult = Apollo.MutationResult<DeleteClinicAdminMutation>;
export type DeleteClinicAdminMutationOptions = Apollo.BaseMutationOptions<DeleteClinicAdminMutation, DeleteClinicAdminMutationVariables>;
export const GetClinicAnalyticsDocument = gql`
    query getClinicAnalytics($clinicId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  clinicAnalytics(clinicId: $clinicId, fromDate: $fromDate, toDate: $toDate) {
    ...ClinicAnalyticsFields
  }
}
    ${ClinicAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetClinicAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetClinicAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicAnalyticsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetClinicAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetClinicAnalyticsQuery, GetClinicAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicAnalyticsQuery, GetClinicAnalyticsQueryVariables>(GetClinicAnalyticsDocument, options);
      }
export function useGetClinicAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicAnalyticsQuery, GetClinicAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicAnalyticsQuery, GetClinicAnalyticsQueryVariables>(GetClinicAnalyticsDocument, options);
        }
export type GetClinicAnalyticsQueryHookResult = ReturnType<typeof useGetClinicAnalyticsQuery>;
export type GetClinicAnalyticsLazyQueryHookResult = ReturnType<typeof useGetClinicAnalyticsLazyQuery>;
export type GetClinicAnalyticsQueryResult = Apollo.QueryResult<GetClinicAnalyticsQuery, GetClinicAnalyticsQueryVariables>;
export const GetAnalyticsNumbersByMonthsForClinicDocument = gql`
    query getAnalyticsNumbersByMonthsForClinic($clinicId: ID!, $numMonths: NonNegativeInt!) {
  getAnalyticsNumbersByMonthsForClinic(clinicId: $clinicId, numMonths: $numMonths) {
    month
    year
    analytics {
      ...AnalyticsNumbersFields
    }
  }
}
    ${AnalyticsNumbersFieldsFragmentDoc}`;

/**
 * __useGetAnalyticsNumbersByMonthsForClinicQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsNumbersByMonthsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsNumbersByMonthsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsNumbersByMonthsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetAnalyticsNumbersByMonthsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsNumbersByMonthsForClinicQuery, GetAnalyticsNumbersByMonthsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsNumbersByMonthsForClinicQuery, GetAnalyticsNumbersByMonthsForClinicQueryVariables>(GetAnalyticsNumbersByMonthsForClinicDocument, options);
      }
export function useGetAnalyticsNumbersByMonthsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsNumbersByMonthsForClinicQuery, GetAnalyticsNumbersByMonthsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsNumbersByMonthsForClinicQuery, GetAnalyticsNumbersByMonthsForClinicQueryVariables>(GetAnalyticsNumbersByMonthsForClinicDocument, options);
        }
export type GetAnalyticsNumbersByMonthsForClinicQueryHookResult = ReturnType<typeof useGetAnalyticsNumbersByMonthsForClinicQuery>;
export type GetAnalyticsNumbersByMonthsForClinicLazyQueryHookResult = ReturnType<typeof useGetAnalyticsNumbersByMonthsForClinicLazyQuery>;
export type GetAnalyticsNumbersByMonthsForClinicQueryResult = Apollo.QueryResult<GetAnalyticsNumbersByMonthsForClinicQuery, GetAnalyticsNumbersByMonthsForClinicQueryVariables>;
export const GetRevenueByMonthsForClinicDocument = gql`
    query getRevenueByMonthsForClinic($clinicId: ID!, $numMonths: NonNegativeInt!) {
  getRevenueByMonthsForClinic(clinicId: $clinicId, numMonths: $numMonths) {
    month
    year
    revenue
  }
}
    `;

/**
 * __useGetRevenueByMonthsForClinicQuery__
 *
 * To run a query within a React component, call `useGetRevenueByMonthsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueByMonthsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueByMonthsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetRevenueByMonthsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>(GetRevenueByMonthsForClinicDocument, options);
      }
export function useGetRevenueByMonthsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>(GetRevenueByMonthsForClinicDocument, options);
        }
export type GetRevenueByMonthsForClinicQueryHookResult = ReturnType<typeof useGetRevenueByMonthsForClinicQuery>;
export type GetRevenueByMonthsForClinicLazyQueryHookResult = ReturnType<typeof useGetRevenueByMonthsForClinicLazyQuery>;
export type GetRevenueByMonthsForClinicQueryResult = Apollo.QueryResult<GetRevenueByMonthsForClinicQuery, GetRevenueByMonthsForClinicQueryVariables>;
export const QueryClinicSexesDocument = gql`
    query queryClinicSexes($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicSexes(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicSexFields
  }
}
    ${ClinicSexFieldsFragmentDoc}`;

/**
 * __useQueryClinicSexesQuery__
 *
 * To run a query within a React component, call `useQueryClinicSexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicSexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicSexesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicSexesQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>(QueryClinicSexesDocument, options);
      }
export function useQueryClinicSexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>(QueryClinicSexesDocument, options);
        }
export type QueryClinicSexesQueryHookResult = ReturnType<typeof useQueryClinicSexesQuery>;
export type QueryClinicSexesLazyQueryHookResult = ReturnType<typeof useQueryClinicSexesLazyQuery>;
export type QueryClinicSexesQueryResult = Apollo.QueryResult<QueryClinicSexesQuery, QueryClinicSexesQueryVariables>;
export const UpdateClinicSexDocument = gql`
    mutation updateClinicSex($id: ID!, $data: UpdateClinicSexInput!) {
  updateClinicSex(id: $id, data: $data) {
    ...ClinicSexFields
  }
}
    ${ClinicSexFieldsFragmentDoc}`;
export type UpdateClinicSexMutationFn = Apollo.MutationFunction<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>;

/**
 * __useUpdateClinicSexMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSexMutation, { data, loading, error }] = useUpdateClinicSexMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSexMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>(UpdateClinicSexDocument, options);
      }
export type UpdateClinicSexMutationHookResult = ReturnType<typeof useUpdateClinicSexMutation>;
export type UpdateClinicSexMutationResult = Apollo.MutationResult<UpdateClinicSexMutation>;
export type UpdateClinicSexMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSexMutation, UpdateClinicSexMutationVariables>;
export const GetClinicSpeciesByClinicDocument = gql`
    query getClinicSpeciesByClinic($clinicId: ID!) {
  getClinicSpeciesByClinic(clinicId: $clinicId) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;

/**
 * __useGetClinicSpeciesByClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicSpeciesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicSpeciesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicSpeciesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicSpeciesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>(GetClinicSpeciesByClinicDocument, options);
      }
export function useGetClinicSpeciesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>(GetClinicSpeciesByClinicDocument, options);
        }
export type GetClinicSpeciesByClinicQueryHookResult = ReturnType<typeof useGetClinicSpeciesByClinicQuery>;
export type GetClinicSpeciesByClinicLazyQueryHookResult = ReturnType<typeof useGetClinicSpeciesByClinicLazyQuery>;
export type GetClinicSpeciesByClinicQueryResult = Apollo.QueryResult<GetClinicSpeciesByClinicQuery, GetClinicSpeciesByClinicQueryVariables>;
export const QueryClinicSpeciesDocument = gql`
    query queryClinicSpecies($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicSpecies(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;

/**
 * __useQueryClinicSpeciesQuery__
 *
 * To run a query within a React component, call `useQueryClinicSpeciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicSpeciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicSpeciesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicSpeciesQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>(QueryClinicSpeciesDocument, options);
      }
export function useQueryClinicSpeciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>(QueryClinicSpeciesDocument, options);
        }
export type QueryClinicSpeciesQueryHookResult = ReturnType<typeof useQueryClinicSpeciesQuery>;
export type QueryClinicSpeciesLazyQueryHookResult = ReturnType<typeof useQueryClinicSpeciesLazyQuery>;
export type QueryClinicSpeciesQueryResult = Apollo.QueryResult<QueryClinicSpeciesQuery, QueryClinicSpeciesQueryVariables>;
export const MakePrimaryClinicSpeciesDocument = gql`
    mutation makePrimaryClinicSpecies($clinicId: ID!, $speciesId: ID!) {
  makePrimaryClinicSpecies(clinicId: $clinicId, speciesId: $speciesId) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export type MakePrimaryClinicSpeciesMutationFn = Apollo.MutationFunction<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>;

/**
 * __useMakePrimaryClinicSpeciesMutation__
 *
 * To run a mutation, you first call `useMakePrimaryClinicSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePrimaryClinicSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePrimaryClinicSpeciesMutation, { data, loading, error }] = useMakePrimaryClinicSpeciesMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      speciesId: // value for 'speciesId'
 *   },
 * });
 */
export function useMakePrimaryClinicSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>(MakePrimaryClinicSpeciesDocument, options);
      }
export type MakePrimaryClinicSpeciesMutationHookResult = ReturnType<typeof useMakePrimaryClinicSpeciesMutation>;
export type MakePrimaryClinicSpeciesMutationResult = Apollo.MutationResult<MakePrimaryClinicSpeciesMutation>;
export type MakePrimaryClinicSpeciesMutationOptions = Apollo.BaseMutationOptions<MakePrimaryClinicSpeciesMutation, MakePrimaryClinicSpeciesMutationVariables>;
export const UpdateClinicSpeciesDocument = gql`
    mutation updateClinicSpecies($clinicId: ID!, $speciesId: ID!, $data: UpdateClinicSpeciesInput!) {
  updateClinicSpecies(clinicId: $clinicId, speciesId: $speciesId, data: $data) {
    ...ClinicSpeciesFields
  }
}
    ${ClinicSpeciesFieldsFragmentDoc}`;
export type UpdateClinicSpeciesMutationFn = Apollo.MutationFunction<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>;

/**
 * __useUpdateClinicSpeciesMutation__
 *
 * To run a mutation, you first call `useUpdateClinicSpeciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicSpeciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicSpeciesMutation, { data, loading, error }] = useUpdateClinicSpeciesMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      speciesId: // value for 'speciesId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicSpeciesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>(UpdateClinicSpeciesDocument, options);
      }
export type UpdateClinicSpeciesMutationHookResult = ReturnType<typeof useUpdateClinicSpeciesMutation>;
export type UpdateClinicSpeciesMutationResult = Apollo.MutationResult<UpdateClinicSpeciesMutation>;
export type UpdateClinicSpeciesMutationOptions = Apollo.BaseMutationOptions<UpdateClinicSpeciesMutation, UpdateClinicSpeciesMutationVariables>;
export const GetRevenueForTimeRangeDocument = gql`
    query getRevenueForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenueForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  )
}
    `;

/**
 * __useGetRevenueForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenueForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenueForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenueForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>(GetRevenueForTimeRangeDocument, options);
      }
export function useGetRevenueForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>(GetRevenueForTimeRangeDocument, options);
        }
export type GetRevenueForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenueForTimeRangeQuery>;
export type GetRevenueForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenueForTimeRangeLazyQuery>;
export type GetRevenueForTimeRangeQueryResult = Apollo.QueryResult<GetRevenueForTimeRangeQuery, GetRevenueForTimeRangeQueryVariables>;
export const GetRevenuesByTypeForTimeRangeDocument = gql`
    query getRevenuesByTypeForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenuesByTypeForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    group
    amount
  }
}
    `;

/**
 * __useGetRevenuesByTypeForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenuesByTypeForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenuesByTypeForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenuesByTypeForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenuesByTypeForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>(GetRevenuesByTypeForTimeRangeDocument, options);
      }
export function useGetRevenuesByTypeForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>(GetRevenuesByTypeForTimeRangeDocument, options);
        }
export type GetRevenuesByTypeForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenuesByTypeForTimeRangeQuery>;
export type GetRevenuesByTypeForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenuesByTypeForTimeRangeLazyQuery>;
export type GetRevenuesByTypeForTimeRangeQueryResult = Apollo.QueryResult<GetRevenuesByTypeForTimeRangeQuery, GetRevenuesByTypeForTimeRangeQueryVariables>;
export const GetRevenuesByClinicianForTimeRangeDocument = gql`
    query getRevenuesByClinicianForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getRevenuesByClinicianForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    group
    amount
  }
}
    `;

/**
 * __useGetRevenuesByClinicianForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetRevenuesByClinicianForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenuesByClinicianForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRevenuesByClinicianForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetRevenuesByClinicianForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>(GetRevenuesByClinicianForTimeRangeDocument, options);
      }
export function useGetRevenuesByClinicianForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>(GetRevenuesByClinicianForTimeRangeDocument, options);
        }
export type GetRevenuesByClinicianForTimeRangeQueryHookResult = ReturnType<typeof useGetRevenuesByClinicianForTimeRangeQuery>;
export type GetRevenuesByClinicianForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetRevenuesByClinicianForTimeRangeLazyQuery>;
export type GetRevenuesByClinicianForTimeRangeQueryResult = Apollo.QueryResult<GetRevenuesByClinicianForTimeRangeQuery, GetRevenuesByClinicianForTimeRangeQueryVariables>;
export const GetAccountsReceivableDocument = gql`
    query getAccountsReceivable($clinicId: ID!) {
  getAccountsReceivable(clinicId: $clinicId)
}
    `;

/**
 * __useGetAccountsReceivableQuery__
 *
 * To run a query within a React component, call `useGetAccountsReceivableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsReceivableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsReceivableQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAccountsReceivableQuery(baseOptions: Apollo.QueryHookOptions<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>(GetAccountsReceivableDocument, options);
      }
export function useGetAccountsReceivableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>(GetAccountsReceivableDocument, options);
        }
export type GetAccountsReceivableQueryHookResult = ReturnType<typeof useGetAccountsReceivableQuery>;
export type GetAccountsReceivableLazyQueryHookResult = ReturnType<typeof useGetAccountsReceivableLazyQuery>;
export type GetAccountsReceivableQueryResult = Apollo.QueryResult<GetAccountsReceivableQuery, GetAccountsReceivableQueryVariables>;
export const GetClinicianServicesByServiceDocument = gql`
    query getClinicianServicesByService($serviceId: ID!) {
  getClinicianServicesByService(serviceId: $serviceId) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;

/**
 * __useGetClinicianServicesByServiceQuery__
 *
 * To run a query within a React component, call `useGetClinicianServicesByServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicianServicesByServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicianServicesByServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetClinicianServicesByServiceQuery(baseOptions: Apollo.QueryHookOptions<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>(GetClinicianServicesByServiceDocument, options);
      }
export function useGetClinicianServicesByServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>(GetClinicianServicesByServiceDocument, options);
        }
export type GetClinicianServicesByServiceQueryHookResult = ReturnType<typeof useGetClinicianServicesByServiceQuery>;
export type GetClinicianServicesByServiceLazyQueryHookResult = ReturnType<typeof useGetClinicianServicesByServiceLazyQuery>;
export type GetClinicianServicesByServiceQueryResult = Apollo.QueryResult<GetClinicianServicesByServiceQuery, GetClinicianServicesByServiceQueryVariables>;
export const CreateClinicianServiceDocument = gql`
    mutation createClinicianService($data: CreateClinicianServiceInput!) {
  createClinicianService(data: $data) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;
export type CreateClinicianServiceMutationFn = Apollo.MutationFunction<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>;

/**
 * __useCreateClinicianServiceMutation__
 *
 * To run a mutation, you first call `useCreateClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicianServiceMutation, { data, loading, error }] = useCreateClinicianServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>(CreateClinicianServiceDocument, options);
      }
export type CreateClinicianServiceMutationHookResult = ReturnType<typeof useCreateClinicianServiceMutation>;
export type CreateClinicianServiceMutationResult = Apollo.MutationResult<CreateClinicianServiceMutation>;
export type CreateClinicianServiceMutationOptions = Apollo.BaseMutationOptions<CreateClinicianServiceMutation, CreateClinicianServiceMutationVariables>;
export const UpdateClinicianServiceDocument = gql`
    mutation updateClinicianService($id: ID!, $data: UpdateClinicianServiceInput!) {
  updateClinicianService(id: $id, data: $data) {
    ...ClinicianServiceFields
  }
}
    ${ClinicianServiceFieldsFragmentDoc}`;
export type UpdateClinicianServiceMutationFn = Apollo.MutationFunction<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>;

/**
 * __useUpdateClinicianServiceMutation__
 *
 * To run a mutation, you first call `useUpdateClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicianServiceMutation, { data, loading, error }] = useUpdateClinicianServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>(UpdateClinicianServiceDocument, options);
      }
export type UpdateClinicianServiceMutationHookResult = ReturnType<typeof useUpdateClinicianServiceMutation>;
export type UpdateClinicianServiceMutationResult = Apollo.MutationResult<UpdateClinicianServiceMutation>;
export type UpdateClinicianServiceMutationOptions = Apollo.BaseMutationOptions<UpdateClinicianServiceMutation, UpdateClinicianServiceMutationVariables>;
export const DeleteClinicianServiceDocument = gql`
    mutation deleteClinicianService($id: ID!) {
  deleteClinicianService(id: $id)
}
    `;
export type DeleteClinicianServiceMutationFn = Apollo.MutationFunction<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>;

/**
 * __useDeleteClinicianServiceMutation__
 *
 * To run a mutation, you first call `useDeleteClinicianServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicianServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicianServiceMutation, { data, loading, error }] = useDeleteClinicianServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicianServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>(DeleteClinicianServiceDocument, options);
      }
export type DeleteClinicianServiceMutationHookResult = ReturnType<typeof useDeleteClinicianServiceMutation>;
export type DeleteClinicianServiceMutationResult = Apollo.MutationResult<DeleteClinicianServiceMutation>;
export type DeleteClinicianServiceMutationOptions = Apollo.BaseMutationOptions<DeleteClinicianServiceMutation, DeleteClinicianServiceMutationVariables>;
export const GetClinicianDocument = gql`
    query getClinician($id: ID!) {
  clinician(id: $id) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useGetClinicianQuery__
 *
 * To run a query within a React component, call `useGetClinicianQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicianQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicianQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicianQuery(baseOptions: Apollo.QueryHookOptions<GetClinicianQuery, GetClinicianQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicianQuery, GetClinicianQueryVariables>(GetClinicianDocument, options);
      }
export function useGetClinicianLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicianQuery, GetClinicianQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicianQuery, GetClinicianQueryVariables>(GetClinicianDocument, options);
        }
export type GetClinicianQueryHookResult = ReturnType<typeof useGetClinicianQuery>;
export type GetClinicianLazyQueryHookResult = ReturnType<typeof useGetClinicianLazyQuery>;
export type GetClinicianQueryResult = Apollo.QueryResult<GetClinicianQuery, GetClinicianQueryVariables>;
export const GetCliniciansByClinicDocument = gql`
    query getCliniciansByClinic($clinicId: ID!, $usingRooms: Boolean) {
  getCliniciansByClinic(clinicId: $clinicId, usingRooms: $usingRooms) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useGetCliniciansByClinicQuery__
 *
 * To run a query within a React component, call `useGetCliniciansByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCliniciansByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCliniciansByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      usingRooms: // value for 'usingRooms'
 *   },
 * });
 */
export function useGetCliniciansByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>(GetCliniciansByClinicDocument, options);
      }
export function useGetCliniciansByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>(GetCliniciansByClinicDocument, options);
        }
export type GetCliniciansByClinicQueryHookResult = ReturnType<typeof useGetCliniciansByClinicQuery>;
export type GetCliniciansByClinicLazyQueryHookResult = ReturnType<typeof useGetCliniciansByClinicLazyQuery>;
export type GetCliniciansByClinicQueryResult = Apollo.QueryResult<GetCliniciansByClinicQuery, GetCliniciansByClinicQueryVariables>;
export const QueryCliniciansDocument = gql`
    query queryClinicians($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinicians(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;

/**
 * __useQueryCliniciansQuery__
 *
 * To run a query within a React component, call `useQueryCliniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCliniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCliniciansQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryCliniciansQuery(baseOptions?: Apollo.QueryHookOptions<QueryCliniciansQuery, QueryCliniciansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCliniciansQuery, QueryCliniciansQueryVariables>(QueryCliniciansDocument, options);
      }
export function useQueryCliniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCliniciansQuery, QueryCliniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCliniciansQuery, QueryCliniciansQueryVariables>(QueryCliniciansDocument, options);
        }
export type QueryCliniciansQueryHookResult = ReturnType<typeof useQueryCliniciansQuery>;
export type QueryCliniciansLazyQueryHookResult = ReturnType<typeof useQueryCliniciansLazyQuery>;
export type QueryCliniciansQueryResult = Apollo.QueryResult<QueryCliniciansQuery, QueryCliniciansQueryVariables>;
export const CreateClinicianDocument = gql`
    mutation createClinician($data: CreateClinicianInput!) {
  createClinician(data: $data) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;
export type CreateClinicianMutationFn = Apollo.MutationFunction<CreateClinicianMutation, CreateClinicianMutationVariables>;

/**
 * __useCreateClinicianMutation__
 *
 * To run a mutation, you first call `useCreateClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicianMutation, { data, loading, error }] = useCreateClinicianMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicianMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicianMutation, CreateClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicianMutation, CreateClinicianMutationVariables>(CreateClinicianDocument, options);
      }
export type CreateClinicianMutationHookResult = ReturnType<typeof useCreateClinicianMutation>;
export type CreateClinicianMutationResult = Apollo.MutationResult<CreateClinicianMutation>;
export type CreateClinicianMutationOptions = Apollo.BaseMutationOptions<CreateClinicianMutation, CreateClinicianMutationVariables>;
export const UpdateClinicianDocument = gql`
    mutation updateClinician($id: ID!, $data: UpdateClinicianInput!) {
  updateClinician(id: $id, data: $data) {
    ...ClinicianFields
  }
}
    ${ClinicianFieldsFragmentDoc}`;
export type UpdateClinicianMutationFn = Apollo.MutationFunction<UpdateClinicianMutation, UpdateClinicianMutationVariables>;

/**
 * __useUpdateClinicianMutation__
 *
 * To run a mutation, you first call `useUpdateClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicianMutation, { data, loading, error }] = useUpdateClinicianMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicianMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicianMutation, UpdateClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicianMutation, UpdateClinicianMutationVariables>(UpdateClinicianDocument, options);
      }
export type UpdateClinicianMutationHookResult = ReturnType<typeof useUpdateClinicianMutation>;
export type UpdateClinicianMutationResult = Apollo.MutationResult<UpdateClinicianMutation>;
export type UpdateClinicianMutationOptions = Apollo.BaseMutationOptions<UpdateClinicianMutation, UpdateClinicianMutationVariables>;
export const DeleteClinicianDocument = gql`
    mutation deleteClinician($id: ID!) {
  deleteClinician(id: $id)
}
    `;
export type DeleteClinicianMutationFn = Apollo.MutationFunction<DeleteClinicianMutation, DeleteClinicianMutationVariables>;

/**
 * __useDeleteClinicianMutation__
 *
 * To run a mutation, you first call `useDeleteClinicianMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicianMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicianMutation, { data, loading, error }] = useDeleteClinicianMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicianMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicianMutation, DeleteClinicianMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicianMutation, DeleteClinicianMutationVariables>(DeleteClinicianDocument, options);
      }
export type DeleteClinicianMutationHookResult = ReturnType<typeof useDeleteClinicianMutation>;
export type DeleteClinicianMutationResult = Apollo.MutationResult<DeleteClinicianMutation>;
export type DeleteClinicianMutationOptions = Apollo.BaseMutationOptions<DeleteClinicianMutation, DeleteClinicianMutationVariables>;
export const GetAllClinicsDocument = gql`
    query getAllClinics($page: NonNegativeInt, $pageSize: NonNegativeInt) {
  allClinics(page: $page, pageSize: $pageSize) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useGetAllClinicsQuery__
 *
 * To run a query within a React component, call `useGetAllClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClinicsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllClinicsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllClinicsQuery, GetAllClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClinicsQuery, GetAllClinicsQueryVariables>(GetAllClinicsDocument, options);
      }
export function useGetAllClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClinicsQuery, GetAllClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClinicsQuery, GetAllClinicsQueryVariables>(GetAllClinicsDocument, options);
        }
export type GetAllClinicsQueryHookResult = ReturnType<typeof useGetAllClinicsQuery>;
export type GetAllClinicsLazyQueryHookResult = ReturnType<typeof useGetAllClinicsLazyQuery>;
export type GetAllClinicsQueryResult = Apollo.QueryResult<GetAllClinicsQuery, GetAllClinicsQueryVariables>;
export const GetClinicDocument = gql`
    query getClinic($id: ID!) {
  clinic(id: $id) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useGetClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
      }
export function useGetClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export type GetClinicQueryHookResult = ReturnType<typeof useGetClinicQuery>;
export type GetClinicLazyQueryHookResult = ReturnType<typeof useGetClinicLazyQuery>;
export type GetClinicQueryResult = Apollo.QueryResult<GetClinicQuery, GetClinicQueryVariables>;
export const GetClientsForClinicDocument = gql`
    query getClientsForClinic($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getClientsForClinic(clinicId: $clinicId, page: $page, pageSize: $pageSize) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientsForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetClientsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>(GetClientsForClinicDocument, options);
      }
export function useGetClientsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>(GetClientsForClinicDocument, options);
        }
export type GetClientsForClinicQueryHookResult = ReturnType<typeof useGetClientsForClinicQuery>;
export type GetClientsForClinicLazyQueryHookResult = ReturnType<typeof useGetClientsForClinicLazyQuery>;
export type GetClientsForClinicQueryResult = Apollo.QueryResult<GetClientsForClinicQuery, GetClientsForClinicQueryVariables>;
export const GetClientCountForClinicDocument = gql`
    query getClientCountForClinic($clinicId: ID!) {
  getClientCountForClinic(clinicId: $clinicId)
}
    `;

/**
 * __useGetClientCountForClinicQuery__
 *
 * To run a query within a React component, call `useGetClientCountForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCountForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCountForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClientCountForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>(GetClientCountForClinicDocument, options);
      }
export function useGetClientCountForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>(GetClientCountForClinicDocument, options);
        }
export type GetClientCountForClinicQueryHookResult = ReturnType<typeof useGetClientCountForClinicQuery>;
export type GetClientCountForClinicLazyQueryHookResult = ReturnType<typeof useGetClientCountForClinicLazyQuery>;
export type GetClientCountForClinicQueryResult = Apollo.QueryResult<GetClientCountForClinicQuery, GetClientCountForClinicQueryVariables>;
export const GetClinicsForUserAdminDocument = gql`
    query getClinicsForUserAdmin($userId: ID!) {
  getClinicsForUserAdmin(userId: $userId) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useGetClinicsForUserAdminQuery__
 *
 * To run a query within a React component, call `useGetClinicsForUserAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicsForUserAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicsForUserAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetClinicsForUserAdminQuery(baseOptions: Apollo.QueryHookOptions<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>(GetClinicsForUserAdminDocument, options);
      }
export function useGetClinicsForUserAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>(GetClinicsForUserAdminDocument, options);
        }
export type GetClinicsForUserAdminQueryHookResult = ReturnType<typeof useGetClinicsForUserAdminQuery>;
export type GetClinicsForUserAdminLazyQueryHookResult = ReturnType<typeof useGetClinicsForUserAdminLazyQuery>;
export type GetClinicsForUserAdminQueryResult = Apollo.QueryResult<GetClinicsForUserAdminQuery, GetClinicsForUserAdminQueryVariables>;
export const SearchClinicsDocument = gql`
    query searchClinics($text: String!, $size: PositiveInt!, $page: NonNegativeInt!) {
  searchClinics(text: $text, size: $size, page: $page) {
    ...ClinicPreviewFields
  }
}
    ${ClinicPreviewFieldsFragmentDoc}`;

/**
 * __useSearchClinicsQuery__
 *
 * To run a query within a React component, call `useSearchClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClinicsQuery({
 *   variables: {
 *      text: // value for 'text'
 *      size: // value for 'size'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchClinicsQuery(baseOptions: Apollo.QueryHookOptions<SearchClinicsQuery, SearchClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClinicsQuery, SearchClinicsQueryVariables>(SearchClinicsDocument, options);
      }
export function useSearchClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClinicsQuery, SearchClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClinicsQuery, SearchClinicsQueryVariables>(SearchClinicsDocument, options);
        }
export type SearchClinicsQueryHookResult = ReturnType<typeof useSearchClinicsQuery>;
export type SearchClinicsLazyQueryHookResult = ReturnType<typeof useSearchClinicsLazyQuery>;
export type SearchClinicsQueryResult = Apollo.QueryResult<SearchClinicsQuery, SearchClinicsQueryVariables>;
export const QueryClinicsDocument = gql`
    query queryClinics($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryClinics(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;

/**
 * __useQueryClinicsQuery__
 *
 * To run a query within a React component, call `useQueryClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryClinicsQuery(baseOptions?: Apollo.QueryHookOptions<QueryClinicsQuery, QueryClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryClinicsQuery, QueryClinicsQueryVariables>(QueryClinicsDocument, options);
      }
export function useQueryClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryClinicsQuery, QueryClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryClinicsQuery, QueryClinicsQueryVariables>(QueryClinicsDocument, options);
        }
export type QueryClinicsQueryHookResult = ReturnType<typeof useQueryClinicsQuery>;
export type QueryClinicsLazyQueryHookResult = ReturnType<typeof useQueryClinicsLazyQuery>;
export type QueryClinicsQueryResult = Apollo.QueryResult<QueryClinicsQuery, QueryClinicsQueryVariables>;
export const CountClinicsDocument = gql`
    query countClinics($where: [QueryInput!]) {
  countClinics(where: $where)
}
    `;

/**
 * __useCountClinicsQuery__
 *
 * To run a query within a React component, call `useCountClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountClinicsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountClinicsQuery(baseOptions?: Apollo.QueryHookOptions<CountClinicsQuery, CountClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountClinicsQuery, CountClinicsQueryVariables>(CountClinicsDocument, options);
      }
export function useCountClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountClinicsQuery, CountClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountClinicsQuery, CountClinicsQueryVariables>(CountClinicsDocument, options);
        }
export type CountClinicsQueryHookResult = ReturnType<typeof useCountClinicsQuery>;
export type CountClinicsLazyQueryHookResult = ReturnType<typeof useCountClinicsLazyQuery>;
export type CountClinicsQueryResult = Apollo.QueryResult<CountClinicsQuery, CountClinicsQueryVariables>;
export const ClinicStatsDocument = gql`
    query clinicStats($clinicId: ID!) {
  clinicStats(clinicId: $clinicId) {
    ...ClinicStatsFields
  }
}
    ${ClinicStatsFieldsFragmentDoc}`;

/**
 * __useClinicStatsQuery__
 *
 * To run a query within a React component, call `useClinicStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicStatsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useClinicStatsQuery(baseOptions: Apollo.QueryHookOptions<ClinicStatsQuery, ClinicStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicStatsQuery, ClinicStatsQueryVariables>(ClinicStatsDocument, options);
      }
export function useClinicStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicStatsQuery, ClinicStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicStatsQuery, ClinicStatsQueryVariables>(ClinicStatsDocument, options);
        }
export type ClinicStatsQueryHookResult = ReturnType<typeof useClinicStatsQuery>;
export type ClinicStatsLazyQueryHookResult = ReturnType<typeof useClinicStatsLazyQuery>;
export type ClinicStatsQueryResult = Apollo.QueryResult<ClinicStatsQuery, ClinicStatsQueryVariables>;
export const GetTotalRevenueForClinicBetweenTimesDocument = gql`
    query getTotalRevenueForClinicBetweenTimes($clinicId: ID!, $endTime: NonNegativeInt!, $startTime: NonNegativeInt!) {
  getTotalRevenueForClinicBetweenTimes(
    clinicId: $clinicId
    endTime: $endTime
    startTime: $startTime
  )
}
    `;

/**
 * __useGetTotalRevenueForClinicBetweenTimesQuery__
 *
 * To run a query within a React component, call `useGetTotalRevenueForClinicBetweenTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalRevenueForClinicBetweenTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalRevenueForClinicBetweenTimesQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      endTime: // value for 'endTime'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useGetTotalRevenueForClinicBetweenTimesQuery(baseOptions: Apollo.QueryHookOptions<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>(GetTotalRevenueForClinicBetweenTimesDocument, options);
      }
export function useGetTotalRevenueForClinicBetweenTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>(GetTotalRevenueForClinicBetweenTimesDocument, options);
        }
export type GetTotalRevenueForClinicBetweenTimesQueryHookResult = ReturnType<typeof useGetTotalRevenueForClinicBetweenTimesQuery>;
export type GetTotalRevenueForClinicBetweenTimesLazyQueryHookResult = ReturnType<typeof useGetTotalRevenueForClinicBetweenTimesLazyQuery>;
export type GetTotalRevenueForClinicBetweenTimesQueryResult = Apollo.QueryResult<GetTotalRevenueForClinicBetweenTimesQuery, GetTotalRevenueForClinicBetweenTimesQueryVariables>;
export const CreateClinicDocument = gql`
    mutation createClinic($data: CreateClinicInput!, $shouldCreateWidget: Boolean) {
  createClinic(data: $data, shouldCreateWidget: $shouldCreateWidget) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type CreateClinicMutationFn = Apollo.MutationFunction<CreateClinicMutation, CreateClinicMutationVariables>;

/**
 * __useCreateClinicMutation__
 *
 * To run a mutation, you first call `useCreateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicMutation, { data, loading, error }] = useCreateClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *      shouldCreateWidget: // value for 'shouldCreateWidget'
 *   },
 * });
 */
export function useCreateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicMutation, CreateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicMutation, CreateClinicMutationVariables>(CreateClinicDocument, options);
      }
export type CreateClinicMutationHookResult = ReturnType<typeof useCreateClinicMutation>;
export type CreateClinicMutationResult = Apollo.MutationResult<CreateClinicMutation>;
export type CreateClinicMutationOptions = Apollo.BaseMutationOptions<CreateClinicMutation, CreateClinicMutationVariables>;
export const UpdateClinicDocument = gql`
    mutation updateClinic($id: ID!, $data: UpdateClinicInput!) {
  updateClinic(id: $id, data: $data) {
    ...ClinicFields
  }
}
    ${ClinicFieldsFragmentDoc}`;
export type UpdateClinicMutationFn = Apollo.MutationFunction<UpdateClinicMutation, UpdateClinicMutationVariables>;

/**
 * __useUpdateClinicMutation__
 *
 * To run a mutation, you first call `useUpdateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicMutation, { data, loading, error }] = useUpdateClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicMutation, UpdateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicMutation, UpdateClinicMutationVariables>(UpdateClinicDocument, options);
      }
export type UpdateClinicMutationHookResult = ReturnType<typeof useUpdateClinicMutation>;
export type UpdateClinicMutationResult = Apollo.MutationResult<UpdateClinicMutation>;
export type UpdateClinicMutationOptions = Apollo.BaseMutationOptions<UpdateClinicMutation, UpdateClinicMutationVariables>;
export const DeleteClinicDocument = gql`
    mutation deleteClinic($id: ID!) {
  deleteClinic(id: $id)
}
    `;
export type DeleteClinicMutationFn = Apollo.MutationFunction<DeleteClinicMutation, DeleteClinicMutationVariables>;

/**
 * __useDeleteClinicMutation__
 *
 * To run a mutation, you first call `useDeleteClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicMutation, { data, loading, error }] = useDeleteClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicMutation, DeleteClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicMutation, DeleteClinicMutationVariables>(DeleteClinicDocument, options);
      }
export type DeleteClinicMutationHookResult = ReturnType<typeof useDeleteClinicMutation>;
export type DeleteClinicMutationResult = Apollo.MutationResult<DeleteClinicMutation>;
export type DeleteClinicMutationOptions = Apollo.BaseMutationOptions<DeleteClinicMutation, DeleteClinicMutationVariables>;
export const GetConnectInstallationDocument = gql`
    query getConnectInstallation($clinicId: ID!, $installationId: ID!) {
  connectInstallation(clinicId: $clinicId, installationId: $installationId) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;

/**
 * __useGetConnectInstallationQuery__
 *
 * To run a query within a React component, call `useGetConnectInstallationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectInstallationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectInstallationQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *   },
 * });
 */
export function useGetConnectInstallationQuery(baseOptions: Apollo.QueryHookOptions<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>(GetConnectInstallationDocument, options);
      }
export function useGetConnectInstallationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>(GetConnectInstallationDocument, options);
        }
export type GetConnectInstallationQueryHookResult = ReturnType<typeof useGetConnectInstallationQuery>;
export type GetConnectInstallationLazyQueryHookResult = ReturnType<typeof useGetConnectInstallationLazyQuery>;
export type GetConnectInstallationQueryResult = Apollo.QueryResult<GetConnectInstallationQuery, GetConnectInstallationQueryVariables>;
export const GetConnectInstallationsByClinicDocument = gql`
    query getConnectInstallationsByClinic($clinicId: ID!) {
  getConnectInstallationsByClinic(clinicId: $clinicId) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;

/**
 * __useGetConnectInstallationsByClinicQuery__
 *
 * To run a query within a React component, call `useGetConnectInstallationsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectInstallationsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectInstallationsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetConnectInstallationsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>(GetConnectInstallationsByClinicDocument, options);
      }
export function useGetConnectInstallationsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>(GetConnectInstallationsByClinicDocument, options);
        }
export type GetConnectInstallationsByClinicQueryHookResult = ReturnType<typeof useGetConnectInstallationsByClinicQuery>;
export type GetConnectInstallationsByClinicLazyQueryHookResult = ReturnType<typeof useGetConnectInstallationsByClinicLazyQuery>;
export type GetConnectInstallationsByClinicQueryResult = Apollo.QueryResult<GetConnectInstallationsByClinicQuery, GetConnectInstallationsByClinicQueryVariables>;
export const CheckIfServerRunningDocument = gql`
    query checkIfServerRunning($clinicId: ID!) {
  checkIfServerRunning(clinicId: $clinicId)
}
    `;

/**
 * __useCheckIfServerRunningQuery__
 *
 * To run a query within a React component, call `useCheckIfServerRunningQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIfServerRunningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIfServerRunningQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useCheckIfServerRunningQuery(baseOptions: Apollo.QueryHookOptions<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>(CheckIfServerRunningDocument, options);
      }
export function useCheckIfServerRunningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>(CheckIfServerRunningDocument, options);
        }
export type CheckIfServerRunningQueryHookResult = ReturnType<typeof useCheckIfServerRunningQuery>;
export type CheckIfServerRunningLazyQueryHookResult = ReturnType<typeof useCheckIfServerRunningLazyQuery>;
export type CheckIfServerRunningQueryResult = Apollo.QueryResult<CheckIfServerRunningQuery, CheckIfServerRunningQueryVariables>;
export const GetLastServerHeartbeatForClinicDocument = gql`
    query getLastServerHeartbeatForClinic($clinicId: ID!) {
  getLastServerHeartbeatForClinic(clinicId: $clinicId) {
    version
    last_ping
  }
}
    `;

/**
 * __useGetLastServerHeartbeatForClinicQuery__
 *
 * To run a query within a React component, call `useGetLastServerHeartbeatForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastServerHeartbeatForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastServerHeartbeatForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetLastServerHeartbeatForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>(GetLastServerHeartbeatForClinicDocument, options);
      }
export function useGetLastServerHeartbeatForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>(GetLastServerHeartbeatForClinicDocument, options);
        }
export type GetLastServerHeartbeatForClinicQueryHookResult = ReturnType<typeof useGetLastServerHeartbeatForClinicQuery>;
export type GetLastServerHeartbeatForClinicLazyQueryHookResult = ReturnType<typeof useGetLastServerHeartbeatForClinicLazyQuery>;
export type GetLastServerHeartbeatForClinicQueryResult = Apollo.QueryResult<GetLastServerHeartbeatForClinicQuery, GetLastServerHeartbeatForClinicQueryVariables>;
export const TriggerServiceUpdateDocument = gql`
    mutation triggerServiceUpdate($clinicId: ID!) {
  triggerServiceUpdateForClinic(clinicId: $clinicId)
}
    `;
export type TriggerServiceUpdateMutationFn = Apollo.MutationFunction<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>;

/**
 * __useTriggerServiceUpdateMutation__
 *
 * To run a mutation, you first call `useTriggerServiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerServiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerServiceUpdateMutation, { data, loading, error }] = useTriggerServiceUpdateMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useTriggerServiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>(TriggerServiceUpdateDocument, options);
      }
export type TriggerServiceUpdateMutationHookResult = ReturnType<typeof useTriggerServiceUpdateMutation>;
export type TriggerServiceUpdateMutationResult = Apollo.MutationResult<TriggerServiceUpdateMutation>;
export type TriggerServiceUpdateMutationOptions = Apollo.BaseMutationOptions<TriggerServiceUpdateMutation, TriggerServiceUpdateMutationVariables>;
export const CreateConnectInstallationDocument = gql`
    mutation createConnectInstallation($clinicId: ID!, $installationId: ID!, $data: CreateConnectInstallationInput!) {
  createConnectInstallation(
    clinicId: $clinicId
    installationId: $installationId
    data: $data
  ) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;
export type CreateConnectInstallationMutationFn = Apollo.MutationFunction<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>;

/**
 * __useCreateConnectInstallationMutation__
 *
 * To run a mutation, you first call `useCreateConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectInstallationMutation, { data, loading, error }] = useCreateConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>(CreateConnectInstallationDocument, options);
      }
export type CreateConnectInstallationMutationHookResult = ReturnType<typeof useCreateConnectInstallationMutation>;
export type CreateConnectInstallationMutationResult = Apollo.MutationResult<CreateConnectInstallationMutation>;
export type CreateConnectInstallationMutationOptions = Apollo.BaseMutationOptions<CreateConnectInstallationMutation, CreateConnectInstallationMutationVariables>;
export const UpdateConnectInstallationDocument = gql`
    mutation updateConnectInstallation($clinicId: ID!, $installationId: ID!, $data: UpdateConnectInstallationInput!) {
  updateConnectInstallation(
    clinicId: $clinicId
    installationId: $installationId
    data: $data
  ) {
    ...ConnectInstallationFields
  }
}
    ${ConnectInstallationFieldsFragmentDoc}`;
export type UpdateConnectInstallationMutationFn = Apollo.MutationFunction<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>;

/**
 * __useUpdateConnectInstallationMutation__
 *
 * To run a mutation, you first call `useUpdateConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectInstallationMutation, { data, loading, error }] = useUpdateConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>(UpdateConnectInstallationDocument, options);
      }
export type UpdateConnectInstallationMutationHookResult = ReturnType<typeof useUpdateConnectInstallationMutation>;
export type UpdateConnectInstallationMutationResult = Apollo.MutationResult<UpdateConnectInstallationMutation>;
export type UpdateConnectInstallationMutationOptions = Apollo.BaseMutationOptions<UpdateConnectInstallationMutation, UpdateConnectInstallationMutationVariables>;
export const DeleteConnectInstallationDocument = gql`
    mutation deleteConnectInstallation($clinicId: ID!, $installationId: ID!) {
  deleteConnectInstallation(clinicId: $clinicId, installationId: $installationId)
}
    `;
export type DeleteConnectInstallationMutationFn = Apollo.MutationFunction<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>;

/**
 * __useDeleteConnectInstallationMutation__
 *
 * To run a mutation, you first call `useDeleteConnectInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectInstallationMutation, { data, loading, error }] = useDeleteConnectInstallationMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      installationId: // value for 'installationId'
 *   },
 * });
 */
export function useDeleteConnectInstallationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>(DeleteConnectInstallationDocument, options);
      }
export type DeleteConnectInstallationMutationHookResult = ReturnType<typeof useDeleteConnectInstallationMutation>;
export type DeleteConnectInstallationMutationResult = Apollo.MutationResult<DeleteConnectInstallationMutation>;
export type DeleteConnectInstallationMutationOptions = Apollo.BaseMutationOptions<DeleteConnectInstallationMutation, DeleteConnectInstallationMutationVariables>;
export const CustomerSegmentDocument = gql`
    query customerSegment($id: ID!) {
  customerSegment(id: $id) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;

/**
 * __useCustomerSegmentQuery__
 *
 * To run a query within a React component, call `useCustomerSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSegmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerSegmentQuery(baseOptions: Apollo.QueryHookOptions<CustomerSegmentQuery, CustomerSegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSegmentQuery, CustomerSegmentQueryVariables>(CustomerSegmentDocument, options);
      }
export function useCustomerSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSegmentQuery, CustomerSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSegmentQuery, CustomerSegmentQueryVariables>(CustomerSegmentDocument, options);
        }
export type CustomerSegmentQueryHookResult = ReturnType<typeof useCustomerSegmentQuery>;
export type CustomerSegmentLazyQueryHookResult = ReturnType<typeof useCustomerSegmentLazyQuery>;
export type CustomerSegmentQueryResult = Apollo.QueryResult<CustomerSegmentQuery, CustomerSegmentQueryVariables>;
export const GetCustomerSegmentsForClinicDocument = gql`
    query getCustomerSegmentsForClinic($clinicId: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getCustomerSegmentsForClinic(
    clinicId: $clinicId
    page: $page
    pageSize: $pageSize
  ) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;

/**
 * __useGetCustomerSegmentsForClinicQuery__
 *
 * To run a query within a React component, call `useGetCustomerSegmentsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSegmentsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSegmentsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetCustomerSegmentsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>(GetCustomerSegmentsForClinicDocument, options);
      }
export function useGetCustomerSegmentsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>(GetCustomerSegmentsForClinicDocument, options);
        }
export type GetCustomerSegmentsForClinicQueryHookResult = ReturnType<typeof useGetCustomerSegmentsForClinicQuery>;
export type GetCustomerSegmentsForClinicLazyQueryHookResult = ReturnType<typeof useGetCustomerSegmentsForClinicLazyQuery>;
export type GetCustomerSegmentsForClinicQueryResult = Apollo.QueryResult<GetCustomerSegmentsForClinicQuery, GetCustomerSegmentsForClinicQueryVariables>;
export const QueryCustomerSegmentsDocument = gql`
    query queryCustomerSegments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryCustomerSegments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;

/**
 * __useQueryCustomerSegmentsQuery__
 *
 * To run a query within a React component, call `useQueryCustomerSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCustomerSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCustomerSegmentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryCustomerSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>(QueryCustomerSegmentsDocument, options);
      }
export function useQueryCustomerSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>(QueryCustomerSegmentsDocument, options);
        }
export type QueryCustomerSegmentsQueryHookResult = ReturnType<typeof useQueryCustomerSegmentsQuery>;
export type QueryCustomerSegmentsLazyQueryHookResult = ReturnType<typeof useQueryCustomerSegmentsLazyQuery>;
export type QueryCustomerSegmentsQueryResult = Apollo.QueryResult<QueryCustomerSegmentsQuery, QueryCustomerSegmentsQueryVariables>;
export const GetClientsByCustomerSegmentRpcDocument = gql`
    query getClientsByCustomerSegmentRPC($id: ID!, $page: NonNegativeInt, $pageSize: NonNegativeInt) {
  getClientsByCustomerSegmentRPC(id: $id, page: $page, pageSize: $pageSize) {
    results {
      client {
        ...ClientPreviewFields
      }
      appointment {
        ...AppointmentPreviewFields
      }
      patient {
        ...PatientPreviewFields
      }
    }
    count
  }
}
    ${ClientPreviewFieldsFragmentDoc}
${AppointmentPreviewFieldsFragmentDoc}
${PatientPreviewFieldsFragmentDoc}`;

/**
 * __useGetClientsByCustomerSegmentRpcQuery__
 *
 * To run a query within a React component, call `useGetClientsByCustomerSegmentRpcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByCustomerSegmentRpcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByCustomerSegmentRpcQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetClientsByCustomerSegmentRpcQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>(GetClientsByCustomerSegmentRpcDocument, options);
      }
export function useGetClientsByCustomerSegmentRpcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>(GetClientsByCustomerSegmentRpcDocument, options);
        }
export type GetClientsByCustomerSegmentRpcQueryHookResult = ReturnType<typeof useGetClientsByCustomerSegmentRpcQuery>;
export type GetClientsByCustomerSegmentRpcLazyQueryHookResult = ReturnType<typeof useGetClientsByCustomerSegmentRpcLazyQuery>;
export type GetClientsByCustomerSegmentRpcQueryResult = Apollo.QueryResult<GetClientsByCustomerSegmentRpcQuery, GetClientsByCustomerSegmentRpcQueryVariables>;
export const CreateCustomerSegmentDocument = gql`
    mutation createCustomerSegment($data: CreateCustomerSegmentInput!) {
  createCustomerSegment(data: $data) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type CreateCustomerSegmentMutationFn = Apollo.MutationFunction<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;

/**
 * __useCreateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSegmentMutation, { data, loading, error }] = useCreateCustomerSegmentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>(CreateCustomerSegmentDocument, options);
      }
export type CreateCustomerSegmentMutationHookResult = ReturnType<typeof useCreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationResult = Apollo.MutationResult<CreateCustomerSegmentMutation>;
export type CreateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSegmentMutation, CreateCustomerSegmentMutationVariables>;
export const UpdateCustomerSegmentDocument = gql`
    mutation updateCustomerSegment($id: ID!, $data: UpdateCustomerSegmentInput!) {
  updateCustomerSegment(id: $id, data: $data) {
    ...CustomerSegmentFields
  }
}
    ${CustomerSegmentFieldsFragmentDoc}`;
export type UpdateCustomerSegmentMutationFn = Apollo.MutationFunction<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;

/**
 * __useUpdateCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSegmentMutation, { data, loading, error }] = useUpdateCustomerSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>(UpdateCustomerSegmentDocument, options);
      }
export type UpdateCustomerSegmentMutationHookResult = ReturnType<typeof useUpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationResult = Apollo.MutationResult<UpdateCustomerSegmentMutation>;
export type UpdateCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerSegmentMutation, UpdateCustomerSegmentMutationVariables>;
export const DeleteCustomerSegmentDocument = gql`
    mutation deleteCustomerSegment($id: ID!) {
  deleteCustomerSegment(id: $id)
}
    `;
export type DeleteCustomerSegmentMutationFn = Apollo.MutationFunction<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>;

/**
 * __useDeleteCustomerSegmentMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerSegmentMutation, { data, loading, error }] = useDeleteCustomerSegmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerSegmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>(DeleteCustomerSegmentDocument, options);
      }
export type DeleteCustomerSegmentMutationHookResult = ReturnType<typeof useDeleteCustomerSegmentMutation>;
export type DeleteCustomerSegmentMutationResult = Apollo.MutationResult<DeleteCustomerSegmentMutation>;
export type DeleteCustomerSegmentMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerSegmentMutation, DeleteCustomerSegmentMutationVariables>;
export const GetDailyHuddleDocument = gql`
    query getDailyHuddle($clinicId: ID!, $dailyHuddleId: ID!) {
  dailyHuddle(clinicId: $clinicId, dailyHuddleId: $dailyHuddleId) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;

/**
 * __useGetDailyHuddleQuery__
 *
 * To run a query within a React component, call `useGetDailyHuddleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyHuddleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyHuddleQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      dailyHuddleId: // value for 'dailyHuddleId'
 *   },
 * });
 */
export function useGetDailyHuddleQuery(baseOptions: Apollo.QueryHookOptions<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>(GetDailyHuddleDocument, options);
      }
export function useGetDailyHuddleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>(GetDailyHuddleDocument, options);
        }
export type GetDailyHuddleQueryHookResult = ReturnType<typeof useGetDailyHuddleQuery>;
export type GetDailyHuddleLazyQueryHookResult = ReturnType<typeof useGetDailyHuddleLazyQuery>;
export type GetDailyHuddleQueryResult = Apollo.QueryResult<GetDailyHuddleQuery, GetDailyHuddleQueryVariables>;
export const GetDailyHuddlesByClinicDocument = gql`
    query getDailyHuddlesByClinic($clinicId: ID!) {
  getDailyHuddlesByClinic(clinicId: $clinicId) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;

/**
 * __useGetDailyHuddlesByClinicQuery__
 *
 * To run a query within a React component, call `useGetDailyHuddlesByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyHuddlesByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyHuddlesByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetDailyHuddlesByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>(GetDailyHuddlesByClinicDocument, options);
      }
export function useGetDailyHuddlesByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>(GetDailyHuddlesByClinicDocument, options);
        }
export type GetDailyHuddlesByClinicQueryHookResult = ReturnType<typeof useGetDailyHuddlesByClinicQuery>;
export type GetDailyHuddlesByClinicLazyQueryHookResult = ReturnType<typeof useGetDailyHuddlesByClinicLazyQuery>;
export type GetDailyHuddlesByClinicQueryResult = Apollo.QueryResult<GetDailyHuddlesByClinicQuery, GetDailyHuddlesByClinicQueryVariables>;
export const CreateDailyHuddleDocument = gql`
    mutation createDailyHuddle($clinicId: ID!, $data: CreateDailyHuddleInput!) {
  createDailyHuddle(clinicId: $clinicId, data: $data) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;
export type CreateDailyHuddleMutationFn = Apollo.MutationFunction<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>;

/**
 * __useCreateDailyHuddleMutation__
 *
 * To run a mutation, you first call `useCreateDailyHuddleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDailyHuddleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDailyHuddleMutation, { data, loading, error }] = useCreateDailyHuddleMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDailyHuddleMutation(baseOptions?: Apollo.MutationHookOptions<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>(CreateDailyHuddleDocument, options);
      }
export type CreateDailyHuddleMutationHookResult = ReturnType<typeof useCreateDailyHuddleMutation>;
export type CreateDailyHuddleMutationResult = Apollo.MutationResult<CreateDailyHuddleMutation>;
export type CreateDailyHuddleMutationOptions = Apollo.BaseMutationOptions<CreateDailyHuddleMutation, CreateDailyHuddleMutationVariables>;
export const UpdateDailyHuddleDocument = gql`
    mutation updateDailyHuddle($clinicId: ID!, $dailyHuddleId: ID!, $data: UpdateDailyHuddleInput!) {
  updateDailyHuddle(
    clinicId: $clinicId
    dailyHuddleId: $dailyHuddleId
    data: $data
  ) {
    ...DailyHuddleFields
  }
}
    ${DailyHuddleFieldsFragmentDoc}`;
export type UpdateDailyHuddleMutationFn = Apollo.MutationFunction<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>;

/**
 * __useUpdateDailyHuddleMutation__
 *
 * To run a mutation, you first call `useUpdateDailyHuddleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDailyHuddleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDailyHuddleMutation, { data, loading, error }] = useUpdateDailyHuddleMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      dailyHuddleId: // value for 'dailyHuddleId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateDailyHuddleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>(UpdateDailyHuddleDocument, options);
      }
export type UpdateDailyHuddleMutationHookResult = ReturnType<typeof useUpdateDailyHuddleMutation>;
export type UpdateDailyHuddleMutationResult = Apollo.MutationResult<UpdateDailyHuddleMutation>;
export type UpdateDailyHuddleMutationOptions = Apollo.BaseMutationOptions<UpdateDailyHuddleMutation, UpdateDailyHuddleMutationVariables>;
export const QueryDiagnosesDocument = gql`
    query queryDiagnoses($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryDiagnoses(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...DiagnosisFields
  }
}
    ${DiagnosisFieldsFragmentDoc}`;

/**
 * __useQueryDiagnosesQuery__
 *
 * To run a query within a React component, call `useQueryDiagnosesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDiagnosesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDiagnosesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryDiagnosesQuery(baseOptions?: Apollo.QueryHookOptions<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>(QueryDiagnosesDocument, options);
      }
export function useQueryDiagnosesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>(QueryDiagnosesDocument, options);
        }
export type QueryDiagnosesQueryHookResult = ReturnType<typeof useQueryDiagnosesQuery>;
export type QueryDiagnosesLazyQueryHookResult = ReturnType<typeof useQueryDiagnosesLazyQuery>;
export type QueryDiagnosesQueryResult = Apollo.QueryResult<QueryDiagnosesQuery, QueryDiagnosesQueryVariables>;
export const QueryEntityReportsDocument = gql`
    query queryEntityReports($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryEntityReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...EntityReportFields
  }
}
    ${EntityReportFieldsFragmentDoc}`;

/**
 * __useQueryEntityReportsQuery__
 *
 * To run a query within a React component, call `useQueryEntityReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryEntityReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryEntityReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryEntityReportsQuery(baseOptions?: Apollo.QueryHookOptions<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>(QueryEntityReportsDocument, options);
      }
export function useQueryEntityReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>(QueryEntityReportsDocument, options);
        }
export type QueryEntityReportsQueryHookResult = ReturnType<typeof useQueryEntityReportsQuery>;
export type QueryEntityReportsLazyQueryHookResult = ReturnType<typeof useQueryEntityReportsLazyQuery>;
export type QueryEntityReportsQueryResult = Apollo.QueryResult<QueryEntityReportsQuery, QueryEntityReportsQueryVariables>;
export const GetOrganizationReportDocument = gql`
    query getOrganizationReport($id: ID!) {
  organizationReport(id: $id) {
    ...OrganizationReportFields
  }
}
    ${OrganizationReportFieldsFragmentDoc}`;

/**
 * __useGetOrganizationReportQuery__
 *
 * To run a query within a React component, call `useGetOrganizationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationReportQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>(GetOrganizationReportDocument, options);
      }
export function useGetOrganizationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>(GetOrganizationReportDocument, options);
        }
export type GetOrganizationReportQueryHookResult = ReturnType<typeof useGetOrganizationReportQuery>;
export type GetOrganizationReportLazyQueryHookResult = ReturnType<typeof useGetOrganizationReportLazyQuery>;
export type GetOrganizationReportQueryResult = Apollo.QueryResult<GetOrganizationReportQuery, GetOrganizationReportQueryVariables>;
export const QueryOrganizationReportsDocument = gql`
    query queryOrganizationReports($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizationReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationReportFields
  }
}
    ${OrganizationReportFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationReportsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationReportsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationReportsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>(QueryOrganizationReportsDocument, options);
      }
export function useQueryOrganizationReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>(QueryOrganizationReportsDocument, options);
        }
export type QueryOrganizationReportsQueryHookResult = ReturnType<typeof useQueryOrganizationReportsQuery>;
export type QueryOrganizationReportsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationReportsLazyQuery>;
export type QueryOrganizationReportsQueryResult = Apollo.QueryResult<QueryOrganizationReportsQuery, QueryOrganizationReportsQueryVariables>;
export const QueryOrganizationReportPreviewsDocument = gql`
    query queryOrganizationReportPreviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizationReports(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationReportPreviewFields
  }
}
    ${OrganizationReportPreviewFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationReportPreviewsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationReportPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationReportPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationReportPreviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationReportPreviewsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>(QueryOrganizationReportPreviewsDocument, options);
      }
export function useQueryOrganizationReportPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>(QueryOrganizationReportPreviewsDocument, options);
        }
export type QueryOrganizationReportPreviewsQueryHookResult = ReturnType<typeof useQueryOrganizationReportPreviewsQuery>;
export type QueryOrganizationReportPreviewsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationReportPreviewsLazyQuery>;
export type QueryOrganizationReportPreviewsQueryResult = Apollo.QueryResult<QueryOrganizationReportPreviewsQuery, QueryOrganizationReportPreviewsQueryVariables>;
export const CreateReportClinicDocument = gql`
    mutation createReportClinic($data: CreateReportClinicInput!) {
  createReportClinic(data: $data) {
    ...ReportClinicFields
  }
}
    ${ReportClinicFieldsFragmentDoc}`;
export type CreateReportClinicMutationFn = Apollo.MutationFunction<CreateReportClinicMutation, CreateReportClinicMutationVariables>;

/**
 * __useCreateReportClinicMutation__
 *
 * To run a mutation, you first call `useCreateReportClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportClinicMutation, { data, loading, error }] = useCreateReportClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportClinicMutation, CreateReportClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportClinicMutation, CreateReportClinicMutationVariables>(CreateReportClinicDocument, options);
      }
export type CreateReportClinicMutationHookResult = ReturnType<typeof useCreateReportClinicMutation>;
export type CreateReportClinicMutationResult = Apollo.MutationResult<CreateReportClinicMutation>;
export type CreateReportClinicMutationOptions = Apollo.BaseMutationOptions<CreateReportClinicMutation, CreateReportClinicMutationVariables>;
export const DeleteReportClinicDocument = gql`
    mutation deleteReportClinic($id: ID!) {
  deleteReportClinic(id: $id)
}
    `;
export type DeleteReportClinicMutationFn = Apollo.MutationFunction<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>;

/**
 * __useDeleteReportClinicMutation__
 *
 * To run a mutation, you first call `useDeleteReportClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportClinicMutation, { data, loading, error }] = useDeleteReportClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>(DeleteReportClinicDocument, options);
      }
export type DeleteReportClinicMutationHookResult = ReturnType<typeof useDeleteReportClinicMutation>;
export type DeleteReportClinicMutationResult = Apollo.MutationResult<DeleteReportClinicMutation>;
export type DeleteReportClinicMutationOptions = Apollo.BaseMutationOptions<DeleteReportClinicMutation, DeleteReportClinicMutationVariables>;
export const GetReportTemplateDocument = gql`
    query getReportTemplate($id: ID!) {
  reportTemplate(id: $id) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;

/**
 * __useGetReportTemplateQuery__
 *
 * To run a query within a React component, call `useGetReportTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetReportTemplateQuery, GetReportTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
      }
export function useGetReportTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportTemplateQuery, GetReportTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(GetReportTemplateDocument, options);
        }
export type GetReportTemplateQueryHookResult = ReturnType<typeof useGetReportTemplateQuery>;
export type GetReportTemplateLazyQueryHookResult = ReturnType<typeof useGetReportTemplateLazyQuery>;
export type GetReportTemplateQueryResult = Apollo.QueryResult<GetReportTemplateQuery, GetReportTemplateQueryVariables>;
export const QueryReportTemplatesDocument = gql`
    query queryReportTemplates($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReportTemplates(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;

/**
 * __useQueryReportTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReportTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>(QueryReportTemplatesDocument, options);
      }
export function useQueryReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>(QueryReportTemplatesDocument, options);
        }
export type QueryReportTemplatesQueryHookResult = ReturnType<typeof useQueryReportTemplatesQuery>;
export type QueryReportTemplatesLazyQueryHookResult = ReturnType<typeof useQueryReportTemplatesLazyQuery>;
export type QueryReportTemplatesQueryResult = Apollo.QueryResult<QueryReportTemplatesQuery, QueryReportTemplatesQueryVariables>;
export const CreateReportTemplateDocument = gql`
    mutation createReportTemplate($data: CreateReportTemplateInput!) {
  createReportTemplate(data: $data) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;
export type CreateReportTemplateMutationFn = Apollo.MutationFunction<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>;

/**
 * __useCreateReportTemplateMutation__
 *
 * To run a mutation, you first call `useCreateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportTemplateMutation, { data, loading, error }] = useCreateReportTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>(CreateReportTemplateDocument, options);
      }
export type CreateReportTemplateMutationHookResult = ReturnType<typeof useCreateReportTemplateMutation>;
export type CreateReportTemplateMutationResult = Apollo.MutationResult<CreateReportTemplateMutation>;
export type CreateReportTemplateMutationOptions = Apollo.BaseMutationOptions<CreateReportTemplateMutation, CreateReportTemplateMutationVariables>;
export const UpdateReportTemplateDocument = gql`
    mutation updateReportTemplate($id: ID!, $data: UpdateReportTemplateInput!) {
  updateReportTemplate(id: $id, data: $data) {
    ...ReportTemplateFields
  }
}
    ${ReportTemplateFieldsFragmentDoc}`;
export type UpdateReportTemplateMutationFn = Apollo.MutationFunction<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>;

/**
 * __useUpdateReportTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateReportTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportTemplateMutation, { data, loading, error }] = useUpdateReportTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateReportTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>(UpdateReportTemplateDocument, options);
      }
export type UpdateReportTemplateMutationHookResult = ReturnType<typeof useUpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationResult = Apollo.MutationResult<UpdateReportTemplateMutation>;
export type UpdateReportTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateReportTemplateMutation, UpdateReportTemplateMutationVariables>;
export const CreateTemplateClinicDocument = gql`
    mutation createTemplateClinic($data: CreateTemplateClinicInput!) {
  createTemplateClinic(data: $data) {
    ...TemplateClinicFields
  }
}
    ${TemplateClinicFieldsFragmentDoc}`;
export type CreateTemplateClinicMutationFn = Apollo.MutationFunction<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>;

/**
 * __useCreateTemplateClinicMutation__
 *
 * To run a mutation, you first call `useCreateTemplateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateClinicMutation, { data, loading, error }] = useCreateTemplateClinicMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTemplateClinicMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>(CreateTemplateClinicDocument, options);
      }
export type CreateTemplateClinicMutationHookResult = ReturnType<typeof useCreateTemplateClinicMutation>;
export type CreateTemplateClinicMutationResult = Apollo.MutationResult<CreateTemplateClinicMutation>;
export type CreateTemplateClinicMutationOptions = Apollo.BaseMutationOptions<CreateTemplateClinicMutation, CreateTemplateClinicMutationVariables>;
export const DeleteTemplateClinicDocument = gql`
    mutation deleteTemplateClinic($id: ID!) {
  deleteTemplateClinic(id: $id)
}
    `;
export type DeleteTemplateClinicMutationFn = Apollo.MutationFunction<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>;

/**
 * __useDeleteTemplateClinicMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateClinicMutation, { data, loading, error }] = useDeleteTemplateClinicMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateClinicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>(DeleteTemplateClinicDocument, options);
      }
export type DeleteTemplateClinicMutationHookResult = ReturnType<typeof useDeleteTemplateClinicMutation>;
export type DeleteTemplateClinicMutationResult = Apollo.MutationResult<DeleteTemplateClinicMutation>;
export type DeleteTemplateClinicMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateClinicMutation, DeleteTemplateClinicMutationVariables>;
export const CreateFormDocument = gql`
    mutation createForm($data: CreateFormInput!) {
  createForm(data: $data) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type CreateFormMutationFn = Apollo.MutationFunction<CreateFormMutation, CreateFormMutationVariables>;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormMutation, { data, loading, error }] = useCreateFormMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormMutation, CreateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormMutation, CreateFormMutationVariables>(CreateFormDocument, options);
      }
export type CreateFormMutationHookResult = ReturnType<typeof useCreateFormMutation>;
export type CreateFormMutationResult = Apollo.MutationResult<CreateFormMutation>;
export type CreateFormMutationOptions = Apollo.BaseMutationOptions<CreateFormMutation, CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation updateForm($id: ID!, $data: UpdateFormInput!) {
  updateForm(id: $id, data: $data) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;
export type UpdateFormMutationFn = Apollo.MutationFunction<UpdateFormMutation, UpdateFormMutationVariables>;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormMutation, { data, loading, error }] = useUpdateFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormMutation, UpdateFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormMutation, UpdateFormMutationVariables>(UpdateFormDocument, options);
      }
export type UpdateFormMutationHookResult = ReturnType<typeof useUpdateFormMutation>;
export type UpdateFormMutationResult = Apollo.MutationResult<UpdateFormMutation>;
export type UpdateFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormMutation, UpdateFormMutationVariables>;
export const QueryFormsDocument = gql`
    query queryForms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryForms(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...FormFields
  }
}
    ${FormFieldsFragmentDoc}`;

/**
 * __useQueryFormsQuery__
 *
 * To run a query within a React component, call `useQueryFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryFormsQuery(baseOptions?: Apollo.QueryHookOptions<QueryFormsQuery, QueryFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryFormsQuery, QueryFormsQueryVariables>(QueryFormsDocument, options);
      }
export function useQueryFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryFormsQuery, QueryFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryFormsQuery, QueryFormsQueryVariables>(QueryFormsDocument, options);
        }
export type QueryFormsQueryHookResult = ReturnType<typeof useQueryFormsQuery>;
export type QueryFormsLazyQueryHookResult = ReturnType<typeof useQueryFormsLazyQuery>;
export type QueryFormsQueryResult = Apollo.QueryResult<QueryFormsQuery, QueryFormsQueryVariables>;
export const CountFormsDocument = gql`
    query countForms($where: [QueryInput!]) {
  countForms(where: $where)
}
    `;

/**
 * __useCountFormsQuery__
 *
 * To run a query within a React component, call `useCountFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountFormsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountFormsQuery(baseOptions?: Apollo.QueryHookOptions<CountFormsQuery, CountFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountFormsQuery, CountFormsQueryVariables>(CountFormsDocument, options);
      }
export function useCountFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountFormsQuery, CountFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountFormsQuery, CountFormsQueryVariables>(CountFormsDocument, options);
        }
export type CountFormsQueryHookResult = ReturnType<typeof useCountFormsQuery>;
export type CountFormsLazyQueryHookResult = ReturnType<typeof useCountFormsLazyQuery>;
export type CountFormsQueryResult = Apollo.QueryResult<CountFormsQuery, CountFormsQueryVariables>;
export const GetGoalByClinicAndIdDocument = gql`
    query getGoalByClinicAndId($clinicId: ID!, $goalId: ID!) {
  goal(clinicId: $clinicId, goalId: $goalId) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;

/**
 * __useGetGoalByClinicAndIdQuery__
 *
 * To run a query within a React component, call `useGetGoalByClinicAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalByClinicAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalByClinicAndIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useGetGoalByClinicAndIdQuery(baseOptions: Apollo.QueryHookOptions<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>(GetGoalByClinicAndIdDocument, options);
      }
export function useGetGoalByClinicAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>(GetGoalByClinicAndIdDocument, options);
        }
export type GetGoalByClinicAndIdQueryHookResult = ReturnType<typeof useGetGoalByClinicAndIdQuery>;
export type GetGoalByClinicAndIdLazyQueryHookResult = ReturnType<typeof useGetGoalByClinicAndIdLazyQuery>;
export type GetGoalByClinicAndIdQueryResult = Apollo.QueryResult<GetGoalByClinicAndIdQuery, GetGoalByClinicAndIdQueryVariables>;
export const GetGoalsByClinicDocument = gql`
    query getGoalsByClinic($clinicId: ID!) {
  getGoalsByClinic(clinicId: $clinicId) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;

/**
 * __useGetGoalsByClinicQuery__
 *
 * To run a query within a React component, call `useGetGoalsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetGoalsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>(GetGoalsByClinicDocument, options);
      }
export function useGetGoalsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>(GetGoalsByClinicDocument, options);
        }
export type GetGoalsByClinicQueryHookResult = ReturnType<typeof useGetGoalsByClinicQuery>;
export type GetGoalsByClinicLazyQueryHookResult = ReturnType<typeof useGetGoalsByClinicLazyQuery>;
export type GetGoalsByClinicQueryResult = Apollo.QueryResult<GetGoalsByClinicQuery, GetGoalsByClinicQueryVariables>;
export const CreateGoalDocument = gql`
    mutation createGoal($clinicId: ID!, $data: CreateGoalInput!) {
  createGoal(clinicId: $clinicId, data: $data) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;
export type CreateGoalMutationFn = Apollo.MutationFunction<CreateGoalMutation, CreateGoalMutationVariables>;

/**
 * __useCreateGoalMutation__
 *
 * To run a mutation, you first call `useCreateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalMutation, { data, loading, error }] = useCreateGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGoalMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalMutation, CreateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalMutation, CreateGoalMutationVariables>(CreateGoalDocument, options);
      }
export type CreateGoalMutationHookResult = ReturnType<typeof useCreateGoalMutation>;
export type CreateGoalMutationResult = Apollo.MutationResult<CreateGoalMutation>;
export type CreateGoalMutationOptions = Apollo.BaseMutationOptions<CreateGoalMutation, CreateGoalMutationVariables>;
export const UpdateGoalDocument = gql`
    mutation updateGoal($clinicId: ID!, $goalId: ID!, $data: UpdateGoalInput!) {
  updateGoal(clinicId: $clinicId, goalId: $goalId, data: $data) {
    ...GoalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;
export type UpdateGoalMutationFn = Apollo.MutationFunction<UpdateGoalMutation, UpdateGoalMutationVariables>;

/**
 * __useUpdateGoalMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMutation, { data, loading, error }] = useUpdateGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalMutation, UpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument, options);
      }
export type UpdateGoalMutationHookResult = ReturnType<typeof useUpdateGoalMutation>;
export type UpdateGoalMutationResult = Apollo.MutationResult<UpdateGoalMutation>;
export type UpdateGoalMutationOptions = Apollo.BaseMutationOptions<UpdateGoalMutation, UpdateGoalMutationVariables>;
export const DeleteGoalDocument = gql`
    mutation deleteGoal($clinicId: ID!, $goalId: ID!) {
  deleteGoal(clinicId: $clinicId, goalId: $goalId)
}
    `;
export type DeleteGoalMutationFn = Apollo.MutationFunction<DeleteGoalMutation, DeleteGoalMutationVariables>;

/**
 * __useDeleteGoalMutation__
 *
 * To run a mutation, you first call `useDeleteGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoalMutation, { data, loading, error }] = useDeleteGoalMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useDeleteGoalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoalMutation, DeleteGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoalMutation, DeleteGoalMutationVariables>(DeleteGoalDocument, options);
      }
export type DeleteGoalMutationHookResult = ReturnType<typeof useDeleteGoalMutation>;
export type DeleteGoalMutationResult = Apollo.MutationResult<DeleteGoalMutation>;
export type DeleteGoalMutationOptions = Apollo.BaseMutationOptions<DeleteGoalMutation, DeleteGoalMutationVariables>;
export const GetLoyaltyRewardsForClinicDocument = gql`
    query getLoyaltyRewardsForClinic($clinicId: ID!) {
  getLoyaltyRewardsForClinic(clinicId: $clinicId) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyRewardsForClinicQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRewardsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRewardsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRewardsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetLoyaltyRewardsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>(GetLoyaltyRewardsForClinicDocument, options);
      }
export function useGetLoyaltyRewardsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>(GetLoyaltyRewardsForClinicDocument, options);
        }
export type GetLoyaltyRewardsForClinicQueryHookResult = ReturnType<typeof useGetLoyaltyRewardsForClinicQuery>;
export type GetLoyaltyRewardsForClinicLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRewardsForClinicLazyQuery>;
export type GetLoyaltyRewardsForClinicQueryResult = Apollo.QueryResult<GetLoyaltyRewardsForClinicQuery, GetLoyaltyRewardsForClinicQueryVariables>;
export const GetLoyaltyMemberFromClientDocument = gql`
    query getLoyaltyMemberFromClient($clientId: ID!) {
  client(id: $clientId) {
    loyalty_members {
      id
      available_points
      all_time_points
    }
  }
}
    `;

/**
 * __useGetLoyaltyMemberFromClientQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyMemberFromClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyMemberFromClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyMemberFromClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLoyaltyMemberFromClientQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>(GetLoyaltyMemberFromClientDocument, options);
      }
export function useGetLoyaltyMemberFromClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>(GetLoyaltyMemberFromClientDocument, options);
        }
export type GetLoyaltyMemberFromClientQueryHookResult = ReturnType<typeof useGetLoyaltyMemberFromClientQuery>;
export type GetLoyaltyMemberFromClientLazyQueryHookResult = ReturnType<typeof useGetLoyaltyMemberFromClientLazyQuery>;
export type GetLoyaltyMemberFromClientQueryResult = Apollo.QueryResult<GetLoyaltyMemberFromClientQuery, GetLoyaltyMemberFromClientQueryVariables>;
export const GetLoyaltyMemberDocument = gql`
    query getLoyaltyMember($id: ID!) {
  loyaltyMember(id: $id) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyMemberQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoyaltyMemberQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>(GetLoyaltyMemberDocument, options);
      }
export function useGetLoyaltyMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>(GetLoyaltyMemberDocument, options);
        }
export type GetLoyaltyMemberQueryHookResult = ReturnType<typeof useGetLoyaltyMemberQuery>;
export type GetLoyaltyMemberLazyQueryHookResult = ReturnType<typeof useGetLoyaltyMemberLazyQuery>;
export type GetLoyaltyMemberQueryResult = Apollo.QueryResult<GetLoyaltyMemberQuery, GetLoyaltyMemberQueryVariables>;
export const GetLoyaltyRewardDocument = gql`
    query getLoyaltyReward($id: ID!) {
  loyaltyReward(id: $id) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;

/**
 * __useGetLoyaltyRewardQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyRewardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyRewardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyRewardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoyaltyRewardQuery(baseOptions: Apollo.QueryHookOptions<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>(GetLoyaltyRewardDocument, options);
      }
export function useGetLoyaltyRewardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>(GetLoyaltyRewardDocument, options);
        }
export type GetLoyaltyRewardQueryHookResult = ReturnType<typeof useGetLoyaltyRewardQuery>;
export type GetLoyaltyRewardLazyQueryHookResult = ReturnType<typeof useGetLoyaltyRewardLazyQuery>;
export type GetLoyaltyRewardQueryResult = Apollo.QueryResult<GetLoyaltyRewardQuery, GetLoyaltyRewardQueryVariables>;
export const CreateLoyaltyRewardDocument = gql`
    mutation createLoyaltyReward($data: CreateLoyaltyRewardInput!) {
  createLoyaltyReward(data: $data) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;
export type CreateLoyaltyRewardMutationFn = Apollo.MutationFunction<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>;

/**
 * __useCreateLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyRewardMutation, { data, loading, error }] = useCreateLoyaltyRewardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>(CreateLoyaltyRewardDocument, options);
      }
export type CreateLoyaltyRewardMutationHookResult = ReturnType<typeof useCreateLoyaltyRewardMutation>;
export type CreateLoyaltyRewardMutationResult = Apollo.MutationResult<CreateLoyaltyRewardMutation>;
export type CreateLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyRewardMutation, CreateLoyaltyRewardMutationVariables>;
export const UpdateLoyaltyRewardDocument = gql`
    mutation updateLoyaltyReward($id: ID!, $data: UpdateLoyaltyRewardInput!) {
  updateLoyaltyReward(id: $id, data: $data) {
    ...LoyaltyRewardFields
  }
}
    ${LoyaltyRewardFieldsFragmentDoc}`;
export type UpdateLoyaltyRewardMutationFn = Apollo.MutationFunction<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>;

/**
 * __useUpdateLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyRewardMutation, { data, loading, error }] = useUpdateLoyaltyRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>(UpdateLoyaltyRewardDocument, options);
      }
export type UpdateLoyaltyRewardMutationHookResult = ReturnType<typeof useUpdateLoyaltyRewardMutation>;
export type UpdateLoyaltyRewardMutationResult = Apollo.MutationResult<UpdateLoyaltyRewardMutation>;
export type UpdateLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyRewardMutation, UpdateLoyaltyRewardMutationVariables>;
export const DeleteLoyaltyRewardDocument = gql`
    mutation deleteLoyaltyReward($id: ID!) {
  deleteLoyaltyReward(id: $id)
}
    `;
export type DeleteLoyaltyRewardMutationFn = Apollo.MutationFunction<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>;

/**
 * __useDeleteLoyaltyRewardMutation__
 *
 * To run a mutation, you first call `useDeleteLoyaltyRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoyaltyRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoyaltyRewardMutation, { data, loading, error }] = useDeleteLoyaltyRewardMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLoyaltyRewardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>(DeleteLoyaltyRewardDocument, options);
      }
export type DeleteLoyaltyRewardMutationHookResult = ReturnType<typeof useDeleteLoyaltyRewardMutation>;
export type DeleteLoyaltyRewardMutationResult = Apollo.MutationResult<DeleteLoyaltyRewardMutation>;
export type DeleteLoyaltyRewardMutationOptions = Apollo.BaseMutationOptions<DeleteLoyaltyRewardMutation, DeleteLoyaltyRewardMutationVariables>;
export const CreateLoyaltyMemberDocument = gql`
    mutation createLoyaltyMember($data: CreateLoyaltyMemberInput!) {
  createLoyaltyMember(data: $data) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type CreateLoyaltyMemberMutationFn = Apollo.MutationFunction<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>;

/**
 * __useCreateLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyMemberMutation, { data, loading, error }] = useCreateLoyaltyMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>(CreateLoyaltyMemberDocument, options);
      }
export type CreateLoyaltyMemberMutationHookResult = ReturnType<typeof useCreateLoyaltyMemberMutation>;
export type CreateLoyaltyMemberMutationResult = Apollo.MutationResult<CreateLoyaltyMemberMutation>;
export type CreateLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyMemberMutation, CreateLoyaltyMemberMutationVariables>;
export const UpdateLoyaltyMemberDocument = gql`
    mutation updateLoyaltyMember($id: ID!, $data: UpdateLoyaltyMemberInput!) {
  updateLoyaltyMember(id: $id, data: $data) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type UpdateLoyaltyMemberMutationFn = Apollo.MutationFunction<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>;

/**
 * __useUpdateLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useUpdateLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoyaltyMemberMutation, { data, loading, error }] = useUpdateLoyaltyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>(UpdateLoyaltyMemberDocument, options);
      }
export type UpdateLoyaltyMemberMutationHookResult = ReturnType<typeof useUpdateLoyaltyMemberMutation>;
export type UpdateLoyaltyMemberMutationResult = Apollo.MutationResult<UpdateLoyaltyMemberMutation>;
export type UpdateLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<UpdateLoyaltyMemberMutation, UpdateLoyaltyMemberMutationVariables>;
export const AddPointsToLoyaltyMemberDocument = gql`
    mutation addPointsToLoyaltyMember($id: ID!, $points: NonNegativeInt!) {
  addPointsToLoyaltyMember(id: $id, points: $points) {
    ...LoyaltyMemberFields
  }
}
    ${LoyaltyMemberFieldsFragmentDoc}`;
export type AddPointsToLoyaltyMemberMutationFn = Apollo.MutationFunction<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>;

/**
 * __useAddPointsToLoyaltyMemberMutation__
 *
 * To run a mutation, you first call `useAddPointsToLoyaltyMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPointsToLoyaltyMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPointsToLoyaltyMemberMutation, { data, loading, error }] = useAddPointsToLoyaltyMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      points: // value for 'points'
 *   },
 * });
 */
export function useAddPointsToLoyaltyMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>(AddPointsToLoyaltyMemberDocument, options);
      }
export type AddPointsToLoyaltyMemberMutationHookResult = ReturnType<typeof useAddPointsToLoyaltyMemberMutation>;
export type AddPointsToLoyaltyMemberMutationResult = Apollo.MutationResult<AddPointsToLoyaltyMemberMutation>;
export type AddPointsToLoyaltyMemberMutationOptions = Apollo.BaseMutationOptions<AddPointsToLoyaltyMemberMutation, AddPointsToLoyaltyMemberMutationVariables>;
export const QueryLoyaltyRedemptionsDocument = gql`
    query queryLoyaltyRedemptions($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryLoyaltyRedemptions(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;

/**
 * __useQueryLoyaltyRedemptionsQuery__
 *
 * To run a query within a React component, call `useQueryLoyaltyRedemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryLoyaltyRedemptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryLoyaltyRedemptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryLoyaltyRedemptionsQuery(baseOptions?: Apollo.QueryHookOptions<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>(QueryLoyaltyRedemptionsDocument, options);
      }
export function useQueryLoyaltyRedemptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>(QueryLoyaltyRedemptionsDocument, options);
        }
export type QueryLoyaltyRedemptionsQueryHookResult = ReturnType<typeof useQueryLoyaltyRedemptionsQuery>;
export type QueryLoyaltyRedemptionsLazyQueryHookResult = ReturnType<typeof useQueryLoyaltyRedemptionsLazyQuery>;
export type QueryLoyaltyRedemptionsQueryResult = Apollo.QueryResult<QueryLoyaltyRedemptionsQuery, QueryLoyaltyRedemptionsQueryVariables>;
export const CreateLoyaltyRedemptionDocument = gql`
    mutation createLoyaltyRedemption($data: CreateLoyaltyRedemptionInput!) {
  createLoyaltyRedemption(data: $data) {
    ...LoyaltyRedemptionFields
  }
}
    ${LoyaltyRedemptionFieldsFragmentDoc}`;
export type CreateLoyaltyRedemptionMutationFn = Apollo.MutationFunction<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>;

/**
 * __useCreateLoyaltyRedemptionMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyRedemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyRedemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyRedemptionMutation, { data, loading, error }] = useCreateLoyaltyRedemptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLoyaltyRedemptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>(CreateLoyaltyRedemptionDocument, options);
      }
export type CreateLoyaltyRedemptionMutationHookResult = ReturnType<typeof useCreateLoyaltyRedemptionMutation>;
export type CreateLoyaltyRedemptionMutationResult = Apollo.MutationResult<CreateLoyaltyRedemptionMutation>;
export type CreateLoyaltyRedemptionMutationOptions = Apollo.BaseMutationOptions<CreateLoyaltyRedemptionMutation, CreateLoyaltyRedemptionMutationVariables>;
export const GetMessagesByChatIdDocument = gql`
    query getMessagesByChatId($chatId: ID!, $limit: NonNegativeInt, $startAtCreatedAt: NonNegativeInt, $patientId: ID) {
  getMessagesByChatId(
    chatId: $chatId
    limit: $limit
    startAtCreatedAt: $startAtCreatedAt
    patientId: $patientId
  ) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useGetMessagesByChatIdQuery__
 *
 * To run a query within a React component, call `useGetMessagesByChatIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesByChatIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesByChatIdQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      limit: // value for 'limit'
 *      startAtCreatedAt: // value for 'startAtCreatedAt'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetMessagesByChatIdQuery(baseOptions: Apollo.QueryHookOptions<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>(GetMessagesByChatIdDocument, options);
      }
export function useGetMessagesByChatIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>(GetMessagesByChatIdDocument, options);
        }
export type GetMessagesByChatIdQueryHookResult = ReturnType<typeof useGetMessagesByChatIdQuery>;
export type GetMessagesByChatIdLazyQueryHookResult = ReturnType<typeof useGetMessagesByChatIdLazyQuery>;
export type GetMessagesByChatIdQueryResult = Apollo.QueryResult<GetMessagesByChatIdQuery, GetMessagesByChatIdQueryVariables>;
export const QueryMessagesDocument = gql`
    query queryMessages($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryMessages(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useQueryMessagesQuery__
 *
 * To run a query within a React component, call `useQueryMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryMessagesQuery(baseOptions?: Apollo.QueryHookOptions<QueryMessagesQuery, QueryMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryMessagesQuery, QueryMessagesQueryVariables>(QueryMessagesDocument, options);
      }
export function useQueryMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryMessagesQuery, QueryMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryMessagesQuery, QueryMessagesQueryVariables>(QueryMessagesDocument, options);
        }
export type QueryMessagesQueryHookResult = ReturnType<typeof useQueryMessagesQuery>;
export type QueryMessagesLazyQueryHookResult = ReturnType<typeof useQueryMessagesLazyQuery>;
export type QueryMessagesQueryResult = Apollo.QueryResult<QueryMessagesQuery, QueryMessagesQueryVariables>;
export const CountMessagesDocument = gql`
    query countMessages($where: [QueryInput!]) {
  countMessages(where: $where)
}
    `;

/**
 * __useCountMessagesQuery__
 *
 * To run a query within a React component, call `useCountMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMessagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountMessagesQuery(baseOptions?: Apollo.QueryHookOptions<CountMessagesQuery, CountMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountMessagesQuery, CountMessagesQueryVariables>(CountMessagesDocument, options);
      }
export function useCountMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountMessagesQuery, CountMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountMessagesQuery, CountMessagesQueryVariables>(CountMessagesDocument, options);
        }
export type CountMessagesQueryHookResult = ReturnType<typeof useCountMessagesQuery>;
export type CountMessagesLazyQueryHookResult = ReturnType<typeof useCountMessagesLazyQuery>;
export type CountMessagesQueryResult = Apollo.QueryResult<CountMessagesQuery, CountMessagesQueryVariables>;
export const CreateMessageDocument = gql`
    mutation createMessage($chatId: ID!, $data: CreateMessageInput!) {
  createMessage(chatId: $chatId, data: $data) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation updateMessage($chatId: ID!, $messageId: ID!, $data: UpdateMessageInput!) {
  updateMessage(chatId: $chatId, messageId: $messageId, data: $data) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation deleteMessage($chatId: ID!, $messageId: ID!) {
  deleteMessage(chatId: $chatId, messageId: $messageId)
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const NotificationTemplateDocument = gql`
    query notificationTemplate($notificationTemplateId: ID!) {
  notificationTemplate(notificationTemplateId: $notificationTemplateId) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useNotificationTemplateQuery__
 *
 * To run a query within a React component, call `useNotificationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplateQuery({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useNotificationTemplateQuery(baseOptions: Apollo.QueryHookOptions<NotificationTemplateQuery, NotificationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationTemplateQuery, NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
      }
export function useNotificationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationTemplateQuery, NotificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationTemplateQuery, NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
        }
export type NotificationTemplateQueryHookResult = ReturnType<typeof useNotificationTemplateQuery>;
export type NotificationTemplateLazyQueryHookResult = ReturnType<typeof useNotificationTemplateLazyQuery>;
export type NotificationTemplateQueryResult = Apollo.QueryResult<NotificationTemplateQuery, NotificationTemplateQueryVariables>;
export const GetNotificationTemplatesByClinicIdDocument = gql`
    query getNotificationTemplatesByClinicId($clinicId: ID!) {
  getNotificationTemplatesByClinicId(clinicId: $clinicId) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useGetNotificationTemplatesByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationTemplatesByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTemplatesByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTemplatesByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetNotificationTemplatesByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>(GetNotificationTemplatesByClinicIdDocument, options);
      }
export function useGetNotificationTemplatesByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>(GetNotificationTemplatesByClinicIdDocument, options);
        }
export type GetNotificationTemplatesByClinicIdQueryHookResult = ReturnType<typeof useGetNotificationTemplatesByClinicIdQuery>;
export type GetNotificationTemplatesByClinicIdLazyQueryHookResult = ReturnType<typeof useGetNotificationTemplatesByClinicIdLazyQuery>;
export type GetNotificationTemplatesByClinicIdQueryResult = Apollo.QueryResult<GetNotificationTemplatesByClinicIdQuery, GetNotificationTemplatesByClinicIdQueryVariables>;
export const QueryNotificationTemplatesDocument = gql`
    query queryNotificationTemplates($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryNotificationTemplates(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;

/**
 * __useQueryNotificationTemplatesQuery__
 *
 * To run a query within a React component, call `useQueryNotificationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryNotificationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryNotificationTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryNotificationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>(QueryNotificationTemplatesDocument, options);
      }
export function useQueryNotificationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>(QueryNotificationTemplatesDocument, options);
        }
export type QueryNotificationTemplatesQueryHookResult = ReturnType<typeof useQueryNotificationTemplatesQuery>;
export type QueryNotificationTemplatesLazyQueryHookResult = ReturnType<typeof useQueryNotificationTemplatesLazyQuery>;
export type QueryNotificationTemplatesQueryResult = Apollo.QueryResult<QueryNotificationTemplatesQuery, QueryNotificationTemplatesQueryVariables>;
export const CreateNotificationTemplateDocument = gql`
    mutation createNotificationTemplate($data: CreateNotificationTemplateInput!) {
  createNotificationTemplate(data: $data) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type CreateNotificationTemplateMutationFn = Apollo.MutationFunction<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;

/**
 * __useCreateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTemplateMutation, { data, loading, error }] = useCreateNotificationTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>(CreateNotificationTemplateDocument, options);
      }
export type CreateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationResult = Apollo.MutationResult<CreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;
export const UpdateNotificationTemplateDocument = gql`
    mutation updateNotificationTemplate($notificationTemplateId: ID!, $data: UpdateNotificationTemplateInput!) {
  updateNotificationTemplate(
    notificationTemplateId: $notificationTemplateId
    data: $data
  ) {
    ...NotificationTemplateFields
  }
}
    ${NotificationTemplateFieldsFragmentDoc}`;
export type UpdateNotificationTemplateMutationFn = Apollo.MutationFunction<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;

/**
 * __useUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTemplateMutation, { data, loading, error }] = useUpdateNotificationTemplateMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>(UpdateNotificationTemplateDocument, options);
      }
export type UpdateNotificationTemplateMutationHookResult = ReturnType<typeof useUpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationResult = Apollo.MutationResult<UpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;
export const DeleteNotificationTemplateDocument = gql`
    mutation deleteNotificationTemplate($notificationTemplateId: ID!) {
  deleteNotificationTemplate(notificationTemplateId: $notificationTemplateId)
}
    `;
export type DeleteNotificationTemplateMutationFn = Apollo.MutationFunction<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;

/**
 * __useDeleteNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTemplateMutation, { data, loading, error }] = useDeleteNotificationTemplateMutation({
 *   variables: {
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useDeleteNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>(DeleteNotificationTemplateDocument, options);
      }
export type DeleteNotificationTemplateMutationHookResult = ReturnType<typeof useDeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationResult = Apollo.MutationResult<DeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;
export const GetOrganizationAnalyticsDocument = gql`
    query getOrganizationAnalytics($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationAnalytics(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    ...OrganizationAnalyticsFields
  }
}
    ${OrganizationAnalyticsFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>(GetOrganizationAnalyticsDocument, options);
      }
export function useGetOrganizationAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>(GetOrganizationAnalyticsDocument, options);
        }
export type GetOrganizationAnalyticsQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsQuery>;
export type GetOrganizationAnalyticsLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsLazyQuery>;
export type GetOrganizationAnalyticsQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsQuery, GetOrganizationAnalyticsQueryVariables>;
export const GetOrganizationAnalyticsNumbersDocument = gql`
    query getOrganizationAnalyticsNumbers($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationAnalyticsNumbers(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    ...OrganizationAnalyticsNumbersFields
  }
}
    ${OrganizationAnalyticsNumbersFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsNumbersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsNumbersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>(GetOrganizationAnalyticsNumbersDocument, options);
      }
export function useGetOrganizationAnalyticsNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>(GetOrganizationAnalyticsNumbersDocument, options);
        }
export type GetOrganizationAnalyticsNumbersQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersQuery>;
export type GetOrganizationAnalyticsNumbersLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersLazyQuery>;
export type GetOrganizationAnalyticsNumbersQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsNumbersQuery, GetOrganizationAnalyticsNumbersQueryVariables>;
export const GetOrganizationScheduleEfficiencyDocument = gql`
    query getOrganizationScheduleEfficiency($organizationId: ID!, $fromDate: NonNegativeInt!, $toDate: NonNegativeInt!) {
  organizationScheduleEfficiency(
    organizationId: $organizationId
    fromDate: $fromDate
    toDate: $toDate
  ) {
    average
    per_clinic {
      clinic {
        id
        name
      }
      schedule_efficiency
    }
  }
}
    `;

/**
 * __useGetOrganizationScheduleEfficiencyQuery__
 *
 * To run a query within a React component, call `useGetOrganizationScheduleEfficiencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationScheduleEfficiencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationScheduleEfficiencyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetOrganizationScheduleEfficiencyQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>(GetOrganizationScheduleEfficiencyDocument, options);
      }
export function useGetOrganizationScheduleEfficiencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>(GetOrganizationScheduleEfficiencyDocument, options);
        }
export type GetOrganizationScheduleEfficiencyQueryHookResult = ReturnType<typeof useGetOrganizationScheduleEfficiencyQuery>;
export type GetOrganizationScheduleEfficiencyLazyQueryHookResult = ReturnType<typeof useGetOrganizationScheduleEfficiencyLazyQuery>;
export type GetOrganizationScheduleEfficiencyQueryResult = Apollo.QueryResult<GetOrganizationScheduleEfficiencyQuery, GetOrganizationScheduleEfficiencyQueryVariables>;
export const GetOrganizationAnalyticsNumbersByMonthsDocument = gql`
    query getOrganizationAnalyticsNumbersByMonths($organizationId: ID!, $numMonths: NonNegativeInt!) {
  getAnalyticsNumbersByMonthsForOrganization(
    organizationId: $organizationId
    numMonths: $numMonths
  ) {
    clinic {
      id
      name
    }
    analytic_numbers {
      analytics {
        ...AnalyticsNumbersFields
      }
      month
      year
    }
  }
}
    ${AnalyticsNumbersFieldsFragmentDoc}`;

/**
 * __useGetOrganizationAnalyticsNumbersByMonthsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAnalyticsNumbersByMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAnalyticsNumbersByMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAnalyticsNumbersByMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetOrganizationAnalyticsNumbersByMonthsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>(GetOrganizationAnalyticsNumbersByMonthsDocument, options);
      }
export function useGetOrganizationAnalyticsNumbersByMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>(GetOrganizationAnalyticsNumbersByMonthsDocument, options);
        }
export type GetOrganizationAnalyticsNumbersByMonthsQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersByMonthsQuery>;
export type GetOrganizationAnalyticsNumbersByMonthsLazyQueryHookResult = ReturnType<typeof useGetOrganizationAnalyticsNumbersByMonthsLazyQuery>;
export type GetOrganizationAnalyticsNumbersByMonthsQueryResult = Apollo.QueryResult<GetOrganizationAnalyticsNumbersByMonthsQuery, GetOrganizationAnalyticsNumbersByMonthsQueryVariables>;
export const GetOrganizationRevenueByMonthsDocument = gql`
    query getOrganizationRevenueByMonths($organizationId: ID!, $numMonths: NonNegativeInt!) {
  getRevenueByMonthsForOrganization(
    organizationId: $organizationId
    numMonths: $numMonths
  ) {
    clinic {
      id
      name
    }
    revenue {
      revenue
      month
      year
    }
  }
}
    `;

/**
 * __useGetOrganizationRevenueByMonthsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRevenueByMonthsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRevenueByMonthsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRevenueByMonthsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      numMonths: // value for 'numMonths'
 *   },
 * });
 */
export function useGetOrganizationRevenueByMonthsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>(GetOrganizationRevenueByMonthsDocument, options);
      }
export function useGetOrganizationRevenueByMonthsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>(GetOrganizationRevenueByMonthsDocument, options);
        }
export type GetOrganizationRevenueByMonthsQueryHookResult = ReturnType<typeof useGetOrganizationRevenueByMonthsQuery>;
export type GetOrganizationRevenueByMonthsLazyQueryHookResult = ReturnType<typeof useGetOrganizationRevenueByMonthsLazyQuery>;
export type GetOrganizationRevenueByMonthsQueryResult = Apollo.QueryResult<GetOrganizationRevenueByMonthsQuery, GetOrganizationRevenueByMonthsQueryVariables>;
export const GetOrganizationDocument = gql`
    query getOrganization($id: ID!) {
  organization(id: $id) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const QueryOrganizationsDocument = gql`
    query queryOrganizations($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryOrganizations(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useQueryOrganizationsQuery__
 *
 * To run a query within a React component, call `useQueryOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>(QueryOrganizationsDocument, options);
      }
export function useQueryOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>(QueryOrganizationsDocument, options);
        }
export type QueryOrganizationsQueryHookResult = ReturnType<typeof useQueryOrganizationsQuery>;
export type QueryOrganizationsLazyQueryHookResult = ReturnType<typeof useQueryOrganizationsLazyQuery>;
export type QueryOrganizationsQueryResult = Apollo.QueryResult<QueryOrganizationsQuery, QueryOrganizationsQueryVariables>;
export const CountOrganizationsDocument = gql`
    query countOrganizations($where: [QueryInput!]) {
  countOrganizations(where: $where)
}
    `;

/**
 * __useCountOrganizationsQuery__
 *
 * To run a query within a React component, call `useCountOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountOrganizationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<CountOrganizationsQuery, CountOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountOrganizationsQuery, CountOrganizationsQueryVariables>(CountOrganizationsDocument, options);
      }
export function useCountOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountOrganizationsQuery, CountOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountOrganizationsQuery, CountOrganizationsQueryVariables>(CountOrganizationsDocument, options);
        }
export type CountOrganizationsQueryHookResult = ReturnType<typeof useCountOrganizationsQuery>;
export type CountOrganizationsLazyQueryHookResult = ReturnType<typeof useCountOrganizationsLazyQuery>;
export type CountOrganizationsQueryResult = Apollo.QueryResult<CountOrganizationsQuery, CountOrganizationsQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($data: CreateOrganizationInput!) {
  createOrganization(data: $data) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($id: ID!, $data: UpdateOrganizationInput!) {
  updateOrganization(id: $id, data: $data) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($id: ID!) {
  deleteOrganization(id: $id)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const GetPatientDocument = gql`
    query getPatient($id: ID!) {
  patient(id: $id) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const GetPatientsByClientDocument = gql`
    query getPatientsByClient($clientId: ID!) {
  getPatientsByClient(clientId: $clientId) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsByClientQuery__
 *
 * To run a query within a React component, call `useGetPatientsByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsByClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetPatientsByClientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>(GetPatientsByClientDocument, options);
      }
export function useGetPatientsByClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>(GetPatientsByClientDocument, options);
        }
export type GetPatientsByClientQueryHookResult = ReturnType<typeof useGetPatientsByClientQuery>;
export type GetPatientsByClientLazyQueryHookResult = ReturnType<typeof useGetPatientsByClientLazyQuery>;
export type GetPatientsByClientQueryResult = Apollo.QueryResult<GetPatientsByClientQuery, GetPatientsByClientQueryVariables>;
export const GetPatientsByClientsDocument = gql`
    query getPatientsByClients($clientIds: [ID!]!) {
  getPatientsByClients(clientIds: $clientIds) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsByClientsQuery__
 *
 * To run a query within a React component, call `useGetPatientsByClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsByClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsByClientsQuery({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useGetPatientsByClientsQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>(GetPatientsByClientsDocument, options);
      }
export function useGetPatientsByClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>(GetPatientsByClientsDocument, options);
        }
export type GetPatientsByClientsQueryHookResult = ReturnType<typeof useGetPatientsByClientsQuery>;
export type GetPatientsByClientsLazyQueryHookResult = ReturnType<typeof useGetPatientsByClientsLazyQuery>;
export type GetPatientsByClientsQueryResult = Apollo.QueryResult<GetPatientsByClientsQuery, GetPatientsByClientsQueryVariables>;
export const GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument = gql`
    query getPatientsWithoutRescheduledAppointmentsForTimeRange($clinicId: ID!, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getPatientsWithoutRescheduledAppointmentsForTimeRange(
    clinicId: $clinicId
    start_time: $start_time
    end_time: $end_time
  ) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery__
 *
 * To run a query within a React component, call `useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery(baseOptions: Apollo.QueryHookOptions<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>(GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument, options);
      }
export function useGetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>(GetPatientsWithoutRescheduledAppointmentsForTimeRangeDocument, options);
        }
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryHookResult = ReturnType<typeof useGetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery>;
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQueryHookResult = ReturnType<typeof useGetPatientsWithoutRescheduledAppointmentsForTimeRangeLazyQuery>;
export type GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryResult = Apollo.QueryResult<GetPatientsWithoutRescheduledAppointmentsForTimeRangeQuery, GetPatientsWithoutRescheduledAppointmentsForTimeRangeQueryVariables>;
export const GetNewPatientsForClinicDocument = gql`
    query getNewPatientsForClinic($clinicId: ID!, $fromPmsCreatedAt: NonNegativeInt!, $toPmsCreatedAt: NonNegativeInt!) {
  getNewPatientsForClinic(
    clinicId: $clinicId
    fromPmsCreatedAt: $fromPmsCreatedAt
    toPmsCreatedAt: $toPmsCreatedAt
  )
}
    `;

/**
 * __useGetNewPatientsForClinicQuery__
 *
 * To run a query within a React component, call `useGetNewPatientsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewPatientsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewPatientsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      fromPmsCreatedAt: // value for 'fromPmsCreatedAt'
 *      toPmsCreatedAt: // value for 'toPmsCreatedAt'
 *   },
 * });
 */
export function useGetNewPatientsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetNewPatientsForClinicQuery, GetNewPatientsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewPatientsForClinicQuery, GetNewPatientsForClinicQueryVariables>(GetNewPatientsForClinicDocument, options);
      }
export function useGetNewPatientsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewPatientsForClinicQuery, GetNewPatientsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewPatientsForClinicQuery, GetNewPatientsForClinicQueryVariables>(GetNewPatientsForClinicDocument, options);
        }
export type GetNewPatientsForClinicQueryHookResult = ReturnType<typeof useGetNewPatientsForClinicQuery>;
export type GetNewPatientsForClinicLazyQueryHookResult = ReturnType<typeof useGetNewPatientsForClinicLazyQuery>;
export type GetNewPatientsForClinicQueryResult = Apollo.QueryResult<GetNewPatientsForClinicQuery, GetNewPatientsForClinicQueryVariables>;
export const QueryPatientsDocument = gql`
    query queryPatients($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPatients(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;

/**
 * __useQueryPatientsQuery__
 *
 * To run a query within a React component, call `useQueryPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPatientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPatientsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPatientsQuery, QueryPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPatientsQuery, QueryPatientsQueryVariables>(QueryPatientsDocument, options);
      }
export function useQueryPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPatientsQuery, QueryPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPatientsQuery, QueryPatientsQueryVariables>(QueryPatientsDocument, options);
        }
export type QueryPatientsQueryHookResult = ReturnType<typeof useQueryPatientsQuery>;
export type QueryPatientsLazyQueryHookResult = ReturnType<typeof useQueryPatientsLazyQuery>;
export type QueryPatientsQueryResult = Apollo.QueryResult<QueryPatientsQuery, QueryPatientsQueryVariables>;
export const CreatePatientDocument = gql`
    mutation createPatient($data: CreatePatientInput!) {
  createPatient(data: $data) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation updatePatient($id: ID!, $data: UpdatePatientInput!) {
  updatePatient(id: $id, data: $data) {
    ...PatientFields
  }
}
    ${PatientFieldsFragmentDoc}`;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const DeletePatientDocument = gql`
    mutation deletePatient($id: ID!) {
  deletePatient(id: $id)
}
    `;
export type DeletePatientMutationFn = Apollo.MutationFunction<DeletePatientMutation, DeletePatientMutationVariables>;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientMutation, { data, loading, error }] = useDeletePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientMutation, DeletePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(DeletePatientDocument, options);
      }
export type DeletePatientMutationHookResult = ReturnType<typeof useDeletePatientMutation>;
export type DeletePatientMutationResult = Apollo.MutationResult<DeletePatientMutation>;
export type DeletePatientMutationOptions = Apollo.BaseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>;
export const GetPaymentDocument = gql`
    query getPayment($id: ID!) {
  payment(id: $id) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetPaymentsByClinicIdDocument = gql`
    query getPaymentsByClinicId($clinicId: ID!) {
  getPaymentsByClinicId(clinicId: $clinicId) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentsByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentsByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPaymentsByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>(GetPaymentsByClinicIdDocument, options);
      }
export function useGetPaymentsByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>(GetPaymentsByClinicIdDocument, options);
        }
export type GetPaymentsByClinicIdQueryHookResult = ReturnType<typeof useGetPaymentsByClinicIdQuery>;
export type GetPaymentsByClinicIdLazyQueryHookResult = ReturnType<typeof useGetPaymentsByClinicIdLazyQuery>;
export type GetPaymentsByClinicIdQueryResult = Apollo.QueryResult<GetPaymentsByClinicIdQuery, GetPaymentsByClinicIdQueryVariables>;
export const QueryPaymentsDocument = gql`
    query queryPayments($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryPayments(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useQueryPaymentsQuery__
 *
 * To run a query within a React component, call `useQueryPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<QueryPaymentsQuery, QueryPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryPaymentsQuery, QueryPaymentsQueryVariables>(QueryPaymentsDocument, options);
      }
export function useQueryPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryPaymentsQuery, QueryPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryPaymentsQuery, QueryPaymentsQueryVariables>(QueryPaymentsDocument, options);
        }
export type QueryPaymentsQueryHookResult = ReturnType<typeof useQueryPaymentsQuery>;
export type QueryPaymentsLazyQueryHookResult = ReturnType<typeof useQueryPaymentsLazyQuery>;
export type QueryPaymentsQueryResult = Apollo.QueryResult<QueryPaymentsQuery, QueryPaymentsQueryVariables>;
export const CountPaymentsDocument = gql`
    query countPayments($where: [QueryInput!]) {
  countPayments(where: $where)
}
    `;

/**
 * __useCountPaymentsQuery__
 *
 * To run a query within a React component, call `useCountPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPaymentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<CountPaymentsQuery, CountPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPaymentsQuery, CountPaymentsQueryVariables>(CountPaymentsDocument, options);
      }
export function useCountPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPaymentsQuery, CountPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPaymentsQuery, CountPaymentsQueryVariables>(CountPaymentsDocument, options);
        }
export type CountPaymentsQueryHookResult = ReturnType<typeof useCountPaymentsQuery>;
export type CountPaymentsLazyQueryHookResult = ReturnType<typeof useCountPaymentsLazyQuery>;
export type CountPaymentsQueryResult = Apollo.QueryResult<CountPaymentsQuery, CountPaymentsQueryVariables>;
export const GetPatientRecordDocument = gql`
    query getPatientRecord($id: ID!) {
  patientRecord(id: $id) {
    ...PatientRecordFields
  }
}
    ${PatientRecordFieldsFragmentDoc}`;

/**
 * __useGetPatientRecordQuery__
 *
 * To run a query within a React component, call `useGetPatientRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientRecordQuery(baseOptions: Apollo.QueryHookOptions<GetPatientRecordQuery, GetPatientRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientRecordQuery, GetPatientRecordQueryVariables>(GetPatientRecordDocument, options);
      }
export function useGetPatientRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientRecordQuery, GetPatientRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientRecordQuery, GetPatientRecordQueryVariables>(GetPatientRecordDocument, options);
        }
export type GetPatientRecordQueryHookResult = ReturnType<typeof useGetPatientRecordQuery>;
export type GetPatientRecordLazyQueryHookResult = ReturnType<typeof useGetPatientRecordLazyQuery>;
export type GetPatientRecordQueryResult = Apollo.QueryResult<GetPatientRecordQuery, GetPatientRecordQueryVariables>;
export const GetPimsSettingsDocument = gql`
    query getPimsSettings($clinicId: ID!) {
  pimsSettings(clinicId: $clinicId) {
    ...PimsSettingsFields
  }
}
    ${PimsSettingsFieldsFragmentDoc}`;

/**
 * __useGetPimsSettingsQuery__
 *
 * To run a query within a React component, call `useGetPimsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPimsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPimsSettingsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPimsSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>(GetPimsSettingsDocument, options);
      }
export function useGetPimsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>(GetPimsSettingsDocument, options);
        }
export type GetPimsSettingsQueryHookResult = ReturnType<typeof useGetPimsSettingsQuery>;
export type GetPimsSettingsLazyQueryHookResult = ReturnType<typeof useGetPimsSettingsLazyQuery>;
export type GetPimsSettingsQueryResult = Apollo.QueryResult<GetPimsSettingsQuery, GetPimsSettingsQueryVariables>;
export const CreatePimsSettingsDocument = gql`
    mutation createPimsSettings($data: CreatePimsSettingsInput!) {
  createPimsSettings(data: $data) {
    ...PimsSettingsFields
  }
}
    ${PimsSettingsFieldsFragmentDoc}`;
export type CreatePimsSettingsMutationFn = Apollo.MutationFunction<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>;

/**
 * __useCreatePimsSettingsMutation__
 *
 * To run a mutation, you first call `useCreatePimsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePimsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPimsSettingsMutation, { data, loading, error }] = useCreatePimsSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePimsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>(CreatePimsSettingsDocument, options);
      }
export type CreatePimsSettingsMutationHookResult = ReturnType<typeof useCreatePimsSettingsMutation>;
export type CreatePimsSettingsMutationResult = Apollo.MutationResult<CreatePimsSettingsMutation>;
export type CreatePimsSettingsMutationOptions = Apollo.BaseMutationOptions<CreatePimsSettingsMutation, CreatePimsSettingsMutationVariables>;
export const UpdatePimsSettingsDocument = gql`
    mutation updatePimsSettings($clinicId: ID!, $data: UpdatePimsSettingsInput!) {
  updatePimsSettings(clinicId: $clinicId, data: $data) {
    ...PimsSettingsFields
  }
}
    ${PimsSettingsFieldsFragmentDoc}`;
export type UpdatePimsSettingsMutationFn = Apollo.MutationFunction<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>;

/**
 * __useUpdatePimsSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatePimsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePimsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePimsSettingsMutation, { data, loading, error }] = useUpdatePimsSettingsMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePimsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>(UpdatePimsSettingsDocument, options);
      }
export type UpdatePimsSettingsMutationHookResult = ReturnType<typeof useUpdatePimsSettingsMutation>;
export type UpdatePimsSettingsMutationResult = Apollo.MutationResult<UpdatePimsSettingsMutation>;
export type UpdatePimsSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatePimsSettingsMutation, UpdatePimsSettingsMutationVariables>;
export const GetPmsApptTypeDocument = gql`
    query getPmsApptType($clinidId: ID!, $pmsApptTypeId: ID!) {
  pmsApptType(clinicId: $clinidId, pmsApptTypeId: $pmsApptTypeId) {
    ...PmsApptTypeFields
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useGetPmsApptTypeQuery__
 *
 * To run a query within a React component, call `useGetPmsApptTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsApptTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsApptTypeQuery({
 *   variables: {
 *      clinidId: // value for 'clinidId'
 *      pmsApptTypeId: // value for 'pmsApptTypeId'
 *   },
 * });
 */
export function useGetPmsApptTypeQuery(baseOptions: Apollo.QueryHookOptions<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>(GetPmsApptTypeDocument, options);
      }
export function useGetPmsApptTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>(GetPmsApptTypeDocument, options);
        }
export type GetPmsApptTypeQueryHookResult = ReturnType<typeof useGetPmsApptTypeQuery>;
export type GetPmsApptTypeLazyQueryHookResult = ReturnType<typeof useGetPmsApptTypeLazyQuery>;
export type GetPmsApptTypeQueryResult = Apollo.QueryResult<GetPmsApptTypeQuery, GetPmsApptTypeQueryVariables>;
export const GetPmsApptTypesForClinicDocument = gql`
    query getPmsApptTypesForClinic($clinicId: ID!) {
  getPmsApptTypesForClinic(clinicId: $clinicId) {
    ...PmsApptTypeFields
  }
}
    ${PmsApptTypeFieldsFragmentDoc}`;

/**
 * __useGetPmsApptTypesForClinicQuery__
 *
 * To run a query within a React component, call `useGetPmsApptTypesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPmsApptTypesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPmsApptTypesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPmsApptTypesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>(GetPmsApptTypesForClinicDocument, options);
      }
export function useGetPmsApptTypesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>(GetPmsApptTypesForClinicDocument, options);
        }
export type GetPmsApptTypesForClinicQueryHookResult = ReturnType<typeof useGetPmsApptTypesForClinicQuery>;
export type GetPmsApptTypesForClinicLazyQueryHookResult = ReturnType<typeof useGetPmsApptTypesForClinicLazyQuery>;
export type GetPmsApptTypesForClinicQueryResult = Apollo.QueryResult<GetPmsApptTypesForClinicQuery, GetPmsApptTypesForClinicQueryVariables>;
export const GetPrescriptionRequestDocument = gql`
    query getPrescriptionRequest($id: ID!) {
  prescriptionRequest(id: $id) {
    ...PrescriptionRequestFields
  }
}
    ${PrescriptionRequestFieldsFragmentDoc}`;

/**
 * __useGetPrescriptionRequestQuery__
 *
 * To run a query within a React component, call `useGetPrescriptionRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrescriptionRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrescriptionRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrescriptionRequestQuery(baseOptions: Apollo.QueryHookOptions<GetPrescriptionRequestQuery, GetPrescriptionRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrescriptionRequestQuery, GetPrescriptionRequestQueryVariables>(GetPrescriptionRequestDocument, options);
      }
export function useGetPrescriptionRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrescriptionRequestQuery, GetPrescriptionRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrescriptionRequestQuery, GetPrescriptionRequestQueryVariables>(GetPrescriptionRequestDocument, options);
        }
export type GetPrescriptionRequestQueryHookResult = ReturnType<typeof useGetPrescriptionRequestQuery>;
export type GetPrescriptionRequestLazyQueryHookResult = ReturnType<typeof useGetPrescriptionRequestLazyQuery>;
export type GetPrescriptionRequestQueryResult = Apollo.QueryResult<GetPrescriptionRequestQuery, GetPrescriptionRequestQueryVariables>;
export const GetPrescriptionRequestsForPatientDocument = gql`
    query getPrescriptionRequestsForPatient($patientId: ID!) {
  getPrescriptionRequestsForPatient(patientId: $patientId) {
    ...PrescriptionRequestFields
  }
}
    ${PrescriptionRequestFieldsFragmentDoc}`;

/**
 * __useGetPrescriptionRequestsForPatientQuery__
 *
 * To run a query within a React component, call `useGetPrescriptionRequestsForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrescriptionRequestsForPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrescriptionRequestsForPatientQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPrescriptionRequestsForPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPrescriptionRequestsForPatientQuery, GetPrescriptionRequestsForPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrescriptionRequestsForPatientQuery, GetPrescriptionRequestsForPatientQueryVariables>(GetPrescriptionRequestsForPatientDocument, options);
      }
export function useGetPrescriptionRequestsForPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrescriptionRequestsForPatientQuery, GetPrescriptionRequestsForPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrescriptionRequestsForPatientQuery, GetPrescriptionRequestsForPatientQueryVariables>(GetPrescriptionRequestsForPatientDocument, options);
        }
export type GetPrescriptionRequestsForPatientQueryHookResult = ReturnType<typeof useGetPrescriptionRequestsForPatientQuery>;
export type GetPrescriptionRequestsForPatientLazyQueryHookResult = ReturnType<typeof useGetPrescriptionRequestsForPatientLazyQuery>;
export type GetPrescriptionRequestsForPatientQueryResult = Apollo.QueryResult<GetPrescriptionRequestsForPatientQuery, GetPrescriptionRequestsForPatientQueryVariables>;
export const GetPrescriptionRequestsForClinicDocument = gql`
    query getPrescriptionRequestsForClinic($clinicId: ID!) {
  getPrescriptionRequestsForClinic(clinicId: $clinicId) {
    ...PrescriptionRequestFields
  }
}
    ${PrescriptionRequestFieldsFragmentDoc}`;

/**
 * __useGetPrescriptionRequestsForClinicQuery__
 *
 * To run a query within a React component, call `useGetPrescriptionRequestsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrescriptionRequestsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrescriptionRequestsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetPrescriptionRequestsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetPrescriptionRequestsForClinicQuery, GetPrescriptionRequestsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrescriptionRequestsForClinicQuery, GetPrescriptionRequestsForClinicQueryVariables>(GetPrescriptionRequestsForClinicDocument, options);
      }
export function useGetPrescriptionRequestsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrescriptionRequestsForClinicQuery, GetPrescriptionRequestsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrescriptionRequestsForClinicQuery, GetPrescriptionRequestsForClinicQueryVariables>(GetPrescriptionRequestsForClinicDocument, options);
        }
export type GetPrescriptionRequestsForClinicQueryHookResult = ReturnType<typeof useGetPrescriptionRequestsForClinicQuery>;
export type GetPrescriptionRequestsForClinicLazyQueryHookResult = ReturnType<typeof useGetPrescriptionRequestsForClinicLazyQuery>;
export type GetPrescriptionRequestsForClinicQueryResult = Apollo.QueryResult<GetPrescriptionRequestsForClinicQuery, GetPrescriptionRequestsForClinicQueryVariables>;
export const CreatePrescriptionRequestDocument = gql`
    mutation createPrescriptionRequest($data: CreatePrescriptionRequestInput!) {
  createPrescriptionRequest(data: $data) {
    ...PrescriptionRequestFields
  }
}
    ${PrescriptionRequestFieldsFragmentDoc}`;
export type CreatePrescriptionRequestMutationFn = Apollo.MutationFunction<CreatePrescriptionRequestMutation, CreatePrescriptionRequestMutationVariables>;

/**
 * __useCreatePrescriptionRequestMutation__
 *
 * To run a mutation, you first call `useCreatePrescriptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrescriptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrescriptionRequestMutation, { data, loading, error }] = useCreatePrescriptionRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePrescriptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrescriptionRequestMutation, CreatePrescriptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrescriptionRequestMutation, CreatePrescriptionRequestMutationVariables>(CreatePrescriptionRequestDocument, options);
      }
export type CreatePrescriptionRequestMutationHookResult = ReturnType<typeof useCreatePrescriptionRequestMutation>;
export type CreatePrescriptionRequestMutationResult = Apollo.MutationResult<CreatePrescriptionRequestMutation>;
export type CreatePrescriptionRequestMutationOptions = Apollo.BaseMutationOptions<CreatePrescriptionRequestMutation, CreatePrescriptionRequestMutationVariables>;
export const UpdatePrescriptionRequestDocument = gql`
    mutation updatePrescriptionRequest($id: ID!, $data: UpdatePrescriptionRequestInput!) {
  updatePrescriptionRequest(id: $id, data: $data) {
    ...PrescriptionRequestFields
  }
}
    ${PrescriptionRequestFieldsFragmentDoc}`;
export type UpdatePrescriptionRequestMutationFn = Apollo.MutationFunction<UpdatePrescriptionRequestMutation, UpdatePrescriptionRequestMutationVariables>;

/**
 * __useUpdatePrescriptionRequestMutation__
 *
 * To run a mutation, you first call `useUpdatePrescriptionRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrescriptionRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrescriptionRequestMutation, { data, loading, error }] = useUpdatePrescriptionRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePrescriptionRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrescriptionRequestMutation, UpdatePrescriptionRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrescriptionRequestMutation, UpdatePrescriptionRequestMutationVariables>(UpdatePrescriptionRequestDocument, options);
      }
export type UpdatePrescriptionRequestMutationHookResult = ReturnType<typeof useUpdatePrescriptionRequestMutation>;
export type UpdatePrescriptionRequestMutationResult = Apollo.MutationResult<UpdatePrescriptionRequestMutation>;
export type UpdatePrescriptionRequestMutationOptions = Apollo.BaseMutationOptions<UpdatePrescriptionRequestMutation, UpdatePrescriptionRequestMutationVariables>;
export const GetAllPressItemsDocument = gql`
    query getAllPressItems {
  allPressItems {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;

/**
 * __useGetAllPressItemsQuery__
 *
 * To run a query within a React component, call `useGetAllPressItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPressItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPressItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPressItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPressItemsQuery, GetAllPressItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPressItemsQuery, GetAllPressItemsQueryVariables>(GetAllPressItemsDocument, options);
      }
export function useGetAllPressItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPressItemsQuery, GetAllPressItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPressItemsQuery, GetAllPressItemsQueryVariables>(GetAllPressItemsDocument, options);
        }
export type GetAllPressItemsQueryHookResult = ReturnType<typeof useGetAllPressItemsQuery>;
export type GetAllPressItemsLazyQueryHookResult = ReturnType<typeof useGetAllPressItemsLazyQuery>;
export type GetAllPressItemsQueryResult = Apollo.QueryResult<GetAllPressItemsQuery, GetAllPressItemsQueryVariables>;
export const GetPressItemDocument = gql`
    query getPressItem($id: ID!) {
  pressItem(id: $id) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;

/**
 * __useGetPressItemQuery__
 *
 * To run a query within a React component, call `useGetPressItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPressItemQuery(baseOptions: Apollo.QueryHookOptions<GetPressItemQuery, GetPressItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressItemQuery, GetPressItemQueryVariables>(GetPressItemDocument, options);
      }
export function useGetPressItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressItemQuery, GetPressItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressItemQuery, GetPressItemQueryVariables>(GetPressItemDocument, options);
        }
export type GetPressItemQueryHookResult = ReturnType<typeof useGetPressItemQuery>;
export type GetPressItemLazyQueryHookResult = ReturnType<typeof useGetPressItemLazyQuery>;
export type GetPressItemQueryResult = Apollo.QueryResult<GetPressItemQuery, GetPressItemQueryVariables>;
export const CreatePressItemDocument = gql`
    mutation createPressItem($data: CreatePressItemInput!) {
  createPressItem(data: $data) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;
export type CreatePressItemMutationFn = Apollo.MutationFunction<CreatePressItemMutation, CreatePressItemMutationVariables>;

/**
 * __useCreatePressItemMutation__
 *
 * To run a mutation, you first call `useCreatePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPressItemMutation, { data, loading, error }] = useCreatePressItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePressItemMutation(baseOptions?: Apollo.MutationHookOptions<CreatePressItemMutation, CreatePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePressItemMutation, CreatePressItemMutationVariables>(CreatePressItemDocument, options);
      }
export type CreatePressItemMutationHookResult = ReturnType<typeof useCreatePressItemMutation>;
export type CreatePressItemMutationResult = Apollo.MutationResult<CreatePressItemMutation>;
export type CreatePressItemMutationOptions = Apollo.BaseMutationOptions<CreatePressItemMutation, CreatePressItemMutationVariables>;
export const UpdatePressItemDocument = gql`
    mutation updatePressItem($id: ID!, $data: UpdatePressItemInput!) {
  updatePressItem(id: $id, data: $data) {
    ...PressItemFields
  }
}
    ${PressItemFieldsFragmentDoc}`;
export type UpdatePressItemMutationFn = Apollo.MutationFunction<UpdatePressItemMutation, UpdatePressItemMutationVariables>;

/**
 * __useUpdatePressItemMutation__
 *
 * To run a mutation, you first call `useUpdatePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePressItemMutation, { data, loading, error }] = useUpdatePressItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePressItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePressItemMutation, UpdatePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePressItemMutation, UpdatePressItemMutationVariables>(UpdatePressItemDocument, options);
      }
export type UpdatePressItemMutationHookResult = ReturnType<typeof useUpdatePressItemMutation>;
export type UpdatePressItemMutationResult = Apollo.MutationResult<UpdatePressItemMutation>;
export type UpdatePressItemMutationOptions = Apollo.BaseMutationOptions<UpdatePressItemMutation, UpdatePressItemMutationVariables>;
export const DeletePressItemDocument = gql`
    mutation deletePressItem($id: ID!) {
  deletePressItem(id: $id)
}
    `;
export type DeletePressItemMutationFn = Apollo.MutationFunction<DeletePressItemMutation, DeletePressItemMutationVariables>;

/**
 * __useDeletePressItemMutation__
 *
 * To run a mutation, you first call `useDeletePressItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePressItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePressItemMutation, { data, loading, error }] = useDeletePressItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePressItemMutation(baseOptions?: Apollo.MutationHookOptions<DeletePressItemMutation, DeletePressItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePressItemMutation, DeletePressItemMutationVariables>(DeletePressItemDocument, options);
      }
export type DeletePressItemMutationHookResult = ReturnType<typeof useDeletePressItemMutation>;
export type DeletePressItemMutationResult = Apollo.MutationResult<DeletePressItemMutation>;
export type DeletePressItemMutationOptions = Apollo.BaseMutationOptions<DeletePressItemMutation, DeletePressItemMutationVariables>;
export const QueryProductsDocument = gql`
    query queryProducts($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryProducts(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useQueryProductsQuery__
 *
 * To run a query within a React component, call `useQueryProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryProductsQuery(baseOptions?: Apollo.QueryHookOptions<QueryProductsQuery, QueryProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProductsQuery, QueryProductsQueryVariables>(QueryProductsDocument, options);
      }
export function useQueryProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProductsQuery, QueryProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProductsQuery, QueryProductsQueryVariables>(QueryProductsDocument, options);
        }
export type QueryProductsQueryHookResult = ReturnType<typeof useQueryProductsQuery>;
export type QueryProductsLazyQueryHookResult = ReturnType<typeof useQueryProductsLazyQuery>;
export type QueryProductsQueryResult = Apollo.QueryResult<QueryProductsQuery, QueryProductsQueryVariables>;
export const TriggerSyncForClinicDocument = gql`
    mutation triggerSyncForClinic($clinicId: ID!, $isFullSync: Boolean!) {
  triggerSyncForClinic(clinicId: $clinicId, isFullSync: $isFullSync)
}
    `;
export type TriggerSyncForClinicMutationFn = Apollo.MutationFunction<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>;

/**
 * __useTriggerSyncForClinicMutation__
 *
 * To run a mutation, you first call `useTriggerSyncForClinicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSyncForClinicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSyncForClinicMutation, { data, loading, error }] = useTriggerSyncForClinicMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      isFullSync: // value for 'isFullSync'
 *   },
 * });
 */
export function useTriggerSyncForClinicMutation(baseOptions?: Apollo.MutationHookOptions<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>(TriggerSyncForClinicDocument, options);
      }
export type TriggerSyncForClinicMutationHookResult = ReturnType<typeof useTriggerSyncForClinicMutation>;
export type TriggerSyncForClinicMutationResult = Apollo.MutationResult<TriggerSyncForClinicMutation>;
export type TriggerSyncForClinicMutationOptions = Apollo.BaseMutationOptions<TriggerSyncForClinicMutation, TriggerSyncForClinicMutationVariables>;
export const QueryReschedulesDocument = gql`
    query queryReschedules($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReschedules(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;

/**
 * __useQueryReschedulesQuery__
 *
 * To run a query within a React component, call `useQueryReschedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReschedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReschedulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReschedulesQuery(baseOptions?: Apollo.QueryHookOptions<QueryReschedulesQuery, QueryReschedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReschedulesQuery, QueryReschedulesQueryVariables>(QueryReschedulesDocument, options);
      }
export function useQueryReschedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReschedulesQuery, QueryReschedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReschedulesQuery, QueryReschedulesQueryVariables>(QueryReschedulesDocument, options);
        }
export type QueryReschedulesQueryHookResult = ReturnType<typeof useQueryReschedulesQuery>;
export type QueryReschedulesLazyQueryHookResult = ReturnType<typeof useQueryReschedulesLazyQuery>;
export type QueryReschedulesQueryResult = Apollo.QueryResult<QueryReschedulesQuery, QueryReschedulesQueryVariables>;
export const UpdateRescheduleDocument = gql`
    mutation updateReschedule($id: ID!, $data: UpdateRescheduleInput!) {
  updateReschedule(id: $id, data: $data) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;
export type UpdateRescheduleMutationFn = Apollo.MutationFunction<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>;

/**
 * __useUpdateRescheduleMutation__
 *
 * To run a mutation, you first call `useUpdateRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRescheduleMutation, { data, loading, error }] = useUpdateRescheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>(UpdateRescheduleDocument, options);
      }
export type UpdateRescheduleMutationHookResult = ReturnType<typeof useUpdateRescheduleMutation>;
export type UpdateRescheduleMutationResult = Apollo.MutationResult<UpdateRescheduleMutation>;
export type UpdateRescheduleMutationOptions = Apollo.BaseMutationOptions<UpdateRescheduleMutation, UpdateRescheduleMutationVariables>;
export const ApproveRescheduleDocument = gql`
    mutation approveReschedule($id: ID!) {
  approveReschedule(id: $id) {
    ...RescheduleFields
  }
}
    ${RescheduleFieldsFragmentDoc}`;
export type ApproveRescheduleMutationFn = Apollo.MutationFunction<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>;

/**
 * __useApproveRescheduleMutation__
 *
 * To run a mutation, you first call `useApproveRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRescheduleMutation, { data, loading, error }] = useApproveRescheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>(ApproveRescheduleDocument, options);
      }
export type ApproveRescheduleMutationHookResult = ReturnType<typeof useApproveRescheduleMutation>;
export type ApproveRescheduleMutationResult = Apollo.MutationResult<ApproveRescheduleMutation>;
export type ApproveRescheduleMutationOptions = Apollo.BaseMutationOptions<ApproveRescheduleMutation, ApproveRescheduleMutationVariables>;
export const GetReviewsForClinicDocument = gql`
    query getReviewsForClinic($clinicId: ID!) {
  getReviewsForClinic(clinicId: $clinicId) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`;

/**
 * __useGetReviewsForClinicQuery__
 *
 * To run a query within a React component, call `useGetReviewsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetReviewsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>(GetReviewsForClinicDocument, options);
      }
export function useGetReviewsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>(GetReviewsForClinicDocument, options);
        }
export type GetReviewsForClinicQueryHookResult = ReturnType<typeof useGetReviewsForClinicQuery>;
export type GetReviewsForClinicLazyQueryHookResult = ReturnType<typeof useGetReviewsForClinicLazyQuery>;
export type GetReviewsForClinicQueryResult = Apollo.QueryResult<GetReviewsForClinicQuery, GetReviewsForClinicQueryVariables>;
export const QueryReviewsDocument = gql`
    query queryReviews($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryReviews(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...ReviewFields
  }
}
    ${ReviewFieldsFragmentDoc}`;

/**
 * __useQueryReviewsQuery__
 *
 * To run a query within a React component, call `useQueryReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryReviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryReviewsQuery(baseOptions?: Apollo.QueryHookOptions<QueryReviewsQuery, QueryReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryReviewsQuery, QueryReviewsQueryVariables>(QueryReviewsDocument, options);
      }
export function useQueryReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryReviewsQuery, QueryReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryReviewsQuery, QueryReviewsQueryVariables>(QueryReviewsDocument, options);
        }
export type QueryReviewsQueryHookResult = ReturnType<typeof useQueryReviewsQuery>;
export type QueryReviewsLazyQueryHookResult = ReturnType<typeof useQueryReviewsLazyQuery>;
export type QueryReviewsQueryResult = Apollo.QueryResult<QueryReviewsQuery, QueryReviewsQueryVariables>;
export const GetAverageRatingForRecentReviewsDocument = gql`
    query getAverageRatingForRecentReviews($clinicId: ID!, $maxCount: PositiveInt) {
  getAverageRatingForRecentReviews(clinicId: $clinicId, maxCount: $maxCount) {
    count
    total
  }
}
    `;

/**
 * __useGetAverageRatingForRecentReviewsQuery__
 *
 * To run a query within a React component, call `useGetAverageRatingForRecentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageRatingForRecentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageRatingForRecentReviewsQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      maxCount: // value for 'maxCount'
 *   },
 * });
 */
export function useGetAverageRatingForRecentReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>(GetAverageRatingForRecentReviewsDocument, options);
      }
export function useGetAverageRatingForRecentReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>(GetAverageRatingForRecentReviewsDocument, options);
        }
export type GetAverageRatingForRecentReviewsQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsQuery>;
export type GetAverageRatingForRecentReviewsLazyQueryHookResult = ReturnType<typeof useGetAverageRatingForRecentReviewsLazyQuery>;
export type GetAverageRatingForRecentReviewsQueryResult = Apollo.QueryResult<GetAverageRatingForRecentReviewsQuery, GetAverageRatingForRecentReviewsQueryVariables>;
export const CountReviewsDocument = gql`
    query countReviews($where: [QueryInput!]) {
  countReviews(where: $where)
}
    `;

/**
 * __useCountReviewsQuery__
 *
 * To run a query within a React component, call `useCountReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountReviewsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountReviewsQuery(baseOptions?: Apollo.QueryHookOptions<CountReviewsQuery, CountReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountReviewsQuery, CountReviewsQueryVariables>(CountReviewsDocument, options);
      }
export function useCountReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountReviewsQuery, CountReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountReviewsQuery, CountReviewsQueryVariables>(CountReviewsDocument, options);
        }
export type CountReviewsQueryHookResult = ReturnType<typeof useCountReviewsQuery>;
export type CountReviewsLazyQueryHookResult = ReturnType<typeof useCountReviewsLazyQuery>;
export type CountReviewsQueryResult = Apollo.QueryResult<CountReviewsQuery, CountReviewsQueryVariables>;
export const GetRoomDocument = gql`
    query getRoom($roomId: ID!) {
  room(roomId: $roomId) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useGetRoomQuery__
 *
 * To run a query within a React component, call `useGetRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useGetRoomQuery(baseOptions: Apollo.QueryHookOptions<GetRoomQuery, GetRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomQuery, GetRoomQueryVariables>(GetRoomDocument, options);
      }
export function useGetRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomQuery, GetRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomQuery, GetRoomQueryVariables>(GetRoomDocument, options);
        }
export type GetRoomQueryHookResult = ReturnType<typeof useGetRoomQuery>;
export type GetRoomLazyQueryHookResult = ReturnType<typeof useGetRoomLazyQuery>;
export type GetRoomQueryResult = Apollo.QueryResult<GetRoomQuery, GetRoomQueryVariables>;
export const QueryRoomsDocument = gql`
    query queryRooms($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryRooms(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useQueryRoomsQuery__
 *
 * To run a query within a React component, call `useQueryRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryRoomsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryRoomsQuery(baseOptions?: Apollo.QueryHookOptions<QueryRoomsQuery, QueryRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryRoomsQuery, QueryRoomsQueryVariables>(QueryRoomsDocument, options);
      }
export function useQueryRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryRoomsQuery, QueryRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryRoomsQuery, QueryRoomsQueryVariables>(QueryRoomsDocument, options);
        }
export type QueryRoomsQueryHookResult = ReturnType<typeof useQueryRoomsQuery>;
export type QueryRoomsLazyQueryHookResult = ReturnType<typeof useQueryRoomsLazyQuery>;
export type QueryRoomsQueryResult = Apollo.QueryResult<QueryRoomsQuery, QueryRoomsQueryVariables>;
export const CountRoomsDocument = gql`
    query countRooms($where: [QueryInput!]) {
  countRooms(where: $where)
}
    `;

/**
 * __useCountRoomsQuery__
 *
 * To run a query within a React component, call `useCountRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountRoomsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountRoomsQuery(baseOptions?: Apollo.QueryHookOptions<CountRoomsQuery, CountRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountRoomsQuery, CountRoomsQueryVariables>(CountRoomsDocument, options);
      }
export function useCountRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountRoomsQuery, CountRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountRoomsQuery, CountRoomsQueryVariables>(CountRoomsDocument, options);
        }
export type CountRoomsQueryHookResult = ReturnType<typeof useCountRoomsQuery>;
export type CountRoomsLazyQueryHookResult = ReturnType<typeof useCountRoomsLazyQuery>;
export type CountRoomsQueryResult = Apollo.QueryResult<CountRoomsQuery, CountRoomsQueryVariables>;
export const GetRoomsForClinicDocument = gql`
    query getRoomsForClinic($clinicId: ID!) {
  getRoomsByClinic(clinicId: $clinicId) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;

/**
 * __useGetRoomsForClinicQuery__
 *
 * To run a query within a React component, call `useGetRoomsForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomsForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomsForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetRoomsForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>(GetRoomsForClinicDocument, options);
      }
export function useGetRoomsForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>(GetRoomsForClinicDocument, options);
        }
export type GetRoomsForClinicQueryHookResult = ReturnType<typeof useGetRoomsForClinicQuery>;
export type GetRoomsForClinicLazyQueryHookResult = ReturnType<typeof useGetRoomsForClinicLazyQuery>;
export type GetRoomsForClinicQueryResult = Apollo.QueryResult<GetRoomsForClinicQuery, GetRoomsForClinicQueryVariables>;
export const UpdateRoomDocument = gql`
    mutation updateRoom($roomId: ID!, $data: UpdateRoomInput!) {
  updateRoom(roomId: $roomId, data: $data) {
    ...RoomFields
  }
}
    ${RoomFieldsFragmentDoc}`;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const GetSchedulingRuleByClinicAndIdDocument = gql`
    query getSchedulingRuleByClinicAndId($clinicId: ID!, $schedulingRulesId: ID!) {
  schedulingRuleByClinicAndId(
    clinicId: $clinicId
    schedulingRulesId: $schedulingRulesId
  ) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useGetSchedulingRuleByClinicAndIdQuery__
 *
 * To run a query within a React component, call `useGetSchedulingRuleByClinicAndIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingRuleByClinicAndIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingRuleByClinicAndIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *   },
 * });
 */
export function useGetSchedulingRuleByClinicAndIdQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingRuleByClinicAndIdQuery, GetSchedulingRuleByClinicAndIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingRuleByClinicAndIdQuery, GetSchedulingRuleByClinicAndIdQueryVariables>(GetSchedulingRuleByClinicAndIdDocument, options);
      }
export function useGetSchedulingRuleByClinicAndIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingRuleByClinicAndIdQuery, GetSchedulingRuleByClinicAndIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingRuleByClinicAndIdQuery, GetSchedulingRuleByClinicAndIdQueryVariables>(GetSchedulingRuleByClinicAndIdDocument, options);
        }
export type GetSchedulingRuleByClinicAndIdQueryHookResult = ReturnType<typeof useGetSchedulingRuleByClinicAndIdQuery>;
export type GetSchedulingRuleByClinicAndIdLazyQueryHookResult = ReturnType<typeof useGetSchedulingRuleByClinicAndIdLazyQuery>;
export type GetSchedulingRuleByClinicAndIdQueryResult = Apollo.QueryResult<GetSchedulingRuleByClinicAndIdQuery, GetSchedulingRuleByClinicAndIdQueryVariables>;
export const GetSchedulingRulesForClinicDocument = gql`
    query getSchedulingRulesForClinic($clinicId: ID!) {
  schedulingRulesForClinic(clinicId: $clinicId) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;

/**
 * __useGetSchedulingRulesForClinicQuery__
 *
 * To run a query within a React component, call `useGetSchedulingRulesForClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulingRulesForClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulingRulesForClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetSchedulingRulesForClinicQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>(GetSchedulingRulesForClinicDocument, options);
      }
export function useGetSchedulingRulesForClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>(GetSchedulingRulesForClinicDocument, options);
        }
export type GetSchedulingRulesForClinicQueryHookResult = ReturnType<typeof useGetSchedulingRulesForClinicQuery>;
export type GetSchedulingRulesForClinicLazyQueryHookResult = ReturnType<typeof useGetSchedulingRulesForClinicLazyQuery>;
export type GetSchedulingRulesForClinicQueryResult = Apollo.QueryResult<GetSchedulingRulesForClinicQuery, GetSchedulingRulesForClinicQueryVariables>;
export const UpdateSchedulingRulesDocument = gql`
    mutation updateSchedulingRules($data: UpdateSchedulingRulesInput!, $clinicId: ID!, $schedulingRulesId: ID!) {
  updateSchedulingRules(
    data: $data
    clinicId: $clinicId
    schedulingRulesId: $schedulingRulesId
  ) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;
export type UpdateSchedulingRulesMutationFn = Apollo.MutationFunction<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>;

/**
 * __useUpdateSchedulingRulesMutation__
 *
 * To run a mutation, you first call `useUpdateSchedulingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchedulingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchedulingRulesMutation, { data, loading, error }] = useUpdateSchedulingRulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clinicId: // value for 'clinicId'
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *   },
 * });
 */
export function useUpdateSchedulingRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>(UpdateSchedulingRulesDocument, options);
      }
export type UpdateSchedulingRulesMutationHookResult = ReturnType<typeof useUpdateSchedulingRulesMutation>;
export type UpdateSchedulingRulesMutationResult = Apollo.MutationResult<UpdateSchedulingRulesMutation>;
export type UpdateSchedulingRulesMutationOptions = Apollo.BaseMutationOptions<UpdateSchedulingRulesMutation, UpdateSchedulingRulesMutationVariables>;
export const CreateSchedulingRulesDocument = gql`
    mutation createSchedulingRules($data: CreateSchedulingRulesInput!) {
  createSchedulingRules(data: $data) {
    ...SchedulingRulesFields
  }
}
    ${SchedulingRulesFieldsFragmentDoc}`;
export type CreateSchedulingRulesMutationFn = Apollo.MutationFunction<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>;

/**
 * __useCreateSchedulingRulesMutation__
 *
 * To run a mutation, you first call `useCreateSchedulingRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulingRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulingRulesMutation, { data, loading, error }] = useCreateSchedulingRulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSchedulingRulesMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>(CreateSchedulingRulesDocument, options);
      }
export type CreateSchedulingRulesMutationHookResult = ReturnType<typeof useCreateSchedulingRulesMutation>;
export type CreateSchedulingRulesMutationResult = Apollo.MutationResult<CreateSchedulingRulesMutation>;
export type CreateSchedulingRulesMutationOptions = Apollo.BaseMutationOptions<CreateSchedulingRulesMutation, CreateSchedulingRulesMutationVariables>;
export const DeleteSchedulingRuleDocument = gql`
    mutation deleteSchedulingRule($clinicId: ID!, $schedulingRulesId: ID!) {
  deleteSchedulingRules(
    clinicId: $clinicId
    schedulingRulesId: $schedulingRulesId
  )
}
    `;
export type DeleteSchedulingRuleMutationFn = Apollo.MutationFunction<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>;

/**
 * __useDeleteSchedulingRuleMutation__
 *
 * To run a mutation, you first call `useDeleteSchedulingRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchedulingRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchedulingRuleMutation, { data, loading, error }] = useDeleteSchedulingRuleMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      schedulingRulesId: // value for 'schedulingRulesId'
 *   },
 * });
 */
export function useDeleteSchedulingRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>(DeleteSchedulingRuleDocument, options);
      }
export type DeleteSchedulingRuleMutationHookResult = ReturnType<typeof useDeleteSchedulingRuleMutation>;
export type DeleteSchedulingRuleMutationResult = Apollo.MutationResult<DeleteSchedulingRuleMutation>;
export type DeleteSchedulingRuleMutationOptions = Apollo.BaseMutationOptions<DeleteSchedulingRuleMutation, DeleteSchedulingRuleMutationVariables>;
export const GetAllServicesDocument = gql`
    query getAllServices {
  allServices {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useGetAllServicesQuery__
 *
 * To run a query within a React component, call `useGetAllServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllServicesQuery, GetAllServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(GetAllServicesDocument, options);
      }
export function useGetAllServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServicesQuery, GetAllServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(GetAllServicesDocument, options);
        }
export type GetAllServicesQueryHookResult = ReturnType<typeof useGetAllServicesQuery>;
export type GetAllServicesLazyQueryHookResult = ReturnType<typeof useGetAllServicesLazyQuery>;
export type GetAllServicesQueryResult = Apollo.QueryResult<GetAllServicesQuery, GetAllServicesQueryVariables>;
export const GetAllServicesByClinicIdDocument = gql`
    query getAllServicesByClinicId($clinicId: ID!) {
  allServicesByClinicId(id: $clinicId) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useGetAllServicesByClinicIdQuery__
 *
 * To run a query within a React component, call `useGetAllServicesByClinicIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesByClinicIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesByClinicIdQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetAllServicesByClinicIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>(GetAllServicesByClinicIdDocument, options);
      }
export function useGetAllServicesByClinicIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>(GetAllServicesByClinicIdDocument, options);
        }
export type GetAllServicesByClinicIdQueryHookResult = ReturnType<typeof useGetAllServicesByClinicIdQuery>;
export type GetAllServicesByClinicIdLazyQueryHookResult = ReturnType<typeof useGetAllServicesByClinicIdLazyQuery>;
export type GetAllServicesByClinicIdQueryResult = Apollo.QueryResult<GetAllServicesByClinicIdQuery, GetAllServicesByClinicIdQueryVariables>;
export const QueryServicesDocument = gql`
    query queryServices($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryServices(
    where: $where
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useQueryServicesQuery__
 *
 * To run a query within a React component, call `useQueryServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryServicesQuery(baseOptions?: Apollo.QueryHookOptions<QueryServicesQuery, QueryServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryServicesQuery, QueryServicesQueryVariables>(QueryServicesDocument, options);
      }
export function useQueryServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryServicesQuery, QueryServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryServicesQuery, QueryServicesQueryVariables>(QueryServicesDocument, options);
        }
export type QueryServicesQueryHookResult = ReturnType<typeof useQueryServicesQuery>;
export type QueryServicesLazyQueryHookResult = ReturnType<typeof useQueryServicesLazyQuery>;
export type QueryServicesQueryResult = Apollo.QueryResult<QueryServicesQuery, QueryServicesQueryVariables>;
export const CountServicesDocument = gql`
    query countServices($where: [QueryInput!]) {
  countServices(where: $where)
}
    `;

/**
 * __useCountServicesQuery__
 *
 * To run a query within a React component, call `useCountServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountServicesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountServicesQuery(baseOptions?: Apollo.QueryHookOptions<CountServicesQuery, CountServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountServicesQuery, CountServicesQueryVariables>(CountServicesDocument, options);
      }
export function useCountServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountServicesQuery, CountServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountServicesQuery, CountServicesQueryVariables>(CountServicesDocument, options);
        }
export type CountServicesQueryHookResult = ReturnType<typeof useCountServicesQuery>;
export type CountServicesLazyQueryHookResult = ReturnType<typeof useCountServicesLazyQuery>;
export type CountServicesQueryResult = Apollo.QueryResult<CountServicesQuery, CountServicesQueryVariables>;
export const GetServiceDocument = gql`
    query getService($id: ID!) {
  service(id: $id) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceQuery(baseOptions: Apollo.QueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
      }
export function useGetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<typeof useGetServiceLazyQuery>;
export type GetServiceQueryResult = Apollo.QueryResult<GetServiceQuery, GetServiceQueryVariables>;
export const PaymentIntentFromServiceDocument = gql`
    query paymentIntentFromService($clinicId: ID!, $serviceId: ID!, $customerInfo: CustomerInfoInput!) {
  paymentIntentFromService(
    clinicId: $clinicId
    serviceId: $serviceId
    customerInfo: $customerInfo
  ) {
    id
    amount
    client_secret
  }
}
    `;

/**
 * __usePaymentIntentFromServiceQuery__
 *
 * To run a query within a React component, call `usePaymentIntentFromServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentIntentFromServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentIntentFromServiceQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      serviceId: // value for 'serviceId'
 *      customerInfo: // value for 'customerInfo'
 *   },
 * });
 */
export function usePaymentIntentFromServiceQuery(baseOptions: Apollo.QueryHookOptions<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>(PaymentIntentFromServiceDocument, options);
      }
export function usePaymentIntentFromServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>(PaymentIntentFromServiceDocument, options);
        }
export type PaymentIntentFromServiceQueryHookResult = ReturnType<typeof usePaymentIntentFromServiceQuery>;
export type PaymentIntentFromServiceLazyQueryHookResult = ReturnType<typeof usePaymentIntentFromServiceLazyQuery>;
export type PaymentIntentFromServiceQueryResult = Apollo.QueryResult<PaymentIntentFromServiceQuery, PaymentIntentFromServiceQueryVariables>;
export const CreateServiceDocument = gql`
    mutation createService($data: CreateServiceInput!) {
  createService(data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const CreateClinicServiceDocument = gql`
    mutation createClinicService($clinicId: ID!, $data: CreateServiceInput!) {
  createClinicService(clinicId: $clinicId, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type CreateClinicServiceMutationFn = Apollo.MutationFunction<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>;

/**
 * __useCreateClinicServiceMutation__
 *
 * To run a mutation, you first call `useCreateClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicServiceMutation, { data, loading, error }] = useCreateClinicServiceMutation({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>(CreateClinicServiceDocument, options);
      }
export type CreateClinicServiceMutationHookResult = ReturnType<typeof useCreateClinicServiceMutation>;
export type CreateClinicServiceMutationResult = Apollo.MutationResult<CreateClinicServiceMutation>;
export type CreateClinicServiceMutationOptions = Apollo.BaseMutationOptions<CreateClinicServiceMutation, CreateClinicServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation updateService($id: ID!, $data: UpdateServiceInput!) {
  updateService(id: $id, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const UpdateClinicServiceDocument = gql`
    mutation updateClinicService($serviceId: ID!, $clinicId: ID!, $data: UpdateServiceInput!) {
  updateClinicService(id: $serviceId, clinicId: $clinicId, data: $data) {
    ...ServiceFields
  }
}
    ${ServiceFieldsFragmentDoc}`;
export type UpdateClinicServiceMutationFn = Apollo.MutationFunction<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>;

/**
 * __useUpdateClinicServiceMutation__
 *
 * To run a mutation, you first call `useUpdateClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicServiceMutation, { data, loading, error }] = useUpdateClinicServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>(UpdateClinicServiceDocument, options);
      }
export type UpdateClinicServiceMutationHookResult = ReturnType<typeof useUpdateClinicServiceMutation>;
export type UpdateClinicServiceMutationResult = Apollo.MutationResult<UpdateClinicServiceMutation>;
export type UpdateClinicServiceMutationOptions = Apollo.BaseMutationOptions<UpdateClinicServiceMutation, UpdateClinicServiceMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation deleteService($id: ID!) {
  deleteService(id: $id)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const DeleteClinicServiceDocument = gql`
    mutation deleteClinicService($serviceId: ID!, $clinicId: ID!) {
  deleteClinicService(id: $serviceId, clinicId: $clinicId)
}
    `;
export type DeleteClinicServiceMutationFn = Apollo.MutationFunction<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>;

/**
 * __useDeleteClinicServiceMutation__
 *
 * To run a mutation, you first call `useDeleteClinicServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicServiceMutation, { data, loading, error }] = useDeleteClinicServiceMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useDeleteClinicServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>(DeleteClinicServiceDocument, options);
      }
export type DeleteClinicServiceMutationHookResult = ReturnType<typeof useDeleteClinicServiceMutation>;
export type DeleteClinicServiceMutationResult = Apollo.MutationResult<DeleteClinicServiceMutation>;
export type DeleteClinicServiceMutationOptions = Apollo.BaseMutationOptions<DeleteClinicServiceMutation, DeleteClinicServiceMutationVariables>;
export const GetTransactionsByClinicAndRangeDocument = gql`
    query getTransactionsByClinicAndRange($clinicId: ID!, $pms: PracticeManagementSystem, $start_time: NonNegativeInt!, $end_time: NonNegativeInt!) {
  getTransactionsByClinicAndRange(
    clinicId: $clinicId
    pms: $pms
    start_time: $start_time
    end_time: $end_time
  ) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useGetTransactionsByClinicAndRangeQuery__
 *
 * To run a query within a React component, call `useGetTransactionsByClinicAndRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsByClinicAndRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsByClinicAndRangeQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      pms: // value for 'pms'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *   },
 * });
 */
export function useGetTransactionsByClinicAndRangeQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>(GetTransactionsByClinicAndRangeDocument, options);
      }
export function useGetTransactionsByClinicAndRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>(GetTransactionsByClinicAndRangeDocument, options);
        }
export type GetTransactionsByClinicAndRangeQueryHookResult = ReturnType<typeof useGetTransactionsByClinicAndRangeQuery>;
export type GetTransactionsByClinicAndRangeLazyQueryHookResult = ReturnType<typeof useGetTransactionsByClinicAndRangeLazyQuery>;
export type GetTransactionsByClinicAndRangeQueryResult = Apollo.QueryResult<GetTransactionsByClinicAndRangeQuery, GetTransactionsByClinicAndRangeQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  user(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($roles: [AuthRoles!], $limit: NonNegativeInt, $startAtId: String) {
  searchUsers(roles: $roles, limit: $limit, startAtId: $startAtId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *      limit: // value for 'limit'
 *      startAtId: // value for 'startAtId'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const QueryUsersDocument = gql`
    query queryUsers($where: [QueryInput!], $page: NonNegativeInt, $pageSize: NonNegativeInt, $orderBy: OrderByInput) {
  queryUsers(where: $where, page: $page, pageSize: $pageSize, orderBy: $orderBy) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useQueryUsersQuery__
 *
 * To run a query within a React component, call `useQueryUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useQueryUsersQuery(baseOptions?: Apollo.QueryHookOptions<QueryUsersQuery, QueryUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryUsersQuery, QueryUsersQueryVariables>(QueryUsersDocument, options);
      }
export function useQueryUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryUsersQuery, QueryUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryUsersQuery, QueryUsersQueryVariables>(QueryUsersDocument, options);
        }
export type QueryUsersQueryHookResult = ReturnType<typeof useQueryUsersQuery>;
export type QueryUsersLazyQueryHookResult = ReturnType<typeof useQueryUsersLazyQuery>;
export type QueryUsersQueryResult = Apollo.QueryResult<QueryUsersQuery, QueryUsersQueryVariables>;
export const CountUsersDocument = gql`
    query countUsers($where: [QueryInput!]) {
  countUsers(where: $where)
}
    `;

/**
 * __useCountUsersQuery__
 *
 * To run a query within a React component, call `useCountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountUsersQuery(baseOptions?: Apollo.QueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
      }
export function useCountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUsersQuery, CountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUsersQuery, CountUsersQueryVariables>(CountUsersDocument, options);
        }
export type CountUsersQueryHookResult = ReturnType<typeof useCountUsersQuery>;
export type CountUsersLazyQueryHookResult = ReturnType<typeof useCountUsersLazyQuery>;
export type CountUsersQueryResult = Apollo.QueryResult<CountUsersQuery, CountUsersQueryVariables>;
export const CheckForUserByEmailDocument = gql`
    query checkForUserByEmail($email: String!) {
  checkForUserByEmail(email: $email) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCheckForUserByEmailQuery__
 *
 * To run a query within a React component, call `useCheckForUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckForUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>(CheckForUserByEmailDocument, options);
      }
export function useCheckForUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>(CheckForUserByEmailDocument, options);
        }
export type CheckForUserByEmailQueryHookResult = ReturnType<typeof useCheckForUserByEmailQuery>;
export type CheckForUserByEmailLazyQueryHookResult = ReturnType<typeof useCheckForUserByEmailLazyQuery>;
export type CheckForUserByEmailQueryResult = Apollo.QueryResult<CheckForUserByEmailQuery, CheckForUserByEmailQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $password: String!, $data: CreateUserInput!, $role: String) {
  createUser(email: $email, password: $password, data: $data, role: $role) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      data: // value for 'data'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($updateUserId: ID!, $data: UpdateUserInput!) {
  updateUser(id: $updateUserId, data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserId: // value for 'updateUserId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const StripeAccountOnboardLinkDocument = gql`
    query stripeAccountOnboardLink($clinicId: ID!, $data: AccountOnboardLinkInput!) {
  stripeAccountOnboardLink(clinicId: $clinicId, data: $data)
}
    `;

/**
 * __useStripeAccountOnboardLinkQuery__
 *
 * To run a query within a React component, call `useStripeAccountOnboardLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountOnboardLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccountOnboardLinkQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStripeAccountOnboardLinkQuery(baseOptions: Apollo.QueryHookOptions<StripeAccountOnboardLinkQuery, StripeAccountOnboardLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeAccountOnboardLinkQuery, StripeAccountOnboardLinkQueryVariables>(StripeAccountOnboardLinkDocument, options);
      }
export function useStripeAccountOnboardLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeAccountOnboardLinkQuery, StripeAccountOnboardLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeAccountOnboardLinkQuery, StripeAccountOnboardLinkQueryVariables>(StripeAccountOnboardLinkDocument, options);
        }
export type StripeAccountOnboardLinkQueryHookResult = ReturnType<typeof useStripeAccountOnboardLinkQuery>;
export type StripeAccountOnboardLinkLazyQueryHookResult = ReturnType<typeof useStripeAccountOnboardLinkLazyQuery>;
export type StripeAccountOnboardLinkQueryResult = Apollo.QueryResult<StripeAccountOnboardLinkQuery, StripeAccountOnboardLinkQueryVariables>;
export const StripeAccountLoginLinkDocument = gql`
    query stripeAccountLoginLink($clinicId: ID!) {
  stripeAccountLoginLink(clinicId: $clinicId)
}
    `;

/**
 * __useStripeAccountLoginLinkQuery__
 *
 * To run a query within a React component, call `useStripeAccountLoginLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountLoginLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccountLoginLinkQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useStripeAccountLoginLinkQuery(baseOptions: Apollo.QueryHookOptions<StripeAccountLoginLinkQuery, StripeAccountLoginLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeAccountLoginLinkQuery, StripeAccountLoginLinkQueryVariables>(StripeAccountLoginLinkDocument, options);
      }
export function useStripeAccountLoginLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeAccountLoginLinkQuery, StripeAccountLoginLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeAccountLoginLinkQuery, StripeAccountLoginLinkQueryVariables>(StripeAccountLoginLinkDocument, options);
        }
export type StripeAccountLoginLinkQueryHookResult = ReturnType<typeof useStripeAccountLoginLinkQuery>;
export type StripeAccountLoginLinkLazyQueryHookResult = ReturnType<typeof useStripeAccountLoginLinkLazyQuery>;
export type StripeAccountLoginLinkQueryResult = Apollo.QueryResult<StripeAccountLoginLinkQuery, StripeAccountLoginLinkQueryVariables>;
export const StripeAccountCheckDocument = gql`
    query stripeAccountCheck($clinicId: ID!) {
  stripeAccountCheck(clinicId: $clinicId)
}
    `;

/**
 * __useStripeAccountCheckQuery__
 *
 * To run a query within a React component, call `useStripeAccountCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccountCheckQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useStripeAccountCheckQuery(baseOptions: Apollo.QueryHookOptions<StripeAccountCheckQuery, StripeAccountCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeAccountCheckQuery, StripeAccountCheckQueryVariables>(StripeAccountCheckDocument, options);
      }
export function useStripeAccountCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeAccountCheckQuery, StripeAccountCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeAccountCheckQuery, StripeAccountCheckQueryVariables>(StripeAccountCheckDocument, options);
        }
export type StripeAccountCheckQueryHookResult = ReturnType<typeof useStripeAccountCheckQuery>;
export type StripeAccountCheckLazyQueryHookResult = ReturnType<typeof useStripeAccountCheckLazyQuery>;
export type StripeAccountCheckQueryResult = Apollo.QueryResult<StripeAccountCheckQuery, StripeAccountCheckQueryVariables>;
export const GetWidgetDocument = gql`
    query getWidget($id: ID!) {
  widget(id: $id) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetQuery__
 *
 * To run a query within a React component, call `useGetWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetQuery, GetWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetQuery, GetWidgetQueryVariables>(GetWidgetDocument, options);
      }
export function useGetWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetQuery, GetWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetQuery, GetWidgetQueryVariables>(GetWidgetDocument, options);
        }
export type GetWidgetQueryHookResult = ReturnType<typeof useGetWidgetQuery>;
export type GetWidgetLazyQueryHookResult = ReturnType<typeof useGetWidgetLazyQuery>;
export type GetWidgetQueryResult = Apollo.QueryResult<GetWidgetQuery, GetWidgetQueryVariables>;
export const GetWidgetsByClinicDocument = gql`
    query getWidgetsByClinic($clinicId: ID!) {
  getWidgetsByClinic(clinicId: $clinicId) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetsByClinicQuery__
 *
 * To run a query within a React component, call `useGetWidgetsByClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetsByClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetsByClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetWidgetsByClinicQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>(GetWidgetsByClinicDocument, options);
      }
export function useGetWidgetsByClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>(GetWidgetsByClinicDocument, options);
        }
export type GetWidgetsByClinicQueryHookResult = ReturnType<typeof useGetWidgetsByClinicQuery>;
export type GetWidgetsByClinicLazyQueryHookResult = ReturnType<typeof useGetWidgetsByClinicLazyQuery>;
export type GetWidgetsByClinicQueryResult = Apollo.QueryResult<GetWidgetsByClinicQuery, GetWidgetsByClinicQueryVariables>;
export const GetWidgetsByOrganizationDocument = gql`
    query getWidgetsByOrganization($organizationId: ID!) {
  getWidgetsByOrganization(organizationId: $organizationId) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetWidgetsByOrganizationQuery__
 *
 * To run a query within a React component, call `useGetWidgetsByOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetsByOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetsByOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWidgetsByOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>(GetWidgetsByOrganizationDocument, options);
      }
export function useGetWidgetsByOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>(GetWidgetsByOrganizationDocument, options);
        }
export type GetWidgetsByOrganizationQueryHookResult = ReturnType<typeof useGetWidgetsByOrganizationQuery>;
export type GetWidgetsByOrganizationLazyQueryHookResult = ReturnType<typeof useGetWidgetsByOrganizationLazyQuery>;
export type GetWidgetsByOrganizationQueryResult = Apollo.QueryResult<GetWidgetsByOrganizationQuery, GetWidgetsByOrganizationQueryVariables>;
export const GetAllWidgetsDocument = gql`
    query getAllWidgets {
  allWidgets {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;

/**
 * __useGetAllWidgetsQuery__
 *
 * To run a query within a React component, call `useGetAllWidgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWidgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWidgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWidgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllWidgetsQuery, GetAllWidgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllWidgetsQuery, GetAllWidgetsQueryVariables>(GetAllWidgetsDocument, options);
      }
export function useGetAllWidgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllWidgetsQuery, GetAllWidgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllWidgetsQuery, GetAllWidgetsQueryVariables>(GetAllWidgetsDocument, options);
        }
export type GetAllWidgetsQueryHookResult = ReturnType<typeof useGetAllWidgetsQuery>;
export type GetAllWidgetsLazyQueryHookResult = ReturnType<typeof useGetAllWidgetsLazyQuery>;
export type GetAllWidgetsQueryResult = Apollo.QueryResult<GetAllWidgetsQuery, GetAllWidgetsQueryVariables>;
export const GetAppointmentCountByWidgetSourceDocument = gql`
    query getAppointmentCountByWidgetSource($widgetSource: String!) {
  getAppointmentCountByWidgetSource(widgetSource: $widgetSource)
}
    `;

/**
 * __useGetAppointmentCountByWidgetSourceQuery__
 *
 * To run a query within a React component, call `useGetAppointmentCountByWidgetSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentCountByWidgetSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentCountByWidgetSourceQuery({
 *   variables: {
 *      widgetSource: // value for 'widgetSource'
 *   },
 * });
 */
export function useGetAppointmentCountByWidgetSourceQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>(GetAppointmentCountByWidgetSourceDocument, options);
      }
export function useGetAppointmentCountByWidgetSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>(GetAppointmentCountByWidgetSourceDocument, options);
        }
export type GetAppointmentCountByWidgetSourceQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetSourceQuery>;
export type GetAppointmentCountByWidgetSourceLazyQueryHookResult = ReturnType<typeof useGetAppointmentCountByWidgetSourceLazyQuery>;
export type GetAppointmentCountByWidgetSourceQueryResult = Apollo.QueryResult<GetAppointmentCountByWidgetSourceQuery, GetAppointmentCountByWidgetSourceQueryVariables>;
export const CreateWidgetDocument = gql`
    mutation createWidget($data: CreateWidgetInput!) {
  createWidget(data: $data) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;
export type CreateWidgetMutationFn = Apollo.MutationFunction<CreateWidgetMutation, CreateWidgetMutationVariables>;

/**
 * __useCreateWidgetMutation__
 *
 * To run a mutation, you first call `useCreateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWidgetMutation, { data, loading, error }] = useCreateWidgetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<CreateWidgetMutation, CreateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWidgetMutation, CreateWidgetMutationVariables>(CreateWidgetDocument, options);
      }
export type CreateWidgetMutationHookResult = ReturnType<typeof useCreateWidgetMutation>;
export type CreateWidgetMutationResult = Apollo.MutationResult<CreateWidgetMutation>;
export type CreateWidgetMutationOptions = Apollo.BaseMutationOptions<CreateWidgetMutation, CreateWidgetMutationVariables>;
export const UpdateWidgetDocument = gql`
    mutation updateWidget($id: ID!, $data: UpdateWidgetInput!) {
  updateWidget(id: $id, data: $data) {
    ...WidgetFields
  }
}
    ${WidgetFieldsFragmentDoc}`;
export type UpdateWidgetMutationFn = Apollo.MutationFunction<UpdateWidgetMutation, UpdateWidgetMutationVariables>;

/**
 * __useUpdateWidgetMutation__
 *
 * To run a mutation, you first call `useUpdateWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWidgetMutation, { data, loading, error }] = useUpdateWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWidgetMutation, UpdateWidgetMutationVariables>(UpdateWidgetDocument, options);
      }
export type UpdateWidgetMutationHookResult = ReturnType<typeof useUpdateWidgetMutation>;
export type UpdateWidgetMutationResult = Apollo.MutationResult<UpdateWidgetMutation>;
export type UpdateWidgetMutationOptions = Apollo.BaseMutationOptions<UpdateWidgetMutation, UpdateWidgetMutationVariables>;
export const DeleteWidgetDocument = gql`
    mutation deleteWidget($id: ID!) {
  deleteWidget(id: $id)
}
    `;
export type DeleteWidgetMutationFn = Apollo.MutationFunction<DeleteWidgetMutation, DeleteWidgetMutationVariables>;

/**
 * __useDeleteWidgetMutation__
 *
 * To run a mutation, you first call `useDeleteWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWidgetMutation, { data, loading, error }] = useDeleteWidgetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWidgetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWidgetMutation, DeleteWidgetMutationVariables>(DeleteWidgetDocument, options);
      }
export type DeleteWidgetMutationHookResult = ReturnType<typeof useDeleteWidgetMutation>;
export type DeleteWidgetMutationResult = Apollo.MutationResult<DeleteWidgetMutation>;
export type DeleteWidgetMutationOptions = Apollo.BaseMutationOptions<DeleteWidgetMutation, DeleteWidgetMutationVariables>;
export const namedOperations = {
  Query: {
    getActionItem: 'getActionItem',
    queryActionItems: 'queryActionItems',
    countActionItems: 'countActionItems',
    queryAppointmentActionItems: 'queryAppointmentActionItems',
    queryRescheduleActionItems: 'queryRescheduleActionItems',
    getAllAnimals: 'getAllAnimals',
    getAppointmentPrompt: 'getAppointmentPrompt',
    allAppointmentPrompts: 'allAppointmentPrompts',
    queryAppointmentPrompts: 'queryAppointmentPrompts',
    getPublicAppointmentTimes: 'getPublicAppointmentTimes',
    getAllAppointments: 'getAllAppointments',
    getAppointment: 'getAppointment',
    searchAppointments: 'searchAppointments',
    queryAppointments: 'queryAppointments',
    countAppointments: 'countAppointments',
    searchAppointmentsStatus: 'searchAppointmentsStatus',
    getNewAppointmentsForClinic: 'getNewAppointmentsForClinic',
    getAppointmentsByClinicAndRange: 'getAppointmentsByClinicAndRange',
    getTimeSlotsForClinicForDay: 'getTimeSlotsForClinicForDay',
    getBreedsByClinic: 'getBreedsByClinic',
    queryBreeds: 'queryBreeds',
    getChat: 'getChat',
    getChatsByClientId: 'getChatsByClientId',
    getChatsByClinicId: 'getChatsByClinicId',
    queryChats: 'queryChats',
    countChats: 'countChats',
    getChatByClientAndClinic: 'getChatByClientAndClinic',
    getCheckIn: 'getCheckIn',
    getCheckInsByUser: 'getCheckInsByUser',
    getCheckInsByClinic: 'getCheckInsByClinic',
    queryClientForms: 'queryClientForms',
    countClientForms: 'countClientForms',
    getClient: 'getClient',
    checkExistingClients: 'checkExistingClients',
    checkExistingClient: 'checkExistingClient',
    getClientsWithNegativeBalancesForClinic: 'getClientsWithNegativeBalancesForClinic',
    getClientsWithoutApptOverDaysForClinic: 'getClientsWithoutApptOverDaysForClinic',
    getNewClientsForClinic: 'getNewClientsForClinic',
    queryClients: 'queryClients',
    queryClientsPatients: 'queryClientsPatients',
    countClients: 'countClients',
    getClinicAdmin: 'getClinicAdmin',
    getClinicAdminsByClinic: 'getClinicAdminsByClinic',
    getClinicAdminsByUser: 'getClinicAdminsByUser',
    getClinicAdminsForLogin: 'getClinicAdminsForLogin',
    getClinicAnalytics: 'getClinicAnalytics',
    getAnalyticsNumbersByMonthsForClinic: 'getAnalyticsNumbersByMonthsForClinic',
    getRevenueByMonthsForClinic: 'getRevenueByMonthsForClinic',
    queryClinicSexes: 'queryClinicSexes',
    getClinicSpeciesByClinic: 'getClinicSpeciesByClinic',
    queryClinicSpecies: 'queryClinicSpecies',
    getRevenueForTimeRange: 'getRevenueForTimeRange',
    getRevenuesByTypeForTimeRange: 'getRevenuesByTypeForTimeRange',
    getRevenuesByClinicianForTimeRange: 'getRevenuesByClinicianForTimeRange',
    getAccountsReceivable: 'getAccountsReceivable',
    getClinicianServicesByService: 'getClinicianServicesByService',
    getClinician: 'getClinician',
    getCliniciansByClinic: 'getCliniciansByClinic',
    queryClinicians: 'queryClinicians',
    getAllClinics: 'getAllClinics',
    getClinic: 'getClinic',
    getClientsForClinic: 'getClientsForClinic',
    getClientCountForClinic: 'getClientCountForClinic',
    getClinicsForUserAdmin: 'getClinicsForUserAdmin',
    searchClinics: 'searchClinics',
    queryClinics: 'queryClinics',
    countClinics: 'countClinics',
    clinicStats: 'clinicStats',
    getTotalRevenueForClinicBetweenTimes: 'getTotalRevenueForClinicBetweenTimes',
    getConnectInstallation: 'getConnectInstallation',
    getConnectInstallationsByClinic: 'getConnectInstallationsByClinic',
    checkIfServerRunning: 'checkIfServerRunning',
    getLastServerHeartbeatForClinic: 'getLastServerHeartbeatForClinic',
    customerSegment: 'customerSegment',
    getCustomerSegmentsForClinic: 'getCustomerSegmentsForClinic',
    queryCustomerSegments: 'queryCustomerSegments',
    getClientsByCustomerSegmentRPC: 'getClientsByCustomerSegmentRPC',
    getDailyHuddle: 'getDailyHuddle',
    getDailyHuddlesByClinic: 'getDailyHuddlesByClinic',
    queryDiagnoses: 'queryDiagnoses',
    queryEntityReports: 'queryEntityReports',
    getOrganizationReport: 'getOrganizationReport',
    queryOrganizationReports: 'queryOrganizationReports',
    queryOrganizationReportPreviews: 'queryOrganizationReportPreviews',
    getReportTemplate: 'getReportTemplate',
    queryReportTemplates: 'queryReportTemplates',
    queryForms: 'queryForms',
    countForms: 'countForms',
    getGoalByClinicAndId: 'getGoalByClinicAndId',
    getGoalsByClinic: 'getGoalsByClinic',
    getLoyaltyRewardsForClinic: 'getLoyaltyRewardsForClinic',
    getLoyaltyMemberFromClient: 'getLoyaltyMemberFromClient',
    getLoyaltyMember: 'getLoyaltyMember',
    getLoyaltyReward: 'getLoyaltyReward',
    queryLoyaltyRedemptions: 'queryLoyaltyRedemptions',
    getMessagesByChatId: 'getMessagesByChatId',
    queryMessages: 'queryMessages',
    countMessages: 'countMessages',
    notificationTemplate: 'notificationTemplate',
    getNotificationTemplatesByClinicId: 'getNotificationTemplatesByClinicId',
    queryNotificationTemplates: 'queryNotificationTemplates',
    getOrganizationAnalytics: 'getOrganizationAnalytics',
    getOrganizationAnalyticsNumbers: 'getOrganizationAnalyticsNumbers',
    getOrganizationScheduleEfficiency: 'getOrganizationScheduleEfficiency',
    getOrganizationAnalyticsNumbersByMonths: 'getOrganizationAnalyticsNumbersByMonths',
    getOrganizationRevenueByMonths: 'getOrganizationRevenueByMonths',
    getOrganization: 'getOrganization',
    queryOrganizations: 'queryOrganizations',
    countOrganizations: 'countOrganizations',
    getPatient: 'getPatient',
    getPatientsByClient: 'getPatientsByClient',
    getPatientsByClients: 'getPatientsByClients',
    getPatientsWithoutRescheduledAppointmentsForTimeRange: 'getPatientsWithoutRescheduledAppointmentsForTimeRange',
    getNewPatientsForClinic: 'getNewPatientsForClinic',
    queryPatients: 'queryPatients',
    getPayment: 'getPayment',
    getPaymentsByClinicId: 'getPaymentsByClinicId',
    queryPayments: 'queryPayments',
    countPayments: 'countPayments',
    getPatientRecord: 'getPatientRecord',
    getPimsSettings: 'getPimsSettings',
    getPmsApptType: 'getPmsApptType',
    getPmsApptTypesForClinic: 'getPmsApptTypesForClinic',
    getPrescriptionRequest: 'getPrescriptionRequest',
    getPrescriptionRequestsForPatient: 'getPrescriptionRequestsForPatient',
    getPrescriptionRequestsForClinic: 'getPrescriptionRequestsForClinic',
    getAllPressItems: 'getAllPressItems',
    getPressItem: 'getPressItem',
    queryProducts: 'queryProducts',
    queryReschedules: 'queryReschedules',
    getReviewsForClinic: 'getReviewsForClinic',
    queryReviews: 'queryReviews',
    getAverageRatingForRecentReviews: 'getAverageRatingForRecentReviews',
    countReviews: 'countReviews',
    getRoom: 'getRoom',
    queryRooms: 'queryRooms',
    countRooms: 'countRooms',
    getRoomsForClinic: 'getRoomsForClinic',
    getSchedulingRuleByClinicAndId: 'getSchedulingRuleByClinicAndId',
    getSchedulingRulesForClinic: 'getSchedulingRulesForClinic',
    getAllServices: 'getAllServices',
    getAllServicesByClinicId: 'getAllServicesByClinicId',
    queryServices: 'queryServices',
    countServices: 'countServices',
    getService: 'getService',
    paymentIntentFromService: 'paymentIntentFromService',
    getTransactionsByClinicAndRange: 'getTransactionsByClinicAndRange',
    getUser: 'getUser',
    searchUsers: 'searchUsers',
    queryUsers: 'queryUsers',
    countUsers: 'countUsers',
    checkForUserByEmail: 'checkForUserByEmail',
    stripeAccountOnboardLink: 'stripeAccountOnboardLink',
    stripeAccountLoginLink: 'stripeAccountLoginLink',
    stripeAccountCheck: 'stripeAccountCheck',
    getWidget: 'getWidget',
    getWidgetsByClinic: 'getWidgetsByClinic',
    getWidgetsByOrganization: 'getWidgetsByOrganization',
    getAllWidgets: 'getAllWidgets',
    getAppointmentCountByWidgetSource: 'getAppointmentCountByWidgetSource'
  },
  Mutation: {
    updateActionItem: 'updateActionItem',
    createAnimal: 'createAnimal',
    updateAnimal: 'updateAnimal',
    deleteAnimal: 'deleteAnimal',
    createAppointmentPrompt: 'createAppointmentPrompt',
    sendAppointmentPrompt: 'sendAppointmentPrompt',
    updateAppointmentPrompt: 'updateAppointmentPrompt',
    createAppointment: 'createAppointment',
    updateAppointment: 'updateAppointment',
    markAppointmentAsResolved: 'markAppointmentAsResolved',
    confirmAppointment: 'confirmAppointment',
    updateAppointmentClientPatient: 'updateAppointmentClientPatient',
    deleteAppointment: 'deleteAppointment',
    createChat: 'createChat',
    updateChat: 'updateChat',
    uploadAttachment: 'uploadAttachment',
    createCheckIn: 'createCheckIn',
    updateCheckIn: 'updateCheckIn',
    createClientForm: 'createClientForm',
    updateClientForm: 'updateClientForm',
    createClient: 'createClient',
    updateClient: 'updateClient',
    deleteClient: 'deleteClient',
    addClinicToClient: 'addClinicToClient',
    createClinicAdmin: 'createClinicAdmin',
    updateClinicAdmin: 'updateClinicAdmin',
    deleteClinicAdmin: 'deleteClinicAdmin',
    updateClinicSex: 'updateClinicSex',
    makePrimaryClinicSpecies: 'makePrimaryClinicSpecies',
    updateClinicSpecies: 'updateClinicSpecies',
    createClinicianService: 'createClinicianService',
    updateClinicianService: 'updateClinicianService',
    deleteClinicianService: 'deleteClinicianService',
    createClinician: 'createClinician',
    updateClinician: 'updateClinician',
    deleteClinician: 'deleteClinician',
    createClinic: 'createClinic',
    updateClinic: 'updateClinic',
    deleteClinic: 'deleteClinic',
    triggerServiceUpdate: 'triggerServiceUpdate',
    createConnectInstallation: 'createConnectInstallation',
    updateConnectInstallation: 'updateConnectInstallation',
    deleteConnectInstallation: 'deleteConnectInstallation',
    createCustomerSegment: 'createCustomerSegment',
    updateCustomerSegment: 'updateCustomerSegment',
    deleteCustomerSegment: 'deleteCustomerSegment',
    createDailyHuddle: 'createDailyHuddle',
    updateDailyHuddle: 'updateDailyHuddle',
    createReportClinic: 'createReportClinic',
    deleteReportClinic: 'deleteReportClinic',
    createReportTemplate: 'createReportTemplate',
    updateReportTemplate: 'updateReportTemplate',
    createTemplateClinic: 'createTemplateClinic',
    deleteTemplateClinic: 'deleteTemplateClinic',
    createForm: 'createForm',
    updateForm: 'updateForm',
    createGoal: 'createGoal',
    updateGoal: 'updateGoal',
    deleteGoal: 'deleteGoal',
    createLoyaltyReward: 'createLoyaltyReward',
    updateLoyaltyReward: 'updateLoyaltyReward',
    deleteLoyaltyReward: 'deleteLoyaltyReward',
    createLoyaltyMember: 'createLoyaltyMember',
    updateLoyaltyMember: 'updateLoyaltyMember',
    addPointsToLoyaltyMember: 'addPointsToLoyaltyMember',
    createLoyaltyRedemption: 'createLoyaltyRedemption',
    createMessage: 'createMessage',
    updateMessage: 'updateMessage',
    deleteMessage: 'deleteMessage',
    createNotificationTemplate: 'createNotificationTemplate',
    updateNotificationTemplate: 'updateNotificationTemplate',
    deleteNotificationTemplate: 'deleteNotificationTemplate',
    createOrganization: 'createOrganization',
    updateOrganization: 'updateOrganization',
    deleteOrganization: 'deleteOrganization',
    createPatient: 'createPatient',
    updatePatient: 'updatePatient',
    deletePatient: 'deletePatient',
    createPimsSettings: 'createPimsSettings',
    updatePimsSettings: 'updatePimsSettings',
    createPrescriptionRequest: 'createPrescriptionRequest',
    updatePrescriptionRequest: 'updatePrescriptionRequest',
    createPressItem: 'createPressItem',
    updatePressItem: 'updatePressItem',
    deletePressItem: 'deletePressItem',
    triggerSyncForClinic: 'triggerSyncForClinic',
    updateReschedule: 'updateReschedule',
    approveReschedule: 'approveReschedule',
    updateRoom: 'updateRoom',
    updateSchedulingRules: 'updateSchedulingRules',
    createSchedulingRules: 'createSchedulingRules',
    deleteSchedulingRule: 'deleteSchedulingRule',
    createService: 'createService',
    createClinicService: 'createClinicService',
    updateService: 'updateService',
    updateClinicService: 'updateClinicService',
    deleteService: 'deleteService',
    deleteClinicService: 'deleteClinicService',
    createUser: 'createUser',
    updateUser: 'updateUser',
    createWidget: 'createWidget',
    updateWidget: 'updateWidget',
    deleteWidget: 'deleteWidget'
  },
  Fragment: {
    UserBasicInfo: 'UserBasicInfo',
    ActionItemBaseFields: 'ActionItemBaseFields',
    ActionItemFields: 'ActionItemFields',
    AppointmentWithActionItemsFields: 'AppointmentWithActionItemsFields',
    RescheduleWithActionItemsFields: 'RescheduleWithActionItemsFields',
    AnimalFields: 'AnimalFields',
    AppointmentPromptFields: 'AppointmentPromptFields',
    AppointmentBaseFields: 'AppointmentBaseFields',
    AppointmentPreviewFields: 'AppointmentPreviewFields',
    AppointmentFields: 'AppointmentFields',
    PublicAppointmentTimeFields: 'PublicAppointmentTimeFields',
    TimeSlotClinicianFields: 'TimeSlotClinicianFields',
    TimeSlotFields: 'TimeSlotFields',
    ClientInfoFields: 'ClientInfoFields',
    PatientInfoFields: 'PatientInfoFields',
    BreedFields: 'BreedFields',
    ChatFields: 'ChatFields',
    CheckInFields: 'CheckInFields',
    ClientFormFields: 'ClientFormFields',
    ClientPreviewFields: 'ClientPreviewFields',
    ClientLoyaltyMemberFields: 'ClientLoyaltyMemberFields',
    ClientFields: 'ClientFields',
    ClinicAdminFields: 'ClinicAdminFields',
    ClinicAdminFieldsForLogin: 'ClinicAdminFieldsForLogin',
    ClinicAnalyticsFields: 'ClinicAnalyticsFields',
    AnalyticsNumbersFields: 'AnalyticsNumbersFields',
    ClinicSexFields: 'ClinicSexFields',
    ClinicSpeciesFields: 'ClinicSpeciesFields',
    ClinicianServiceFields: 'ClinicianServiceFields',
    AvailabilityDayFields: 'AvailabilityDayFields',
    AdjustedAvailabilityFields: 'AdjustedAvailabilityFields',
    ClinicianFields: 'ClinicianFields',
    ClinicFields: 'ClinicFields',
    ClinicFeatureFields: 'ClinicFeatureFields',
    ClinicSettingsFields: 'ClinicSettingsFields',
    ClinicPreviewFields: 'ClinicPreviewFields',
    ClinicStatsFields: 'ClinicStatsFields',
    ConnectInstallationFields: 'ConnectInstallationFields',
    QueryFilterFields: 'QueryFilterFields',
    CustomerSegmentFields: 'CustomerSegmentFields',
    DailyHuddleFields: 'DailyHuddleFields',
    DiagnosisFields: 'DiagnosisFields',
    EntityReportSharedFields: 'EntityReportSharedFields',
    EntityReportFields: 'EntityReportFields',
    FirstChildReportFields: 'FirstChildReportFields',
    SecondChildReportFields: 'SecondChildReportFields',
    ReportValueFields: 'ReportValueFields',
    EntityReportClinicianFields: 'EntityReportClinicianFields',
    EntityReportServiceFields: 'EntityReportServiceFields',
    EntityReportProductFields: 'EntityReportProductFields',
    OrganizationReportFields: 'OrganizationReportFields',
    OrganizationReportPreviewFields: 'OrganizationReportPreviewFields',
    ReportClinicClinicFields: 'ReportClinicClinicFields',
    ReportClinicFields: 'ReportClinicFields',
    ReportMetricFields: 'ReportMetricFields',
    TimeParamFields: 'TimeParamFields',
    MetricValueParamsFields: 'MetricValueParamsFields',
    ReportMetricModifierFields: 'ReportMetricModifierFields',
    ReportTemplateFields: 'ReportTemplateFields',
    ReportEntityFields: 'ReportEntityFields',
    ChildReportEntityFields: 'ChildReportEntityFields',
    SecondChildReportEntityFields: 'SecondChildReportEntityFields',
    RepeatParamsFields: 'RepeatParamsFields',
    TemplateClinicClinicFields: 'TemplateClinicClinicFields',
    TemplateClinicFields: 'TemplateClinicFields',
    FormFields: 'FormFields',
    GoalsFields: 'GoalsFields',
    LoyaltyClientFields: 'LoyaltyClientFields',
    LoyaltyMemberFields: 'LoyaltyMemberFields',
    LoyaltyRewardFields: 'LoyaltyRewardFields',
    LoyaltyRedemptionFields: 'LoyaltyRedemptionFields',
    AttachmentFields: 'AttachmentFields',
    MessagePatientFields: 'MessagePatientFields',
    MessageFields: 'MessageFields',
    NotificationTemplateFields: 'NotificationTemplateFields',
    OrganizationClinicAnalyticsNumbersFields: 'OrganizationClinicAnalyticsNumbersFields',
    OrganizationAnalyticsFields: 'OrganizationAnalyticsFields',
    OrganizationAnalyticsNumbersFields: 'OrganizationAnalyticsNumbersFields',
    OrganizationClinicFields: 'OrganizationClinicFields',
    OrganizationAdminFields: 'OrganizationAdminFields',
    OrganizationFields: 'OrganizationFields',
    PatientHistoryItemFields: 'PatientHistoryItemFields',
    PatientPreviewFields: 'PatientPreviewFields',
    PatientFields: 'PatientFields',
    PaymentFields: 'PaymentFields',
    PatientRecordFields: 'PatientRecordFields',
    PimsSettingsFields: 'PimsSettingsFields',
    PmsApptTypeFields: 'PmsApptTypeFields',
    PrescriptionRequestFields: 'PrescriptionRequestFields',
    PrescriptionFields: 'PrescriptionFields',
    PressItemFields: 'PressItemFields',
    ProductFields: 'ProductFields',
    RescheduleAppointmentFields: 'RescheduleAppointmentFields',
    RescheduleFields: 'RescheduleFields',
    ReviewFields: 'ReviewFields',
    RoomFields: 'RoomFields',
    SchedulingRulesFields: 'SchedulingRulesFields',
    PricingFields: 'PricingFields',
    ServiceFields: 'ServiceFields',
    TransactionFields: 'TransactionFields',
    UserFields: 'UserFields',
    WidgetFields: 'WidgetFields'
  }
}